export const codiciPostaliComuni = [
	"Piemonte, Torino, Agliè, A074",
	"Piemonte, Torino, Airasca, A109",
	"Piemonte, Torino, Ala di Stura, A117",
	"Piemonte, Torino, Albiano d'Ivrea, A157",
	"Piemonte, Torino, Almese, A218",
	"Piemonte, Torino, Alpette, A221",
	"Piemonte, Torino, Alpignano, A222",
	"Piemonte, Torino, Andezeno, A275",
	"Piemonte, Torino, Andrate, A282",
	"Piemonte, Torino, Angrogna, A295",
	"Piemonte, Torino, Arignano, A405",
	"Piemonte, Torino, Avigliana, A518",
	"Piemonte, Torino, Azeglio, A525",
	"Piemonte, Torino, Bairo, A584",
	"Piemonte, Torino, Balangero, A587",
	"Piemonte, Torino, Baldissero Canavese, A590",
	"Piemonte, Torino, Baldissero Torinese, A591",
	"Piemonte, Torino, Balme, A599",
	"Piemonte, Torino, Banchette, A607",
	"Piemonte, Torino, Barbania, A625",
	"Piemonte, Torino, Bardonecchia, A651",
	"Piemonte, Torino, Barone Canavese, A673",
	"Piemonte, Torino, Beinasco, A734",
	"Piemonte, Torino, Bibiana, A853",
	"Piemonte, Torino, Bobbio Pellice, A910",
	"Piemonte, Torino, Bollengo, A941",
	"Piemonte, Torino, Borgaro Torinese, A990",
	"Piemonte, Torino, Borgiallo, B003",
	"Piemonte, Torino, Borgofranco d'Ivrea, B015",
	"Piemonte, Torino, Borgomasino, B021",
	"Piemonte, Torino, Borgone Susa, B024",
	"Piemonte, Torino, Bosconero, B075",
	"Piemonte, Torino, Brandizzo, B121",
	"Piemonte, Torino, Bricherasio, B171",
	"Piemonte, Torino, Brosso, B205",
	"Piemonte, Torino, Brozolo, B209",
	"Piemonte, Torino, Bruino, B216",
	"Piemonte, Torino, Brusasco, B225",
	"Piemonte, Torino, Bruzolo, B232",
	"Piemonte, Torino, Buriasco, B278",
	"Piemonte, Torino, Burolo, B279",
	"Piemonte, Torino, Busano, B284",
	"Piemonte, Torino, Bussoleno, B297",
	"Piemonte, Torino, Buttigliera Alta, B305",
	"Piemonte, Torino, Cafasse, B350",
	"Piemonte, Torino, Caluso, B435",
	"Piemonte, Torino, Cambiano, B462",
	"Piemonte, Torino, Campiglione Fenile, B512",
	"Piemonte, Torino, Candia Canavese, B588",
	"Piemonte, Torino, Candia Canavese, B588",
	"Piemonte, Torino, Candiolo, B592",
	"Piemonte, Torino, Canischio, B605",
	"Piemonte, Torino, Cantalupa, B628",
	"Piemonte, Torino, Cantoira, B637",
	"Piemonte, Torino, Caprie, B705",
	"Piemonte, Torino, Caravino, B733",
	"Piemonte, Torino, Carema, B762",
	"Piemonte, Torino, Carignano, B777",
	"Piemonte, Torino, Carmagnola, B791",
	"Piemonte, Torino, Casalborgone, B867",
	"Piemonte, Torino, Cascinette d'Ivrea, B953",
	"Piemonte, Torino, Caselette, B955",
	"Piemonte, Torino, Caselle Torinese, B960",
	"Piemonte, Torino, Castagneto Po, C045",
	"Piemonte, Torino, Castagnole Piemonte, C048",
	"Piemonte, Torino, Castellamonte, C133",
	"Piemonte, Torino, Castelnuovo Nigra, C241",
	"Piemonte, Torino, Castiglione Torinese, C307",
	"Piemonte, Torino, Cavagnolo, C369",
	"Piemonte, Torino, Cavour, C404",
	"Piemonte, Torino, Cercenasco, C487",
	"Piemonte, Torino, Ceres, C497",
	"Piemonte, Torino, Ceresole Reale, C505",
	"Piemonte, Torino, Cesana Torinese, C564",
	"Piemonte, Torino, Chialamberto, C604",
	"Piemonte, Torino, Chianocco, C610",
	"Piemonte, Torino, Chiaverano, C624",
	"Piemonte, Torino, Chieri, C627",
	"Piemonte, Torino, Chiesanuova, C629",
	"Piemonte, Torino, Chiomonte, C639",
	"Piemonte, Torino, Chiusa di San Michele, C655",
	"Piemonte, Torino, Chivasso, C665",
	"Piemonte, Torino, Ciconio, C679",
	"Piemonte, Torino, Cintano, C711",
	"Piemonte, Torino, Cinzano, C715",
	"Piemonte, Torino, Ciriè, C722",
	"Piemonte, Torino, Claviere, C793",
	"Piemonte, Torino, Coassolo Torinese, C801",
	"Piemonte, Torino, Coazze, C803",
	"Piemonte, Torino, Collegno, C860",
	"Piemonte, Torino, Colleretto Castelnuovo, C867",
	"Piemonte, Torino, Colleretto Giacosa, C868",
	"Piemonte, Torino, Condove, C955",
	"Piemonte, Torino, Corio, D008",
	"Piemonte, Torino, Cossano Canavese, D092",
	"Piemonte, Torino, Cuceglio, D197",
	"Piemonte, Torino, Cumiana, D202",
	"Piemonte, Torino, Cuorgnè, D208",
	"Piemonte, Torino, Druento, D373",
	"Piemonte, Torino, Exilles, D433",
	"Piemonte, Torino, Favria, D520",
	"Piemonte, Torino, Feletto, D524",
	"Piemonte, Torino, Fenestrelle, D532",
	"Piemonte, Torino, Fiano, D562",
	"Piemonte, Torino, Fiorano Canavese, D608",
	"Piemonte, Torino, Foglizzo, D646",
	"Piemonte, Torino, Forno Canavese, D725",
	"Piemonte, Torino, Frassinetto, D781",
	"Piemonte, Torino, Front, D805",
	"Piemonte, Torino, Frossasco, D812",
	"Piemonte, Torino, Garzigliana, D931",
	"Piemonte, Torino, Gassino Torinese, D933",
	"Piemonte, Torino, Germagnano, D983",
	"Piemonte, Torino, Giaglione, E009",
	"Piemonte, Torino, Giaveno, E020",
	"Piemonte, Torino, Givoletto, E067",
	"Piemonte, Torino, Gravere, E154",
	"Piemonte, Torino, Groscavallo, E199",
	"Piemonte, Torino, Grosso, E203",
	"Piemonte, Torino, Grugliasco, E216",
	"Piemonte, Torino, Ingria, E301",
	"Piemonte, Torino, Inverso Pinasca, E311",
	"Piemonte, Torino, Isolabella, E345",
	"Piemonte, Torino, Issiglio, E368",
	"Piemonte, Torino, Ivrea, E379",
	"Piemonte, Torino, La Cassa, E394",
	"Piemonte, Torino, La Loggia, E423",
	"Piemonte, Torino, Lanzo Torinese, E445",
	"Piemonte, Torino, Lauriano, E484",
	"Piemonte, Torino, Leini, E518",
	"Piemonte, Torino, Lemie, E520",
	"Piemonte, Torino, Lessolo, E551",
	"Piemonte, Torino, Levone, E566",
	"Piemonte, Torino, Locana, E635",
	"Piemonte, Torino, Lombardore, E660",
	"Piemonte, Torino, Lombriasco, E661",
	"Piemonte, Torino, Loranzè, E683",
	"Piemonte, Torino, Luserna San Giovanni, E758",
	"Piemonte, Torino, Lusernetta, E759",
	"Piemonte, Torino, Lusigliè, E763",
	"Piemonte, Torino, Macello, E782",
	"Piemonte, Torino, Maglione, E817",
	"Piemonte, Torino, Marentino, E941",
	"Piemonte, Torino, Massello, F041",
	"Piemonte, Torino, Mathi, F053",
	"Piemonte, Torino, Mattie, F058",
	"Piemonte, Torino, Mazzè, F067",
	"Piemonte, Torino, Meana di Susa, F074",
	"Piemonte, Torino, Mercenasco, F140",
	"Piemonte, Torino, Mezzenile, F182",
	"Piemonte, Torino, Mombello di Torino, F315",
	"Piemonte, Torino, Mompantero, F318",
	"Piemonte, Torino, Monastero di Lanzo, F327",
	"Piemonte, Torino, Moncalieri, F335",
	"Piemonte, Torino, Moncenisio, D553",
	"Piemonte, Torino, Montaldo Torinese, F407",
	"Piemonte, Torino, Montalenghe, F411",
	"Piemonte, Torino, Montalto Dora, F420",
	"Piemonte, Torino, Montanaro, F422",
	"Piemonte, Torino, Monteu da Po, F651",
	"Piemonte, Torino, Moriondo Torinese, F733",
	"Piemonte, Torino, Nichelino, F889",
	"Piemonte, Torino, Noasca, F906",
	"Piemonte, Torino, Nole, F925",
	"Piemonte, Torino, Nomaglio, F927",
	"Piemonte, Torino, None, F931",
	"Piemonte, Torino, Novalesa, F948",
	"Piemonte, Torino, Oglianico, G010",
	"Piemonte, Torino, Orbassano, G087",
	"Piemonte, Torino, Orio Canavese, G109",
	"Piemonte, Torino, Osasco, G151",
	"Piemonte, Torino, Osasio, G152",
	"Piemonte, Torino, Oulx, G196",
	"Piemonte, Torino, Ozegna, G202",
	"Piemonte, Torino, Palazzo Canavese, G262",
	"Piemonte, Torino, Pancalieri, G303",
	"Piemonte, Torino, Parella, G330",
	"Piemonte, Torino, Pavarolo, G387",
	"Piemonte, Torino, Pavone Canavese, G392",
	"Piemonte, Torino, Pecetto Torinese, G398",
	"Piemonte, Torino, Perosa Argentina, G463",
	"Piemonte, Torino, Perosa Canavese, G462",
	"Piemonte, Torino, Perrero, G465",
	"Piemonte, Torino, Pertusio, G477",
	"Piemonte, Torino, Pessinetto, G505",
	"Piemonte, Torino, Pianezza, G559",
	"Piemonte, Torino, Pinasca, G672",
	"Piemonte, Torino, Pinerolo, G674",
	"Piemonte, Torino, Pino Torinese, G678",
	"Piemonte, Torino, Piobesi Torinese, G684",
	"Piemonte, Torino, Piossasco, G691",
	"Piemonte, Torino, Piscina, G705",
	"Piemonte, Torino, Piverone, G719",
	"Piemonte, Torino, Poirino, G777",
	"Piemonte, Torino, Pomaretto, G805",
	"Piemonte, Torino, Pont Canavese, G826",
	"Piemonte, Torino, Porte, G900",
	"Piemonte, Torino, Pragelato, G973",
	"Piemonte, Torino, Prali, G978",
	"Piemonte, Torino, Pralormo, G979",
	"Piemonte, Torino, Pramollo, G982",
	"Piemonte, Torino, Prarostino, G986",
	"Piemonte, Torino, Prascorsano, G988",
	"Piemonte, Torino, Pratiglione, G997",
	"Piemonte, Torino, Quagliuzzo, H100",
	"Piemonte, Torino, Quassolo, H120",
	"Piemonte, Torino, Quincinetto, H127",
	"Piemonte, Torino, Reano, H207",
	"Piemonte, Torino, Ribordone, H270",
	"Piemonte, Torino, Rivalba, H333",
	"Piemonte, Torino, Rivalta di Torino, H335",
	"Piemonte, Torino, Riva presso Chieri, H337",
	"Piemonte, Torino, Rivara, H338",
	"Piemonte, Torino, Rivarolo Canavese, H340",
	"Piemonte, Torino, Rivarossa, H344",
	"Piemonte, Torino, Rivoli, H355",
	"Piemonte, Torino, Robassomero, H367",
	"Piemonte, Torino, Rocca Canavese, H386",
	"Piemonte, Torino, Roletto, H498",
	"Piemonte, Torino, Romano Canavese, H511",
	"Piemonte, Torino, Ronco Canavese, H539",
	"Piemonte, Torino, Rondissone, H547",
	"Piemonte, Torino, Rorà, H554",
	"Piemonte, Torino, Roure, H555",
	"Piemonte, Torino, Rosta, H583",
	"Piemonte, Torino, Rubiana, H627",
	"Piemonte, Torino, Rueglio, H631",
	"Piemonte, Torino, Salassa, H691",
	"Piemonte, Torino, Salbertrand, H684",
	"Piemonte, Torino, Salerano Canavese, H702",
	"Piemonte, Torino, Salza di Pinerolo, H734",
	"Piemonte, Torino, Samone, H753",
	"Piemonte, Torino, San Benigno Canavese, H775",
	"Piemonte, Torino, San Carlo Canavese, H789",
	"Piemonte, Torino, San Colombano Belmonte, H804",
	"Piemonte, Torino, San Didero, H820",
	"Piemonte, Torino, San Francesco al Campo, H847",
	"Piemonte, Torino, Sangano, H855",
	"Piemonte, Torino, San Germano Chisone, H862",
	"Piemonte, Torino, San Gillio, H873",
	"Piemonte, Torino, San Giorgio Canavese, H890",
	"Piemonte, Torino, San Giorio di Susa, H900",
	"Piemonte, Torino, San Giusto Canavese, H936",
	"Piemonte, Torino, San Martino Canavese, H997",
	"Piemonte, Torino, San Maurizio Canavese, I024",
	"Piemonte, Torino, San Mauro Torinese, I030",
	"Piemonte, Torino, San Pietro Val Lemina, I090",
	"Piemonte, Torino, San Ponso, I126",
	"Piemonte, Torino, San Raffaele Cimena, I137",
	"Piemonte, Torino, San Sebastiano da Po, I152",
	"Piemonte, Torino, San Secondo di Pinerolo, I154",
	"Piemonte, Torino, Sant'Ambrogio di Torino, I258",
	"Piemonte, Torino, Sant'Antonino di Susa, I296",
	"Piemonte, Torino, Santena, I327",
	"Piemonte, Torino, Sauze di Cesana, I465",
	"Piemonte, Torino, Sauze d'Oulx, I466",
	"Piemonte, Torino, Scalenghe, I490",
	"Piemonte, Torino, Scarmagno, I511",
	"Piemonte, Torino, Sciolze, I539",
	"Piemonte, Torino, Sestriere, I692",
	"Piemonte, Torino, Settimo Rottaro, I701",
	"Piemonte, Torino, Settimo Torinese, I703",
	"Piemonte, Torino, Settimo Vittone, I702",
	"Piemonte, Torino, Sparone, I886",
	"Piemonte, Torino, Strambinello, I969",
	"Piemonte, Torino, Strambino, I970",
	"Piemonte, Torino, Susa, L013",
	"Piemonte, Torino, Tavagnasco, L066",
	"Piemonte, Torino, Torino, L219",
	"Piemonte, Torino, Torrazza Piemonte, L238",
	"Piemonte, Torino, Torre Canavese, L247",
	"Piemonte, Torino, Torre Pellice, L277",
	"Piemonte, Torino, Trana, L327",
	"Piemonte, Torino, Traversella, L345",
	"Piemonte, Torino, Traves, L340",
	"Piemonte, Torino, Trofarello, L445",
	"Piemonte, Torino, Usseaux, L515",
	"Piemonte, Torino, Usseglio, L516",
	"Piemonte, Torino, Vaie, L538",
	"Piemonte, Torino, Val della Torre, L555",
	"Piemonte, Torino, Valgioie, L578",
	"Piemonte, Torino, Vallo Torinese, L629",
	"Piemonte, Torino, Valperga, L644",
	"Piemonte, Torino, Valprato Soana, B510",
	"Piemonte, Torino, Varisella, L685",
	"Piemonte, Torino, Vauda Canavese, L698",
	"Piemonte, Torino, Venaus, L726",
	"Piemonte, Torino, Venaria Reale, L727",
	"Piemonte, Torino, Verolengo, L779",
	"Piemonte, Torino, Verrua Savoia, L787",
	"Piemonte, Torino, Vestignè, L811",
	"Piemonte, Torino, Vialfrè, L830",
	"Piemonte, Torino, Vidracco, L857",
	"Piemonte, Torino, Vigone, L898",
	"Piemonte, Torino, Villafranca Piemonte, L948",
	"Piemonte, Torino, Villanova Canavese, L982",
	"Piemonte, Torino, Villarbasse, M002",
	"Piemonte, Torino, Villar Dora, L999",
	"Piemonte, Torino, Villareggia, M004",
	"Piemonte, Torino, Villar Focchiardo, M007",
	"Piemonte, Torino, Villar Pellice, M013",
	"Piemonte, Torino, Villar Perosa, M014",
	"Piemonte, Torino, Villastellone, M027",
	"Piemonte, Torino, Vinovo, M060",
	"Piemonte, Torino, Virle Piemonte, M069",
	"Piemonte, Torino, Vische, M071",
	"Piemonte, Torino, Vistrorio, M080",
	"Piemonte, Torino, Viù, M094",
	"Piemonte, Torino, Volpiano, M122",
	"Piemonte, Torino, Volvera, M133",
	"Piemonte, Torino, Mappano, M316",
	"Piemonte, Torino, Val di Chy, M405",
	"Piemonte, Torino, Valchiusa, M415",
	"Piemonte, Vercelli, Alagna Valsesia, A119",
	"Piemonte, Vercelli, Albano Vercellese, A130",
	"Piemonte, Vercelli, Alice Castello, A198",
	"Piemonte, Vercelli, Arborio, A358",
	"Piemonte, Vercelli, Asigliano Vercellese, A466",
	"Piemonte, Vercelli, Balmuccia, A600",
	"Piemonte, Vercelli, Balocco, A601",
	"Piemonte, Vercelli, Bianzè, A847",
	"Piemonte, Vercelli, Boccioleto, A914",
	"Piemonte, Vercelli, Borgo d'Ale, B009",
	"Piemonte, Vercelli, Borgosesia, B041",
	"Piemonte, Vercelli, Borgo Vercelli, B046",
	"Piemonte, Vercelli, Buronzo, B280",
	"Piemonte, Vercelli, Campertogno, B505",
	"Piemonte, Vercelli, Carcoforo, B752",
	"Piemonte, Vercelli, Caresana, B767",
	"Piemonte, Vercelli, Caresanablot, B768",
	"Piemonte, Vercelli, Carisio, B782",
	"Piemonte, Vercelli, Casanova Elvo, B928",
	"Piemonte, Vercelli, San Giacomo Vercellese, B952",
	"Piemonte, Vercelli, Cervatto, C548",
	"Piemonte, Vercelli, Cigliano, C680",
	"Piemonte, Vercelli, Civiasco, C757",
	"Piemonte, Vercelli, Collobiano, C884",
	"Piemonte, Vercelli, Costanzana, D113",
	"Piemonte, Vercelli, Cravagliana, D132",
	"Piemonte, Vercelli, Crescentino, D154",
	"Piemonte, Vercelli, Crova, D187",
	"Piemonte, Vercelli, Desana, D281",
	"Piemonte, Vercelli, Fobello, D641",
	"Piemonte, Vercelli, Fontanetto Po, D676",
	"Piemonte, Vercelli, Formigliana, D712",
	"Piemonte, Vercelli, Gattinara, D938",
	"Piemonte, Vercelli, Ghislarengo, E007",
	"Piemonte, Vercelli, Greggio, E163",
	"Piemonte, Vercelli, Guardabosone, E237",
	"Piemonte, Vercelli, Lamporo, E433",
	"Piemonte, Vercelli, Lenta, E528",
	"Piemonte, Vercelli, Lignana, E583",
	"Piemonte, Vercelli, Livorno Ferraris, E626",
	"Piemonte, Vercelli, Lozzolo, E711",
	"Piemonte, Vercelli, Mollia, F297",
	"Piemonte, Vercelli, Moncrivello, F342",
	"Piemonte, Vercelli, Motta de' Conti, F774",
	"Piemonte, Vercelli, Olcenengo, G016",
	"Piemonte, Vercelli, Oldenico, G018",
	"Piemonte, Vercelli, Palazzolo Vercellese, G266",
	"Piemonte, Vercelli, Pertengo, G471",
	"Piemonte, Vercelli, Pezzana, G528",
	"Piemonte, Vercelli, Pila, G666",
	"Piemonte, Vercelli, Piode, G685",
	"Piemonte, Vercelli, Postua, G940",
	"Piemonte, Vercelli, Prarolo, G985",
	"Piemonte, Vercelli, Quarona, H108",
	"Piemonte, Vercelli, Quinto Vercellese, H132",
	"Piemonte, Vercelli, Rassa, H188",
	"Piemonte, Vercelli, Rimella, H293",
	"Piemonte, Vercelli, Rive, H346",
	"Piemonte, Vercelli, Roasio, H365",
	"Piemonte, Vercelli, Ronsecco, H549",
	"Piemonte, Vercelli, Rossa, H577",
	"Piemonte, Vercelli, Rovasenda, H364",
	"Piemonte, Vercelli, Salasco, H690",
	"Piemonte, Vercelli, Sali Vercellese, H707",
	"Piemonte, Vercelli, Saluggia, H725",
	"Piemonte, Vercelli, San Germano Vercellese, H861",
	"Piemonte, Vercelli, Santhià, I337",
	"Piemonte, Vercelli, Scopa, I544",
	"Piemonte, Vercelli, Scopello, I545",
	"Piemonte, Vercelli, Serravalle Sesia, I663",
	"Piemonte, Vercelli, Stroppiana, I984",
	"Piemonte, Vercelli, Tricerro, L420",
	"Piemonte, Vercelli, Trino, L429",
	"Piemonte, Vercelli, Tronzano Vercellese, L451",
	"Piemonte, Vercelli, Valduggia, L566",
	"Piemonte, Vercelli, Varallo, L669",
	"Piemonte, Vercelli, Vercelli, L750",
	"Piemonte, Vercelli, Villarboit, M003",
	"Piemonte, Vercelli, Villata, M028",
	"Piemonte, Vercelli, Vocca, M106",
	"Piemonte, Vercelli, Alto Sermenza, M389",
	"Piemonte, Vercelli, Cellio con Breia, M398",
	"Piemonte, Novara, Agrate Conturbia, A088",
	"Piemonte, Novara, Ameno, A264",
	"Piemonte, Novara, Armeno, A414",
	"Piemonte, Novara, Arona, A429",
	"Piemonte, Novara, Barengo, A653",
	"Piemonte, Novara, Bellinzago Novarese, A752",
	"Piemonte, Novara, Biandrate, A844",
	"Piemonte, Novara, Boca, A911",
	"Piemonte, Novara, Bogogno, A929",
	"Piemonte, Novara, Bolzano Novarese, A953",
	"Piemonte, Novara, Borgolavezzaro, B016",
	"Piemonte, Novara, Borgomanero, B019",
	"Piemonte, Novara, Borgo Ticino, B043",
	"Piemonte, Novara, Briga Novarese, B176",
	"Piemonte, Novara, Briona, B183",
	"Piemonte, Novara, Caltignaga, B431",
	"Piemonte, Novara, Cameri, B473",
	"Piemonte, Novara, Carpignano Sesia, B823",
	"Piemonte, Novara, Casalbeltrame, B864",
	"Piemonte, Novara, Casaleggio Novara, B883",
	"Piemonte, Novara, Casalino, B897",
	"Piemonte, Novara, Casalvolone, B920",
	"Piemonte, Novara, Castellazzo Novarese, C149",
	"Piemonte, Novara, Castelletto sopra Ticino, C166",
	"Piemonte, Novara, Cavaglietto, C364",
	"Piemonte, Novara, Cavaglio d'Agogna, C365",
	"Piemonte, Novara, Cavallirio, C378",
	"Piemonte, Novara, Cerano, C483",
	"Piemonte, Novara, Colazza, C829",
	"Piemonte, Novara, Comignago, C926",
	"Piemonte, Novara, Cressa, D162",
	"Piemonte, Novara, Cureggio, D216",
	"Piemonte, Novara, Divignano, D309",
	"Piemonte, Novara, Dormelletto, D347",
	"Piemonte, Novara, Fara Novarese, D492",
	"Piemonte, Novara, Fontaneto d'Agogna, D675",
	"Piemonte, Novara, Galliate, D872",
	"Piemonte, Novara, Garbagna Novarese, D911",
	"Piemonte, Novara, Gargallo, D921",
	"Piemonte, Novara, Ghemme, E001",
	"Piemonte, Novara, Gozzano, E120",
	"Piemonte, Novara, Granozzo con Monticello, E143",
	"Piemonte, Novara, Grignasco, E177",
	"Piemonte, Novara, Invorio, E314",
	"Piemonte, Novara, Landiona, E436",
	"Piemonte, Novara, Lesa, E544",
	"Piemonte, Novara, Maggiora, E803",
	"Piemonte, Novara, Mandello Vitta, E880",
	"Piemonte, Novara, Marano Ticino, E907",
	"Piemonte, Novara, Massino Visconti, F047",
	"Piemonte, Novara, Meina, F093",
	"Piemonte, Novara, Mezzomerico, F188",
	"Piemonte, Novara, Miasino, F191",
	"Piemonte, Novara, Momo, F317",
	"Piemonte, Novara, Nebbiuno, F859",
	"Piemonte, Novara, Nibbiola, F886",
	"Piemonte, Novara, Novara, F952",
	"Piemonte, Novara, Oleggio, G019",
	"Piemonte, Novara, Oleggio Castello, G020",
	"Piemonte, Novara, Orta San Giulio, G134",
	"Piemonte, Novara, Paruzzaro, G349",
	"Piemonte, Novara, Pella, G421",
	"Piemonte, Novara, Pettenasco, G520",
	"Piemonte, Novara, Pisano, G703",
	"Piemonte, Novara, Pogno, G775",
	"Piemonte, Novara, Pombia, G809",
	"Piemonte, Novara, Prato Sesia, H001",
	"Piemonte, Novara, Recetto, H213",
	"Piemonte, Novara, Romagnano Sesia, H502",
	"Piemonte, Novara, Romentino, H518",
	"Piemonte, Novara, San Maurizio d'Opaglio, I025",
	"Piemonte, Novara, San Nazzaro Sesia, I052",
	"Piemonte, Novara, San Pietro Mosezzo, I116",
	"Piemonte, Novara, Sillavengo, I736",
	"Piemonte, Novara, Sizzano, I767",
	"Piemonte, Novara, Soriso, I857",
	"Piemonte, Novara, Sozzago, I880",
	"Piemonte, Novara, Suno, L007",
	"Piemonte, Novara, Terdobbiate, L104",
	"Piemonte, Novara, Tornaco, L223",
	"Piemonte, Novara, Trecate, L356",
	"Piemonte, Novara, Vaprio d'Agogna, L668",
	"Piemonte, Novara, Varallo Pombia, L670",
	"Piemonte, Novara, Vespolate, L808",
	"Piemonte, Novara, Vicolungo, L847",
	"Piemonte, Novara, Vinzaglio, M062",
	"Piemonte, Novara, Gattico-Veruno, M416",
	"Piemonte, Cuneo, Acceglio, A016",
	"Piemonte, Cuneo, Aisone, A113",
	"Piemonte, Cuneo, Alba, A124",
	"Piemonte, Cuneo, Albaretto della Torre, A139",
	"Piemonte, Cuneo, Alto, A238",
	"Piemonte, Cuneo, Argentera, A394",
	"Piemonte, Cuneo, Arguello, A396",
	"Piemonte, Cuneo, Bagnasco, A555",
	"Piemonte, Cuneo, Bagnolo Piemonte, A571",
	"Piemonte, Cuneo, Baldissero d'Alba, A589",
	"Piemonte, Cuneo, Barbaresco, A629",
	"Piemonte, Cuneo, Barge, A660",
	"Piemonte, Cuneo, Barolo, A671",
	"Piemonte, Cuneo, Bastia Mondovì, A709",
	"Piemonte, Cuneo, Battifollo, A716",
	"Piemonte, Cuneo, Beinette, A735",
	"Piemonte, Cuneo, Bellino, A750",
	"Piemonte, Cuneo, Belvedere Langhe, A774",
	"Piemonte, Cuneo, Bene Vagienna, A779",
	"Piemonte, Cuneo, Benevello, A782",
	"Piemonte, Cuneo, Bergolo, A798",
	"Piemonte, Cuneo, Bernezzo, A805",
	"Piemonte, Cuneo, Bonvicino, A979",
	"Piemonte, Cuneo, Borgomale, B018",
	"Piemonte, Cuneo, Borgo San Dalmazzo, B033",
	"Piemonte, Cuneo, Bosia, B079",
	"Piemonte, Cuneo, Bossolasco, B084",
	"Piemonte, Cuneo, Boves, B101",
	"Piemonte, Cuneo, Bra, B111",
	"Piemonte, Cuneo, Briaglia, B167",
	"Piemonte, Cuneo, Briga Alta, B175",
	"Piemonte, Cuneo, Brondello, B200",
	"Piemonte, Cuneo, Brossasco, B204",
	"Piemonte, Cuneo, Busca, B285",
	"Piemonte, Cuneo, Camerana, B467",
	"Piemonte, Cuneo, Canale, B573",
	"Piemonte, Cuneo, Canosio, B621",
	"Piemonte, Cuneo, Caprauna, B692",
	"Piemonte, Cuneo, Caraglio, B719",
	"Piemonte, Cuneo, Caramagna Piemonte, B720",
	"Piemonte, Cuneo, Cardè, B755",
	"Piemonte, Cuneo, Carrù, B841",
	"Piemonte, Cuneo, Cartignano, B845",
	"Piemonte, Cuneo, Casalgrasso, B894",
	"Piemonte, Cuneo, Castagnito, C046",
	"Piemonte, Cuneo, Casteldelfino, C081",
	"Piemonte, Cuneo, Castelletto Stura, C165",
	"Piemonte, Cuneo, Castelletto Uzzone, C167",
	"Piemonte, Cuneo, Castellinaldo d'Alba, C173",
	"Piemonte, Cuneo, Castellino Tanaro, C176",
	"Piemonte, Cuneo, Castelmagno, C205",
	"Piemonte, Cuneo, Castelnuovo di Ceva, C214",
	"Piemonte, Cuneo, Castiglione Falletto, C314",
	"Piemonte, Cuneo, Castiglione Tinella, C317",
	"Piemonte, Cuneo, Castino, C323",
	"Piemonte, Cuneo, Cavallerleone, C375",
	"Piemonte, Cuneo, Cavallermaggiore, C376",
	"Piemonte, Cuneo, Celle di Macra, C441",
	"Piemonte, Cuneo, Centallo, C466",
	"Piemonte, Cuneo, Ceresole Alba, C504",
	"Piemonte, Cuneo, Cerretto Langhe, C530",
	"Piemonte, Cuneo, Cervasca, C547",
	"Piemonte, Cuneo, Cervere, C550",
	"Piemonte, Cuneo, Ceva, C589",
	"Piemonte, Cuneo, Cherasco, C599",
	"Piemonte, Cuneo, Chiusa di Pesio, C653",
	"Piemonte, Cuneo, Cigliè, C681",
	"Piemonte, Cuneo, Cissone, C738",
	"Piemonte, Cuneo, Clavesana, C792",
	"Piemonte, Cuneo, Corneliano d'Alba, D022",
	"Piemonte, Cuneo, Cortemilia, D062",
	"Piemonte, Cuneo, Cossano Belbo, D093",
	"Piemonte, Cuneo, Costigliole Saluzzo, D120",
	"Piemonte, Cuneo, Cravanzana, D133",
	"Piemonte, Cuneo, Crissolo, D172",
	"Piemonte, Cuneo, Cuneo, D205",
	"Piemonte, Cuneo, Demonte, D271",
	"Piemonte, Cuneo, Diano d'Alba, D291",
	"Piemonte, Cuneo, Dogliani, D314",
	"Piemonte, Cuneo, Dronero, D372",
	"Piemonte, Cuneo, Elva, D401",
	"Piemonte, Cuneo, Entracque, D410",
	"Piemonte, Cuneo, Envie, D412",
	"Piemonte, Cuneo, Farigliano, D499",
	"Piemonte, Cuneo, Faule, D511",
	"Piemonte, Cuneo, Feisoglio, D523",
	"Piemonte, Cuneo, Fossano, D742",
	"Piemonte, Cuneo, Frabosa Soprana, D751",
	"Piemonte, Cuneo, Frabosa Sottana, D752",
	"Piemonte, Cuneo, Frassino, D782",
	"Piemonte, Cuneo, Gaiola, D856",
	"Piemonte, Cuneo, Gambasca, D894",
	"Piemonte, Cuneo, Garessio, D920",
	"Piemonte, Cuneo, Genola, D967",
	"Piemonte, Cuneo, Gorzegno, E111",
	"Piemonte, Cuneo, Gottasecca, E115",
	"Piemonte, Cuneo, Govone, E118",
	"Piemonte, Cuneo, Grinzane Cavour, E182",
	"Piemonte, Cuneo, Guarene, E251",
	"Piemonte, Cuneo, Igliano, E282",
	"Piemonte, Cuneo, Isasca, E327",
	"Piemonte, Cuneo, Lagnasco, E406",
	"Piemonte, Cuneo, La Morra, E430",
	"Piemonte, Cuneo, Lequio Berria, E540",
	"Piemonte, Cuneo, Lequio Tanaro, E539",
	"Piemonte, Cuneo, Lesegno, E546",
	"Piemonte, Cuneo, Levice, E564",
	"Piemonte, Cuneo, Limone Piemonte, E597",
	"Piemonte, Cuneo, Lisio, E615",
	"Piemonte, Cuneo, Macra, E789",
	"Piemonte, Cuneo, Magliano Alfieri, E809",
	"Piemonte, Cuneo, Magliano Alpi, E808",
	"Piemonte, Cuneo, Mango, E887",
	"Piemonte, Cuneo, Manta, E894",
	"Piemonte, Cuneo, Marene, E939",
	"Piemonte, Cuneo, Margarita, E945",
	"Piemonte, Cuneo, Marmora, E963",
	"Piemonte, Cuneo, Marsaglia, E973",
	"Piemonte, Cuneo, Martiniana Po, E988",
	"Piemonte, Cuneo, Melle, F114",
	"Piemonte, Cuneo, Moiola, F279",
	"Piemonte, Cuneo, Mombarcaro, F309",
	"Piemonte, Cuneo, Mombasiglio, F312",
	"Piemonte, Cuneo, Monastero di Vasco, F326",
	"Piemonte, Cuneo, Monasterolo Casotto, F329",
	"Piemonte, Cuneo, Monasterolo di Savigliano, F330",
	"Piemonte, Cuneo, Monchiero, F338",
	"Piemonte, Cuneo, Mondovì, F351",
	"Piemonte, Cuneo, Monesiglio, F355",
	"Piemonte, Cuneo, Monforte d'Alba, F358",
	"Piemonte, Cuneo, Montà, F385",
	"Piemonte, Cuneo, Montaldo di Mondovì, F405",
	"Piemonte, Cuneo, Montaldo Roero, F408",
	"Piemonte, Cuneo, Montanera, F424",
	"Piemonte, Cuneo, Montelupo Albese, F550",
	"Piemonte, Cuneo, Montemale di Cuneo, F558",
	"Piemonte, Cuneo, Monterosso Grana, F608",
	"Piemonte, Cuneo, Monteu Roero, F654",
	"Piemonte, Cuneo, Montezemolo, F666",
	"Piemonte, Cuneo, Monticello d'Alba, F669",
	"Piemonte, Cuneo, Moretta, F723",
	"Piemonte, Cuneo, Morozzo, F743",
	"Piemonte, Cuneo, Murazzano, F809",
	"Piemonte, Cuneo, Murello, F811",
	"Piemonte, Cuneo, Narzole, F846",
	"Piemonte, Cuneo, Neive, F863",
	"Piemonte, Cuneo, Neviglie, F883",
	"Piemonte, Cuneo, Niella Belbo, F894",
	"Piemonte, Cuneo, Niella Tanaro, F895",
	"Piemonte, Cuneo, Novello, F961",
	"Piemonte, Cuneo, Nucetto, F972",
	"Piemonte, Cuneo, Oncino, G066",
	"Piemonte, Cuneo, Ormea, G114",
	"Piemonte, Cuneo, Ostana, G183",
	"Piemonte, Cuneo, Paesana, G228",
	"Piemonte, Cuneo, Pagno, G240",
	"Piemonte, Cuneo, Pamparato, G302",
	"Piemonte, Cuneo, Paroldo, G339",
	"Piemonte, Cuneo, Perletto, G457",
	"Piemonte, Cuneo, Perlo, G458",
	"Piemonte, Cuneo, Peveragno, G526",
	"Piemonte, Cuneo, Pezzolo Valle Uzzone, G532",
	"Piemonte, Cuneo, Pianfei, G561",
	"Piemonte, Cuneo, Piasco, G575",
	"Piemonte, Cuneo, Pietraporzio, G625",
	"Piemonte, Cuneo, Piobesi d'Alba, G683",
	"Piemonte, Cuneo, Piozzo, G697",
	"Piemonte, Cuneo, Pocapaglia, G742",
	"Piemonte, Cuneo, Polonghera, G800",
	"Piemonte, Cuneo, Pontechianale, G837",
	"Piemonte, Cuneo, Pradleves, G970",
	"Piemonte, Cuneo, Prazzo, H011",
	"Piemonte, Cuneo, Priero, H059",
	"Piemonte, Cuneo, Priocca, H068",
	"Piemonte, Cuneo, Priola, H069",
	"Piemonte, Cuneo, Prunetto, H085",
	"Piemonte, Cuneo, Racconigi, H150",
	"Piemonte, Cuneo, Revello, H247",
	"Piemonte, Cuneo, Rifreddo, H285",
	"Piemonte, Cuneo, Rittana, H326",
	"Piemonte, Cuneo, Roaschia, H362",
	"Piemonte, Cuneo, Roascio, H363",
	"Piemonte, Cuneo, Robilante, H377",
	"Piemonte, Cuneo, Roburent, H378",
	"Piemonte, Cuneo, Roccabruna, H385",
	"Piemonte, Cuneo, Rocca Cigliè, H391",
	"Piemonte, Cuneo, Rocca de' Baldi, H395",
	"Piemonte, Cuneo, Roccaforte Mondovì, H407",
	"Piemonte, Cuneo, Roccasparvera, H447",
	"Piemonte, Cuneo, Roccavione, H453",
	"Piemonte, Cuneo, Rocchetta Belbo, H462",
	"Piemonte, Cuneo, Roddi, H472",
	"Piemonte, Cuneo, Roddino, H473",
	"Piemonte, Cuneo, Rodello, H474",
	"Piemonte, Cuneo, Rossana, H578",
	"Piemonte, Cuneo, Ruffia, H633",
	"Piemonte, Cuneo, Sale delle Langhe, H695",
	"Piemonte, Cuneo, Sale San Giovanni, H704",
	"Piemonte, Cuneo, Saliceto, H710",
	"Piemonte, Cuneo, Salmour, H716",
	"Piemonte, Cuneo, Saluzzo, H727",
	"Piemonte, Cuneo, Sambuco, H746",
	"Piemonte, Cuneo, Sampeyre, H755",
	"Piemonte, Cuneo, San Benedetto Belbo, H770",
	"Piemonte, Cuneo, San Damiano Macra, H812",
	"Piemonte, Cuneo, Sanfrè, H851",
	"Piemonte, Cuneo, Sanfront, H852",
	"Piemonte, Cuneo, San Michele Mondovì, I037",
	"Piemonte, Cuneo, Sant'Albano Stura, I210",
	"Piemonte, Cuneo, Santa Vittoria d'Alba, I316",
	"Piemonte, Cuneo, Santo Stefano Belbo, I367",
	"Piemonte, Cuneo, Santo Stefano Roero, I372",
	"Piemonte, Cuneo, Savigliano, I470",
	"Piemonte, Cuneo, Scagnello, I484",
	"Piemonte, Cuneo, Scarnafigi, I512",
	"Piemonte, Cuneo, Serralunga d'Alba, I646",
	"Piemonte, Cuneo, Serravalle Langhe, I659",
	"Piemonte, Cuneo, Sinio, I750",
	"Piemonte, Cuneo, Somano, I817",
	"Piemonte, Cuneo, Sommariva del Bosco, I822",
	"Piemonte, Cuneo, Sommariva Perno, I823",
	"Piemonte, Cuneo, Stroppo, I985",
	"Piemonte, Cuneo, Tarantasca, L048",
	"Piemonte, Cuneo, Torre Bormida, L252",
	"Piemonte, Cuneo, Torre Mondovì, L241",
	"Piemonte, Cuneo, Torre San Giorgio, L278",
	"Piemonte, Cuneo, Torresina, L281",
	"Piemonte, Cuneo, Treiso, L367",
	"Piemonte, Cuneo, Trezzo Tinella, L410",
	"Piemonte, Cuneo, Trinità, L427",
	"Piemonte, Cuneo, Valdieri, L558",
	"Piemonte, Cuneo, Valgrana, L580",
	"Piemonte, Cuneo, Valloriate, L631",
	"Piemonte, Cuneo, Venasca, L729",
	"Piemonte, Cuneo, Verduno, L758",
	"Piemonte, Cuneo, Vernante, L771",
	"Piemonte, Cuneo, Verzuolo, L804",
	"Piemonte, Cuneo, Vezza d'Alba, L817",
	"Piemonte, Cuneo, Vicoforte, L841",
	"Piemonte, Cuneo, Vignolo, L888",
	"Piemonte, Cuneo, Villafalletto, L942",
	"Piemonte, Cuneo, Villanova Mondovì, L974",
	"Piemonte, Cuneo, Villanova Solaro, L990",
	"Piemonte, Cuneo, Villar San Costanzo, M015",
	"Piemonte, Cuneo, Vinadio, M055",
	"Piemonte, Cuneo, Viola, M063",
	"Piemonte, Cuneo, Vottignasco, M136",
	"Piemonte, Asti, Agliano Terme, A072",
	"Piemonte, Asti, Albugnano, A173",
	"Piemonte, Asti, Antignano, A312",
	"Piemonte, Asti, Aramengo, A352",
	"Piemonte, Asti, Asti, A479",
	"Piemonte, Asti, Azzano d'Asti, A527",
	"Piemonte, Asti, Baldichieri d'Asti, A588",
	"Piemonte, Asti, Belveglio, A770",
	"Piemonte, Asti, Berzano di San Pietro, A812",
	"Piemonte, Asti, Bruno, B221",
	"Piemonte, Asti, Bubbio, B236",
	"Piemonte, Asti, Buttigliera d'Asti, B306",
	"Piemonte, Asti, Calamandrana, B376",
	"Piemonte, Asti, Calliano, B418",
	"Piemonte, Asti, Calosso, B425",
	"Piemonte, Asti, Camerano Casasco, B469",
	"Piemonte, Asti, Canelli, B594",
	"Piemonte, Asti, Cantarana, B633",
	"Piemonte, Asti, Capriglio, B707",
	"Piemonte, Asti, Casorzo, B991",
	"Piemonte, Asti, Cassinasco, C022",
	"Piemonte, Asti, Castagnole delle Lanze, C049",
	"Piemonte, Asti, Castagnole Monferrato, C047",
	"Piemonte, Asti, Castel Boglione, C064",
	"Piemonte, Asti, Castell'Alfero, C127",
	"Piemonte, Asti, Castellero, C154",
	"Piemonte, Asti, Castelletto Molina, C161",
	"Piemonte, Asti, Castello di Annone, A300",
	"Piemonte, Asti, Castelnuovo Belbo, C226",
	"Piemonte, Asti, Castelnuovo Calcea, C230",
	"Piemonte, Asti, Castelnuovo Don Bosco, C232",
	"Piemonte, Asti, Castel Rocchero, C253",
	"Piemonte, Asti, Cellarengo, C438",
	"Piemonte, Asti, Celle Enomondo, C440",
	"Piemonte, Asti, Cerreto d'Asti, C528",
	"Piemonte, Asti, Cerro Tanaro, C533",
	"Piemonte, Asti, Cessole, C583",
	"Piemonte, Asti, Chiusano d'Asti, C658",
	"Piemonte, Asti, Cinaglio, C701",
	"Piemonte, Asti, Cisterna d'Asti, C739",
	"Piemonte, Asti, Coazzolo, C804",
	"Piemonte, Asti, Cocconato, C807",
	"Piemonte, Asti, Corsione, D046",
	"Piemonte, Asti, Cortandone, D050",
	"Piemonte, Asti, Cortanze, D051",
	"Piemonte, Asti, Cortazzone, D052",
	"Piemonte, Asti, Cortiglione, D072",
	"Piemonte, Asti, Cossombrato, D101",
	"Piemonte, Asti, Costigliole d'Asti, D119",
	"Piemonte, Asti, Cunico, D207",
	"Piemonte, Asti, Dusino San Michele, D388",
	"Piemonte, Asti, Ferrere, D554",
	"Piemonte, Asti, Fontanile, D678",
	"Piemonte, Asti, Frinco, D802",
	"Piemonte, Asti, Grana, E134",
	"Piemonte, Asti, Grazzano Badoglio, E159",
	"Piemonte, Asti, Incisa Scapaccino, E295",
	"Piemonte, Asti, Isola d'Asti, E338",
	"Piemonte, Asti, Loazzolo, E633",
	"Piemonte, Asti, Maranzana, E917",
	"Piemonte, Asti, Maretto, E944",
	"Piemonte, Asti, Moasca, F254",
	"Piemonte, Asti, Mombaldone, F308",
	"Piemonte, Asti, Mombaruzzo, F311",
	"Piemonte, Asti, Mombercelli, F316",
	"Piemonte, Asti, Monale, F323",
	"Piemonte, Asti, Monastero Bormida, F325",
	"Piemonte, Asti, Moncalvo, F336",
	"Piemonte, Asti, Moncucco Torinese, F343",
	"Piemonte, Asti, Mongardino, F361",
	"Piemonte, Asti, Montabone, F386",
	"Piemonte, Asti, Montafia, F390",
	"Piemonte, Asti, Montaldo Scarampi, F409",
	"Piemonte, Asti, Montechiaro d'Asti, F468",
	"Piemonte, Asti, Montegrosso d'Asti, F527",
	"Piemonte, Asti, Montemagno, F556",
	"Piemonte, Asti, Moransengo, F709",
	"Piemonte, Asti, Nizza Monferrato, F902",
	"Piemonte, Asti, Olmo Gentile, G048",
	"Piemonte, Asti, Passerano Marmorito, G358",
	"Piemonte, Asti, Penango, G430",
	"Piemonte, Asti, Piea, G593",
	"Piemonte, Asti, Pino d'Asti, G676",
	"Piemonte, Asti, Piovà Massaia, G692",
	"Piemonte, Asti, Portacomaro, G894",
	"Piemonte, Asti, Quaranti, H102",
	"Piemonte, Asti, Refrancore, H219",
	"Piemonte, Asti, Revigliasco d'Asti, H250",
	"Piemonte, Asti, Roatto, H366",
	"Piemonte, Asti, Robella, H376",
	"Piemonte, Asti, Rocca d'Arazzo, H392",
	"Piemonte, Asti, Roccaverano, H451",
	"Piemonte, Asti, Rocchetta Palafea, H466",
	"Piemonte, Asti, Rocchetta Tanaro, H468",
	"Piemonte, Asti, San Damiano d'Asti, H811",
	"Piemonte, Asti, San Giorgio Scarampi, H899",
	"Piemonte, Asti, San Martino Alfieri, H987",
	"Piemonte, Asti, San Marzano Oliveto, I017",
	"Piemonte, Asti, San Paolo Solbrito, I076",
	"Piemonte, Asti, Scurzolengo, I555",
	"Piemonte, Asti, Serole, I637",
	"Piemonte, Asti, Sessame, I678",
	"Piemonte, Asti, Settime, I698",
	"Piemonte, Asti, Soglio, I781",
	"Piemonte, Asti, Tigliole, L168",
	"Piemonte, Asti, Tonco, L203",
	"Piemonte, Asti, Tonengo, L204",
	"Piemonte, Asti, Vaglio Serra, L531",
	"Piemonte, Asti, Valfenera, L574",
	"Piemonte, Asti, Vesime, L807",
	"Piemonte, Asti, Viale, L829",
	"Piemonte, Asti, Viarigi, L834",
	"Piemonte, Asti, Vigliano d'Asti, L879",
	"Piemonte, Asti, Villafranca d'Asti, L945",
	"Piemonte, Asti, Villanova d'Asti, L984",
	"Piemonte, Asti, Villa San Secondo, M019",
	"Piemonte, Asti, Vinchio, M058",
	"Piemonte, Asti, Montiglio Monferrato, M302",
	"Piemonte, Alessandria, Acqui Terme, A052",
	"Piemonte, Alessandria, Albera Ligure, A146",
	"Piemonte, Alessandria, Alessandria, A182",
	"Piemonte, Alessandria, Alfiano Natta, A189",
	"Piemonte, Alessandria, Alice Bel Colle, A197",
	"Piemonte, Alessandria, Altavilla Monferrato, A227",
	"Piemonte, Alessandria, Alzano Scrivia, A245",
	"Piemonte, Alessandria, Arquata Scrivia, A436",
	"Piemonte, Alessandria, Avolasca, A523",
	"Piemonte, Alessandria, Balzola, A605",
	"Piemonte, Alessandria, Basaluzzo, A689",
	"Piemonte, Alessandria, Bassignana, A708",
	"Piemonte, Alessandria, Belforte Monferrato, A738",
	"Piemonte, Alessandria, Bergamasco, A793",
	"Piemonte, Alessandria, Berzano di Tortona, A813",
	"Piemonte, Alessandria, Bistagno, A889",
	"Piemonte, Alessandria, Borghetto di Borbera, A998",
	"Piemonte, Alessandria, Borgoratto Alessandrino, B029",
	"Piemonte, Alessandria, Borgo San Martino, B037",
	"Piemonte, Alessandria, Bosco Marengo, B071",
	"Piemonte, Alessandria, Bosio, B080",
	"Piemonte, Alessandria, Bozzole, B109",
	"Piemonte, Alessandria, Brignano-Frascata, B179",
	"Piemonte, Alessandria, Cabella Ligure, B311",
	"Piemonte, Alessandria, Camagna Monferrato, B453",
	"Piemonte, Alessandria, Camino, B482",
	"Piemonte, Alessandria, Cantalupo Ligure, B629",
	"Piemonte, Alessandria, Capriata d'Orba, B701",
	"Piemonte, Alessandria, Carbonara Scrivia, B736",
	"Piemonte, Alessandria, Carentino, B765",
	"Piemonte, Alessandria, Carezzano, B769",
	"Piemonte, Alessandria, Carpeneto, B818",
	"Piemonte, Alessandria, Carrega Ligure, B836",
	"Piemonte, Alessandria, Carrosio, B840",
	"Piemonte, Alessandria, Cartosio, B847",
	"Piemonte, Alessandria, Casal Cermelli, B870",
	"Piemonte, Alessandria, Casaleggio Boiro, B882",
	"Piemonte, Alessandria, Casale Monferrato, B885",
	"Piemonte, Alessandria, Casalnoceto, B902",
	"Piemonte, Alessandria, Casasco, B941",
	"Piemonte, Alessandria, Cassine, C027",
	"Piemonte, Alessandria, Cassinelle, C030",
	"Piemonte, Alessandria, Castellania Coppi, C137",
	"Piemonte, Alessandria, Castellar Guidobono, C142",
	"Piemonte, Alessandria, Castellazzo Bormida, C148",
	"Piemonte, Alessandria, Castelletto d'Erro, C156",
	"Piemonte, Alessandria, Castelletto d'Orba, C158",
	"Piemonte, Alessandria, Castelletto Merli, C160",
	"Piemonte, Alessandria, Castelletto Monferrato, C162",
	"Piemonte, Alessandria, Castelnuovo Bormida, C229",
	"Piemonte, Alessandria, Castelnuovo Scrivia, C243",
	"Piemonte, Alessandria, Castelspina, C274",
	"Piemonte, Alessandria, Cavatore, C387",
	"Piemonte, Alessandria, Cella Monte, C432",
	"Piemonte, Alessandria, Cereseto, C503",
	"Piemonte, Alessandria, Cerreto Grue, C507",
	"Piemonte, Alessandria, Cerrina Monferrato, C531",
	"Piemonte, Alessandria, Coniolo, C962",
	"Piemonte, Alessandria, Conzano, C977",
	"Piemonte, Alessandria, Costa Vescovato, D102",
	"Piemonte, Alessandria, Cremolino, D149",
	"Piemonte, Alessandria, Denice, D272",
	"Piemonte, Alessandria, Dernice, D277",
	"Piemonte, Alessandria, Fabbrica Curone, D447",
	"Piemonte, Alessandria, Felizzano, D528",
	"Piemonte, Alessandria, Fraconalto, D559",
	"Piemonte, Alessandria, Francavilla Bisio, D759",
	"Piemonte, Alessandria, Frascaro, D770",
	"Piemonte, Alessandria, Frassinello Monferrato, D777",
	"Piemonte, Alessandria, Frassineto Po, D780",
	"Piemonte, Alessandria, Fresonara, D797",
	"Piemonte, Alessandria, Frugarolo, D813",
	"Piemonte, Alessandria, Fubine Monferrato, D814",
	"Piemonte, Alessandria, Gabiano, D835",
	"Piemonte, Alessandria, Gamalero, D890",
	"Piemonte, Alessandria, Garbagna, D910",
	"Piemonte, Alessandria, Gavi, D944",
	"Piemonte, Alessandria, Giarole, E015",
	"Piemonte, Alessandria, Gremiasco, E164",
	"Piemonte, Alessandria, Grognardo, E188",
	"Piemonte, Alessandria, Grondona, E191",
	"Piemonte, Alessandria, Guazzora, E255",
	"Piemonte, Alessandria, Isola Sant'Antonio, E360",
	"Piemonte, Alessandria, Lerma, E543",
	"Piemonte, Alessandria, Malvicino, E870",
	"Piemonte, Alessandria, Masio, F015",
	"Piemonte, Alessandria, Melazzo, F096",
	"Piemonte, Alessandria, Merana, F131",
	"Piemonte, Alessandria, Mirabello Monferrato, F232",
	"Piemonte, Alessandria, Molare, F281",
	"Piemonte, Alessandria, Molino dei Torti, F293",
	"Piemonte, Alessandria, Mombello Monferrato, F313",
	"Piemonte, Alessandria, Momperone, F320",
	"Piemonte, Alessandria, Moncestino, F337",
	"Piemonte, Alessandria, Mongiardino Ligure, F365",
	"Piemonte, Alessandria, Monleale, F374",
	"Piemonte, Alessandria, Montacuto, F387",
	"Piemonte, Alessandria, Montaldeo, F403",
	"Piemonte, Alessandria, Montaldo Bormida, F404",
	"Piemonte, Alessandria, Montecastello, F455",
	"Piemonte, Alessandria, Montechiaro d'Acqui, F469",
	"Piemonte, Alessandria, Montegioco, F518",
	"Piemonte, Alessandria, Montemarzino, F562",
	"Piemonte, Alessandria, Morano sul Po, F707",
	"Piemonte, Alessandria, Morbello, F713",
	"Piemonte, Alessandria, Mornese, F737",
	"Piemonte, Alessandria, Morsasco, F751",
	"Piemonte, Alessandria, Murisengo, F814",
	"Piemonte, Alessandria, Novi Ligure, F965",
	"Piemonte, Alessandria, Occimiano, F995",
	"Piemonte, Alessandria, Odalengo Grande, F997",
	"Piemonte, Alessandria, Odalengo Piccolo, F998",
	"Piemonte, Alessandria, Olivola, G042",
	"Piemonte, Alessandria, Orsara Bormida, G124",
	"Piemonte, Alessandria, Ottiglio, G193",
	"Piemonte, Alessandria, Ovada, G197",
	"Piemonte, Alessandria, Oviglio, G199",
	"Piemonte, Alessandria, Ozzano Monferrato, G204",
	"Piemonte, Alessandria, Paderna, G215",
	"Piemonte, Alessandria, Pareto, G334",
	"Piemonte, Alessandria, Parodi Ligure, G338",
	"Piemonte, Alessandria, Pasturana, G367",
	"Piemonte, Alessandria, Pecetto di Valenza, G397",
	"Piemonte, Alessandria, Pietra Marazzi, G619",
	"Piemonte, Alessandria, Pomaro Monferrato, G807",
	"Piemonte, Alessandria, Pontecurone, G839",
	"Piemonte, Alessandria, Pontestura, G858",
	"Piemonte, Alessandria, Ponti, G861",
	"Piemonte, Alessandria, Ponzano Monferrato, G872",
	"Piemonte, Alessandria, Ponzone, G877",
	"Piemonte, Alessandria, Pozzol Groppo, G960",
	"Piemonte, Alessandria, Pozzolo Formigaro, G961",
	"Piemonte, Alessandria, Prasco, G987",
	"Piemonte, Alessandria, Predosa, H021",
	"Piemonte, Alessandria, Quargnento, H104",
	"Piemonte, Alessandria, Quattordio, H121",
	"Piemonte, Alessandria, Ricaldone, H272",
	"Piemonte, Alessandria, Rivalta Bormida, H334",
	"Piemonte, Alessandria, Rivarone, H343",
	"Piemonte, Alessandria, Roccaforte Ligure, H406",
	"Piemonte, Alessandria, Rocca Grimalda, H414",
	"Piemonte, Alessandria, Rocchetta Ligure, H465",
	"Piemonte, Alessandria, Rosignano Monferrato, H569",
	"Piemonte, Alessandria, Sala Monferrato, H677",
	"Piemonte, Alessandria, Sale, H694",
	"Piemonte, Alessandria, San Cristoforo, H810",
	"Piemonte, Alessandria, San Giorgio Monferrato, H878",
	"Piemonte, Alessandria, San Salvatore Monferrato, I144",
	"Piemonte, Alessandria, San Sebastiano Curone, I150",
	"Piemonte, Alessandria, Sant'Agata Fossili, I190",
	"Piemonte, Alessandria, Sardigliano, I429",
	"Piemonte, Alessandria, Sarezzano, I432",
	"Piemonte, Alessandria, Serralunga di Crea, I645",
	"Piemonte, Alessandria, Serravalle Scrivia, I657",
	"Piemonte, Alessandria, Sezzadio, I711",
	"Piemonte, Alessandria, Silvano d'Orba, I738",
	"Piemonte, Alessandria, Solero, I798",
	"Piemonte, Alessandria, Solonghello, I808",
	"Piemonte, Alessandria, Spigno Monferrato, I901",
	"Piemonte, Alessandria, Spineto Scrivia, I911",
	"Piemonte, Alessandria, Stazzano, I941",
	"Piemonte, Alessandria, Strevi, I977",
	"Piemonte, Alessandria, Tagliolo Monferrato, L027",
	"Piemonte, Alessandria, Tassarolo, L059",
	"Piemonte, Alessandria, Terruggia, L139",
	"Piemonte, Alessandria, Terzo, L143",
	"Piemonte, Alessandria, Ticineto, L165",
	"Piemonte, Alessandria, Tortona, L304",
	"Piemonte, Alessandria, Treville, L403",
	"Piemonte, Alessandria, Trisobbio, L432",
	"Piemonte, Alessandria, Valenza, L570",
	"Piemonte, Alessandria, Valmacca, L633",
	"Piemonte, Alessandria, Vignale Monferrato, L881",
	"Piemonte, Alessandria, Vignole Borbera, L887",
	"Piemonte, Alessandria, Viguzzolo, L904",
	"Piemonte, Alessandria, Villadeati, L931",
	"Piemonte, Alessandria, Villalvernia, L963",
	"Piemonte, Alessandria, Villamiroglio, L970",
	"Piemonte, Alessandria, Villanova Monferrato, L972",
	"Piemonte, Alessandria, Villaromagnano, M009",
	"Piemonte, Alessandria, Visone, M077",
	"Piemonte, Alessandria, Volpedo, M120",
	"Piemonte, Alessandria, Volpeglino, M121",
	"Piemonte, Alessandria, Voltaggio, M123",
	"Piemonte, Alessandria, Cassano Spinola, M388",
	"Piemonte, Alessandria, Alluvioni Piovera, M397",
	"Piemonte, Alessandria, Lu e Cuccaro Monferrato, M420",
	"Piemonte, Biella, Ailoche, A107",
	"Piemonte, Biella, Andorno Micca, A280",
	"Piemonte, Biella, Benna, A784",
	"Piemonte, Biella, Biella, A859",
	"Piemonte, Biella, Bioglio, A876",
	"Piemonte, Biella, Borriana, B058",
	"Piemonte, Biella, Brusnengo, B229",
	"Piemonte, Biella, Callabiana, B417",
	"Piemonte, Biella, Camandona, B457",
	"Piemonte, Biella, Camburzano, B465",
	"Piemonte, Biella, Candelo, B586",
	"Piemonte, Biella, Caprile, B708",
	"Piemonte, Biella, Casapinta, B933",
	"Piemonte, Biella, Castelletto Cervo, C155",
	"Piemonte, Biella, Cavaglià, C363",
	"Piemonte, Biella, Cerrione, C532",
	"Piemonte, Biella, Coggiola, C819",
	"Piemonte, Biella, Cossato, D094",
	"Piemonte, Biella, Crevacuore, D165",
	"Piemonte, Biella, Curino, D219",
	"Piemonte, Biella, Donato, D339",
	"Piemonte, Biella, Dorzano, D350",
	"Piemonte, Biella, Gaglianico, D848",
	"Piemonte, Biella, Gifflenga, E024",
	"Piemonte, Biella, Graglia, E130",
	"Piemonte, Biella, Magnano, E821",
	"Piemonte, Biella, Massazza, F037",
	"Piemonte, Biella, Masserano, F042",
	"Piemonte, Biella, Mezzana Mortigliengo, F167",
	"Piemonte, Biella, Miagliano, F189",
	"Piemonte, Biella, Mongrando, F369",
	"Piemonte, Biella, Mottalciata, F776",
	"Piemonte, Biella, Muzzano, F833",
	"Piemonte, Biella, Netro, F878",
	"Piemonte, Biella, Occhieppo Inferiore, F992",
	"Piemonte, Biella, Occhieppo Superiore, F993",
	"Piemonte, Biella, Pettinengo, G521",
	"Piemonte, Biella, Piatto, G577",
	"Piemonte, Biella, Piedicavallo, G594",
	"Piemonte, Biella, Pollone, G798",
	"Piemonte, Biella, Ponderano, G820",
	"Piemonte, Biella, Portula, G927",
	"Piemonte, Biella, Pralungo, G980",
	"Piemonte, Biella, Pray, G974",
	"Piemonte, Biella, Ronco Biellese, H538",
	"Piemonte, Biella, Roppolo, H553",
	"Piemonte, Biella, Rosazza, H561",
	"Piemonte, Biella, Sagliano Micca, H662",
	"Piemonte, Biella, Sala Biellese, H681",
	"Piemonte, Biella, Salussola, H726",
	"Piemonte, Biella, Sandigliano, H821",
	"Piemonte, Biella, Sordevolo, I847",
	"Piemonte, Biella, Sostegno, I868",
	"Piemonte, Biella, Strona, I980",
	"Piemonte, Biella, Tavigliano, L075",
	"Piemonte, Biella, Ternengo, L116",
	"Piemonte, Biella, Tollegno, L193",
	"Piemonte, Biella, Torrazzo, L239",
	"Piemonte, Biella, Valdengo, L556",
	"Piemonte, Biella, Vallanzengo, L586",
	"Piemonte, Biella, Valle San Nicolao, L620",
	"Piemonte, Biella, Veglio, L712",
	"Piemonte, Biella, Verrone, L785",
	"Piemonte, Biella, Vigliano Biellese, L880",
	"Piemonte, Biella, Villa del Bosco, L933",
	"Piemonte, Biella, Villanova Biellese, L978",
	"Piemonte, Biella, Viverone, M098",
	"Piemonte, Biella, Zimone, M179",
	"Piemonte, Biella, Zubiena, M196",
	"Piemonte, Biella, Zumaglia, M201",
	"Piemonte, Biella, Lessona, M371",
	"Piemonte, Biella, Campiglia Cervo, M373",
	"Piemonte, Biella, Quaregna Cerreto, M414",
	"Piemonte, Biella, Valdilana, M417",
	"Piemonte, Verbano-Cusio-Ossola, Antrona Schieranco, A317",
	"Piemonte, Verbano-Cusio-Ossola, Anzola d'Ossola, A325",
	"Piemonte, Verbano-Cusio-Ossola, Arizzano, A409",
	"Piemonte, Verbano-Cusio-Ossola, Arola, A427",
	"Piemonte, Verbano-Cusio-Ossola, Aurano, A497",
	"Piemonte, Verbano-Cusio-Ossola, Baceno, A534",
	"Piemonte, Verbano-Cusio-Ossola, Bannio Anzino, A610",
	"Piemonte, Verbano-Cusio-Ossola, Baveno, A725",
	"Piemonte, Verbano-Cusio-Ossola, Bee, A733",
	"Piemonte, Verbano-Cusio-Ossola, Belgirate, A742",
	"Piemonte, Verbano-Cusio-Ossola, Beura-Cardezza, A834",
	"Piemonte, Verbano-Cusio-Ossola, Bognanco, A925",
	"Piemonte, Verbano-Cusio-Ossola, Brovello-Carpugnino, B207",
	"Piemonte, Verbano-Cusio-Ossola, Calasca-Castiglione, B380",
	"Piemonte, Verbano-Cusio-Ossola, Cambiasca, B463",
	"Piemonte, Verbano-Cusio-Ossola, Cannero Riviera, B610",
	"Piemonte, Verbano-Cusio-Ossola, Cannobio, B615",
	"Piemonte, Verbano-Cusio-Ossola, Caprezzo, B694",
	"Piemonte, Verbano-Cusio-Ossola, Casale Corte Cerro, B876",
	"Piemonte, Verbano-Cusio-Ossola, Ceppo Morelli, C478",
	"Piemonte, Verbano-Cusio-Ossola, Cesara, C567",
	"Piemonte, Verbano-Cusio-Ossola, Cossogno, D099",
	"Piemonte, Verbano-Cusio-Ossola, Craveggia, D134",
	"Piemonte, Verbano-Cusio-Ossola, Crevoladossola, D168",
	"Piemonte, Verbano-Cusio-Ossola, Crodo, D177",
	"Piemonte, Verbano-Cusio-Ossola, Domodossola, D332",
	"Piemonte, Verbano-Cusio-Ossola, Druogno, D374",
	"Piemonte, Verbano-Cusio-Ossola, Formazza, D706",
	"Piemonte, Verbano-Cusio-Ossola, Germagno, D984",
	"Piemonte, Verbano-Cusio-Ossola, Ghiffa, E003",
	"Piemonte, Verbano-Cusio-Ossola, Gignese, E028",
	"Piemonte, Verbano-Cusio-Ossola, Gravellona Toce, E153",
	"Piemonte, Verbano-Cusio-Ossola, Gurro, E269",
	"Piemonte, Verbano-Cusio-Ossola, Intragna, E304",
	"Piemonte, Verbano-Cusio-Ossola, Loreglia, E685",
	"Piemonte, Verbano-Cusio-Ossola, Macugnaga, E790",
	"Piemonte, Verbano-Cusio-Ossola, Madonna del Sasso, E795",
	"Piemonte, Verbano-Cusio-Ossola, Malesco, E853",
	"Piemonte, Verbano-Cusio-Ossola, Masera, F010",
	"Piemonte, Verbano-Cusio-Ossola, Massiola, F048",
	"Piemonte, Verbano-Cusio-Ossola, Mergozzo, F146",
	"Piemonte, Verbano-Cusio-Ossola, Miazzina, F192",
	"Piemonte, Verbano-Cusio-Ossola, Montecrestese, F483",
	"Piemonte, Verbano-Cusio-Ossola, Montescheno, F639",
	"Piemonte, Verbano-Cusio-Ossola, Nonio, F932",
	"Piemonte, Verbano-Cusio-Ossola, Oggebbio, G007",
	"Piemonte, Verbano-Cusio-Ossola, Omegna, G062",
	"Piemonte, Verbano-Cusio-Ossola, Ornavasso, G117",
	"Piemonte, Verbano-Cusio-Ossola, Pallanzeno, G280",
	"Piemonte, Verbano-Cusio-Ossola, Piedimulera, G600",
	"Piemonte, Verbano-Cusio-Ossola, Pieve Vergonte, G658",
	"Piemonte, Verbano-Cusio-Ossola, Premeno, H030",
	"Piemonte, Verbano-Cusio-Ossola, Premia, H033",
	"Piemonte, Verbano-Cusio-Ossola, Premosello-Chiovenda, H037",
	"Piemonte, Verbano-Cusio-Ossola, Quarna Sopra, H106",
	"Piemonte, Verbano-Cusio-Ossola, Quarna Sotto, H107",
	"Piemonte, Verbano-Cusio-Ossola, Re, H203",
	"Piemonte, Verbano-Cusio-Ossola, San Bernardino Verbano, H777",
	"Piemonte, Verbano-Cusio-Ossola, Santa Maria Maggiore, I249",
	"Piemonte, Verbano-Cusio-Ossola, Stresa, I976",
	"Piemonte, Verbano-Cusio-Ossola, Toceno, L187",
	"Piemonte, Verbano-Cusio-Ossola, Trarego Viggiona, L333",
	"Piemonte, Verbano-Cusio-Ossola, Trasquera, L336",
	"Piemonte, Verbano-Cusio-Ossola, Trontano, L450",
	"Piemonte, Verbano-Cusio-Ossola, Valstrona, L651",
	"Piemonte, Verbano-Cusio-Ossola, Vanzone con San Carlo, L666",
	"Piemonte, Verbano-Cusio-Ossola, Varzo, L691",
	"Piemonte, Verbano-Cusio-Ossola, Verbania, L746",
	"Piemonte, Verbano-Cusio-Ossola, Vignone, L889",
	"Piemonte, Verbano-Cusio-Ossola, Villadossola, L906",
	"Piemonte, Verbano-Cusio-Ossola, Villette, M042",
	"Piemonte, Verbano-Cusio-Ossola, Vogogna, M111",
	"Piemonte, Verbano-Cusio-Ossola, Borgomezzavalle, M370",
	"Piemonte, Verbano-Cusio-Ossola, Valle Cannobina, M404",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Allein, A205",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Antey-Saint-André, A305",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Aosta, A326",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Arnad, A424",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Arvier, A452",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Avise, A521",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Ayas, A094",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Aymavilles, A108",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Bard, A643",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Bionaz, A877",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Brissogne, B192",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Brusson, B230",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Challand-Saint-Anselme, C593",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Challand-Saint-Victor, C594",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Chambave, C595",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Chamois, B491",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Champdepraz, C596",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Champorcher, B540",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Charvensod, C598",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Châtillon, C294",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Cogne, C821",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Courmayeur, D012",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Donnas, D338",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Doues, D356",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Emarèse, D402",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Etroubles, D444",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Fénis, D537",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Fontainemore, D666",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Gaby, D839",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Gignod, E029",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Gressan, E165",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Gressoney-La-Trinité, E167",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Gressoney-Saint-Jean, E168",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Hône, E273",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Introd, E306",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Issime, E369",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Issogne, E371",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Jovençan, E391",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, La Magdeleine, A308",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, La Salle, E458",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, La Thuile, E470",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Lillianes, E587",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Montjovet, F367",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Morgex, F726",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Nus, F987",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Ollomont, G045",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Oyace, G012",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Perloz, G459",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Pollein, G794",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Pontboset, G545",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Pontey, G860",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Pont-Saint-Martin, G854",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Pré-Saint-Didier, H042",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Quart, H110",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Rhêmes-Notre-Dame, H262",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Rhêmes-Saint-Georges, H263",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Roisan, H497",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Saint-Christophe, H669",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Saint-Denis, H670",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Saint-Marcel, H671",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Saint-Nicolas, H672",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Saint-Oyen, H673",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Saint-Pierre, H674",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Saint-Rhémy-en-Bosses, H675",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Saint-Vincent, H676",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Sarre, I442",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Torgnon, L217",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Valgrisenche, L582",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Valpelline, L643",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Valsavarenche, L647",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Valtournenche, L654",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Verrayes, L783",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Verrès, C282",
	"Valle d'Aosta/Vallée d'Aoste, Valle d'Aosta/Vallée d'Aoste, Villeneuve, L981",
	"Lombardia, Varese, Agra, A085",
	"Lombardia, Varese, Albizzate, A167",
	"Lombardia, Varese, Angera, A290",
	"Lombardia, Varese, Arcisate, A371",
	"Lombardia, Varese, Arsago Seprio, A441",
	"Lombardia, Varese, Azzate, A531",
	"Lombardia, Varese, Azzio, A532",
	"Lombardia, Varese, Barasso, A619",
	"Lombardia, Varese, Bardello, A645",
	"Lombardia, Varese, Bedero Valcuvia, A728",
	"Lombardia, Varese, Besano, A819",
	"Lombardia, Varese, Besnate, A825",
	"Lombardia, Varese, Besozzo, A826",
	"Lombardia, Varese, Biandronno, A845",
	"Lombardia, Varese, Bisuschio, A891",
	"Lombardia, Varese, Bodio Lomnago, A918",
	"Lombardia, Varese, Brebbia, B126",
	"Lombardia, Varese, Bregano, B131",
	"Lombardia, Varese, Brenta, B150",
	"Lombardia, Varese, Brezzo di Bedero, B166",
	"Lombardia, Varese, Brinzio, B182",
	"Lombardia, Varese, Brissago-Valtravaglia, B191",
	"Lombardia, Varese, Brunello, B219",
	"Lombardia, Varese, Brusimpiano, B228",
	"Lombardia, Varese, Buguggiate, B258",
	"Lombardia, Varese, Busto Arsizio, B300",
	"Lombardia, Varese, Cadegliano-Viconago, B326",
	"Lombardia, Varese, Cairate, B368",
	"Lombardia, Varese, Cantello, B634",
	"Lombardia, Varese, Caravate, B732",
	"Lombardia, Varese, Cardano al Campo, B754",
	"Lombardia, Varese, Carnago, B796",
	"Lombardia, Varese, Caronno Pertusella, B805",
	"Lombardia, Varese, Caronno Varesino, B807",
	"Lombardia, Varese, Casale Litta, B875",
	"Lombardia, Varese, Casalzuigno, B921",
	"Lombardia, Varese, Casciago, B949",
	"Lombardia, Varese, Casorate Sempione, B987",
	"Lombardia, Varese, Cassano Magnago, C004",
	"Lombardia, Varese, Cassano Valcuvia, B999",
	"Lombardia, Varese, Castellanza, C139",
	"Lombardia, Varese, Castello Cabiaglio, B312",
	"Lombardia, Varese, Castelseprio, C273",
	"Lombardia, Varese, Castelveccana, C181",
	"Lombardia, Varese, Castiglione Olona, C300",
	"Lombardia, Varese, Castronno, C343",
	"Lombardia, Varese, Cavaria con Premezzo, C382",
	"Lombardia, Varese, Cazzago Brabbia, C409",
	"Lombardia, Varese, Cislago, C732",
	"Lombardia, Varese, Cittiglio, C751",
	"Lombardia, Varese, Clivio, C796",
	"Lombardia, Varese, Cocquio-Trevisago, C810",
	"Lombardia, Varese, Comabbio, C911",
	"Lombardia, Varese, Comerio, C922",
	"Lombardia, Varese, Cremenaga, D144",
	"Lombardia, Varese, Crosio della Valle, D185",
	"Lombardia, Varese, Cuasso al Monte, D192",
	"Lombardia, Varese, Cugliate-Fabiasco, D199",
	"Lombardia, Varese, Cunardo, D204",
	"Lombardia, Varese, Curiglia con Monteviasco, D217",
	"Lombardia, Varese, Cuveglio, D238",
	"Lombardia, Varese, Cuvio, D239",
	"Lombardia, Varese, Daverio, D256",
	"Lombardia, Varese, Dumenza, D384",
	"Lombardia, Varese, Duno, D385",
	"Lombardia, Varese, Fagnano Olona, D467",
	"Lombardia, Varese, Ferno, D543",
	"Lombardia, Varese, Ferrera di Varese, D551",
	"Lombardia, Varese, Gallarate, D869",
	"Lombardia, Varese, Galliate Lombardo, D871",
	"Lombardia, Varese, Gavirate, D946",
	"Lombardia, Varese, Gazzada Schianno, D951",
	"Lombardia, Varese, Gemonio, D963",
	"Lombardia, Varese, Gerenzano, D981",
	"Lombardia, Varese, Germignaga, D987",
	"Lombardia, Varese, Golasecca, E079",
	"Lombardia, Varese, Gorla Maggiore, E101",
	"Lombardia, Varese, Gorla Minore, E102",
	"Lombardia, Varese, Gornate Olona, E104",
	"Lombardia, Varese, Grantola, E144",
	"Lombardia, Varese, Inarzo, E292",
	"Lombardia, Varese, Induno Olona, E299",
	"Lombardia, Varese, Ispra, E367",
	"Lombardia, Varese, Jerago con Orago, E386",
	"Lombardia, Varese, Lavena Ponte Tresa, E494",
	"Lombardia, Varese, Laveno-Mombello, E496",
	"Lombardia, Varese, Leggiuno, E510",
	"Lombardia, Varese, Lonate Ceppino, E665",
	"Lombardia, Varese, Lonate Pozzolo, E666",
	"Lombardia, Varese, Lozza, E707",
	"Lombardia, Varese, Luino, E734",
	"Lombardia, Varese, Luvinate, E769",
	"Lombardia, Varese, Malgesso, E856",
	"Lombardia, Varese, Malnate, E863",
	"Lombardia, Varese, Marchirolo, E929",
	"Lombardia, Varese, Marnate, E965",
	"Lombardia, Varese, Marzio, F002",
	"Lombardia, Varese, Masciago Primo, F007",
	"Lombardia, Varese, Mercallo, F134",
	"Lombardia, Varese, Mesenzana, F154",
	"Lombardia, Varese, Montegrino Valtravaglia, F526",
	"Lombardia, Varese, Monvalle, F703",
	"Lombardia, Varese, Morazzone, F711",
	"Lombardia, Varese, Mornago, F736",
	"Lombardia, Varese, Oggiona con Santo Stefano, G008",
	"Lombardia, Varese, Olgiate Olona, G028",
	"Lombardia, Varese, Origgio, G103",
	"Lombardia, Varese, Orino, G105",
	"Lombardia, Varese, Porto Ceresio, G906",
	"Lombardia, Varese, Porto Valtravaglia, G907",
	"Lombardia, Varese, Rancio Valcuvia, H173",
	"Lombardia, Varese, Ranco, H174",
	"Lombardia, Varese, Saltrio, H723",
	"Lombardia, Varese, Samarate, H736",
	"Lombardia, Varese, Saronno, I441",
	"Lombardia, Varese, Sesto Calende, I688",
	"Lombardia, Varese, Solbiate Arno, I793",
	"Lombardia, Varese, Solbiate Olona, I794",
	"Lombardia, Varese, Somma Lombardo, I819",
	"Lombardia, Varese, Sumirago, L003",
	"Lombardia, Varese, Taino, L032",
	"Lombardia, Varese, Ternate, L115",
	"Lombardia, Varese, Tradate, L319",
	"Lombardia, Varese, Travedona-Monate, L342",
	"Lombardia, Varese, Tronzano Lago Maggiore, A705",
	"Lombardia, Varese, Uboldo, L480",
	"Lombardia, Varese, Valganna, L577",
	"Lombardia, Varese, Varano Borghi, L671",
	"Lombardia, Varese, Varese, L682",
	"Lombardia, Varese, Vedano Olona, L703",
	"Lombardia, Varese, Venegono Inferiore, L733",
	"Lombardia, Varese, Venegono Superiore, L734",
	"Lombardia, Varese, Vergiate, L765",
	"Lombardia, Varese, Viggiù, L876",
	"Lombardia, Varese, Vizzola Ticino, M101",
	"Lombardia, Varese, Sangiano, H872",
	"Lombardia, Varese, Maccagno con Pino e Veddasca, M339",
	"Lombardia, Varese, Cadrezzate con Osmate, M425",
	"Lombardia, Como, Albavilla, A143",
	"Lombardia, Como, Albese con Cassano, A153",
	"Lombardia, Como, Albiolo, A164",
	"Lombardia, Como, Alserio, A224",
	"Lombardia, Como, Alzate Brianza, A249",
	"Lombardia, Como, Anzano del Parco, A319",
	"Lombardia, Como, Appiano Gentile, A333",
	"Lombardia, Como, Argegno, A391",
	"Lombardia, Como, Arosio, A430",
	"Lombardia, Como, Asso, A476",
	"Lombardia, Como, Barni, A670",
	"Lombardia, Como, Bene Lario, A778",
	"Lombardia, Como, Beregazzo con Figliaro, A791",
	"Lombardia, Como, Binago, A870",
	"Lombardia, Como, Bizzarone, A898",
	"Lombardia, Como, Blessagno, A904",
	"Lombardia, Como, Blevio, A905",
	"Lombardia, Como, Bregnano, B134",
	"Lombardia, Como, Brenna, B144",
	"Lombardia, Como, Brienno, B172",
	"Lombardia, Como, Brunate, B218",
	"Lombardia, Como, Bulgarograsso, B262",
	"Lombardia, Como, Cabiate, B313",
	"Lombardia, Como, Cadorago, B346",
	"Lombardia, Como, Caglio, B355",
	"Lombardia, Como, Campione d'Italia, B513",
	"Lombardia, Como, Cantù, B639",
	"Lombardia, Como, Canzo, B641",
	"Lombardia, Como, Capiago Intimiano, B653",
	"Lombardia, Como, Carate Urio, B730",
	"Lombardia, Como, Carbonate, B742",
	"Lombardia, Como, Carimate, B778",
	"Lombardia, Como, Carlazzo, B785",
	"Lombardia, Como, Carugo, B851",
	"Lombardia, Como, Caslino d'Erba, B974",
	"Lombardia, Como, Casnate con Bernate, B977",
	"Lombardia, Como, Cassina Rizzardi, C020",
	"Lombardia, Como, Castelmarte, C206",
	"Lombardia, Como, Castelnuovo Bozzente, C220",
	"Lombardia, Como, Cavargna, C381",
	"Lombardia, Como, Cerano d'Intelvi, C482",
	"Lombardia, Como, Cermenate, C516",
	"Lombardia, Como, Cernobbio, C520",
	"Lombardia, Como, Cirimido, C724",
	"Lombardia, Como, Claino con Osteno, C787",
	"Lombardia, Como, Colonno, C902",
	"Lombardia, Como, Como, C933",
	"Lombardia, Como, Corrido, D041",
	"Lombardia, Como, Cremia, D147",
	"Lombardia, Como, Cucciago, D196",
	"Lombardia, Como, Cusino, D232",
	"Lombardia, Como, Dizzasco, D310",
	"Lombardia, Como, Domaso, D329",
	"Lombardia, Como, Dongo, D341",
	"Lombardia, Como, Dosso del Liro, D355",
	"Lombardia, Como, Erba, D416",
	"Lombardia, Como, Eupilio, D445",
	"Lombardia, Como, Faggeto Lario, D462",
	"Lombardia, Como, Faloppio, D482",
	"Lombardia, Como, Fenegrò, D531",
	"Lombardia, Como, Figino Serenza, D579",
	"Lombardia, Como, Fino Mornasco, D605",
	"Lombardia, Como, Garzeno, D930",
	"Lombardia, Como, Gera Lario, D974",
	"Lombardia, Como, Grandate, E139",
	"Lombardia, Como, Grandola ed Uniti, E141",
	"Lombardia, Como, Griante, E172",
	"Lombardia, Como, Guanzate, E235",
	"Lombardia, Como, Inverigo, E309",
	"Lombardia, Como, Laglio, E405",
	"Lombardia, Como, Laino, E416",
	"Lombardia, Como, Lambrugo, E428",
	"Lombardia, Como, Lasnigo, E462",
	"Lombardia, Como, Lezzeno, E569",
	"Lombardia, Como, Limido Comasco, E593",
	"Lombardia, Como, Lipomo, E607",
	"Lombardia, Como, Livo, E623",
	"Lombardia, Como, Locate Varesino, E638",
	"Lombardia, Como, Lomazzo, E659",
	"Lombardia, Como, Longone al Segrino, E679",
	"Lombardia, Como, Luisago, E735",
	"Lombardia, Como, Lurago d'Erba, E749",
	"Lombardia, Como, Lurago Marinone, E750",
	"Lombardia, Como, Lurate Caccivio, E753",
	"Lombardia, Como, Magreglio, E830",
	"Lombardia, Como, Mariano Comense, E951",
	"Lombardia, Como, Maslianico, F017",
	"Lombardia, Como, Menaggio, F120",
	"Lombardia, Como, Merone, F151",
	"Lombardia, Como, Moltrasio, F305",
	"Lombardia, Como, Monguzzo, F372",
	"Lombardia, Como, Montano Lucino, F427",
	"Lombardia, Como, Montemezzo, F564",
	"Lombardia, Como, Montorfano, F688",
	"Lombardia, Como, Mozzate, F788",
	"Lombardia, Como, Musso, F828",
	"Lombardia, Como, Nesso, F877",
	"Lombardia, Como, Novedrate, F958",
	"Lombardia, Como, Olgiate Comasco, G025",
	"Lombardia, Como, Oltrona di San Mamette, G056",
	"Lombardia, Como, Orsenigo, G126",
	"Lombardia, Como, Peglio, G415",
	"Lombardia, Como, Pianello del Lario, G556",
	"Lombardia, Como, Pigra, G665",
	"Lombardia, Como, Plesio, G737",
	"Lombardia, Como, Pognana Lario, G773",
	"Lombardia, Como, Ponna, G821",
	"Lombardia, Como, Ponte Lambro, G847",
	"Lombardia, Como, Porlezza, G889",
	"Lombardia, Como, Proserpio, H074",
	"Lombardia, Como, Pusiano, H094",
	"Lombardia, Como, Rezzago, H255",
	"Lombardia, Como, Rodero, H478",
	"Lombardia, Como, Ronago, H521",
	"Lombardia, Como, Rovellasca, H601",
	"Lombardia, Como, Rovello Porro, H602",
	"Lombardia, Como, Sala Comacina, H679",
	"Lombardia, Como, San Bartolomeo Val Cavargna, H760",
	"Lombardia, Como, San Fermo della Battaglia, H840",
	"Lombardia, Como, San Nazzaro Val Cavargna, I051",
	"Lombardia, Como, Schignano, I529",
	"Lombardia, Como, Senna Comasco, I611",
	"Lombardia, Como, Sorico, I856",
	"Lombardia, Como, Sormano, I860",
	"Lombardia, Como, Stazzona, I943",
	"Lombardia, Como, Tavernerio, L071",
	"Lombardia, Como, Torno, L228",
	"Lombardia, Como, Trezzone, L413",
	"Lombardia, Como, Turate, L470",
	"Lombardia, Como, Uggiate-Trevano, L487",
	"Lombardia, Como, Valbrona, L547",
	"Lombardia, Como, Valmorea, L640",
	"Lombardia, Como, Val Rezzo, H259",
	"Lombardia, Como, Valsolda, C936",
	"Lombardia, Como, Veleso, L715",
	"Lombardia, Como, Veniano, L737",
	"Lombardia, Como, Vercana, L748",
	"Lombardia, Como, Vertemate con Minoprio, L792",
	"Lombardia, Como, Villa Guardia, L956",
	"Lombardia, Como, Zelbio, M156",
	"Lombardia, Como, San Siro, I162",
	"Lombardia, Como, Gravedona ed Uniti, M315",
	"Lombardia, Como, Bellagio, M335",
	"Lombardia, Como, Colverde, M336",
	"Lombardia, Como, Tremezzina, M341",
	"Lombardia, Como, Alta Valle Intelvi, M383",
	"Lombardia, Como, Centro Valle Intelvi, M394",
	"Lombardia, Como, Solbiate con Cagno, M412",
	"Lombardia, Sondrio, Albaredo per San Marco, A135",
	"Lombardia, Sondrio, Albosaggia, A172",
	"Lombardia, Sondrio, Andalo Valtellino, A273",
	"Lombardia, Sondrio, Aprica, A337",
	"Lombardia, Sondrio, Ardenno, A382",
	"Lombardia, Sondrio, Bema, A777",
	"Lombardia, Sondrio, Berbenno di Valtellina, A787",
	"Lombardia, Sondrio, Bianzone, A848",
	"Lombardia, Sondrio, Bormio, B049",
	"Lombardia, Sondrio, Buglio in Monte, B255",
	"Lombardia, Sondrio, Caiolo, B366",
	"Lombardia, Sondrio, Campodolcino, B530",
	"Lombardia, Sondrio, Caspoggio, B993",
	"Lombardia, Sondrio, Castello dell'Acqua, C186",
	"Lombardia, Sondrio, Castione Andevenno, C325",
	"Lombardia, Sondrio, Cedrasco, C418",
	"Lombardia, Sondrio, Cercino, C493",
	"Lombardia, Sondrio, Chiavenna, C623",
	"Lombardia, Sondrio, Chiesa in Valmalenco, C628",
	"Lombardia, Sondrio, Chiuro, C651",
	"Lombardia, Sondrio, Cino, C709",
	"Lombardia, Sondrio, Civo, C785",
	"Lombardia, Sondrio, Colorina, C903",
	"Lombardia, Sondrio, Cosio Valtellino, D088",
	"Lombardia, Sondrio, Dazio, D258",
	"Lombardia, Sondrio, Delebio, D266",
	"Lombardia, Sondrio, Dubino, D377",
	"Lombardia, Sondrio, Faedo Valtellino, D456",
	"Lombardia, Sondrio, Forcola, D694",
	"Lombardia, Sondrio, Fusine, D830",
	"Lombardia, Sondrio, Gerola Alta, D990",
	"Lombardia, Sondrio, Gordona, E090",
	"Lombardia, Sondrio, Grosio, E200",
	"Lombardia, Sondrio, Grosotto, E201",
	"Lombardia, Sondrio, Madesimo, E342",
	"Lombardia, Sondrio, Lanzada, E443",
	"Lombardia, Sondrio, Livigno, E621",
	"Lombardia, Sondrio, Lovero, E705",
	"Lombardia, Sondrio, Mantello, E896",
	"Lombardia, Sondrio, Mazzo di Valtellina, F070",
	"Lombardia, Sondrio, Mello, F115",
	"Lombardia, Sondrio, Mese, F153",
	"Lombardia, Sondrio, Montagna in Valtellina, F393",
	"Lombardia, Sondrio, Morbegno, F712",
	"Lombardia, Sondrio, Novate Mezzola, F956",
	"Lombardia, Sondrio, Pedesina, G410",
	"Lombardia, Sondrio, Piantedo, G572",
	"Lombardia, Sondrio, Piateda, G576",
	"Lombardia, Sondrio, Piuro, G718",
	"Lombardia, Sondrio, Poggiridenti, G431",
	"Lombardia, Sondrio, Ponte in Valtellina, G829",
	"Lombardia, Sondrio, Postalesio, G937",
	"Lombardia, Sondrio, Prata Camportaccio, G993",
	"Lombardia, Sondrio, Rasura, H192",
	"Lombardia, Sondrio, Rogolo, H493",
	"Lombardia, Sondrio, Samolaco, H752",
	"Lombardia, Sondrio, San Giacomo Filippo, H868",
	"Lombardia, Sondrio, Sernio, I636",
	"Lombardia, Sondrio, Sondalo, I828",
	"Lombardia, Sondrio, Sondrio, I829",
	"Lombardia, Sondrio, Spriana, I928",
	"Lombardia, Sondrio, Talamona, L035",
	"Lombardia, Sondrio, Tartano, L056",
	"Lombardia, Sondrio, Teglio, L084",
	"Lombardia, Sondrio, Tirano, L175",
	"Lombardia, Sondrio, Torre di Santa Maria, L244",
	"Lombardia, Sondrio, Tovo di Sant'Agata, L316",
	"Lombardia, Sondrio, Traona, L330",
	"Lombardia, Sondrio, Tresivio, L392",
	"Lombardia, Sondrio, Valdidentro, L557",
	"Lombardia, Sondrio, Valdisotto, L563",
	"Lombardia, Sondrio, Valfurva, L576",
	"Lombardia, Sondrio, Val Masino, L638",
	"Lombardia, Sondrio, Verceia, L749",
	"Lombardia, Sondrio, Vervio, L799",
	"Lombardia, Sondrio, Villa di Chiavenna, L907",
	"Lombardia, Sondrio, Villa di Tirano, L908",
	"Lombardia, Milano, Abbiategrasso, A010",
	"Lombardia, Milano, Albairate, A127",
	"Lombardia, Milano, Arconate, A375",
	"Lombardia, Milano, Arese, A389",
	"Lombardia, Milano, Arluno, A413",
	"Lombardia, Milano, Assago, A473",
	"Lombardia, Milano, Bareggio, A652",
	"Lombardia, Milano, Basiano, A697",
	"Lombardia, Milano, Basiglio, A699",
	"Lombardia, Milano, Bellinzago Lombardo, A751",
	"Lombardia, Milano, Bernate Ticino, A804",
	"Lombardia, Milano, Besate, A820",
	"Lombardia, Milano, Binasco, A872",
	"Lombardia, Milano, Boffalora sopra Ticino, A920",
	"Lombardia, Milano, Bollate, A940",
	"Lombardia, Milano, Bresso, B162",
	"Lombardia, Milano, Bubbiano, B235",
	"Lombardia, Milano, Buccinasco, B240",
	"Lombardia, Milano, Buscate, B286",
	"Lombardia, Milano, Bussero, B292",
	"Lombardia, Milano, Busto Garolfo, B301",
	"Lombardia, Milano, Calvignasco, B448",
	"Lombardia, Milano, Cambiago, B461",
	"Lombardia, Milano, Canegrate, B593",
	"Lombardia, Milano, Carpiano, B820",
	"Lombardia, Milano, Carugate, B850",
	"Lombardia, Milano, Casarile, B938",
	"Lombardia, Milano, Casorezzo, B989",
	"Lombardia, Milano, Cassano d'Adda, C003",
	"Lombardia, Milano, Cassina de' Pecchi, C014",
	"Lombardia, Milano, Cassinetta di Lugagnano, C033",
	"Lombardia, Milano, Castano Primo, C052",
	"Lombardia, Milano, Cernusco sul Naviglio, C523",
	"Lombardia, Milano, Cerro al Lambro, C536",
	"Lombardia, Milano, Cerro Maggiore, C537",
	"Lombardia, Milano, Cesano Boscone, C565",
	"Lombardia, Milano, Cesate, C569",
	"Lombardia, Milano, Cinisello Balsamo, C707",
	"Lombardia, Milano, Cisliano, C733",
	"Lombardia, Milano, Cologno Monzese, C895",
	"Lombardia, Milano, Colturano, C908",
	"Lombardia, Milano, Corbetta, C986",
	"Lombardia, Milano, Cormano, D013",
	"Lombardia, Milano, Cornaredo, D018",
	"Lombardia, Milano, Corsico, D045",
	"Lombardia, Milano, Cuggiono, D198",
	"Lombardia, Milano, Cusago, D229",
	"Lombardia, Milano, Cusano Milanino, D231",
	"Lombardia, Milano, Dairago, D244",
	"Lombardia, Milano, Dresano, D367",
	"Lombardia, Milano, Gaggiano, D845",
	"Lombardia, Milano, Garbagnate Milanese, D912",
	"Lombardia, Milano, Gessate, D995",
	"Lombardia, Milano, Gorgonzola, E094",
	"Lombardia, Milano, Grezzago, E170",
	"Lombardia, Milano, Gudo Visconti, E258",
	"Lombardia, Milano, Inveruno, E313",
	"Lombardia, Milano, Inzago, E317",
	"Lombardia, Milano, Lacchiarella, E395",
	"Lombardia, Milano, Lainate, E415",
	"Lombardia, Milano, Legnano, E514",
	"Lombardia, Milano, Liscate, E610",
	"Lombardia, Milano, Locate di Triulzi, E639",
	"Lombardia, Milano, Magenta, E801",
	"Lombardia, Milano, Magnago, E819",
	"Lombardia, Milano, Marcallo con Casone, E921",
	"Lombardia, Milano, Masate, F003",
	"Lombardia, Milano, Mediglia, F084",
	"Lombardia, Milano, Melegnano, F100",
	"Lombardia, Milano, Melzo, F119",
	"Lombardia, Milano, Mesero, F155",
	"Lombardia, Milano, Milano, F205",
	"Lombardia, Milano, Morimondo, D033",
	"Lombardia, Milano, Motta Visconti, F783",
	"Lombardia, Milano, Nerviano, F874",
	"Lombardia, Milano, Nosate, F939",
	"Lombardia, Milano, Novate Milanese, F955",
	"Lombardia, Milano, Noviglio, F968",
	"Lombardia, Milano, Opera, G078",
	"Lombardia, Milano, Ossona, G181",
	"Lombardia, Milano, Ozzero, G206",
	"Lombardia, Milano, Paderno Dugnano, G220",
	"Lombardia, Milano, Pantigliate, G316",
	"Lombardia, Milano, Parabiago, G324",
	"Lombardia, Milano, Paullo, G385",
	"Lombardia, Milano, Pero, C013",
	"Lombardia, Milano, Peschiera Borromeo, G488",
	"Lombardia, Milano, Pessano con Bornago, G502",
	"Lombardia, Milano, Pieve Emanuele, G634",
	"Lombardia, Milano, Pioltello, G686",
	"Lombardia, Milano, Pogliano Milanese, G772",
	"Lombardia, Milano, Pozzo d'Adda, G955",
	"Lombardia, Milano, Pozzuolo Martesana, G965",
	"Lombardia, Milano, Pregnana Milanese, H026",
	"Lombardia, Milano, Rescaldina, H240",
	"Lombardia, Milano, Rho, H264",
	"Lombardia, Milano, Robecchetto con Induno, H371",
	"Lombardia, Milano, Robecco sul Naviglio, H373",
	"Lombardia, Milano, Rodano, H470",
	"Lombardia, Milano, Rosate, H560",
	"Lombardia, Milano, Rozzano, H623",
	"Lombardia, Milano, San Colombano al Lambro, H803",
	"Lombardia, Milano, San Donato Milanese, H827",
	"Lombardia, Milano, San Giorgio su Legnano, H884",
	"Lombardia, Milano, San Giuliano Milanese, H930",
	"Lombardia, Milano, Santo Stefano Ticino, I361",
	"Lombardia, Milano, San Vittore Olona, I409",
	"Lombardia, Milano, San Zenone al Lambro, I415",
	"Lombardia, Milano, Sedriano, I566",
	"Lombardia, Milano, Segrate, I577",
	"Lombardia, Milano, Senago, I602",
	"Lombardia, Milano, Sesto San Giovanni, I690",
	"Lombardia, Milano, Settala, I696",
	"Lombardia, Milano, Settimo Milanese, I700",
	"Lombardia, Milano, Solaro, I786",
	"Lombardia, Milano, Trezzano Rosa, L408",
	"Lombardia, Milano, Trezzano sul Naviglio, L409",
	"Lombardia, Milano, Trezzo sull'Adda, L411",
	"Lombardia, Milano, Tribiano, L415",
	"Lombardia, Milano, Truccazzano, L454",
	"Lombardia, Milano, Turbigo, L471",
	"Lombardia, Milano, Vanzago, L665",
	"Lombardia, Milano, Vaprio d'Adda, L667",
	"Lombardia, Milano, Vernate, L773",
	"Lombardia, Milano, Vignate, L883",
	"Lombardia, Milano, Vimodrone, M053",
	"Lombardia, Milano, Vittuone, M091",
	"Lombardia, Milano, Vizzolo Predabissi, M102",
	"Lombardia, Milano, Zibido San Giacomo, M176",
	"Lombardia, Milano, Villa Cortese, L928",
	"Lombardia, Milano, Vanzaghello, L664",
	"Lombardia, Milano, Baranzate, A618",
	"Lombardia, Milano, Vermezzo con Zelo, M424",
	"Lombardia, Bergamo, Adrara San Martino, A057",
	"Lombardia, Bergamo, Adrara San Rocco, A058",
	"Lombardia, Bergamo, Albano Sant'Alessandro, A129",
	"Lombardia, Bergamo, Albino, A163",
	"Lombardia, Bergamo, Almè, A214",
	"Lombardia, Bergamo, Almenno San Bartolomeo, A216",
	"Lombardia, Bergamo, Almenno San Salvatore, A217",
	"Lombardia, Bergamo, Alzano Lombardo, A246",
	"Lombardia, Bergamo, Ambivere, A259",
	"Lombardia, Bergamo, Antegnate, A304",
	"Lombardia, Bergamo, Arcene, A365",
	"Lombardia, Bergamo, Ardesio, A383",
	"Lombardia, Bergamo, Arzago d'Adda, A440",
	"Lombardia, Bergamo, Averara, A511",
	"Lombardia, Bergamo, Aviatico, A517",
	"Lombardia, Bergamo, Azzano San Paolo, A528",
	"Lombardia, Bergamo, Azzone, A533",
	"Lombardia, Bergamo, Bagnatica, A557",
	"Lombardia, Bergamo, Barbata, A631",
	"Lombardia, Bergamo, Bariano, A664",
	"Lombardia, Bergamo, Barzana, A684",
	"Lombardia, Bergamo, Bedulita, A732",
	"Lombardia, Bergamo, Berbenno, A786",
	"Lombardia, Bergamo, Bergamo, A794",
	"Lombardia, Bergamo, Berzo San Fermo, A815",
	"Lombardia, Bergamo, Bianzano, A846",
	"Lombardia, Bergamo, Blello, A903",
	"Lombardia, Bergamo, Bolgare, A937",
	"Lombardia, Bergamo, Boltiere, A950",
	"Lombardia, Bergamo, Bonate Sopra, A963",
	"Lombardia, Bergamo, Bonate Sotto, A962",
	"Lombardia, Bergamo, Borgo di Terzo, B010",
	"Lombardia, Bergamo, Bossico, B083",
	"Lombardia, Bergamo, Bottanuco, B088",
	"Lombardia, Bergamo, Bracca, B112",
	"Lombardia, Bergamo, Branzi, B123",
	"Lombardia, Bergamo, Brembate, B137",
	"Lombardia, Bergamo, Brembate di Sopra, B138",
	"Lombardia, Bergamo, Brignano Gera d'Adda, B178",
	"Lombardia, Bergamo, Brumano, B217",
	"Lombardia, Bergamo, Brusaporto, B223",
	"Lombardia, Bergamo, Calcinate, B393",
	"Lombardia, Bergamo, Calcio, B395",
	"Lombardia, Bergamo, Calusco d'Adda, B434",
	"Lombardia, Bergamo, Calvenzano, B442",
	"Lombardia, Bergamo, Camerata Cornello, B471",
	"Lombardia, Bergamo, Canonica d'Adda, B618",
	"Lombardia, Bergamo, Capizzone, B661",
	"Lombardia, Bergamo, Capriate San Gervasio, B703",
	"Lombardia, Bergamo, Caprino Bergamasco, B710",
	"Lombardia, Bergamo, Caravaggio, B731",
	"Lombardia, Bergamo, Carobbio degli Angeli, B801",
	"Lombardia, Bergamo, Carona, B803",
	"Lombardia, Bergamo, Carvico, B854",
	"Lombardia, Bergamo, Casazza, B947",
	"Lombardia, Bergamo, Casirate d'Adda, B971",
	"Lombardia, Bergamo, Casnigo, B978",
	"Lombardia, Bergamo, Cassiglio, C007",
	"Lombardia, Bergamo, Castelli Calepio, C079",
	"Lombardia, Bergamo, Castel Rozzone, C255",
	"Lombardia, Bergamo, Castione della Presolana, C324",
	"Lombardia, Bergamo, Castro, C337",
	"Lombardia, Bergamo, Cavernago, C396",
	"Lombardia, Bergamo, Cazzano Sant'Andrea, C410",
	"Lombardia, Bergamo, Cenate Sopra, C456",
	"Lombardia, Bergamo, Cenate Sotto, C457",
	"Lombardia, Bergamo, Cene, C459",
	"Lombardia, Bergamo, Cerete, C506",
	"Lombardia, Bergamo, Chignolo d'Isola, C635",
	"Lombardia, Bergamo, Chiuduno, C649",
	"Lombardia, Bergamo, Cisano Bergamasco, C728",
	"Lombardia, Bergamo, Ciserano, C730",
	"Lombardia, Bergamo, Cividate al Piano, C759",
	"Lombardia, Bergamo, Clusone, C800",
	"Lombardia, Bergamo, Colere, C835",
	"Lombardia, Bergamo, Cologno al Serio, C894",
	"Lombardia, Bergamo, Colzate, C910",
	"Lombardia, Bergamo, Comun Nuovo, C937",
	"Lombardia, Bergamo, Corna Imagna, D015",
	"Lombardia, Bergamo, Cortenuova, D066",
	"Lombardia, Bergamo, Costa di Mezzate, D110",
	"Lombardia, Bergamo, Costa Valle Imagna, D103",
	"Lombardia, Bergamo, Costa Volpino, D117",
	"Lombardia, Bergamo, Covo, D126",
	"Lombardia, Bergamo, Credaro, D139",
	"Lombardia, Bergamo, Curno, D221",
	"Lombardia, Bergamo, Cusio, D233",
	"Lombardia, Bergamo, Dalmine, D245",
	"Lombardia, Bergamo, Dossena, D352",
	"Lombardia, Bergamo, Endine Gaiano, D406",
	"Lombardia, Bergamo, Entratico, D411",
	"Lombardia, Bergamo, Fara Gera d'Adda, D490",
	"Lombardia, Bergamo, Fara Olivana con Sola, D491",
	"Lombardia, Bergamo, Filago, D588",
	"Lombardia, Bergamo, Fino del Monte, D604",
	"Lombardia, Bergamo, Fiorano al Serio, D606",
	"Lombardia, Bergamo, Fontanella, D672",
	"Lombardia, Bergamo, Fonteno, D684",
	"Lombardia, Bergamo, Foppolo, D688",
	"Lombardia, Bergamo, Foresto Sparso, D697",
	"Lombardia, Bergamo, Fornovo San Giovanni, D727",
	"Lombardia, Bergamo, Fuipiano Valle Imagna, D817",
	"Lombardia, Bergamo, Gandellino, D903",
	"Lombardia, Bergamo, Gandino, D905",
	"Lombardia, Bergamo, Gandosso, D906",
	"Lombardia, Bergamo, Gaverina Terme, D943",
	"Lombardia, Bergamo, Gazzaniga, D952",
	"Lombardia, Bergamo, Ghisalba, E006",
	"Lombardia, Bergamo, Gorlago, E100",
	"Lombardia, Bergamo, Gorle, E103",
	"Lombardia, Bergamo, Gorno, E106",
	"Lombardia, Bergamo, Grassobbio, E148",
	"Lombardia, Bergamo, Gromo, E189",
	"Lombardia, Bergamo, Grone, E192",
	"Lombardia, Bergamo, Grumello del Monte, E219",
	"Lombardia, Bergamo, Isola di Fondra, E353",
	"Lombardia, Bergamo, Isso, E370",
	"Lombardia, Bergamo, Lallio, E422",
	"Lombardia, Bergamo, Leffe, E509",
	"Lombardia, Bergamo, Lenna, E524",
	"Lombardia, Bergamo, Levate, E562",
	"Lombardia, Bergamo, Locatello, E640",
	"Lombardia, Bergamo, Lovere, E704",
	"Lombardia, Bergamo, Lurano, E751",
	"Lombardia, Bergamo, Luzzana, E770",
	"Lombardia, Bergamo, Madone, E794",
	"Lombardia, Bergamo, Mapello, E901",
	"Lombardia, Bergamo, Martinengo, E987",
	"Lombardia, Bergamo, Mezzoldo, F186",
	"Lombardia, Bergamo, Misano di Gera d'Adda, F243",
	"Lombardia, Bergamo, Moio de' Calvi, F276",
	"Lombardia, Bergamo, Monasterolo del Castello, F328",
	"Lombardia, Bergamo, Montello, F547",
	"Lombardia, Bergamo, Morengo, F720",
	"Lombardia, Bergamo, Mornico al Serio, F738",
	"Lombardia, Bergamo, Mozzanica, F786",
	"Lombardia, Bergamo, Mozzo, F791",
	"Lombardia, Bergamo, Nembro, F864",
	"Lombardia, Bergamo, Olmo al Brembo, G049",
	"Lombardia, Bergamo, Oltre il Colle, G050",
	"Lombardia, Bergamo, Oltressenda Alta, G054",
	"Lombardia, Bergamo, Oneta, G068",
	"Lombardia, Bergamo, Onore, G075",
	"Lombardia, Bergamo, Orio al Serio, G108",
	"Lombardia, Bergamo, Ornica, G118",
	"Lombardia, Bergamo, Osio Sopra, G159",
	"Lombardia, Bergamo, Osio Sotto, G160",
	"Lombardia, Bergamo, Pagazzano, G233",
	"Lombardia, Bergamo, Paladina, G249",
	"Lombardia, Bergamo, Palazzago, G259",
	"Lombardia, Bergamo, Palosco, G295",
	"Lombardia, Bergamo, Parre, G346",
	"Lombardia, Bergamo, Parzanica, G350",
	"Lombardia, Bergamo, Pedrengo, G412",
	"Lombardia, Bergamo, Peia, G418",
	"Lombardia, Bergamo, Pianico, G564",
	"Lombardia, Bergamo, Piario, G574",
	"Lombardia, Bergamo, Piazza Brembana, G579",
	"Lombardia, Bergamo, Piazzatorre, G583",
	"Lombardia, Bergamo, Piazzolo, G588",
	"Lombardia, Bergamo, Pognano, G774",
	"Lombardia, Bergamo, Ponte Nossa, F941",
	"Lombardia, Bergamo, Ponteranica, G853",
	"Lombardia, Bergamo, Ponte San Pietro, G856",
	"Lombardia, Bergamo, Pontida, G864",
	"Lombardia, Bergamo, Pontirolo Nuovo, G867",
	"Lombardia, Bergamo, Pradalunga, G968",
	"Lombardia, Bergamo, Predore, H020",
	"Lombardia, Bergamo, Premolo, H036",
	"Lombardia, Bergamo, Presezzo, H046",
	"Lombardia, Bergamo, Pumenengo, H091",
	"Lombardia, Bergamo, Ranica, H176",
	"Lombardia, Bergamo, Ranzanico, H177",
	"Lombardia, Bergamo, Riva di Solto, H331",
	"Lombardia, Bergamo, Rogno, H492",
	"Lombardia, Bergamo, Romano di Lombardia, H509",
	"Lombardia, Bergamo, Roncobello, H535",
	"Lombardia, Bergamo, Roncola, H544",
	"Lombardia, Bergamo, Rota d'Imagna, H584",
	"Lombardia, Bergamo, Rovetta, H615",
	"Lombardia, Bergamo, San Giovanni Bianco, H910",
	"Lombardia, Bergamo, San Paolo d'Argon, B310",
	"Lombardia, Bergamo, San Pellegrino Terme, I079",
	"Lombardia, Bergamo, Santa Brigida, I168",
	"Lombardia, Bergamo, Sarnico, I437",
	"Lombardia, Bergamo, Scanzorosciate, I506",
	"Lombardia, Bergamo, Schilpario, I530",
	"Lombardia, Bergamo, Sedrina, I567",
	"Lombardia, Bergamo, Selvino, I597",
	"Lombardia, Bergamo, Seriate, I628",
	"Lombardia, Bergamo, Serina, I629",
	"Lombardia, Bergamo, Solto Collina, I812",
	"Lombardia, Bergamo, Songavazzo, I830",
	"Lombardia, Bergamo, Sorisole, I858",
	"Lombardia, Bergamo, Sotto il Monte Giovanni XXIII, I869",
	"Lombardia, Bergamo, Sovere, I873",
	"Lombardia, Bergamo, Spinone al Lago, I916",
	"Lombardia, Bergamo, Spirano, I919",
	"Lombardia, Bergamo, Stezzano, I951",
	"Lombardia, Bergamo, Strozza, I986",
	"Lombardia, Bergamo, Suisio, I997",
	"Lombardia, Bergamo, Taleggio, L037",
	"Lombardia, Bergamo, Tavernola Bergamasca, L073",
	"Lombardia, Bergamo, Telgate, L087",
	"Lombardia, Bergamo, Terno d'Isola, L118",
	"Lombardia, Bergamo, Torre Boldone, L251",
	"Lombardia, Bergamo, Torre de' Busi, L257",
	"Lombardia, Bergamo, Torre de' Roveri, L265",
	"Lombardia, Bergamo, Torre Pallavicina, L276",
	"Lombardia, Bergamo, Trescore Balneario, L388",
	"Lombardia, Bergamo, Treviglio, L400",
	"Lombardia, Bergamo, Treviolo, L404",
	"Lombardia, Bergamo, Ubiale Clanezzo, C789",
	"Lombardia, Bergamo, Urgnano, L502",
	"Lombardia, Bergamo, Valbondione, L544",
	"Lombardia, Bergamo, Valbrembo, L545",
	"Lombardia, Bergamo, Valgoglio, L579",
	"Lombardia, Bergamo, Valleve, L623",
	"Lombardia, Bergamo, Valnegra, L642",
	"Lombardia, Bergamo, Valtorta, L655",
	"Lombardia, Bergamo, Vedeseta, L707",
	"Lombardia, Bergamo, Verdellino, L752",
	"Lombardia, Bergamo, Verdello, L753",
	"Lombardia, Bergamo, Vertova, L795",
	"Lombardia, Bergamo, Viadanica, L827",
	"Lombardia, Bergamo, Vigano San Martino, L865",
	"Lombardia, Bergamo, Vigolo, L894",
	"Lombardia, Bergamo, Villa d'Adda, L929",
	"Lombardia, Bergamo, Villa d'Almè, A215",
	"Lombardia, Bergamo, Villa di Serio, L936",
	"Lombardia, Bergamo, Villa d'Ogna, L938",
	"Lombardia, Bergamo, Villongo, M045",
	"Lombardia, Bergamo, Vilminore di Scalve, M050",
	"Lombardia, Bergamo, Zandobbio, M144",
	"Lombardia, Bergamo, Zanica, M147",
	"Lombardia, Bergamo, Zogno, M184",
	"Lombardia, Bergamo, Costa Serina, D111",
	"Lombardia, Bergamo, Algua, A193",
	"Lombardia, Bergamo, Cornalba, D016",
	"Lombardia, Bergamo, Medolago, F085",
	"Lombardia, Bergamo, Solza, I813",
	"Lombardia, Bergamo, Sant'Omobono Terme, M333",
	"Lombardia, Bergamo, Val Brembilla, M334",
	"Lombardia, Brescia, Acquafredda, A034",
	"Lombardia, Brescia, Adro, A060",
	"Lombardia, Brescia, Agnosine, A082",
	"Lombardia, Brescia, Alfianello, A188",
	"Lombardia, Brescia, Anfo, A288",
	"Lombardia, Brescia, Angolo Terme, A293",
	"Lombardia, Brescia, Artogne, A451",
	"Lombardia, Brescia, Azzano Mella, A529",
	"Lombardia, Brescia, Bagnolo Mella, A569",
	"Lombardia, Brescia, Bagolino, A578",
	"Lombardia, Brescia, Barbariga, A630",
	"Lombardia, Brescia, Barghe, A661",
	"Lombardia, Brescia, Bassano Bresciano, A702",
	"Lombardia, Brescia, Bedizzole, A729",
	"Lombardia, Brescia, Berlingo, A799",
	"Lombardia, Brescia, Berzo Demo, A816",
	"Lombardia, Brescia, Berzo Inferiore, A817",
	"Lombardia, Brescia, Bienno, A861",
	"Lombardia, Brescia, Bione, A878",
	"Lombardia, Brescia, Borgo San Giacomo, B035",
	"Lombardia, Brescia, Borgosatollo, B040",
	"Lombardia, Brescia, Borno, B054",
	"Lombardia, Brescia, Botticino, B091",
	"Lombardia, Brescia, Bovegno, B100",
	"Lombardia, Brescia, Bovezzo, B102",
	"Lombardia, Brescia, Brandico, B120",
	"Lombardia, Brescia, Braone, B124",
	"Lombardia, Brescia, Breno, B149",
	"Lombardia, Brescia, Brescia, B157",
	"Lombardia, Brescia, Brione, B184",
	"Lombardia, Brescia, Caino, B365",
	"Lombardia, Brescia, Calcinato, B394",
	"Lombardia, Brescia, Calvagese della Riviera, B436",
	"Lombardia, Brescia, Calvisano, B450",
	"Lombardia, Brescia, Capo di Ponte, B664",
	"Lombardia, Brescia, Capovalle, B676",
	"Lombardia, Brescia, Capriano del Colle, B698",
	"Lombardia, Brescia, Capriolo, B711",
	"Lombardia, Brescia, Carpenedolo, B817",
	"Lombardia, Brescia, Castegnato, C055",
	"Lombardia, Brescia, Castelcovati, C072",
	"Lombardia, Brescia, Castel Mella, C208",
	"Lombardia, Brescia, Castenedolo, C293",
	"Lombardia, Brescia, Casto, C330",
	"Lombardia, Brescia, Castrezzato, C332",
	"Lombardia, Brescia, Cazzago San Martino, C408",
	"Lombardia, Brescia, Cedegolo, C417",
	"Lombardia, Brescia, Cellatica, C439",
	"Lombardia, Brescia, Cerveno, C549",
	"Lombardia, Brescia, Ceto, C585",
	"Lombardia, Brescia, Cevo, C591",
	"Lombardia, Brescia, Chiari, C618",
	"Lombardia, Brescia, Cigole, C685",
	"Lombardia, Brescia, Cimbergo, C691",
	"Lombardia, Brescia, Cividate Camuno, C760",
	"Lombardia, Brescia, Coccaglio, C806",
	"Lombardia, Brescia, Collebeato, C850",
	"Lombardia, Brescia, Collio, C883",
	"Lombardia, Brescia, Cologne, C893",
	"Lombardia, Brescia, Comezzano-Cizzago, C925",
	"Lombardia, Brescia, Concesio, C948",
	"Lombardia, Brescia, Corte Franca, D058",
	"Lombardia, Brescia, Corteno Golgi, D064",
	"Lombardia, Brescia, Corzano, D082",
	"Lombardia, Brescia, Darfo Boario Terme, D251",
	"Lombardia, Brescia, Dello, D270",
	"Lombardia, Brescia, Desenzano del Garda, D284",
	"Lombardia, Brescia, Edolo, D391",
	"Lombardia, Brescia, Erbusco, D421",
	"Lombardia, Brescia, Esine, D434",
	"Lombardia, Brescia, Fiesse, D576",
	"Lombardia, Brescia, Flero, D634",
	"Lombardia, Brescia, Gambara, D891",
	"Lombardia, Brescia, Gardone Riviera, D917",
	"Lombardia, Brescia, Gardone Val Trompia, D918",
	"Lombardia, Brescia, Gargnano, D924",
	"Lombardia, Brescia, Gavardo, D940",
	"Lombardia, Brescia, Ghedi, D999",
	"Lombardia, Brescia, Gianico, E010",
	"Lombardia, Brescia, Gottolengo, E116",
	"Lombardia, Brescia, Gussago, E271",
	"Lombardia, Brescia, Idro, E280",
	"Lombardia, Brescia, Incudine, E297",
	"Lombardia, Brescia, Irma, E325",
	"Lombardia, Brescia, Iseo, E333",
	"Lombardia, Brescia, Isorella, E364",
	"Lombardia, Brescia, Lavenone, E497",
	"Lombardia, Brescia, Leno, E526",
	"Lombardia, Brescia, Limone sul Garda, E596",
	"Lombardia, Brescia, Lodrino, E652",
	"Lombardia, Brescia, Lograto, E654",
	"Lombardia, Brescia, Lonato del Garda, M312",
	"Lombardia, Brescia, Longhena, E673",
	"Lombardia, Brescia, Losine, E698",
	"Lombardia, Brescia, Lozio, E706",
	"Lombardia, Brescia, Lumezzane, E738",
	"Lombardia, Brescia, Maclodio, E787",
	"Lombardia, Brescia, Magasa, E800",
	"Lombardia, Brescia, Mairano, E841",
	"Lombardia, Brescia, Malegno, E851",
	"Lombardia, Brescia, Malonno, E865",
	"Lombardia, Brescia, Manerba del Garda, E883",
	"Lombardia, Brescia, Manerbio, E884",
	"Lombardia, Brescia, Marcheno, E928",
	"Lombardia, Brescia, Marmentino, E961",
	"Lombardia, Brescia, Marone, E967",
	"Lombardia, Brescia, Mazzano, F063",
	"Lombardia, Brescia, Milzano, F216",
	"Lombardia, Brescia, Moniga del Garda, F373",
	"Lombardia, Brescia, Monno, F375",
	"Lombardia, Brescia, Monte Isola, F532",
	"Lombardia, Brescia, Monticelli Brusati, F672",
	"Lombardia, Brescia, Montichiari, F471",
	"Lombardia, Brescia, Montirone, F680",
	"Lombardia, Brescia, Mura, F806",
	"Lombardia, Brescia, Muscoline, F820",
	"Lombardia, Brescia, Nave, F851",
	"Lombardia, Brescia, Niardo, F884",
	"Lombardia, Brescia, Nuvolento, F989",
	"Lombardia, Brescia, Nuvolera, F990",
	"Lombardia, Brescia, Odolo, G001",
	"Lombardia, Brescia, Offlaga, G006",
	"Lombardia, Brescia, Ome, G061",
	"Lombardia, Brescia, Ono San Pietro, G074",
	"Lombardia, Brescia, Orzinuovi, G149",
	"Lombardia, Brescia, Orzivecchi, G150",
	"Lombardia, Brescia, Ospitaletto, G170",
	"Lombardia, Brescia, Ossimo, G179",
	"Lombardia, Brescia, Padenghe sul Garda, G213",
	"Lombardia, Brescia, Paderno Franciacorta, G217",
	"Lombardia, Brescia, Paisco Loveno, G247",
	"Lombardia, Brescia, Paitone, G248",
	"Lombardia, Brescia, Palazzolo sull'Oglio, G264",
	"Lombardia, Brescia, Paratico, G327",
	"Lombardia, Brescia, Paspardo, G354",
	"Lombardia, Brescia, Passirano, G361",
	"Lombardia, Brescia, Pavone del Mella, G391",
	"Lombardia, Brescia, San Paolo, G407",
	"Lombardia, Brescia, Pertica Alta, G474",
	"Lombardia, Brescia, Pertica Bassa, G475",
	"Lombardia, Brescia, Pezzaze, G529",
	"Lombardia, Brescia, Pian Camuno, G546",
	"Lombardia, Brescia, Pisogne, G710",
	"Lombardia, Brescia, Polaveno, G779",
	"Lombardia, Brescia, Polpenazze del Garda, G801",
	"Lombardia, Brescia, Pompiano, G815",
	"Lombardia, Brescia, Poncarale, G818",
	"Lombardia, Brescia, Ponte di Legno, G844",
	"Lombardia, Brescia, Pontevico, G859",
	"Lombardia, Brescia, Pontoglio, G869",
	"Lombardia, Brescia, Pozzolengo, G959",
	"Lombardia, Brescia, Pralboino, G977",
	"Lombardia, Brescia, Preseglie, H043",
	"Lombardia, Brescia, Prevalle, H055",
	"Lombardia, Brescia, Provaglio d'Iseo, H078",
	"Lombardia, Brescia, Provaglio Val Sabbia, H077",
	"Lombardia, Brescia, Puegnago del Garda, H086",
	"Lombardia, Brescia, Quinzano d'Oglio, H140",
	"Lombardia, Brescia, Remedello, H230",
	"Lombardia, Brescia, Rezzato, H256",
	"Lombardia, Brescia, Roccafranca, H410",
	"Lombardia, Brescia, Rodengo Saiano, H477",
	"Lombardia, Brescia, Roè Volciano, H484",
	"Lombardia, Brescia, Roncadelle, H525",
	"Lombardia, Brescia, Rovato, H598",
	"Lombardia, Brescia, Rudiano, H630",
	"Lombardia, Brescia, Sabbio Chiese, H650",
	"Lombardia, Brescia, Sale Marasino, H699",
	"Lombardia, Brescia, Salò, H717",
	"Lombardia, Brescia, San Felice del Benaco, H838",
	"Lombardia, Brescia, San Gervasio Bresciano, H865",
	"Lombardia, Brescia, San Zeno Naviglio, I412",
	"Lombardia, Brescia, Sarezzo, I433",
	"Lombardia, Brescia, Saviore dell'Adamello, I476",
	"Lombardia, Brescia, Sellero, I588",
	"Lombardia, Brescia, Seniga, I607",
	"Lombardia, Brescia, Serle, I631",
	"Lombardia, Brescia, Sirmione, I633",
	"Lombardia, Brescia, Soiano del Lago, I782",
	"Lombardia, Brescia, Sonico, I831",
	"Lombardia, Brescia, Sulzano, L002",
	"Lombardia, Brescia, Tavernole sul Mella, C698",
	"Lombardia, Brescia, Temù, L094",
	"Lombardia, Brescia, Tignale, L169",
	"Lombardia, Brescia, Torbole Casaglia, L210",
	"Lombardia, Brescia, Toscolano-Maderno, L312",
	"Lombardia, Brescia, Travagliato, L339",
	"Lombardia, Brescia, Tremosine sul Garda, L372",
	"Lombardia, Brescia, Trenzano, L380",
	"Lombardia, Brescia, Treviso Bresciano, L406",
	"Lombardia, Brescia, Urago d'Oglio, L494",
	"Lombardia, Brescia, Vallio Terme, L626",
	"Lombardia, Brescia, Valvestino, L468",
	"Lombardia, Brescia, Verolanuova, L777",
	"Lombardia, Brescia, Verolavecchia, L778",
	"Lombardia, Brescia, Vestone, L812",
	"Lombardia, Brescia, Vezza d'Oglio, L816",
	"Lombardia, Brescia, Villa Carcina, L919",
	"Lombardia, Brescia, Villachiara, L923",
	"Lombardia, Brescia, Villanuova sul Clisi, L995",
	"Lombardia, Brescia, Vione, M065",
	"Lombardia, Brescia, Visano, M070",
	"Lombardia, Brescia, Vobarno, M104",
	"Lombardia, Brescia, Zone, M188",
	"Lombardia, Brescia, Piancogno, G549",
	"Lombardia, Pavia, Alagna, A118",
	"Lombardia, Pavia, Albaredo Arnaboldi, A134",
	"Lombardia, Pavia, Albonese, A171",
	"Lombardia, Pavia, Albuzzano, A175",
	"Lombardia, Pavia, Arena Po, A387",
	"Lombardia, Pavia, Badia Pavese, A538",
	"Lombardia, Pavia, Bagnaria, A550",
	"Lombardia, Pavia, Barbianello, A634",
	"Lombardia, Pavia, Bascapè, A690",
	"Lombardia, Pavia, Bastida Pancarana, A712",
	"Lombardia, Pavia, Battuda, A718",
	"Lombardia, Pavia, Belgioioso, A741",
	"Lombardia, Pavia, Bereguardo, A792",
	"Lombardia, Pavia, Borgarello, A989",
	"Lombardia, Pavia, Borgo Priolo, B028",
	"Lombardia, Pavia, Borgoratto Mormorolo, B030",
	"Lombardia, Pavia, Borgo San Siro, B038",
	"Lombardia, Pavia, Bornasco, B051",
	"Lombardia, Pavia, Bosnasco, B082",
	"Lombardia, Pavia, Brallo di Pregola, B117",
	"Lombardia, Pavia, Breme, B142",
	"Lombardia, Pavia, Bressana Bottarone, B159",
	"Lombardia, Pavia, Broni, B201",
	"Lombardia, Pavia, Calvignano, B447",
	"Lombardia, Pavia, Campospinoso, B567",
	"Lombardia, Pavia, Candia Lomellina, B587",
	"Lombardia, Pavia, Canneto Pavese, B613",
	"Lombardia, Pavia, Carbonara al Ticino, B741",
	"Lombardia, Pavia, Casanova Lonati, B929",
	"Lombardia, Pavia, Casatisma, B945",
	"Lombardia, Pavia, Casei Gerola, B954",
	"Lombardia, Pavia, Casorate Primo, B988",
	"Lombardia, Pavia, Cassolnovo, C038",
	"Lombardia, Pavia, Castana, C050",
	"Lombardia, Pavia, Casteggio, C053",
	"Lombardia, Pavia, Castelletto di Branduzzo, C157",
	"Lombardia, Pavia, Castello d'Agogna, C184",
	"Lombardia, Pavia, Castelnovetto, C213",
	"Lombardia, Pavia, Cava Manara, C360",
	"Lombardia, Pavia, Cecima, C414",
	"Lombardia, Pavia, Ceranova, C484",
	"Lombardia, Pavia, Ceretto Lomellina, C508",
	"Lombardia, Pavia, Cergnago, C509",
	"Lombardia, Pavia, Certosa di Pavia, C541",
	"Lombardia, Pavia, Cervesina, C551",
	"Lombardia, Pavia, Chignolo Po, C637",
	"Lombardia, Pavia, Cigognola, C684",
	"Lombardia, Pavia, Cilavegna, C686",
	"Lombardia, Pavia, Codevilla, C813",
	"Lombardia, Pavia, Confienza, C958",
	"Lombardia, Pavia, Copiano, C979",
	"Lombardia, Pavia, Corana, C982",
	"Lombardia, Pavia, Corvino San Quirico, D081",
	"Lombardia, Pavia, Costa de' Nobili, D109",
	"Lombardia, Pavia, Cozzo, D127",
	"Lombardia, Pavia, Cura Carpignano, B824",
	"Lombardia, Pavia, Dorno, D348",
	"Lombardia, Pavia, Ferrera Erbognone, D552",
	"Lombardia, Pavia, Filighera, D594",
	"Lombardia, Pavia, Fortunago, D732",
	"Lombardia, Pavia, Frascarolo, D771",
	"Lombardia, Pavia, Galliavola, D873",
	"Lombardia, Pavia, Gambarana, D892",
	"Lombardia, Pavia, Gambolò, D901",
	"Lombardia, Pavia, Garlasco, D925",
	"Lombardia, Pavia, Gerenzago, D980",
	"Lombardia, Pavia, Giussago, E062",
	"Lombardia, Pavia, Godiasco Salice Terme, E072",
	"Lombardia, Pavia, Golferenzo, E081",
	"Lombardia, Pavia, Gravellona Lomellina, E152",
	"Lombardia, Pavia, Gropello Cairoli, E195",
	"Lombardia, Pavia, Inverno e Monteleone, E310",
	"Lombardia, Pavia, Landriano, E437",
	"Lombardia, Pavia, Langosco, E439",
	"Lombardia, Pavia, Lardirago, E454",
	"Lombardia, Pavia, Linarolo, E600",
	"Lombardia, Pavia, Lirio, E608",
	"Lombardia, Pavia, Lomello, E662",
	"Lombardia, Pavia, Lungavilla, B387",
	"Lombardia, Pavia, Magherno, E804",
	"Lombardia, Pavia, Marcignago, E934",
	"Lombardia, Pavia, Marzano, E999",
	"Lombardia, Pavia, Mede, F080",
	"Lombardia, Pavia, Menconico, F122",
	"Lombardia, Pavia, Mezzana Bigli, F170",
	"Lombardia, Pavia, Mezzana Rabattone, F171",
	"Lombardia, Pavia, Mezzanino, F175",
	"Lombardia, Pavia, Miradolo Terme, F238",
	"Lombardia, Pavia, Montalto Pavese, F417",
	"Lombardia, Pavia, Montebello della Battaglia, F440",
	"Lombardia, Pavia, Montecalvo Versiggia, F449",
	"Lombardia, Pavia, Montescano, F638",
	"Lombardia, Pavia, Montesegale, F644",
	"Lombardia, Pavia, Monticelli Pavese, F670",
	"Lombardia, Pavia, Montù Beccaria, F701",
	"Lombardia, Pavia, Mornico Losana, F739",
	"Lombardia, Pavia, Mortara, F754",
	"Lombardia, Pavia, Nicorvo, F891",
	"Lombardia, Pavia, Olevano di Lomellina, G021",
	"Lombardia, Pavia, Oliva Gessi, G032",
	"Lombardia, Pavia, Ottobiano, G194",
	"Lombardia, Pavia, Palestro, G275",
	"Lombardia, Pavia, Pancarana, G304",
	"Lombardia, Pavia, Parona, G342",
	"Lombardia, Pavia, Pavia, G388",
	"Lombardia, Pavia, Pietra de' Giorgi, G612",
	"Lombardia, Pavia, Pieve Albignola, G635",
	"Lombardia, Pavia, Pieve del Cairo, G639",
	"Lombardia, Pavia, Pieve Porto Morone, G650",
	"Lombardia, Pavia, Pinarolo Po, G671",
	"Lombardia, Pavia, Pizzale, G720",
	"Lombardia, Pavia, Ponte Nizza, G851",
	"Lombardia, Pavia, Portalbera, G895",
	"Lombardia, Pavia, Rea, H204",
	"Lombardia, Pavia, Redavalle, H216",
	"Lombardia, Pavia, Retorbido, H246",
	"Lombardia, Pavia, Rivanazzano Terme, H336",
	"Lombardia, Pavia, Robbio, H369",
	"Lombardia, Pavia, Robecco Pavese, H375",
	"Lombardia, Pavia, Rocca de' Giorgi, H396",
	"Lombardia, Pavia, Rocca Susella, H450",
	"Lombardia, Pavia, Rognano, H491",
	"Lombardia, Pavia, Romagnese, H505",
	"Lombardia, Pavia, Roncaro, H527",
	"Lombardia, Pavia, Rosasco, H559",
	"Lombardia, Pavia, Rovescala, H614",
	"Lombardia, Pavia, San Cipriano Po, H799",
	"Lombardia, Pavia, San Damiano al Colle, H814",
	"Lombardia, Pavia, San Genesio ed Uniti, H859",
	"Lombardia, Pavia, San Giorgio di Lomellina, H885",
	"Lombardia, Pavia, San Martino Siccomario, I014",
	"Lombardia, Pavia, Sannazzaro de' Burgondi, I048",
	"Lombardia, Pavia, Santa Cristina e Bissone, I175",
	"Lombardia, Pavia, Santa Giuletta, I203",
	"Lombardia, Pavia, Sant'Alessio con Vialone, I213",
	"Lombardia, Pavia, Santa Margherita di Staffora, I230",
	"Lombardia, Pavia, Santa Maria della Versa, I237",
	"Lombardia, Pavia, Sant'Angelo Lomellina, I276",
	"Lombardia, Pavia, San Zenone al Po, I416",
	"Lombardia, Pavia, Sartirana Lomellina, I447",
	"Lombardia, Pavia, Scaldasole, I487",
	"Lombardia, Pavia, Semiana, I599",
	"Lombardia, Pavia, Silvano Pietra, I739",
	"Lombardia, Pavia, Siziano, E265",
	"Lombardia, Pavia, Sommo, I825",
	"Lombardia, Pavia, Spessa, I894",
	"Lombardia, Pavia, Stradella, I968",
	"Lombardia, Pavia, Suardi, B014",
	"Lombardia, Pavia, Torrazza Coste, L237",
	"Lombardia, Pavia, Torre Beretti e Castellaro, L250",
	"Lombardia, Pavia, Torre d'Arese, L256",
	"Lombardia, Pavia, Torre de' Negri, L262",
	"Lombardia, Pavia, Torre d'Isola, L269",
	"Lombardia, Pavia, Torrevecchia Pia, L285",
	"Lombardia, Pavia, Torricella Verzate, L292",
	"Lombardia, Pavia, Travacò Siccomario, I236",
	"Lombardia, Pavia, Trivolzio, L440",
	"Lombardia, Pavia, Tromello, L449",
	"Lombardia, Pavia, Trovo, L453",
	"Lombardia, Pavia, Val di Nizza, L562",
	"Lombardia, Pavia, Valeggio, L568",
	"Lombardia, Pavia, Valle Lomellina, L593",
	"Lombardia, Pavia, Valle Salimbene, L617",
	"Lombardia, Pavia, Varzi, L690",
	"Lombardia, Pavia, Velezzo Lomellina, L716",
	"Lombardia, Pavia, Vellezzo Bellini, L720",
	"Lombardia, Pavia, Verretto, L784",
	"Lombardia, Pavia, Verrua Po, L788",
	"Lombardia, Pavia, Vidigulfo, L854",
	"Lombardia, Pavia, Vigevano, L872",
	"Lombardia, Pavia, Villa Biscossi, L917",
	"Lombardia, Pavia, Villanova d'Ardenghi, L983",
	"Lombardia, Pavia, Villanterio, L994",
	"Lombardia, Pavia, Vistarino, M079",
	"Lombardia, Pavia, Voghera, M109",
	"Lombardia, Pavia, Volpara, M119",
	"Lombardia, Pavia, Zavattarello, M150",
	"Lombardia, Pavia, Zeccone, M152",
	"Lombardia, Pavia, Zeme, M161",
	"Lombardia, Pavia, Zenevredo, M162",
	"Lombardia, Pavia, Zerbo, M166",
	"Lombardia, Pavia, Zerbolò, M167",
	"Lombardia, Pavia, Zinasco, M180",
	"Lombardia, Pavia, Cornale e Bastida, M338",
	"Lombardia, Pavia, Corteolona e Genzone, M372",
	"Lombardia, Pavia, Colli Verdi, M419",
	"Lombardia, Cremona, Acquanegra Cremonese, A039",
	"Lombardia, Cremona, Agnadello, A076",
	"Lombardia, Cremona, Annicco, A299",
	"Lombardia, Cremona, Azzanello, A526",
	"Lombardia, Cremona, Bagnolo Cremasco, A570",
	"Lombardia, Cremona, Bonemerse, A972",
	"Lombardia, Cremona, Bordolano, A986",
	"Lombardia, Cremona, Calvatone, B439",
	"Lombardia, Cremona, Camisano, B484",
	"Lombardia, Cremona, Campagnola Cremasca, B498",
	"Lombardia, Cremona, Capergnanica, B650",
	"Lombardia, Cremona, Cappella Cantone, B679",
	"Lombardia, Cremona, Cappella de' Picenardi, B680",
	"Lombardia, Cremona, Capralba, B686",
	"Lombardia, Cremona, Casalbuttano ed Uniti, B869",
	"Lombardia, Cremona, Casale Cremasco-Vidolasco, B881",
	"Lombardia, Cremona, Casaletto Ceredano, B889",
	"Lombardia, Cremona, Casaletto di Sopra, B890",
	"Lombardia, Cremona, Casaletto Vaprio, B891",
	"Lombardia, Cremona, Casalmaggiore, B898",
	"Lombardia, Cremona, Casalmorano, B900",
	"Lombardia, Cremona, Casteldidone, C089",
	"Lombardia, Cremona, Castel Gabbiano, C115",
	"Lombardia, Cremona, Castelleone, C153",
	"Lombardia, Cremona, Castelverde, B129",
	"Lombardia, Cremona, Castelvisconti, C290",
	"Lombardia, Cremona, Cella Dati, C435",
	"Lombardia, Cremona, Chieve, C634",
	"Lombardia, Cremona, Cicognolo, C678",
	"Lombardia, Cremona, Cingia de' Botti, C703",
	"Lombardia, Cremona, Corte de' Cortesi con Cignone, D056",
	"Lombardia, Cremona, Corte de' Frati, D057",
	"Lombardia, Cremona, Credera Rubbiano, D141",
	"Lombardia, Cremona, Crema, D142",
	"Lombardia, Cremona, Cremona, D150",
	"Lombardia, Cremona, Cremosano, D151",
	"Lombardia, Cremona, Crotta d'Adda, D186",
	"Lombardia, Cremona, Cumignano sul Naviglio, D203",
	"Lombardia, Cremona, Derovere, D278",
	"Lombardia, Cremona, Dovera, D358",
	"Lombardia, Cremona, Fiesco, D574",
	"Lombardia, Cremona, Formigara, D710",
	"Lombardia, Cremona, Gabbioneta-Binanuova, D834",
	"Lombardia, Cremona, Gadesco-Pieve Delmona, D841",
	"Lombardia, Cremona, Genivolta, D966",
	"Lombardia, Cremona, Gerre de' Caprioli, D993",
	"Lombardia, Cremona, Gombito, E082",
	"Lombardia, Cremona, Grontardo, E193",
	"Lombardia, Cremona, Grumello Cremonese ed Uniti, E217",
	"Lombardia, Cremona, Gussola, E272",
	"Lombardia, Cremona, Isola Dovarese, E356",
	"Lombardia, Cremona, Izano, E380",
	"Lombardia, Cremona, Madignano, E793",
	"Lombardia, Cremona, Malagnino, E843",
	"Lombardia, Cremona, Martignana di Po, E983",
	"Lombardia, Cremona, Monte Cremasco, F434",
	"Lombardia, Cremona, Montodine, F681",
	"Lombardia, Cremona, Moscazzano, F761",
	"Lombardia, Cremona, Motta Baluffi, F771",
	"Lombardia, Cremona, Offanengo, G004",
	"Lombardia, Cremona, Olmeneta, G047",
	"Lombardia, Cremona, Ostiano, G185",
	"Lombardia, Cremona, Paderno Ponchielli, G222",
	"Lombardia, Cremona, Palazzo Pignano, G260",
	"Lombardia, Cremona, Pandino, G306",
	"Lombardia, Cremona, Persico Dosimo, G469",
	"Lombardia, Cremona, Pescarolo ed Uniti, G483",
	"Lombardia, Cremona, Pessina Cremonese, G504",
	"Lombardia, Cremona, Pianengo, G558",
	"Lombardia, Cremona, Pieranica, G603",
	"Lombardia, Cremona, Pieve d'Olmi, G647",
	"Lombardia, Cremona, Pieve San Giacomo, G651",
	"Lombardia, Cremona, Pizzighettone, G721",
	"Lombardia, Cremona, Pozzaglio ed Uniti, B914",
	"Lombardia, Cremona, Quintano, H130",
	"Lombardia, Cremona, Ricengo, H276",
	"Lombardia, Cremona, Ripalta Arpina, H314",
	"Lombardia, Cremona, Ripalta Cremasca, H315",
	"Lombardia, Cremona, Ripalta Guerina, H316",
	"Lombardia, Cremona, Rivarolo del Re ed Uniti, H341",
	"Lombardia, Cremona, Rivolta d'Adda, H357",
	"Lombardia, Cremona, Robecco d'Oglio, H372",
	"Lombardia, Cremona, Romanengo, H508",
	"Lombardia, Cremona, Salvirola, H731",
	"Lombardia, Cremona, San Bassano, H767",
	"Lombardia, Cremona, San Daniele Po, H815",
	"Lombardia, Cremona, San Giovanni in Croce, H918",
	"Lombardia, Cremona, San Martino del Lago, I007",
	"Lombardia, Cremona, Scandolara Ravara, I497",
	"Lombardia, Cremona, Scandolara Ripa d'Oglio, I498",
	"Lombardia, Cremona, Sergnano, I627",
	"Lombardia, Cremona, Sesto ed Uniti, I683",
	"Lombardia, Cremona, Solarolo Rainerio, I790",
	"Lombardia, Cremona, Soncino, I827",
	"Lombardia, Cremona, Soresina, I849",
	"Lombardia, Cremona, Sospiro, I865",
	"Lombardia, Cremona, Spinadesco, I906",
	"Lombardia, Cremona, Spineda, I909",
	"Lombardia, Cremona, Spino d'Adda, I914",
	"Lombardia, Cremona, Stagno Lombardo, I935",
	"Lombardia, Cremona, Ticengo, L164",
	"Lombardia, Cremona, Torlino Vimercati, L221",
	"Lombardia, Cremona, Tornata, L225",
	"Lombardia, Cremona, Torre de' Picenardi, L258",
	"Lombardia, Cremona, Torricella del Pizzo, L296",
	"Lombardia, Cremona, Trescore Cremasco, L389",
	"Lombardia, Cremona, Trigolo, L426",
	"Lombardia, Cremona, Vaiano Cremasco, L535",
	"Lombardia, Cremona, Vailate, L539",
	"Lombardia, Cremona, Vescovato, L806",
	"Lombardia, Cremona, Volongo, M116",
	"Lombardia, Cremona, Voltido, M127",
	"Lombardia, Cremona, Piadena Drizzona, M418",
	"Lombardia, Mantova, Acquanegra sul Chiese, A038",
	"Lombardia, Mantova, Asola, A470",
	"Lombardia, Mantova, Bagnolo San Vito, A575",
	"Lombardia, Mantova, Bozzolo, B110",
	"Lombardia, Mantova, Canneto sull'Oglio, B612",
	"Lombardia, Mantova, Casalmoro, B901",
	"Lombardia, Mantova, Casaloldo, B907",
	"Lombardia, Mantova, Casalromano, B911",
	"Lombardia, Mantova, Castelbelforte, C059",
	"Lombardia, Mantova, Castel d'Ario, C076",
	"Lombardia, Mantova, Castel Goffredo, C118",
	"Lombardia, Mantova, Castellucchio, C195",
	"Lombardia, Mantova, Castiglione delle Stiviere, C312",
	"Lombardia, Mantova, Cavriana, C406",
	"Lombardia, Mantova, Ceresara, C502",
	"Lombardia, Mantova, Commessaggio, C930",
	"Lombardia, Mantova, Curtatone, D227",
	"Lombardia, Mantova, Dosolo, D351",
	"Lombardia, Mantova, Gazoldo degli Ippoliti, D949",
	"Lombardia, Mantova, Gazzuolo, D959",
	"Lombardia, Mantova, Goito, E078",
	"Lombardia, Mantova, Gonzaga, E089",
	"Lombardia, Mantova, Guidizzolo, E261",
	"Lombardia, Mantova, Magnacavallo, E818",
	"Lombardia, Mantova, Mantova, E897",
	"Lombardia, Mantova, Marcaria, E922",
	"Lombardia, Mantova, Mariana Mantovana, E949",
	"Lombardia, Mantova, Marmirolo, E962",
	"Lombardia, Mantova, Medole, F086",
	"Lombardia, Mantova, Moglia, F267",
	"Lombardia, Mantova, Monzambano, F705",
	"Lombardia, Mantova, Motteggiana, B012",
	"Lombardia, Mantova, Ostiglia, G186",
	"Lombardia, Mantova, Pegognaga, G417",
	"Lombardia, Mantova, Piubega, G717",
	"Lombardia, Mantova, Poggio Rusco, G753",
	"Lombardia, Mantova, Pomponesco, G816",
	"Lombardia, Mantova, Ponti sul Mincio, G862",
	"Lombardia, Mantova, Porto Mantovano, G917",
	"Lombardia, Mantova, Quingentole, H129",
	"Lombardia, Mantova, Quistello, H143",
	"Lombardia, Mantova, Redondesco, H218",
	"Lombardia, Mantova, Rivarolo Mantovano, H342",
	"Lombardia, Mantova, Rodigo, H481",
	"Lombardia, Mantova, Roncoferraro, H541",
	"Lombardia, Mantova, Roverbella, H604",
	"Lombardia, Mantova, Sabbioneta, H652",
	"Lombardia, Mantova, San Benedetto Po, H771",
	"Lombardia, Mantova, San Giacomo delle Segnate, H870",
	"Lombardia, Mantova, San Giorgio Bigarello, H883",
	"Lombardia, Mantova, San Giovanni del Dosso, H912",
	"Lombardia, Mantova, San Martino dall'Argine, I005",
	"Lombardia, Mantova, Schivenoglia, I532",
	"Lombardia, Mantova, Sermide e Felonica, I632",
	"Lombardia, Mantova, Serravalle a Po, I662",
	"Lombardia, Mantova, Solferino, I801",
	"Lombardia, Mantova, Sustinente, L015",
	"Lombardia, Mantova, Suzzara, L020",
	"Lombardia, Mantova, Viadana, L826",
	"Lombardia, Mantova, Villimpenta, M044",
	"Lombardia, Mantova, Volta Mantovana, M125",
	"Lombardia, Mantova, Borgo Virgilio, M340",
	"Lombardia, Mantova, Borgo Mantovano, M396",
	"Lombardia, Mantova, Borgocarbonara, M406",
	"Lombardia, Lecco, Abbadia Lariana, A005",
	"Lombardia, Lecco, Airuno, A112",
	"Lombardia, Lecco, Annone di Brianza, A301",
	"Lombardia, Lecco, Ballabio, A594",
	"Lombardia, Lecco, Barzago, A683",
	"Lombardia, Lecco, Barzanò, A686",
	"Lombardia, Lecco, Barzio, A687",
	"Lombardia, Lecco, Bellano, A745",
	"Lombardia, Lecco, Bosisio Parini, B081",
	"Lombardia, Lecco, Brivio, B194",
	"Lombardia, Lecco, Bulciago, B261",
	"Lombardia, Lecco, Calco, B396",
	"Lombardia, Lecco, Calolziocorte, B423",
	"Lombardia, Lecco, Carenno, B763",
	"Lombardia, Lecco, Casargo, B937",
	"Lombardia, Lecco, Casatenovo, B943",
	"Lombardia, Lecco, Cassago Brianza, B996",
	"Lombardia, Lecco, Cassina Valsassina, C024",
	"Lombardia, Lecco, Castello di Brianza, C187",
	"Lombardia, Lecco, Cernusco Lombardone, C521",
	"Lombardia, Lecco, Cesana Brianza, C563",
	"Lombardia, Lecco, Civate, C752",
	"Lombardia, Lecco, Colico, C839",
	"Lombardia, Lecco, Colle Brianza, C851",
	"Lombardia, Lecco, Cortenova, D065",
	"Lombardia, Lecco, Costa Masnaga, D112",
	"Lombardia, Lecco, Crandola Valsassina, D131",
	"Lombardia, Lecco, Cremella, D143",
	"Lombardia, Lecco, Cremeno, D145",
	"Lombardia, Lecco, Dervio, D280",
	"Lombardia, Lecco, Dolzago, D327",
	"Lombardia, Lecco, Dorio, D346",
	"Lombardia, Lecco, Ello, D398",
	"Lombardia, Lecco, Erve, D428",
	"Lombardia, Lecco, Esino Lario, D436",
	"Lombardia, Lecco, Galbiate, D865",
	"Lombardia, Lecco, Garbagnate Monastero, D913",
	"Lombardia, Lecco, Garlate, D926",
	"Lombardia, Lecco, Imbersago, E287",
	"Lombardia, Lecco, Introbio, E305",
	"Lombardia, Lecco, Lecco, E507",
	"Lombardia, Lecco, Lierna, E581",
	"Lombardia, Lecco, Lomagna, E656",
	"Lombardia, Lecco, Malgrate, E858",
	"Lombardia, Lecco, Mandello del Lario, E879",
	"Lombardia, Lecco, Margno, E947",
	"Lombardia, Lecco, Merate, F133",
	"Lombardia, Lecco, Missaglia, F248",
	"Lombardia, Lecco, Moggio, F265",
	"Lombardia, Lecco, Molteno, F304",
	"Lombardia, Lecco, Monte Marenzo, F561",
	"Lombardia, Lecco, Montevecchia, F657",
	"Lombardia, Lecco, Monticello Brianza, F674",
	"Lombardia, Lecco, Morterone, F758",
	"Lombardia, Lecco, Nibionno, F887",
	"Lombardia, Lecco, Oggiono, G009",
	"Lombardia, Lecco, Olgiate Molgora, G026",
	"Lombardia, Lecco, Olginate, G030",
	"Lombardia, Lecco, Oliveto Lario, G040",
	"Lombardia, Lecco, Osnago, G161",
	"Lombardia, Lecco, Paderno d'Adda, G218",
	"Lombardia, Lecco, Pagnona, G241",
	"Lombardia, Lecco, Parlasco, G336",
	"Lombardia, Lecco, Pasturo, G368",
	"Lombardia, Lecco, Perledo, G456",
	"Lombardia, Lecco, Pescate, G485",
	"Lombardia, Lecco, Premana, H028",
	"Lombardia, Lecco, Primaluna, H063",
	"Lombardia, Lecco, Robbiate, G223",
	"Lombardia, Lecco, Rogeno, H486",
	"Lombardia, Lecco, Santa Maria Hoè, I243",
	"Lombardia, Lecco, Sirone, I759",
	"Lombardia, Lecco, Sirtori, I761",
	"Lombardia, Lecco, Sueglio, I994",
	"Lombardia, Lecco, Suello, I996",
	"Lombardia, Lecco, Taceno, L022",
	"Lombardia, Lecco, Valgreghentino, L581",
	"Lombardia, Lecco, Valmadrera, L634",
	"Lombardia, Lecco, Varenna, L680",
	"Lombardia, Lecco, Vercurago, L751",
	"Lombardia, Lecco, Viganò, L866",
	"Lombardia, Lecco, Verderio, M337",
	"Lombardia, Lecco, La Valletta Brianza, M348",
	"Lombardia, Lecco, Valvarrone, M395",
	"Lombardia, Lodi, Abbadia Cerreto, A004",
	"Lombardia, Lodi, Bertonico, A811",
	"Lombardia, Lodi, Boffalora d'Adda, A919",
	"Lombardia, Lodi, Borghetto Lodigiano, A995",
	"Lombardia, Lodi, Borgo San Giovanni, B017",
	"Lombardia, Lodi, Brembio, B141",
	"Lombardia, Lodi, Casaletto Lodigiano, B887",
	"Lombardia, Lodi, Casalmaiocco, B899",
	"Lombardia, Lodi, Casalpusterlengo, B910",
	"Lombardia, Lodi, Caselle Landi, B961",
	"Lombardia, Lodi, Caselle Lurani, B958",
	"Lombardia, Lodi, Castelnuovo Bocca d'Adda, C228",
	"Lombardia, Lodi, Castiglione d'Adda, C304",
	"Lombardia, Lodi, Castiraga Vidardo, C329",
	"Lombardia, Lodi, Cavenago d'Adda, C394",
	"Lombardia, Lodi, Cervignano d'Adda, C555",
	"Lombardia, Lodi, Codogno, C816",
	"Lombardia, Lodi, Comazzo, C917",
	"Lombardia, Lodi, Cornegliano Laudense, D021",
	"Lombardia, Lodi, Corno Giovine, D028",
	"Lombardia, Lodi, Cornovecchio, D029",
	"Lombardia, Lodi, Corte Palasio, D068",
	"Lombardia, Lodi, Crespiatica, D159",
	"Lombardia, Lodi, Fombio, D660",
	"Lombardia, Lodi, Galgagnano, D868",
	"Lombardia, Lodi, Graffignana, E127",
	"Lombardia, Lodi, Guardamiglio, E238",
	"Lombardia, Lodi, Livraga, E627",
	"Lombardia, Lodi, Lodi, E648",
	"Lombardia, Lodi, Lodi Vecchio, E651",
	"Lombardia, Lodi, Maccastorna, E777",
	"Lombardia, Lodi, Mairago, E840",
	"Lombardia, Lodi, Maleo, E852",
	"Lombardia, Lodi, Marudo, E994",
	"Lombardia, Lodi, Massalengo, F028",
	"Lombardia, Lodi, Meleti, F102",
	"Lombardia, Lodi, Merlino, F149",
	"Lombardia, Lodi, Montanaso Lombardo, F423",
	"Lombardia, Lodi, Mulazzano, F801",
	"Lombardia, Lodi, Orio Litta, G107",
	"Lombardia, Lodi, Ospedaletto Lodigiano, G166",
	"Lombardia, Lodi, Ossago Lodigiano, G171",
	"Lombardia, Lodi, Pieve Fissiraga, G096",
	"Lombardia, Lodi, Salerano sul Lambro, H701",
	"Lombardia, Lodi, San Fiorano, H844",
	"Lombardia, Lodi, San Martino in Strada, I012",
	"Lombardia, Lodi, San Rocco al Porto, I140",
	"Lombardia, Lodi, Sant'Angelo Lodigiano, I274",
	"Lombardia, Lodi, Santo Stefano Lodigiano, I362",
	"Lombardia, Lodi, Secugnago, I561",
	"Lombardia, Lodi, Senna Lodigiana, I612",
	"Lombardia, Lodi, Somaglia, I815",
	"Lombardia, Lodi, Sordio, I848",
	"Lombardia, Lodi, Tavazzano con Villavesco, F260",
	"Lombardia, Lodi, Terranova dei Passerini, L125",
	"Lombardia, Lodi, Turano Lodigiano, L469",
	"Lombardia, Lodi, Valera Fratta, L572",
	"Lombardia, Lodi, Villanova del Sillaro, L977",
	"Lombardia, Lodi, Zelo Buon Persico, M158",
	"Lombardia, Lodi, Castelgerundo, M393",
	"Lombardia, Monza e della Brianza, Agrate Brianza, A087",
	"Lombardia, Monza e della Brianza, Aicurzio, A096",
	"Lombardia, Monza e della Brianza, Albiate, A159",
	"Lombardia, Monza e della Brianza, Arcore, A376",
	"Lombardia, Monza e della Brianza, Barlassina, A668",
	"Lombardia, Monza e della Brianza, Bellusco, A759",
	"Lombardia, Monza e della Brianza, Bernareggio, A802",
	"Lombardia, Monza e della Brianza, Besana in Brianza, A818",
	"Lombardia, Monza e della Brianza, Biassono, A849",
	"Lombardia, Monza e della Brianza, Bovisio-Masciago, B105",
	"Lombardia, Monza e della Brianza, Briosco, B187",
	"Lombardia, Monza e della Brianza, Brugherio, B212",
	"Lombardia, Monza e della Brianza, Burago di Molgora, B272",
	"Lombardia, Monza e della Brianza, Camparada, B501",
	"Lombardia, Monza e della Brianza, Carate Brianza, B729",
	"Lombardia, Monza e della Brianza, Carnate, B798",
	"Lombardia, Monza e della Brianza, Cavenago di Brianza, C395",
	"Lombardia, Monza e della Brianza, Ceriano Laghetto, C512",
	"Lombardia, Monza e della Brianza, Cesano Maderno, C566",
	"Lombardia, Monza e della Brianza, Cogliate, C820",
	"Lombardia, Monza e della Brianza, Concorezzo, C952",
	"Lombardia, Monza e della Brianza, Correzzana, D038",
	"Lombardia, Monza e della Brianza, Desio, D286",
	"Lombardia, Monza e della Brianza, Giussano, E063",
	"Lombardia, Monza e della Brianza, Lazzate, E504",
	"Lombardia, Monza e della Brianza, Lesmo, E550",
	"Lombardia, Monza e della Brianza, Limbiate, E591",
	"Lombardia, Monza e della Brianza, Lissone, E617",
	"Lombardia, Monza e della Brianza, Macherio, E786",
	"Lombardia, Monza e della Brianza, Meda, F078",
	"Lombardia, Monza e della Brianza, Mezzago, F165",
	"Lombardia, Monza e della Brianza, Misinto, F247",
	"Lombardia, Monza e della Brianza, Monza, F704",
	"Lombardia, Monza e della Brianza, Muggiò, F797",
	"Lombardia, Monza e della Brianza, Nova Milanese, F944",
	"Lombardia, Monza e della Brianza, Ornago, G116",
	"Lombardia, Monza e della Brianza, Renate, H233",
	"Lombardia, Monza e della Brianza, Ronco Briantino, H537",
	"Lombardia, Monza e della Brianza, Seregno, I625",
	"Lombardia, Monza e della Brianza, Seveso, I709",
	"Lombardia, Monza e della Brianza, Sovico, I878",
	"Lombardia, Monza e della Brianza, Sulbiate, I998",
	"Lombardia, Monza e della Brianza, Triuggio, L434",
	"Lombardia, Monza e della Brianza, Usmate Velate, L511",
	"Lombardia, Monza e della Brianza, Varedo, L677",
	"Lombardia, Monza e della Brianza, Vedano al Lambro, L704",
	"Lombardia, Monza e della Brianza, Veduggio con Colzano, L709",
	"Lombardia, Monza e della Brianza, Verano Brianza, L744",
	"Lombardia, Monza e della Brianza, Villasanta, M017",
	"Lombardia, Monza e della Brianza, Vimercate, M052",
	"Lombardia, Monza e della Brianza, Busnago, B289",
	"Lombardia, Monza e della Brianza, Caponago, B671",
	"Lombardia, Monza e della Brianza, Cornate d'Adda, D019",
	"Lombardia, Monza e della Brianza, Lentate sul Seveso, E530",
	"Lombardia, Monza e della Brianza, Roncello, H529",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Aldino, A179",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Andriano, A286",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Anterivo, A306",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Appiano sulla strada del vino, A332",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Avelengo, A507",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Badia, A537",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Barbiano, A635",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Bolzano, A952",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Braies, B116",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Brennero, B145",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Bressanone, B160",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Bronzolo, B203",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Brunico, B220",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Caines, B364",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Caldaro sulla strada del vino, B397",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Campo di Trens, B529",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Campo Tures, B570",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Castelbello-Ciardes, C062",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Castelrotto, C254",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Cermes, A022",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Chienes, C625",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Chiusa, C652",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Cornedo all'Isarco, B799",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Cortaccia sulla strada del vino, D048",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Cortina sulla strada del vino, D075",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Corvara in Badia, D079",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Curon Venosta, D222",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Dobbiaco, D311",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Egna, D392",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Falzes, D484",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Fiè allo Sciliar, D571",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Fortezza, D731",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Funes, D821",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Gais, D860",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Gargazzone, D923",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Glorenza, E069",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Laces, E398",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Lagundo, E412",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Laion, E420",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Laives, E421",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Lana, E434",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Lasa, E457",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Lauregno, E481",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Luson, E764",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Magrè sulla strada del vino, E829",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Malles Venosta, E862",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Marebbe, E938",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Marlengo, E959",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Martello, E981",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Meltina, F118",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Merano, F132",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Monguelfo-Tesido, F371",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Montagna, F392",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Moso in Passiria, F766",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Nalles, F836",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Naturno, F849",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Naz-Sciaves, F856",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Nova Levante, F949",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Nova Ponente, F950",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Ora, G083",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Ortisei, G140",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Parcines, G328",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Perca, G443",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Plaus, G299",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Ponte Gardena, G830",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Postal, G936",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Prato allo Stelvio, H004",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Predoi, H019",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Proves, H081",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Racines, H152",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Rasun-Anterselva, H189",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Renon, H236",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Rifiano, H284",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Rio di Pusteria, H299",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Rodengo, H475",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Salorno sulla strada del vino, H719",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, San Candido, H786",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, San Genesio Atesino, H858",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, San Leonardo in Passiria, H952",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, San Lorenzo di Sebato, H956",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, San Martino in Badia, H988",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, San Martino in Passiria, H989",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, San Pancrazio, I065",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Santa Cristina Valgardena, I173",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Sarentino, I431",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Scena, I519",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Selva dei Molini, I593",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Selva di Val Gardena, I591",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Senales, I604",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Sesto, I687",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Silandro, I729",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Sluderno, I771",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Stelvio, I948",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Terento, L106",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Terlano, L108",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Termeno sulla strada del vino, L111",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Tesimo, L149",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Tires, L176",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Tirolo, L178",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Trodena nel parco naturale, L444",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Tubre, L455",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Ultimo, L490",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Vadena, L527",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Valdaora, L552",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Val di Vizze, L564",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Valle Aurina, L595",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Valle di Casies, L601",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Vandoies, L660",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Varna, L687",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Verano, L745",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Villabassa, L915",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Villandro, L971",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Vipiteno, M067",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Velturno, L724",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, La Valle, E491",
	"Trentino-Alto Adige/Südtirol, Bolzano/Bozen, Senale-San Felice, I603",
	"Trentino-Alto Adige/Südtirol, Trento, Ala, A116",
	"Trentino-Alto Adige/Südtirol, Trento, Albiano, A158",
	"Trentino-Alto Adige/Südtirol, Trento, Aldeno, A178",
	"Trentino-Alto Adige/Südtirol, Trento, Andalo, A274",
	"Trentino-Alto Adige/Südtirol, Trento, Arco, A372",
	"Trentino-Alto Adige/Südtirol, Trento, Avio, A520",
	"Trentino-Alto Adige/Südtirol, Trento, Baselga di Pinè, A694",
	"Trentino-Alto Adige/Südtirol, Trento, Bedollo, A730",
	"Trentino-Alto Adige/Südtirol, Trento, Besenello, A821",
	"Trentino-Alto Adige/Südtirol, Trento, Bieno, A863",
	"Trentino-Alto Adige/Südtirol, Trento, Bleggio Superiore, A902",
	"Trentino-Alto Adige/Südtirol, Trento, Bocenago, A916",
	"Trentino-Alto Adige/Südtirol, Trento, Bondone, A968",
	"Trentino-Alto Adige/Südtirol, Trento, Borgo Valsugana, B006",
	"Trentino-Alto Adige/Südtirol, Trento, Brentonico, B153",
	"Trentino-Alto Adige/Südtirol, Trento, Bresimo, B158",
	"Trentino-Alto Adige/Südtirol, Trento, Caderzone Terme, B335",
	"Trentino-Alto Adige/Südtirol, Trento, Calceranica al Lago, B389",
	"Trentino-Alto Adige/Südtirol, Trento, Caldes, B400",
	"Trentino-Alto Adige/Südtirol, Trento, Caldonazzo, B404",
	"Trentino-Alto Adige/Südtirol, Trento, Calliano, B419",
	"Trentino-Alto Adige/Südtirol, Trento, Campitello di Fassa, B514",
	"Trentino-Alto Adige/Südtirol, Trento, Campodenno, B525",
	"Trentino-Alto Adige/Südtirol, Trento, Canal San Bovo, B577",
	"Trentino-Alto Adige/Südtirol, Trento, Canazei, B579",
	"Trentino-Alto Adige/Südtirol, Trento, Capriana, B697",
	"Trentino-Alto Adige/Südtirol, Trento, Carisolo, B783",
	"Trentino-Alto Adige/Südtirol, Trento, Carzano, B856",
	"Trentino-Alto Adige/Südtirol, Trento, Castel Condino, C183",
	"Trentino-Alto Adige/Südtirol, Trento, Castello-Molina di Fiemme, C189",
	"Trentino-Alto Adige/Südtirol, Trento, Castello Tesino, C194",
	"Trentino-Alto Adige/Südtirol, Trento, Castelnuovo, C216",
	"Trentino-Alto Adige/Südtirol, Trento, Cavalese, C372",
	"Trentino-Alto Adige/Südtirol, Trento, Cavareno, C380",
	"Trentino-Alto Adige/Südtirol, Trento, Cavedago, C392",
	"Trentino-Alto Adige/Südtirol, Trento, Cavedine, C393",
	"Trentino-Alto Adige/Südtirol, Trento, Cavizzana, C400",
	"Trentino-Alto Adige/Südtirol, Trento, Cimone, C700",
	"Trentino-Alto Adige/Südtirol, Trento, Cinte Tesino, C712",
	"Trentino-Alto Adige/Südtirol, Trento, Cis, C727",
	"Trentino-Alto Adige/Südtirol, Trento, Civezzano, C756",
	"Trentino-Alto Adige/Südtirol, Trento, Cles, C794",
	"Trentino-Alto Adige/Südtirol, Trento, Commezzadura, C931",
	"Trentino-Alto Adige/Südtirol, Trento, Croviana, D188",
	"Trentino-Alto Adige/Südtirol, Trento, Dambel, D246",
	"Trentino-Alto Adige/Südtirol, Trento, Denno, D273",
	"Trentino-Alto Adige/Südtirol, Trento, Drena, D365",
	"Trentino-Alto Adige/Südtirol, Trento, Dro, D371",
	"Trentino-Alto Adige/Südtirol, Trento, Fai della Paganella, D468",
	"Trentino-Alto Adige/Südtirol, Trento, Fiavè, D565",
	"Trentino-Alto Adige/Südtirol, Trento, Fierozzo, D573",
	"Trentino-Alto Adige/Südtirol, Trento, Folgaria, D651",
	"Trentino-Alto Adige/Südtirol, Trento, Fornace, D714",
	"Trentino-Alto Adige/Südtirol, Trento, Frassilongo, D775",
	"Trentino-Alto Adige/Südtirol, Trento, Garniga Terme, D928",
	"Trentino-Alto Adige/Südtirol, Trento, Giovo, E048",
	"Trentino-Alto Adige/Südtirol, Trento, Giustino, E065",
	"Trentino-Alto Adige/Südtirol, Trento, Grigno, E178",
	"Trentino-Alto Adige/Südtirol, Trento, Imer, E288",
	"Trentino-Alto Adige/Südtirol, Trento, Isera, E334",
	"Trentino-Alto Adige/Südtirol, Trento, Lavarone, E492",
	"Trentino-Alto Adige/Südtirol, Trento, Lavis, E500",
	"Trentino-Alto Adige/Südtirol, Trento, Levico Terme, E565",
	"Trentino-Alto Adige/Südtirol, Trento, Livo, E624",
	"Trentino-Alto Adige/Südtirol, Trento, Lona-Lases, E664",
	"Trentino-Alto Adige/Südtirol, Trento, Luserna, E757",
	"Trentino-Alto Adige/Südtirol, Trento, Malé, E850",
	"Trentino-Alto Adige/Südtirol, Trento, Massimeno, F045",
	"Trentino-Alto Adige/Südtirol, Trento, Mazzin, F068",
	"Trentino-Alto Adige/Südtirol, Trento, Mezzana, F168",
	"Trentino-Alto Adige/Südtirol, Trento, Mezzano, F176",
	"Trentino-Alto Adige/Südtirol, Trento, Mezzocorona, F183",
	"Trentino-Alto Adige/Südtirol, Trento, Mezzolombardo, F187",
	"Trentino-Alto Adige/Südtirol, Trento, Moena, F263",
	"Trentino-Alto Adige/Südtirol, Trento, Molveno, F307",
	"Trentino-Alto Adige/Südtirol, Trento, Mori, F728",
	"Trentino-Alto Adige/Südtirol, Trento, Nago-Torbole, F835",
	"Trentino-Alto Adige/Südtirol, Trento, Nogaredo, F920",
	"Trentino-Alto Adige/Südtirol, Trento, Nomi, F929",
	"Trentino-Alto Adige/Südtirol, Trento, Novaledo, F947",
	"Trentino-Alto Adige/Südtirol, Trento, Ospedaletto, G168",
	"Trentino-Alto Adige/Südtirol, Trento, Ossana, G173",
	"Trentino-Alto Adige/Südtirol, Trento, Palù del Fersina, G296",
	"Trentino-Alto Adige/Südtirol, Trento, Panchià, G305",
	"Trentino-Alto Adige/Südtirol, Trento, Ronzo-Chienis, M303",
	"Trentino-Alto Adige/Südtirol, Trento, Peio, G419",
	"Trentino-Alto Adige/Südtirol, Trento, Pellizzano, G428",
	"Trentino-Alto Adige/Südtirol, Trento, Pelugo, G429",
	"Trentino-Alto Adige/Südtirol, Trento, Pergine Valsugana, G452",
	"Trentino-Alto Adige/Südtirol, Trento, Pieve Tesino, G656",
	"Trentino-Alto Adige/Südtirol, Trento, Pinzolo, G681",
	"Trentino-Alto Adige/Südtirol, Trento, Pomarolo, G808",
	"Trentino-Alto Adige/Südtirol, Trento, Predazzo, H018",
	"Trentino-Alto Adige/Südtirol, Trento, Rabbi, H146",
	"Trentino-Alto Adige/Südtirol, Trento, Riva del Garda, H330",
	"Trentino-Alto Adige/Südtirol, Trento, Romeno, H517",
	"Trentino-Alto Adige/Südtirol, Trento, Roncegno Terme, H528",
	"Trentino-Alto Adige/Südtirol, Trento, Ronchi Valsugana, H532",
	"Trentino-Alto Adige/Südtirol, Trento, Ronzone, H552",
	"Trentino-Alto Adige/Südtirol, Trento, Roverè della Luna, H607",
	"Trentino-Alto Adige/Südtirol, Trento, Rovereto, H612",
	"Trentino-Alto Adige/Südtirol, Trento, Ruffrè-Mendola, H634",
	"Trentino-Alto Adige/Südtirol, Trento, Rumo, H639",
	"Trentino-Alto Adige/Südtirol, Trento, Sagron Mis, H666",
	"Trentino-Alto Adige/Südtirol, Trento, Samone, H754",
	"Trentino-Alto Adige/Südtirol, Trento, San Michele all'Adige, I042",
	"Trentino-Alto Adige/Südtirol, Trento, Sant'Orsola Terme, I354",
	"Trentino-Alto Adige/Südtirol, Trento, Sanzeno, I411",
	"Trentino-Alto Adige/Südtirol, Trento, Sarnonico, I439",
	"Trentino-Alto Adige/Südtirol, Trento, Scurelle, I554",
	"Trentino-Alto Adige/Südtirol, Trento, Segonzano, I576",
	"Trentino-Alto Adige/Südtirol, Trento, Sfruz, I714",
	"Trentino-Alto Adige/Südtirol, Trento, Soraga di Fassa, I839",
	"Trentino-Alto Adige/Südtirol, Trento, Sover, I871",
	"Trentino-Alto Adige/Südtirol, Trento, Spiazzo, I899",
	"Trentino-Alto Adige/Südtirol, Trento, Spormaggiore, I924",
	"Trentino-Alto Adige/Südtirol, Trento, Sporminore, I925",
	"Trentino-Alto Adige/Südtirol, Trento, Stenico, I949",
	"Trentino-Alto Adige/Südtirol, Trento, Storo, I964",
	"Trentino-Alto Adige/Südtirol, Trento, Strembo, I975",
	"Trentino-Alto Adige/Südtirol, Trento, Telve, L089",
	"Trentino-Alto Adige/Südtirol, Trento, Telve di Sopra, L090",
	"Trentino-Alto Adige/Südtirol, Trento, Tenna, L096",
	"Trentino-Alto Adige/Südtirol, Trento, Tenno, L097",
	"Trentino-Alto Adige/Südtirol, Trento, Terragnolo, L121",
	"Trentino-Alto Adige/Südtirol, Trento, Terzolas, L145",
	"Trentino-Alto Adige/Südtirol, Trento, Tesero, L147",
	"Trentino-Alto Adige/Südtirol, Trento, Tione di Trento, L174",
	"Trentino-Alto Adige/Südtirol, Trento, Ton, L200",
	"Trentino-Alto Adige/Südtirol, Trento, Torcegno, L211",
	"Trentino-Alto Adige/Südtirol, Trento, Trambileno, L322",
	"Trentino-Alto Adige/Südtirol, Trento, Trento, L378",
	"Trentino-Alto Adige/Südtirol, Trento, Valfloriana, L575",
	"Trentino-Alto Adige/Südtirol, Trento, Vallarsa, L588",
	"Trentino-Alto Adige/Südtirol, Trento, Vermiglio, L769",
	"Trentino-Alto Adige/Südtirol, Trento, Vignola-Falesina, L886",
	"Trentino-Alto Adige/Südtirol, Trento, Villa Lagarina, L957",
	"Trentino-Alto Adige/Südtirol, Trento, Volano, M113",
	"Trentino-Alto Adige/Südtirol, Trento, Ziano di Fiemme, M173",
	"Trentino-Alto Adige/Südtirol, Trento, Comano Terme, M314",
	"Trentino-Alto Adige/Südtirol, Trento, Ledro, M313",
	"Trentino-Alto Adige/Südtirol, Trento, Predaia, M344",
	"Trentino-Alto Adige/Südtirol, Trento, San Lorenzo Dorsino, M345",
	"Trentino-Alto Adige/Südtirol, Trento, Valdaone, M343",
	"Trentino-Alto Adige/Südtirol, Trento, Dimaro Folgarida, M366",
	"Trentino-Alto Adige/Südtirol, Trento, Pieve di Bono-Prezzo, M365",
	"Trentino-Alto Adige/Südtirol, Trento, Altavalle, M349",
	"Trentino-Alto Adige/Südtirol, Trento, Altopiano della Vigolana, M350",
	"Trentino-Alto Adige/Südtirol, Trento, Amblar-Don, M351",
	"Trentino-Alto Adige/Südtirol, Trento, Borgo Chiese, M352",
	"Trentino-Alto Adige/Südtirol, Trento, Borgo Lares, M353",
	"Trentino-Alto Adige/Südtirol, Trento, Castel Ivano, M354",
	"Trentino-Alto Adige/Südtirol, Trento, Cembra Lisignago, M355",
	"Trentino-Alto Adige/Südtirol, Trento, Contà, M356",
	"Trentino-Alto Adige/Südtirol, Trento, Madruzzo, M357",
	"Trentino-Alto Adige/Südtirol, Trento, Porte di Rendena, M358",
	"Trentino-Alto Adige/Südtirol, Trento, Primiero San Martino di Castrozza, M359",
	"Trentino-Alto Adige/Südtirol, Trento, Sella Giudicarie, M360",
	"Trentino-Alto Adige/Südtirol, Trento, Tre Ville, M361",
	"Trentino-Alto Adige/Südtirol, Trento, Vallelaghi, M362",
	"Trentino-Alto Adige/Südtirol, Trento, Ville d'Anaunia, M363",
	"Trentino-Alto Adige/Südtirol, Trento, San Giovanni di Fassa, M390",
	"Trentino-Alto Adige/Südtirol, Trento, Terre d'Adige, M407",
	"Trentino-Alto Adige/Südtirol, Trento, Borgo d'Anaunia, M429",
	"Trentino-Alto Adige/Südtirol, Trento, Novella, M430",
	"Trentino-Alto Adige/Südtirol, Trento, Ville di Fiemme, M431",
	"Veneto, Verona, Affi, A061",
	"Veneto, Verona, Albaredo d'Adige, A137",
	"Veneto, Verona, Angiari, A292",
	"Veneto, Verona, Arcole, A374",
	"Veneto, Verona, Badia Calavena, A540",
	"Veneto, Verona, Bardolino, A650",
	"Veneto, Verona, Belfiore, A737",
	"Veneto, Verona, Bevilacqua, A837",
	"Veneto, Verona, Bonavigo, A964",
	"Veneto, Verona, Boschi Sant'Anna, B070",
	"Veneto, Verona, Bosco Chiesanuova, B073",
	"Veneto, Verona, Bovolone, B107",
	"Veneto, Verona, Brentino Belluno, B152",
	"Veneto, Verona, Brenzone sul Garda, B154",
	"Veneto, Verona, Bussolengo, B296",
	"Veneto, Verona, Buttapietra, B304",
	"Veneto, Verona, Caldiero, B402",
	"Veneto, Verona, Caprino Veronese, B709",
	"Veneto, Verona, Casaleone, B886",
	"Veneto, Verona, Castagnaro, C041",
	"Veneto, Verona, Castel d'Azzano, C078",
	"Veneto, Verona, Castelnuovo del Garda, C225",
	"Veneto, Verona, Cavaion Veronese, C370",
	"Veneto, Verona, Cazzano di Tramigna, C412",
	"Veneto, Verona, Cerea, C498",
	"Veneto, Verona, Cerro Veronese, C538",
	"Veneto, Verona, Cologna Veneta, C890",
	"Veneto, Verona, Colognola ai Colli, C897",
	"Veneto, Verona, Concamarise, C943",
	"Veneto, Verona, Costermano sul Garda, D118",
	"Veneto, Verona, Dolcè, D317",
	"Veneto, Verona, Erbè, D419",
	"Veneto, Verona, Erbezzo, D420",
	"Veneto, Verona, Ferrara di Monte Baldo, D549",
	"Veneto, Verona, Fumane, D818",
	"Veneto, Verona, Garda, D915",
	"Veneto, Verona, Gazzo Veronese, D957",
	"Veneto, Verona, Grezzana, E171",
	"Veneto, Verona, Illasi, E284",
	"Veneto, Verona, Isola della Scala, E349",
	"Veneto, Verona, Isola Rizza, E358",
	"Veneto, Verona, Lavagno, E489",
	"Veneto, Verona, Lazise, E502",
	"Veneto, Verona, Legnago, E512",
	"Veneto, Verona, Malcesine, E848",
	"Veneto, Verona, Marano di Valpolicella, E911",
	"Veneto, Verona, Mezzane di Sotto, F172",
	"Veneto, Verona, Minerbe, F218",
	"Veneto, Verona, Montecchia di Crosara, F461",
	"Veneto, Verona, Monteforte d'Alpone, F508",
	"Veneto, Verona, Mozzecane, F789",
	"Veneto, Verona, Negrar di Valpolicella, F861",
	"Veneto, Verona, Nogara, F918",
	"Veneto, Verona, Nogarole Rocca, F921",
	"Veneto, Verona, Oppeano, G080",
	"Veneto, Verona, Palù, G297",
	"Veneto, Verona, Pastrengo, G365",
	"Veneto, Verona, Pescantina, G481",
	"Veneto, Verona, Peschiera del Garda, G489",
	"Veneto, Verona, Povegliano Veronese, G945",
	"Veneto, Verona, Pressana, H048",
	"Veneto, Verona, Rivoli Veronese, H356",
	"Veneto, Verona, Roncà, H522",
	"Veneto, Verona, Ronco all'Adige, H540",
	"Veneto, Verona, Roverchiara, H606",
	"Veneto, Verona, Roveredo di Guà, H610",
	"Veneto, Verona, Roverè Veronese, H608",
	"Veneto, Verona, Salizzole, H714",
	"Veneto, Verona, San Bonifacio, H783",
	"Veneto, Verona, San Giovanni Ilarione, H916",
	"Veneto, Verona, San Giovanni Lupatoto, H924",
	"Veneto, Verona, Sanguinetto, H944",
	"Veneto, Verona, San Martino Buon Albergo, I003",
	"Veneto, Verona, San Mauro di Saline, H712",
	"Veneto, Verona, San Pietro di Morubio, I105",
	"Veneto, Verona, San Pietro in Cariano, I109",
	"Veneto, Verona, Sant'Ambrogio di Valpolicella, I259",
	"Veneto, Verona, Sant'Anna d'Alfaedo, I292",
	"Veneto, Verona, San Zeno di Montagna, I414",
	"Veneto, Verona, Selva di Progno, I594",
	"Veneto, Verona, Soave, I775",
	"Veneto, Verona, Sommacampagna, I821",
	"Veneto, Verona, Sona, I826",
	"Veneto, Verona, Sorgà, I850",
	"Veneto, Verona, Terrazzo, L136",
	"Veneto, Verona, Torri del Benaco, L287",
	"Veneto, Verona, Tregnago, L364",
	"Veneto, Verona, Trevenzuolo, L396",
	"Veneto, Verona, Valeggio sul Mincio, L567",
	"Veneto, Verona, Velo Veronese, L722",
	"Veneto, Verona, Verona, L781",
	"Veneto, Verona, Veronella, D193",
	"Veneto, Verona, Vestenanova, L810",
	"Veneto, Verona, Vigasio, L869",
	"Veneto, Verona, Villa Bartolomea, L912",
	"Veneto, Verona, Villafranca di Verona, L949",
	"Veneto, Verona, Zevio, M172",
	"Veneto, Verona, Zimella, M178",
	"Veneto, Vicenza, Agugliaro, A093",
	"Veneto, Vicenza, Albettone, A154",
	"Veneto, Vicenza, Alonte, A220",
	"Veneto, Vicenza, Altavilla Vicentina, A231",
	"Veneto, Vicenza, Altissimo, A236",
	"Veneto, Vicenza, Arcugnano, A377",
	"Veneto, Vicenza, Arsiero, A444",
	"Veneto, Vicenza, Arzignano, A459",
	"Veneto, Vicenza, Asiago, A465",
	"Veneto, Vicenza, Asigliano Veneto, A467",
	"Veneto, Vicenza, Bassano del Grappa, A703",
	"Veneto, Vicenza, Bolzano Vicentino, A954",
	"Veneto, Vicenza, Breganze, B132",
	"Veneto, Vicenza, Brendola, B143",
	"Veneto, Vicenza, Bressanvido, B161",
	"Veneto, Vicenza, Brogliano, B196",
	"Veneto, Vicenza, Caldogno, B403",
	"Veneto, Vicenza, Caltrano, B433",
	"Veneto, Vicenza, Calvene, B441",
	"Veneto, Vicenza, Camisano Vicentino, B485",
	"Veneto, Vicenza, Campiglia dei Berici, B511",
	"Veneto, Vicenza, Carrè, B835",
	"Veneto, Vicenza, Cartigliano, B844",
	"Veneto, Vicenza, Cassola, C037",
	"Veneto, Vicenza, Castegnero, C056",
	"Veneto, Vicenza, Castelgomberto, C119",
	"Veneto, Vicenza, Chiampo, C605",
	"Veneto, Vicenza, Chiuppano, C650",
	"Veneto, Vicenza, Cogollo del Cengio, C824",
	"Veneto, Vicenza, Cornedo Vicentino, D020",
	"Veneto, Vicenza, Costabissara, D107",
	"Veneto, Vicenza, Creazzo, D136",
	"Veneto, Vicenza, Crespadoro, D156",
	"Veneto, Vicenza, Dueville, D379",
	"Veneto, Vicenza, Enego, D407",
	"Veneto, Vicenza, Fara Vicentino, D496",
	"Veneto, Vicenza, Foza, D750",
	"Veneto, Vicenza, Gallio, D882",
	"Veneto, Vicenza, Gambellara, D897",
	"Veneto, Vicenza, Gambugliano, D902",
	"Veneto, Vicenza, Grisignano di Zocco, E184",
	"Veneto, Vicenza, Grumolo delle Abbadesse, E226",
	"Veneto, Vicenza, Isola Vicentina, E354",
	"Veneto, Vicenza, Laghi, E403",
	"Veneto, Vicenza, Lastebasse, E465",
	"Veneto, Vicenza, Longare, E671",
	"Veneto, Vicenza, Lonigo, E682",
	"Veneto, Vicenza, Lugo di Vicenza, E731",
	"Veneto, Vicenza, Malo, E864",
	"Veneto, Vicenza, Marano Vicentino, E912",
	"Veneto, Vicenza, Marostica, E970",
	"Veneto, Vicenza, Montebello Vicentino, F442",
	"Veneto, Vicenza, Montecchio Maggiore, F464",
	"Veneto, Vicenza, Montecchio Precalcino, F465",
	"Veneto, Vicenza, Monte di Malo, F486",
	"Veneto, Vicenza, Montegalda, F514",
	"Veneto, Vicenza, Montegaldella, F515",
	"Veneto, Vicenza, Monteviale, F662",
	"Veneto, Vicenza, Monticello Conte Otto, F675",
	"Veneto, Vicenza, Montorso Vicentino, F696",
	"Veneto, Vicenza, Mussolente, F829",
	"Veneto, Vicenza, Nanto, F838",
	"Veneto, Vicenza, Nogarole Vicentino, F922",
	"Veneto, Vicenza, Nove, F957",
	"Veneto, Vicenza, Noventa Vicentina, F964",
	"Veneto, Vicenza, Orgiano, G095",
	"Veneto, Vicenza, Pedemonte, G406",
	"Veneto, Vicenza, Pianezze, G560",
	"Veneto, Vicenza, Piovene Rocchette, G694",
	"Veneto, Vicenza, Pojana Maggiore, G776",
	"Veneto, Vicenza, Posina, G931",
	"Veneto, Vicenza, Pove del Grappa, G943",
	"Veneto, Vicenza, Pozzoleone, G957",
	"Veneto, Vicenza, Quinto Vicentino, H134",
	"Veneto, Vicenza, Recoaro Terme, H214",
	"Veneto, Vicenza, Roana, H361",
	"Veneto, Vicenza, Romano d'Ezzelino, H512",
	"Veneto, Vicenza, Rosà, H556",
	"Veneto, Vicenza, Rossano Veneto, H580",
	"Veneto, Vicenza, Rotzo, H594",
	"Veneto, Vicenza, Salcedo, F810",
	"Veneto, Vicenza, Sandrigo, H829",
	"Veneto, Vicenza, San Pietro Mussolino, I117",
	"Veneto, Vicenza, Santorso, I353",
	"Veneto, Vicenza, San Vito di Leguzzano, I401",
	"Veneto, Vicenza, Sarcedo, I425",
	"Veneto, Vicenza, Sarego, I430",
	"Veneto, Vicenza, Schiavon, I527",
	"Veneto, Vicenza, Schio, I531",
	"Veneto, Vicenza, Solagna, I783",
	"Veneto, Vicenza, Sossano, I867",
	"Veneto, Vicenza, Sovizzo, I879",
	"Veneto, Vicenza, Tezze sul Brenta, L156",
	"Veneto, Vicenza, Thiene, L157",
	"Veneto, Vicenza, Tonezza del Cimone, D717",
	"Veneto, Vicenza, Torrebelvicino, L248",
	"Veneto, Vicenza, Torri di Quartesolo, L297",
	"Veneto, Vicenza, Trissino, L433",
	"Veneto, Vicenza, Valdagno, L551",
	"Veneto, Vicenza, Valdastico, L554",
	"Veneto, Vicenza, Valli del Pasubio, L624",
	"Veneto, Vicenza, Velo d'Astico, L723",
	"Veneto, Vicenza, Vicenza, L840",
	"Veneto, Vicenza, Villaga, L952",
	"Veneto, Vicenza, Villaverla, M032",
	"Veneto, Vicenza, Zanè, M145",
	"Veneto, Vicenza, Zermeghedo, M170",
	"Veneto, Vicenza, Zovencedo, M194",
	"Veneto, Vicenza, Zugliano, M199",
	"Veneto, Vicenza, Val Liona, M384",
	"Veneto, Vicenza, Barbarano Mossano, M401",
	"Veneto, Vicenza, Valbrenta, M423",
	"Veneto, Vicenza, Colceresa, M426",
	"Veneto, Vicenza, Lusiana Conco, M427",
	"Veneto, Belluno, Agordo, A083",
	"Veneto, Belluno, Alano di Piave, A121",
	"Veneto, Belluno, Alleghe, A206",
	"Veneto, Belluno, Arsiè, A443",
	"Veneto, Belluno, Auronzo di Cadore, A501",
	"Veneto, Belluno, Belluno, A757",
	"Veneto, Belluno, Borca di Cadore, A982",
	"Veneto, Belluno, Calalzo di Cadore, B375",
	"Veneto, Belluno, Cencenighe Agordino, C458",
	"Veneto, Belluno, Cesiomaggiore, C577",
	"Veneto, Belluno, Chies d'Alpago, C630",
	"Veneto, Belluno, Cibiana di Cadore, C672",
	"Veneto, Belluno, Colle Santa Lucia, C872",
	"Veneto, Belluno, Comelico Superiore, C920",
	"Veneto, Belluno, Cortina d'Ampezzo, A266",
	"Veneto, Belluno, Danta di Cadore, D247",
	"Veneto, Belluno, Domegge di Cadore, D330",
	"Veneto, Belluno, Falcade, D470",
	"Veneto, Belluno, Feltre, D530",
	"Veneto, Belluno, Fonzaso, D686",
	"Veneto, Belluno, Canale d'Agordo, B574",
	"Veneto, Belluno, Gosaldo, E113",
	"Veneto, Belluno, Lamon, E429",
	"Veneto, Belluno, La Valle Agordina, E490",
	"Veneto, Belluno, Limana, E588",
	"Veneto, Belluno, Livinallongo del Col di Lana, E622",
	"Veneto, Belluno, Lorenzago di Cadore, E687",
	"Veneto, Belluno, Lozzo di Cadore, E708",
	"Veneto, Belluno, Ospitale di Cadore, G169",
	"Veneto, Belluno, Pedavena, G404",
	"Veneto, Belluno, Perarolo di Cadore, G442",
	"Veneto, Belluno, Pieve di Cadore, G642",
	"Veneto, Belluno, Ponte nelle Alpi, B662",
	"Veneto, Belluno, Rivamonte Agordino, H327",
	"Veneto, Belluno, Rocca Pietore, H379",
	"Veneto, Belluno, San Gregorio nelle Alpi, H938",
	"Veneto, Belluno, San Nicolò di Comelico, I063",
	"Veneto, Belluno, San Pietro di Cadore, I088",
	"Veneto, Belluno, Santa Giustina, I206",
	"Veneto, Belluno, San Tomaso Agordino, I347",
	"Veneto, Belluno, Santo Stefano di Cadore, C919",
	"Veneto, Belluno, San Vito di Cadore, I392",
	"Veneto, Belluno, Sedico, I563",
	"Veneto, Belluno, Selva di Cadore, I592",
	"Veneto, Belluno, Seren del Grappa, I626",
	"Veneto, Belluno, Sospirolo, I866",
	"Veneto, Belluno, Soverzene, I876",
	"Veneto, Belluno, Sovramonte, I673",
	"Veneto, Belluno, Taibon Agordino, L030",
	"Veneto, Belluno, Tambre, L040",
	"Veneto, Belluno, Vallada Agordina, L584",
	"Veneto, Belluno, Valle di Cadore, L590",
	"Veneto, Belluno, Vigo di Cadore, L890",
	"Veneto, Belluno, Vodo Cadore, M108",
	"Veneto, Belluno, Voltago Agordino, M124",
	"Veneto, Belluno, Zoppè di Cadore, M189",
	"Veneto, Belluno, Quero Vas, M332",
	"Veneto, Belluno, Longarone, M342",
	"Veneto, Belluno, Alpago, M375",
	"Veneto, Belluno, Val di Zoldo, M374",
	"Veneto, Belluno, Borgo Valbelluna, M421",
	"Veneto, Treviso, Altivole, A237",
	"Veneto, Treviso, Arcade, A360",
	"Veneto, Treviso, Asolo, A471",
	"Veneto, Treviso, Borso del Grappa, B061",
	"Veneto, Treviso, Breda di Piave, B128",
	"Veneto, Treviso, Caerano di San Marco, B349",
	"Veneto, Treviso, Cappella Maggiore, B678",
	"Veneto, Treviso, Carbonera, B744",
	"Veneto, Treviso, Casale sul Sile, B879",
	"Veneto, Treviso, Casier, B965",
	"Veneto, Treviso, Castelcucco, C073",
	"Veneto, Treviso, Castelfranco Veneto, C111",
	"Veneto, Treviso, Castello di Godego, C190",
	"Veneto, Treviso, Cavaso del Tomba, C384",
	"Veneto, Treviso, Cessalto, C580",
	"Veneto, Treviso, Chiarano, C614",
	"Veneto, Treviso, Cimadolmo, C689",
	"Veneto, Treviso, Cison di Valmarino, C735",
	"Veneto, Treviso, Codognè, C815",
	"Veneto, Treviso, Colle Umberto, C848",
	"Veneto, Treviso, Conegliano, C957",
	"Veneto, Treviso, Cordignano, C992",
	"Veneto, Treviso, Cornuda, D030",
	"Veneto, Treviso, Crocetta del Montello, C670",
	"Veneto, Treviso, Farra di Soligo, D505",
	"Veneto, Treviso, Follina, D654",
	"Veneto, Treviso, Fontanelle, D674",
	"Veneto, Treviso, Fonte, D680",
	"Veneto, Treviso, Fregona, D794",
	"Veneto, Treviso, Gaiarine, D854",
	"Veneto, Treviso, Giavera del Montello, E021",
	"Veneto, Treviso, Godega di Sant'Urbano, E071",
	"Veneto, Treviso, Gorgo al Monticano, E092",
	"Veneto, Treviso, Istrana, E373",
	"Veneto, Treviso, Loria, E692",
	"Veneto, Treviso, Mansuè, E893",
	"Veneto, Treviso, Mareno di Piave, E940",
	"Veneto, Treviso, Maser, F009",
	"Veneto, Treviso, Maserada sul Piave, F012",
	"Veneto, Treviso, Meduna di Livenza, F088",
	"Veneto, Treviso, Miane, F190",
	"Veneto, Treviso, Mogliano Veneto, F269",
	"Veneto, Treviso, Monastier di Treviso, F332",
	"Veneto, Treviso, Monfumo, F360",
	"Veneto, Treviso, Montebelluna, F443",
	"Veneto, Treviso, Morgano, F725",
	"Veneto, Treviso, Moriago della Battaglia, F729",
	"Veneto, Treviso, Motta di Livenza, F770",
	"Veneto, Treviso, Nervesa della Battaglia, F872",
	"Veneto, Treviso, Oderzo, F999",
	"Veneto, Treviso, Ormelle, G115",
	"Veneto, Treviso, Orsago, G123",
	"Veneto, Treviso, Paese, G229",
	"Veneto, Treviso, Pederobba, G408",
	"Veneto, Treviso, Pieve di Soligo, G645",
	"Veneto, Treviso, Ponte di Piave, G846",
	"Veneto, Treviso, Ponzano Veneto, G875",
	"Veneto, Treviso, Portobuffolè, G909",
	"Veneto, Treviso, Possagno, G933",
	"Veneto, Treviso, Povegliano, G944",
	"Veneto, Treviso, Preganziol, H022",
	"Veneto, Treviso, Quinto di Treviso, H131",
	"Veneto, Treviso, Refrontolo, H220",
	"Veneto, Treviso, Resana, H238",
	"Veneto, Treviso, Revine Lago, H253",
	"Veneto, Treviso, Riese Pio X, H280",
	"Veneto, Treviso, Roncade, H523",
	"Veneto, Treviso, Salgareda, H706",
	"Veneto, Treviso, San Biagio di Callalta, H781",
	"Veneto, Treviso, San Fior, H843",
	"Veneto, Treviso, San Pietro di Feletto, I103",
	"Veneto, Treviso, San Polo di Piave, I124",
	"Veneto, Treviso, Santa Lucia di Piave, I221",
	"Veneto, Treviso, San Vendemiano, I382",
	"Veneto, Treviso, San Zenone degli Ezzelini, I417",
	"Veneto, Treviso, Sarmede, I435",
	"Veneto, Treviso, Segusino, I578",
	"Veneto, Treviso, Sernaglia della Battaglia, I635",
	"Veneto, Treviso, Silea, F116",
	"Veneto, Treviso, Spresiano, I927",
	"Veneto, Treviso, Susegana, L014",
	"Veneto, Treviso, Tarzo, L058",
	"Veneto, Treviso, Trevignano, L402",
	"Veneto, Treviso, Treviso, L407",
	"Veneto, Treviso, Valdobbiadene, L565",
	"Veneto, Treviso, Vazzola, L700",
	"Veneto, Treviso, Vedelago, L706",
	"Veneto, Treviso, Vidor, L856",
	"Veneto, Treviso, Villorba, M048",
	"Veneto, Treviso, Vittorio Veneto, M089",
	"Veneto, Treviso, Volpago del Montello, M118",
	"Veneto, Treviso, Zenson di Piave, M163",
	"Veneto, Treviso, Zero Branco, M171",
	"Veneto, Treviso, Pieve del Grappa, M422",
	"Veneto, Venezia, Annone Veneto, A302",
	"Veneto, Venezia, Campagna Lupia, B493",
	"Veneto, Venezia, Campolongo Maggiore, B546",
	"Veneto, Venezia, Camponogara, B554",
	"Veneto, Venezia, Caorle, B642",
	"Veneto, Venezia, Cavarzere, C383",
	"Veneto, Venezia, Ceggia, C422",
	"Veneto, Venezia, Chioggia, C638",
	"Veneto, Venezia, Cinto Caomaggiore, C714",
	"Veneto, Venezia, Cona, C938",
	"Veneto, Venezia, Concordia Sagittaria, C950",
	"Veneto, Venezia, Dolo, D325",
	"Veneto, Venezia, Eraclea, D415",
	"Veneto, Venezia, Fiesso d'Artico, D578",
	"Veneto, Venezia, Fossalta di Piave, D740",
	"Veneto, Venezia, Fossalta di Portogruaro, D741",
	"Veneto, Venezia, Fossò, D748",
	"Veneto, Venezia, Gruaro, E215",
	"Veneto, Venezia, Jesolo, C388",
	"Veneto, Venezia, Marcon, E936",
	"Veneto, Venezia, Martellago, E980",
	"Veneto, Venezia, Meolo, F130",
	"Veneto, Venezia, Mira, F229",
	"Veneto, Venezia, Mirano, F241",
	"Veneto, Venezia, Musile di Piave, F826",
	"Veneto, Venezia, Noale, F904",
	"Veneto, Venezia, Noventa di Piave, F963",
	"Veneto, Venezia, Pianiga, G565",
	"Veneto, Venezia, Portogruaro, G914",
	"Veneto, Venezia, Pramaggiore, G981",
	"Veneto, Venezia, Quarto d'Altino, H117",
	"Veneto, Venezia, Salzano, H735",
	"Veneto, Venezia, San Donà di Piave, H823",
	"Veneto, Venezia, San Michele al Tagliamento, I040",
	"Veneto, Venezia, Santa Maria di Sala, I242",
	"Veneto, Venezia, San Stino di Livenza, I373",
	"Veneto, Venezia, Scorzè, I551",
	"Veneto, Venezia, Spinea, I908",
	"Veneto, Venezia, Stra, I965",
	"Veneto, Venezia, Teglio Veneto, L085",
	"Veneto, Venezia, Torre di Mosto, L267",
	"Veneto, Venezia, Venezia, L736",
	"Veneto, Venezia, Vigonovo, L899",
	"Veneto, Venezia, Cavallino-Treporti, M308",
	"Veneto, Padova, Abano Terme, A001",
	"Veneto, Padova, Agna, A075",
	"Veneto, Padova, Albignasego, A161",
	"Veneto, Padova, Anguillara Veneta, A296",
	"Veneto, Padova, Arquà Petrarca, A434",
	"Veneto, Padova, Arre, A438",
	"Veneto, Padova, Arzergrande, A458",
	"Veneto, Padova, Bagnoli di Sopra, A568",
	"Veneto, Padova, Baone, A613",
	"Veneto, Padova, Barbona, A637",
	"Veneto, Padova, Battaglia Terme, A714",
	"Veneto, Padova, Boara Pisani, A906",
	"Veneto, Padova, Borgoricco, B031",
	"Veneto, Padova, Bovolenta, B106",
	"Veneto, Padova, Brugine, B213",
	"Veneto, Padova, Cadoneghe, B345",
	"Veneto, Padova, Campodarsego, B524",
	"Veneto, Padova, Campodoro, B531",
	"Veneto, Padova, Camposampiero, B563",
	"Veneto, Padova, Campo San Martino, B564",
	"Veneto, Padova, Candiana, B589",
	"Veneto, Padova, Carceri, B749",
	"Veneto, Padova, Carmignano di Brenta, B795",
	"Veneto, Padova, Cartura, B848",
	"Veneto, Padova, Casale di Scodosia, B877",
	"Veneto, Padova, Casalserugo, B912",
	"Veneto, Padova, Castelbaldo, C057",
	"Veneto, Padova, Cervarese Santa Croce, C544",
	"Veneto, Padova, Cinto Euganeo, C713",
	"Veneto, Padova, Cittadella, C743",
	"Veneto, Padova, Codevigo, C812",
	"Veneto, Padova, Conselve, C964",
	"Veneto, Padova, Correzzola, D040",
	"Veneto, Padova, Curtarolo, D226",
	"Veneto, Padova, Este, D442",
	"Veneto, Padova, Fontaniva, D679",
	"Veneto, Padova, Galliera Veneta, D879",
	"Veneto, Padova, Galzignano Terme, D889",
	"Veneto, Padova, Gazzo, D956",
	"Veneto, Padova, Grantorto, E145",
	"Veneto, Padova, Granze, E146",
	"Veneto, Padova, Legnaro, E515",
	"Veneto, Padova, Limena, E592",
	"Veneto, Padova, Loreggia, E684",
	"Veneto, Padova, Lozzo Atestino, E709",
	"Veneto, Padova, Maserà di Padova, F011",
	"Veneto, Padova, Masi, F013",
	"Veneto, Padova, Massanzago, F033",
	"Veneto, Padova, Megliadino San Vitale, F092",
	"Veneto, Padova, Merlara, F148",
	"Veneto, Padova, Mestrino, F161",
	"Veneto, Padova, Monselice, F382",
	"Veneto, Padova, Montagnana, F394",
	"Veneto, Padova, Montegrotto Terme, F529",
	"Veneto, Padova, Noventa Padovana, F962",
	"Veneto, Padova, Ospedaletto Euganeo, G167",
	"Veneto, Padova, Padova, G224",
	"Veneto, Padova, Pernumia, G461",
	"Veneto, Padova, Piacenza d'Adige, G534",
	"Veneto, Padova, Piazzola sul Brenta, G587",
	"Veneto, Padova, Piombino Dese, G688",
	"Veneto, Padova, Piove di Sacco, G693",
	"Veneto, Padova, Polverara, G802",
	"Veneto, Padova, Ponso, G823",
	"Veneto, Padova, Pontelongo, G850",
	"Veneto, Padova, Ponte San Nicolò, G855",
	"Veneto, Padova, Pozzonovo, G963",
	"Veneto, Padova, Rovolon, H622",
	"Veneto, Padova, Rubano, H625",
	"Veneto, Padova, Saccolongo, H655",
	"Veneto, Padova, San Giorgio delle Pertiche, H893",
	"Veneto, Padova, San Giorgio in Bosco, H897",
	"Veneto, Padova, San Martino di Lupari, I008",
	"Veneto, Padova, San Pietro in Gu, I107",
	"Veneto, Padova, San Pietro Viminario, I120",
	"Veneto, Padova, Santa Giustina in Colle, I207",
	"Veneto, Padova, Sant'Angelo di Piove di Sacco, I275",
	"Veneto, Padova, Sant'Elena, I319",
	"Veneto, Padova, Sant'Urbano, I375",
	"Veneto, Padova, Saonara, I418",
	"Veneto, Padova, Selvazzano Dentro, I595",
	"Veneto, Padova, Solesino, I799",
	"Veneto, Padova, Stanghella, I938",
	"Veneto, Padova, Teolo, L100",
	"Veneto, Padova, Terrassa Padovana, L132",
	"Veneto, Padova, Tombolo, L199",
	"Veneto, Padova, Torreglia, L270",
	"Veneto, Padova, Trebaseleghe, L349",
	"Veneto, Padova, Tribano, L414",
	"Veneto, Padova, Urbana, L497",
	"Veneto, Padova, Veggiano, L710",
	"Veneto, Padova, Vescovana, L805",
	"Veneto, Padova, Vighizzolo d'Este, L878",
	"Veneto, Padova, Vigodarzere, L892",
	"Veneto, Padova, Vigonza, L900",
	"Veneto, Padova, Villa del Conte, L934",
	"Veneto, Padova, Villa Estense, L937",
	"Veneto, Padova, Villafranca Padovana, L947",
	"Veneto, Padova, Villanova di Camposampiero, L979",
	"Veneto, Padova, Vo', M103",
	"Veneto, Padova, Due Carrare, M300",
	"Veneto, Padova, Borgo Veneto, M402",
	"Veneto, Rovigo, Adria, A059",
	"Veneto, Rovigo, Ariano nel Polesine, A400",
	"Veneto, Rovigo, Arquà Polesine, A435",
	"Veneto, Rovigo, Badia Polesine, A539",
	"Veneto, Rovigo, Bagnolo di Po, A574",
	"Veneto, Rovigo, Bergantino, A795",
	"Veneto, Rovigo, Bosaro, B069",
	"Veneto, Rovigo, Calto, B432",
	"Veneto, Rovigo, Canaro, B578",
	"Veneto, Rovigo, Canda, B582",
	"Veneto, Rovigo, Castelguglielmo, C122",
	"Veneto, Rovigo, Castelmassa, C207",
	"Veneto, Rovigo, Castelnovo Bariano, C215",
	"Veneto, Rovigo, Ceneselli, C461",
	"Veneto, Rovigo, Ceregnano, C500",
	"Veneto, Rovigo, Corbola, C987",
	"Veneto, Rovigo, Costa di Rovigo, D105",
	"Veneto, Rovigo, Crespino, D161",
	"Veneto, Rovigo, Ficarolo, D568",
	"Veneto, Rovigo, Fiesso Umbertiano, D577",
	"Veneto, Rovigo, Frassinelle Polesine, D776",
	"Veneto, Rovigo, Fratta Polesine, D788",
	"Veneto, Rovigo, Gaiba, D855",
	"Veneto, Rovigo, Gavello, D942",
	"Veneto, Rovigo, Giacciano con Baruchella, E008",
	"Veneto, Rovigo, Guarda Veneta, E240",
	"Veneto, Rovigo, Lendinara, E522",
	"Veneto, Rovigo, Loreo, E689",
	"Veneto, Rovigo, Lusia, E761",
	"Veneto, Rovigo, Melara, F095",
	"Veneto, Rovigo, Occhiobello, F994",
	"Veneto, Rovigo, Papozze, G323",
	"Veneto, Rovigo, Pettorazza Grimani, G525",
	"Veneto, Rovigo, Pincara, G673",
	"Veneto, Rovigo, Polesella, G782",
	"Veneto, Rovigo, Pontecchio Polesine, G836",
	"Veneto, Rovigo, Porto Tolle, G923",
	"Veneto, Rovigo, Rosolina, H573",
	"Veneto, Rovigo, Rovigo, H620",
	"Veneto, Rovigo, Salara, H689",
	"Veneto, Rovigo, San Bellino, H768",
	"Veneto, Rovigo, San Martino di Venezze, H996",
	"Veneto, Rovigo, Stienta, I953",
	"Veneto, Rovigo, Taglio di Po, L026",
	"Veneto, Rovigo, Trecenta, L359",
	"Veneto, Rovigo, Villadose, L939",
	"Veneto, Rovigo, Villamarzana, L967",
	"Veneto, Rovigo, Villanova del Ghebbo, L985",
	"Veneto, Rovigo, Villanova Marchesana, L988",
	"Veneto, Rovigo, Porto Viro, G926",
	"Friuli-Venezia Giulia, Udine, Aiello del Friuli, A103",
	"Friuli-Venezia Giulia, Udine, Amaro, A254",
	"Friuli-Venezia Giulia, Udine, Ampezzo, A267",
	"Friuli-Venezia Giulia, Udine, Aquileia, A346",
	"Friuli-Venezia Giulia, Udine, Arta Terme, A447",
	"Friuli-Venezia Giulia, Udine, Artegna, A448",
	"Friuli-Venezia Giulia, Udine, Attimis, A491",
	"Friuli-Venezia Giulia, Udine, Bagnaria Arsa, A553",
	"Friuli-Venezia Giulia, Udine, Basiliano, A700",
	"Friuli-Venezia Giulia, Udine, Bertiolo, A810",
	"Friuli-Venezia Giulia, Udine, Bicinicco, A855",
	"Friuli-Venezia Giulia, Udine, Bordano, A983",
	"Friuli-Venezia Giulia, Udine, Buja, B259",
	"Friuli-Venezia Giulia, Udine, Buttrio, B309",
	"Friuli-Venezia Giulia, Udine, Camino al Tagliamento, B483",
	"Friuli-Venezia Giulia, Udine, Campoformido, B536",
	"Friuli-Venezia Giulia, Udine, Carlino, B788",
	"Friuli-Venezia Giulia, Udine, Cassacco, B994",
	"Friuli-Venezia Giulia, Udine, Castions di Strada, C327",
	"Friuli-Venezia Giulia, Udine, Cavazzo Carnico, C389",
	"Friuli-Venezia Giulia, Udine, Cercivento, C494",
	"Friuli-Venezia Giulia, Udine, Cervignano del Friuli, C556",
	"Friuli-Venezia Giulia, Udine, Chiopris-Viscone, C641",
	"Friuli-Venezia Giulia, Udine, Chiusaforte, C656",
	"Friuli-Venezia Giulia, Udine, Cividale del Friuli, C758",
	"Friuli-Venezia Giulia, Udine, Codroipo, C817",
	"Friuli-Venezia Giulia, Udine, Colloredo di Monte Albano, C885",
	"Friuli-Venezia Giulia, Udine, Comeglians, C918",
	"Friuli-Venezia Giulia, Udine, Corno di Rosazzo, D027",
	"Friuli-Venezia Giulia, Udine, Coseano, D085",
	"Friuli-Venezia Giulia, Udine, Dignano, D300",
	"Friuli-Venezia Giulia, Udine, Dogna, D316",
	"Friuli-Venezia Giulia, Udine, Drenchia, D366",
	"Friuli-Venezia Giulia, Udine, Enemonzo, D408",
	"Friuli-Venezia Giulia, Udine, Faedis, D455",
	"Friuli-Venezia Giulia, Udine, Fagagna, D461",
	"Friuli-Venezia Giulia, Udine, Flaibano, D630",
	"Friuli-Venezia Giulia, Udine, Forni Avoltri, D718",
	"Friuli-Venezia Giulia, Udine, Forni di Sopra, D719",
	"Friuli-Venezia Giulia, Udine, Forni di Sotto, D720",
	"Friuli-Venezia Giulia, Udine, Gemona del Friuli, D962",
	"Friuli-Venezia Giulia, Udine, Gonars, E083",
	"Friuli-Venezia Giulia, Udine, Grimacco, E179",
	"Friuli-Venezia Giulia, Udine, Latisana, E473",
	"Friuli-Venezia Giulia, Udine, Lauco, E476",
	"Friuli-Venezia Giulia, Udine, Lestizza, E553",
	"Friuli-Venezia Giulia, Udine, Lignano Sabbiadoro, E584",
	"Friuli-Venezia Giulia, Udine, Lusevera, E760",
	"Friuli-Venezia Giulia, Udine, Magnano in Riviera, E820",
	"Friuli-Venezia Giulia, Udine, Majano, E833",
	"Friuli-Venezia Giulia, Udine, Malborghetto Valbruna, E847",
	"Friuli-Venezia Giulia, Udine, Manzano, E899",
	"Friuli-Venezia Giulia, Udine, Marano Lagunare, E910",
	"Friuli-Venezia Giulia, Udine, Martignacco, E982",
	"Friuli-Venezia Giulia, Udine, Mereto di Tomba, F144",
	"Friuli-Venezia Giulia, Udine, Moggio Udinese, F266",
	"Friuli-Venezia Giulia, Udine, Moimacco, F275",
	"Friuli-Venezia Giulia, Udine, Montenars, F574",
	"Friuli-Venezia Giulia, Udine, Mortegliano, F756",
	"Friuli-Venezia Giulia, Udine, Moruzzo, F760",
	"Friuli-Venezia Giulia, Udine, Muzzana del Turgnano, F832",
	"Friuli-Venezia Giulia, Udine, Nimis, F898",
	"Friuli-Venezia Giulia, Udine, Osoppo, G163",
	"Friuli-Venezia Giulia, Udine, Ovaro, G198",
	"Friuli-Venezia Giulia, Udine, Pagnacco, G238",
	"Friuli-Venezia Giulia, Udine, Palazzolo dello Stella, G268",
	"Friuli-Venezia Giulia, Udine, Palmanova, G284",
	"Friuli-Venezia Giulia, Udine, Paluzza, G300",
	"Friuli-Venezia Giulia, Udine, Pasian di Prato, G352",
	"Friuli-Venezia Giulia, Udine, Paularo, G381",
	"Friuli-Venezia Giulia, Udine, Pavia di Udine, G389",
	"Friuli-Venezia Giulia, Udine, Pocenia, G743",
	"Friuli-Venezia Giulia, Udine, Pontebba, G831",
	"Friuli-Venezia Giulia, Udine, Porpetto, G891",
	"Friuli-Venezia Giulia, Udine, Povoletto, G949",
	"Friuli-Venezia Giulia, Udine, Pozzuolo del Friuli, G966",
	"Friuli-Venezia Giulia, Udine, Pradamano, G969",
	"Friuli-Venezia Giulia, Udine, Prato Carnico, H002",
	"Friuli-Venezia Giulia, Udine, Precenicco, H014",
	"Friuli-Venezia Giulia, Udine, Premariacco, H029",
	"Friuli-Venezia Giulia, Udine, Preone, H038",
	"Friuli-Venezia Giulia, Udine, Prepotto, H040",
	"Friuli-Venezia Giulia, Udine, Pulfero, H089",
	"Friuli-Venezia Giulia, Udine, Ragogna, H161",
	"Friuli-Venezia Giulia, Udine, Ravascletto, H196",
	"Friuli-Venezia Giulia, Udine, Raveo, H200",
	"Friuli-Venezia Giulia, Udine, Reana del Rojale, H206",
	"Friuli-Venezia Giulia, Udine, Remanzacco, H229",
	"Friuli-Venezia Giulia, Udine, Resia, H242",
	"Friuli-Venezia Giulia, Udine, Resiutta, H244",
	"Friuli-Venezia Giulia, Udine, Rigolato, H289",
	"Friuli-Venezia Giulia, Udine, Rive d'Arcano, H347",
	"Friuli-Venezia Giulia, Udine, Ronchis, H533",
	"Friuli-Venezia Giulia, Udine, Ruda, H629",
	"Friuli-Venezia Giulia, Udine, San Daniele del Friuli, H816",
	"Friuli-Venezia Giulia, Udine, San Giorgio di Nogaro, H895",
	"Friuli-Venezia Giulia, Udine, San Giovanni al Natisone, H906",
	"Friuli-Venezia Giulia, Udine, San Leonardo, H951",
	"Friuli-Venezia Giulia, Udine, San Pietro al Natisone, I092",
	"Friuli-Venezia Giulia, Udine, Santa Maria la Longa, I248",
	"Friuli-Venezia Giulia, Udine, San Vito al Torre, I404",
	"Friuli-Venezia Giulia, Udine, San Vito di Fagagna, I405",
	"Friuli-Venezia Giulia, Udine, Sauris, I464",
	"Friuli-Venezia Giulia, Udine, Savogna, I478",
	"Friuli-Venezia Giulia, Udine, Sedegliano, I562",
	"Friuli-Venezia Giulia, Udine, Socchieve, I777",
	"Friuli-Venezia Giulia, Udine, Stregna, I974",
	"Friuli-Venezia Giulia, Udine, Sutrio, L018",
	"Friuli-Venezia Giulia, Udine, Taipana, G736",
	"Friuli-Venezia Giulia, Udine, Talmassons, L039",
	"Friuli-Venezia Giulia, Udine, Tarcento, L050",
	"Friuli-Venezia Giulia, Udine, Tarvisio, L057",
	"Friuli-Venezia Giulia, Udine, Tavagnacco, L065",
	"Friuli-Venezia Giulia, Udine, Terzo d'Aquileia, L144",
	"Friuli-Venezia Giulia, Udine, Tolmezzo, L195",
	"Friuli-Venezia Giulia, Udine, Torreano, L246",
	"Friuli-Venezia Giulia, Udine, Torviscosa, L309",
	"Friuli-Venezia Giulia, Udine, Trasaghis, L335",
	"Friuli-Venezia Giulia, Udine, Treppo Grande, L382",
	"Friuli-Venezia Giulia, Udine, Tricesimo, L421",
	"Friuli-Venezia Giulia, Udine, Trivignano Udinese, L438",
	"Friuli-Venezia Giulia, Udine, Udine, L483",
	"Friuli-Venezia Giulia, Udine, Varmo, L686",
	"Friuli-Venezia Giulia, Udine, Venzone, L743",
	"Friuli-Venezia Giulia, Udine, Verzegnis, L801",
	"Friuli-Venezia Giulia, Udine, Villa Santina, L909",
	"Friuli-Venezia Giulia, Udine, Visco, M073",
	"Friuli-Venezia Giulia, Udine, Zuglio, M200",
	"Friuli-Venezia Giulia, Udine, Forgaria nel Friuli, D700",
	"Friuli-Venezia Giulia, Udine, Campolongo Tapogliano, M311",
	"Friuli-Venezia Giulia, Udine, Rivignano Teor, M317",
	"Friuli-Venezia Giulia, Udine, Sappada, I421",
	"Friuli-Venezia Giulia, Udine, Fiumicello Villa Vicentina, M400",
	"Friuli-Venezia Giulia, Udine, Treppo Ligosullo, M399",
	"Friuli-Venezia Giulia, Gorizia, Capriva del Friuli, B712",
	"Friuli-Venezia Giulia, Gorizia, Cormons, D014",
	"Friuli-Venezia Giulia, Gorizia, Doberdò del Lago, D312",
	"Friuli-Venezia Giulia, Gorizia, Dolegna del Collio, D321",
	"Friuli-Venezia Giulia, Gorizia, Farra d'Isonzo, D504",
	"Friuli-Venezia Giulia, Gorizia, Fogliano Redipuglia, D645",
	"Friuli-Venezia Giulia, Gorizia, Gorizia, E098",
	"Friuli-Venezia Giulia, Gorizia, Gradisca d'Isonzo, E124",
	"Friuli-Venezia Giulia, Gorizia, Grado, E125",
	"Friuli-Venezia Giulia, Gorizia, Mariano del Friuli, E952",
	"Friuli-Venezia Giulia, Gorizia, Medea, F081",
	"Friuli-Venezia Giulia, Gorizia, Monfalcone, F356",
	"Friuli-Venezia Giulia, Gorizia, Moraro, F710",
	"Friuli-Venezia Giulia, Gorizia, Mossa, F767",
	"Friuli-Venezia Giulia, Gorizia, Romans d'Isonzo, H514",
	"Friuli-Venezia Giulia, Gorizia, Ronchi dei Legionari, H531",
	"Friuli-Venezia Giulia, Gorizia, Sagrado, H665",
	"Friuli-Venezia Giulia, Gorizia, San Canzian d'Isonzo, H787",
	"Friuli-Venezia Giulia, Gorizia, San Floriano del Collio, H845",
	"Friuli-Venezia Giulia, Gorizia, San Lorenzo Isontino, H964",
	"Friuli-Venezia Giulia, Gorizia, San Pier d'Isonzo, I082",
	"Friuli-Venezia Giulia, Gorizia, Savogna d'Isonzo, I479",
	"Friuli-Venezia Giulia, Gorizia, Staranzano, I939",
	"Friuli-Venezia Giulia, Gorizia, Turriaco, L474",
	"Friuli-Venezia Giulia, Gorizia, Villesse, M043",
	"Friuli-Venezia Giulia, Trieste, Duino Aurisina, D383",
	"Friuli-Venezia Giulia, Trieste, Monrupino, F378",
	"Friuli-Venezia Giulia, Trieste, Muggia, F795",
	"Friuli-Venezia Giulia, Trieste, San Dorligo della Valle, D324",
	"Friuli-Venezia Giulia, Trieste, Sgonico, I715",
	"Friuli-Venezia Giulia, Trieste, Trieste, L424",
	"Friuli-Venezia Giulia, Pordenone, Andreis, A283",
	"Friuli-Venezia Giulia, Pordenone, Arba, A354",
	"Friuli-Venezia Giulia, Pordenone, Aviano, A516",
	"Friuli-Venezia Giulia, Pordenone, Azzano Decimo, A530",
	"Friuli-Venezia Giulia, Pordenone, Barcis, A640",
	"Friuli-Venezia Giulia, Pordenone, Brugnera, B215",
	"Friuli-Venezia Giulia, Pordenone, Budoia, B247",
	"Friuli-Venezia Giulia, Pordenone, Caneva, B598",
	"Friuli-Venezia Giulia, Pordenone, Casarsa della Delizia, B940",
	"Friuli-Venezia Giulia, Pordenone, Castelnovo del Friuli, C217",
	"Friuli-Venezia Giulia, Pordenone, Cavasso Nuovo, C385",
	"Friuli-Venezia Giulia, Pordenone, Chions, C640",
	"Friuli-Venezia Giulia, Pordenone, Cimolais, C699",
	"Friuli-Venezia Giulia, Pordenone, Claut, C790",
	"Friuli-Venezia Giulia, Pordenone, Clauzetto, C791",
	"Friuli-Venezia Giulia, Pordenone, Cordenons, C991",
	"Friuli-Venezia Giulia, Pordenone, Cordovado, C993",
	"Friuli-Venezia Giulia, Pordenone, Erto e Casso, D426",
	"Friuli-Venezia Giulia, Pordenone, Fanna, D487",
	"Friuli-Venezia Giulia, Pordenone, Fiume Veneto, D621",
	"Friuli-Venezia Giulia, Pordenone, Fontanafredda, D670",
	"Friuli-Venezia Giulia, Pordenone, Frisanco, D804",
	"Friuli-Venezia Giulia, Pordenone, Maniago, E889",
	"Friuli-Venezia Giulia, Pordenone, Meduno, F089",
	"Friuli-Venezia Giulia, Pordenone, Montereale Valcellina, F596",
	"Friuli-Venezia Giulia, Pordenone, Morsano al Tagliamento, F750",
	"Friuli-Venezia Giulia, Pordenone, Pasiano di Pordenone, G353",
	"Friuli-Venezia Giulia, Pordenone, Pinzano al Tagliamento, G680",
	"Friuli-Venezia Giulia, Pordenone, Polcenigo, G780",
	"Friuli-Venezia Giulia, Pordenone, Porcia, G886",
	"Friuli-Venezia Giulia, Pordenone, Pordenone, G888",
	"Friuli-Venezia Giulia, Pordenone, Prata di Pordenone, G994",
	"Friuli-Venezia Giulia, Pordenone, Pravisdomini, H010",
	"Friuli-Venezia Giulia, Pordenone, Roveredo in Piano, H609",
	"Friuli-Venezia Giulia, Pordenone, Sacile, H657",
	"Friuli-Venezia Giulia, Pordenone, San Giorgio della Richinvelda, H891",
	"Friuli-Venezia Giulia, Pordenone, San Martino al Tagliamento, H999",
	"Friuli-Venezia Giulia, Pordenone, San Quirino, I136",
	"Friuli-Venezia Giulia, Pordenone, San Vito al Tagliamento, I403",
	"Friuli-Venezia Giulia, Pordenone, Sequals, I621",
	"Friuli-Venezia Giulia, Pordenone, Sesto al Reghena, I686",
	"Friuli-Venezia Giulia, Pordenone, Spilimbergo, I904",
	"Friuli-Venezia Giulia, Pordenone, Tramonti di Sopra, L324",
	"Friuli-Venezia Giulia, Pordenone, Tramonti di Sotto, L325",
	"Friuli-Venezia Giulia, Pordenone, Travesio, L347",
	"Friuli-Venezia Giulia, Pordenone, Vito d'Asio, M085",
	"Friuli-Venezia Giulia, Pordenone, Vivaro, M096",
	"Friuli-Venezia Giulia, Pordenone, Zoppola, M190",
	"Friuli-Venezia Giulia, Pordenone, Vajont, M265",
	"Friuli-Venezia Giulia, Pordenone, Valvasone Arzene, M346",
	"Liguria, Imperia, Airole, A111",
	"Liguria, Imperia, Apricale, A338",
	"Liguria, Imperia, Aquila d'Arroscia, A344",
	"Liguria, Imperia, Armo, A418",
	"Liguria, Imperia, Aurigo, A499",
	"Liguria, Imperia, Badalucco, A536",
	"Liguria, Imperia, Bajardo, A581",
	"Liguria, Imperia, Bordighera, A984",
	"Liguria, Imperia, Borghetto d'Arroscia, A993",
	"Liguria, Imperia, Borgomaro, B020",
	"Liguria, Imperia, Camporosso, B559",
	"Liguria, Imperia, Caravonica, B734",
	"Liguria, Imperia, Castellaro, C143",
	"Liguria, Imperia, Castel Vittorio, C110",
	"Liguria, Imperia, Ceriana, C511",
	"Liguria, Imperia, Cervo, C559",
	"Liguria, Imperia, Cesio, C578",
	"Liguria, Imperia, Chiusanico, C657",
	"Liguria, Imperia, Chiusavecchia, C660",
	"Liguria, Imperia, Cipressa, C718",
	"Liguria, Imperia, Civezza, C755",
	"Liguria, Imperia, Cosio d'Arroscia, D087",
	"Liguria, Imperia, Costarainera, D114",
	"Liguria, Imperia, Diano Arentino, D293",
	"Liguria, Imperia, Diano Castello, D296",
	"Liguria, Imperia, Diano Marina, D297",
	"Liguria, Imperia, Diano San Pietro, D298",
	"Liguria, Imperia, Dolceacqua, D318",
	"Liguria, Imperia, Dolcedo, D319",
	"Liguria, Imperia, Imperia, E290",
	"Liguria, Imperia, Isolabona, E346",
	"Liguria, Imperia, Lucinasco, E719",
	"Liguria, Imperia, Mendatica, F123",
	"Liguria, Imperia, Molini di Triora, F290",
	"Liguria, Imperia, Montegrosso Pian Latte, F528",
	"Liguria, Imperia, Olivetta San Michele, G041",
	"Liguria, Imperia, Ospedaletti, G164",
	"Liguria, Imperia, Perinaldo, G454",
	"Liguria, Imperia, Pietrabruna, G607",
	"Liguria, Imperia, Pieve di Teco, G632",
	"Liguria, Imperia, Pigna, G660",
	"Liguria, Imperia, Pompeiana, G814",
	"Liguria, Imperia, Pontedassio, G840",
	"Liguria, Imperia, Pornassio, G890",
	"Liguria, Imperia, Prelà, H027",
	"Liguria, Imperia, Ranzo, H180",
	"Liguria, Imperia, Rezzo, H257",
	"Liguria, Imperia, Riva Ligure, H328",
	"Liguria, Imperia, Rocchetta Nervina, H460",
	"Liguria, Imperia, San Bartolomeo al Mare, H763",
	"Liguria, Imperia, San Biagio della Cima, H780",
	"Liguria, Imperia, San Lorenzo al Mare, H957",
	"Liguria, Imperia, Sanremo, I138",
	"Liguria, Imperia, Santo Stefano al Mare, I365",
	"Liguria, Imperia, Seborga, I556",
	"Liguria, Imperia, Soldano, I796",
	"Liguria, Imperia, Taggia, L024",
	"Liguria, Imperia, Terzorio, L146",
	"Liguria, Imperia, Triora, L430",
	"Liguria, Imperia, Vallebona, L596",
	"Liguria, Imperia, Vallecrosia, L599",
	"Liguria, Imperia, Vasia, L693",
	"Liguria, Imperia, Ventimiglia, L741",
	"Liguria, Imperia, Vessalico, L809",
	"Liguria, Imperia, Villa Faraldi, L943",
	"Liguria, Imperia, Montalto Carpasio, M387",
	"Liguria, Savona, Alassio, A122",
	"Liguria, Savona, Albenga, A145",
	"Liguria, Savona, Albissola Marina, A165",
	"Liguria, Savona, Albisola Superiore, A166",
	"Liguria, Savona, Altare, A226",
	"Liguria, Savona, Andora, A278",
	"Liguria, Savona, Arnasco, A422",
	"Liguria, Savona, Balestrino, A593",
	"Liguria, Savona, Bardineto, A647",
	"Liguria, Savona, Bergeggi, A796",
	"Liguria, Savona, Boissano, A931",
	"Liguria, Savona, Borghetto Santo Spirito, A999",
	"Liguria, Savona, Borgio Verezzi, B005",
	"Liguria, Savona, Bormida, B048",
	"Liguria, Savona, Cairo Montenotte, B369",
	"Liguria, Savona, Calice Ligure, B409",
	"Liguria, Savona, Calizzano, B416",
	"Liguria, Savona, Carcare, B748",
	"Liguria, Savona, Casanova Lerrone, B927",
	"Liguria, Savona, Castelbianco, C063",
	"Liguria, Savona, Castelvecchio di Rocca Barbena, C276",
	"Liguria, Savona, Celle Ligure, C443",
	"Liguria, Savona, Cengio, C463",
	"Liguria, Savona, Ceriale, C510",
	"Liguria, Savona, Cisano sul Neva, C729",
	"Liguria, Savona, Cosseria, D095",
	"Liguria, Savona, Dego, D264",
	"Liguria, Savona, Erli, D424",
	"Liguria, Savona, Finale Ligure, D600",
	"Liguria, Savona, Garlenda, D927",
	"Liguria, Savona, Giustenice, E064",
	"Liguria, Savona, Giusvalla, E066",
	"Liguria, Savona, Laigueglia, E414",
	"Liguria, Savona, Loano, E632",
	"Liguria, Savona, Magliolo, E816",
	"Liguria, Savona, Mallare, E860",
	"Liguria, Savona, Massimino, F046",
	"Liguria, Savona, Millesimo, F213",
	"Liguria, Savona, Mioglia, F226",
	"Liguria, Savona, Murialdo, F813",
	"Liguria, Savona, Nasino, F847",
	"Liguria, Savona, Noli, F926",
	"Liguria, Savona, Onzo, G076",
	"Liguria, Savona, Orco Feglino, D522",
	"Liguria, Savona, Ortovero, G144",
	"Liguria, Savona, Osiglia, G155",
	"Liguria, Savona, Pallare, G281",
	"Liguria, Savona, Piana Crixia, G542",
	"Liguria, Savona, Pietra Ligure, G605",
	"Liguria, Savona, Plodio, G741",
	"Liguria, Savona, Pontinvrea, G866",
	"Liguria, Savona, Quiliano, H126",
	"Liguria, Savona, Rialto, H266",
	"Liguria, Savona, Roccavignale, H452",
	"Liguria, Savona, Sassello, I453",
	"Liguria, Savona, Savona, I480",
	"Liguria, Savona, Spotorno, I926",
	"Liguria, Savona, Stella, I946",
	"Liguria, Savona, Stellanello, I947",
	"Liguria, Savona, Testico, L152",
	"Liguria, Savona, Toirano, L190",
	"Liguria, Savona, Tovo San Giacomo, L315",
	"Liguria, Savona, Urbe, L499",
	"Liguria, Savona, Vado Ligure, L528",
	"Liguria, Savona, Varazze, L675",
	"Liguria, Savona, Vendone, L730",
	"Liguria, Savona, Vezzi Portio, L823",
	"Liguria, Savona, Villanova d'Albenga, L975",
	"Liguria, Savona, Zuccarello, M197",
	"Liguria, Genova, Arenzano, A388",
	"Liguria, Genova, Avegno, A506",
	"Liguria, Genova, Bargagli, A658",
	"Liguria, Genova, Bogliasco, A922",
	"Liguria, Genova, Borzonasca, B067",
	"Liguria, Genova, Busalla, B282",
	"Liguria, Genova, Camogli, B490",
	"Liguria, Genova, Campo Ligure, B538",
	"Liguria, Genova, Campomorone, B551",
	"Liguria, Genova, Carasco, B726",
	"Liguria, Genova, Casarza Ligure, B939",
	"Liguria, Genova, Casella, B956",
	"Liguria, Genova, Castiglione Chiavarese, C302",
	"Liguria, Genova, Ceranesi, C481",
	"Liguria, Genova, Chiavari, C621",
	"Liguria, Genova, Cicagna, C673",
	"Liguria, Genova, Cogoleto, C823",
	"Liguria, Genova, Cogorno, C826",
	"Liguria, Genova, Coreglia Ligure, C995",
	"Liguria, Genova, Crocefieschi, D175",
	"Liguria, Genova, Davagna, D255",
	"Liguria, Genova, Fascia, D509",
	"Liguria, Genova, Favale di Malvaro, D512",
	"Liguria, Genova, Fontanigorda, D677",
	"Liguria, Genova, Genova, D969",
	"Liguria, Genova, Gorreto, E109",
	"Liguria, Genova, Isola del Cantone, E341",
	"Liguria, Genova, Lavagna, E488",
	"Liguria, Genova, Leivi, E519",
	"Liguria, Genova, Lorsica, E695",
	"Liguria, Genova, Lumarzo, E737",
	"Liguria, Genova, Masone, F020",
	"Liguria, Genova, Mele, F098",
	"Liguria, Genova, Mezzanego, F173",
	"Liguria, Genova, Mignanego, F202",
	"Liguria, Genova, Moconesi, F256",
	"Liguria, Genova, Moneglia, F354",
	"Liguria, Genova, Montebruno, F445",
	"Liguria, Genova, Montoggio, F682",
	"Liguria, Genova, Ne, F858",
	"Liguria, Genova, Neirone, F862",
	"Liguria, Genova, Orero, G093",
	"Liguria, Genova, Pieve Ligure, G646",
	"Liguria, Genova, Portofino, G913",
	"Liguria, Genova, Propata, H073",
	"Liguria, Genova, Rapallo, H183",
	"Liguria, Genova, Recco, H212",
	"Liguria, Genova, Rezzoaglio, H258",
	"Liguria, Genova, Ronco Scrivia, H536",
	"Liguria, Genova, Rondanina, H546",
	"Liguria, Genova, Rossiglione, H581",
	"Liguria, Genova, Rovegno, H599",
	"Liguria, Genova, San Colombano Certenoli, H802",
	"Liguria, Genova, Santa Margherita Ligure, I225",
	"Liguria, Genova, Sant'Olcese, I346",
	"Liguria, Genova, Santo Stefano d'Aveto, I368",
	"Liguria, Genova, Savignone, I475",
	"Liguria, Genova, Serra Riccò, I640",
	"Liguria, Genova, Sestri Levante, I693",
	"Liguria, Genova, Sori, I852",
	"Liguria, Genova, Tiglieto, L167",
	"Liguria, Genova, Torriglia, L298",
	"Liguria, Genova, Tribogna, L416",
	"Liguria, Genova, Uscio, L507",
	"Liguria, Genova, Valbrevenna, L546",
	"Liguria, Genova, Vobbia, M105",
	"Liguria, Genova, Zoagli, M182",
	"Liguria, La Spezia, Ameglia, A261",
	"Liguria, La Spezia, Arcola, A373",
	"Liguria, La Spezia, Beverino, A836",
	"Liguria, La Spezia, Bolano, A932",
	"Liguria, La Spezia, Bonassola, A961",
	"Liguria, La Spezia, Borghetto di Vara, A992",
	"Liguria, La Spezia, Brugnato, B214",
	"Liguria, La Spezia, Calice al Cornoviglio, B410",
	"Liguria, La Spezia, Carro, B838",
	"Liguria, La Spezia, Carrodano, B839",
	"Liguria, La Spezia, Castelnuovo Magra, C240",
	"Liguria, La Spezia, Deiva Marina, D265",
	"Liguria, La Spezia, Follo, D655",
	"Liguria, La Spezia, Framura, D758",
	"Liguria, La Spezia, La Spezia, E463",
	"Liguria, La Spezia, Lerici, E542",
	"Liguria, La Spezia, Levanto, E560",
	"Liguria, La Spezia, Maissana, E842",
	"Liguria, La Spezia, Monterosso al Mare, F609",
	"Liguria, La Spezia, Luni, G143",
	"Liguria, La Spezia, Pignone, G664",
	"Liguria, La Spezia, Portovenere, G925",
	"Liguria, La Spezia, Riccò del Golfo di Spezia, H275",
	"Liguria, La Spezia, Riomaggiore, H304",
	"Liguria, La Spezia, Rocchetta di Vara, H461",
	"Liguria, La Spezia, Santo Stefano di Magra, I363",
	"Liguria, La Spezia, Sarzana, I449",
	"Liguria, La Spezia, Sesta Godano, E070",
	"Liguria, La Spezia, Varese Ligure, L681",
	"Liguria, La Spezia, Vernazza, L774",
	"Liguria, La Spezia, Vezzano Ligure, L819",
	"Liguria, La Spezia, Zignago, M177",
	"Emilia-Romagna, Piacenza, Agazzano, A067",
	"Emilia-Romagna, Piacenza, Alseno, A223",
	"Emilia-Romagna, Piacenza, Besenzone, A823",
	"Emilia-Romagna, Piacenza, Bettola, A831",
	"Emilia-Romagna, Piacenza, Bobbio, A909",
	"Emilia-Romagna, Piacenza, Borgonovo Val Tidone, B025",
	"Emilia-Romagna, Piacenza, Cadeo, B332",
	"Emilia-Romagna, Piacenza, Calendasco, B405",
	"Emilia-Romagna, Piacenza, Caorso, B643",
	"Emilia-Romagna, Piacenza, Carpaneto Piacentino, B812",
	"Emilia-Romagna, Piacenza, Castell'Arquato, C145",
	"Emilia-Romagna, Piacenza, Castel San Giovanni, C261",
	"Emilia-Romagna, Piacenza, Castelvetro Piacentino, C288",
	"Emilia-Romagna, Piacenza, Cerignale, C513",
	"Emilia-Romagna, Piacenza, Coli, C838",
	"Emilia-Romagna, Piacenza, Corte Brugnatella, D054",
	"Emilia-Romagna, Piacenza, Cortemaggiore, D061",
	"Emilia-Romagna, Piacenza, Farini, D502",
	"Emilia-Romagna, Piacenza, Ferriere, D555",
	"Emilia-Romagna, Piacenza, Fiorenzuola d'Arda, D611",
	"Emilia-Romagna, Piacenza, Gazzola, D958",
	"Emilia-Romagna, Piacenza, Gossolengo, E114",
	"Emilia-Romagna, Piacenza, Gragnano Trebbiense, E132",
	"Emilia-Romagna, Piacenza, Gropparello, E196",
	"Emilia-Romagna, Piacenza, Lugagnano Val d'Arda, E726",
	"Emilia-Romagna, Piacenza, Monticelli d'Ongina, F671",
	"Emilia-Romagna, Piacenza, Morfasso, F724",
	"Emilia-Romagna, Piacenza, Ottone, G195",
	"Emilia-Romagna, Piacenza, Piacenza, G535",
	"Emilia-Romagna, Piacenza, Pianello Val Tidone, G557",
	"Emilia-Romagna, Piacenza, Piozzano, G696",
	"Emilia-Romagna, Piacenza, Podenzano, G747",
	"Emilia-Romagna, Piacenza, Ponte dell'Olio, G842",
	"Emilia-Romagna, Piacenza, Pontenure, G852",
	"Emilia-Romagna, Piacenza, Rivergaro, H350",
	"Emilia-Romagna, Piacenza, Rottofreno, H593",
	"Emilia-Romagna, Piacenza, San Giorgio Piacentino, H887",
	"Emilia-Romagna, Piacenza, San Pietro in Cerro, G788",
	"Emilia-Romagna, Piacenza, Sarmato, I434",
	"Emilia-Romagna, Piacenza, Travo, L348",
	"Emilia-Romagna, Piacenza, Vernasca, L772",
	"Emilia-Romagna, Piacenza, Vigolzone, L897",
	"Emilia-Romagna, Piacenza, Villanova sull'Arda, L980",
	"Emilia-Romagna, Piacenza, Zerba, M165",
	"Emilia-Romagna, Piacenza, Ziano Piacentino, L848",
	"Emilia-Romagna, Piacenza, Alta Val Tidone, M386",
	"Emilia-Romagna, Parma, Albareto, A138",
	"Emilia-Romagna, Parma, Bardi, A646",
	"Emilia-Romagna, Parma, Bedonia, A731",
	"Emilia-Romagna, Parma, Berceto, A788",
	"Emilia-Romagna, Parma, Bore, A987",
	"Emilia-Romagna, Parma, Borgo Val di Taro, B042",
	"Emilia-Romagna, Parma, Busseto, B293",
	"Emilia-Romagna, Parma, Calestano, B408",
	"Emilia-Romagna, Parma, Collecchio, C852",
	"Emilia-Romagna, Parma, Colorno, C904",
	"Emilia-Romagna, Parma, Compiano, C934",
	"Emilia-Romagna, Parma, Corniglio, D026",
	"Emilia-Romagna, Parma, Felino, D526",
	"Emilia-Romagna, Parma, Fidenza, B034",
	"Emilia-Romagna, Parma, Fontanellato, D673",
	"Emilia-Romagna, Parma, Fontevivo, D685",
	"Emilia-Romagna, Parma, Fornovo di Taro, D728",
	"Emilia-Romagna, Parma, Langhirano, E438",
	"Emilia-Romagna, Parma, Lesignano de' Bagni, E547",
	"Emilia-Romagna, Parma, Medesano, F082",
	"Emilia-Romagna, Parma, Monchio delle Corti, F340",
	"Emilia-Romagna, Parma, Montechiarugolo, F473",
	"Emilia-Romagna, Parma, Neviano degli Arduini, F882",
	"Emilia-Romagna, Parma, Noceto, F914",
	"Emilia-Romagna, Parma, Palanzano, G255",
	"Emilia-Romagna, Parma, Parma, G337",
	"Emilia-Romagna, Parma, Pellegrino Parmense, G424",
	"Emilia-Romagna, Parma, Roccabianca, H384",
	"Emilia-Romagna, Parma, Sala Baganza, H682",
	"Emilia-Romagna, Parma, Salsomaggiore Terme, H720",
	"Emilia-Romagna, Parma, San Secondo Parmense, I153",
	"Emilia-Romagna, Parma, Solignano, I803",
	"Emilia-Romagna, Parma, Soragna, I840",
	"Emilia-Romagna, Parma, Terenzo, E548",
	"Emilia-Romagna, Parma, Tizzano Val Parma, L183",
	"Emilia-Romagna, Parma, Tornolo, L229",
	"Emilia-Romagna, Parma, Torrile, L299",
	"Emilia-Romagna, Parma, Traversetolo, L346",
	"Emilia-Romagna, Parma, Valmozzola, L641",
	"Emilia-Romagna, Parma, Varano de' Melegari, L672",
	"Emilia-Romagna, Parma, Varsi, L689",
	"Emilia-Romagna, Parma, Sissa Trecasali, M325",
	"Emilia-Romagna, Parma, Polesine Zibello, M367",
	"Emilia-Romagna, Parma, Sorbolo Mezzani, M411",
	"Emilia-Romagna, Reggio nell'Emilia, Albinea, A162",
	"Emilia-Romagna, Reggio nell'Emilia, Bagnolo in Piano, A573",
	"Emilia-Romagna, Reggio nell'Emilia, Baiso, A586",
	"Emilia-Romagna, Reggio nell'Emilia, Bibbiano, A850",
	"Emilia-Romagna, Reggio nell'Emilia, Boretto, A988",
	"Emilia-Romagna, Reggio nell'Emilia, Brescello, B156",
	"Emilia-Romagna, Reggio nell'Emilia, Cadelbosco di Sopra, B328",
	"Emilia-Romagna, Reggio nell'Emilia, Campagnola Emilia, B499",
	"Emilia-Romagna, Reggio nell'Emilia, Campegine, B502",
	"Emilia-Romagna, Reggio nell'Emilia, Carpineti, B825",
	"Emilia-Romagna, Reggio nell'Emilia, Casalgrande, B893",
	"Emilia-Romagna, Reggio nell'Emilia, Casina, B967",
	"Emilia-Romagna, Reggio nell'Emilia, Castellarano, C141",
	"Emilia-Romagna, Reggio nell'Emilia, Castelnovo di Sotto, C218",
	"Emilia-Romagna, Reggio nell'Emilia, Castelnovo ne' Monti, C219",
	"Emilia-Romagna, Reggio nell'Emilia, Cavriago, C405",
	"Emilia-Romagna, Reggio nell'Emilia, Canossa, C669",
	"Emilia-Romagna, Reggio nell'Emilia, Correggio, D037",
	"Emilia-Romagna, Reggio nell'Emilia, Fabbrico, D450",
	"Emilia-Romagna, Reggio nell'Emilia, Gattatico, D934",
	"Emilia-Romagna, Reggio nell'Emilia, Gualtieri, E232",
	"Emilia-Romagna, Reggio nell'Emilia, Guastalla, E253",
	"Emilia-Romagna, Reggio nell'Emilia, Luzzara, E772",
	"Emilia-Romagna, Reggio nell'Emilia, Montecchio Emilia, F463",
	"Emilia-Romagna, Reggio nell'Emilia, Novellara, F960",
	"Emilia-Romagna, Reggio nell'Emilia, Poviglio, G947",
	"Emilia-Romagna, Reggio nell'Emilia, Quattro Castella, H122",
	"Emilia-Romagna, Reggio nell'Emilia, Reggiolo, H225",
	"Emilia-Romagna, Reggio nell'Emilia, Reggio nell'Emilia, H223",
	"Emilia-Romagna, Reggio nell'Emilia, Rio Saliceto, H298",
	"Emilia-Romagna, Reggio nell'Emilia, Rolo, H500",
	"Emilia-Romagna, Reggio nell'Emilia, Rubiera, H628",
	"Emilia-Romagna, Reggio nell'Emilia, San Martino in Rio, I011",
	"Emilia-Romagna, Reggio nell'Emilia, San Polo d'Enza, I123",
	"Emilia-Romagna, Reggio nell'Emilia, Sant'Ilario d'Enza, I342",
	"Emilia-Romagna, Reggio nell'Emilia, Scandiano, I496",
	"Emilia-Romagna, Reggio nell'Emilia, Toano, L184",
	"Emilia-Romagna, Reggio nell'Emilia, Vetto, L815",
	"Emilia-Romagna, Reggio nell'Emilia, Vezzano sul Crostolo, L820",
	"Emilia-Romagna, Reggio nell'Emilia, Viano, L831",
	"Emilia-Romagna, Reggio nell'Emilia, Villa Minozzo, L969",
	"Emilia-Romagna, Reggio nell'Emilia, Ventasso, M364",
	"Emilia-Romagna, Modena, Bastiglia, A713",
	"Emilia-Romagna, Modena, Bomporto, A959",
	"Emilia-Romagna, Modena, Campogalliano, B539",
	"Emilia-Romagna, Modena, Camposanto, B566",
	"Emilia-Romagna, Modena, Carpi, B819",
	"Emilia-Romagna, Modena, Castelfranco Emilia, C107",
	"Emilia-Romagna, Modena, Castelnuovo Rangone, C242",
	"Emilia-Romagna, Modena, Castelvetro di Modena, C287",
	"Emilia-Romagna, Modena, Cavezzo, C398",
	"Emilia-Romagna, Modena, Concordia sulla Secchia, C951",
	"Emilia-Romagna, Modena, Fanano, D486",
	"Emilia-Romagna, Modena, Finale Emilia, D599",
	"Emilia-Romagna, Modena, Fiorano Modenese, D607",
	"Emilia-Romagna, Modena, Fiumalbo, D617",
	"Emilia-Romagna, Modena, Formigine, D711",
	"Emilia-Romagna, Modena, Frassinoro, D783",
	"Emilia-Romagna, Modena, Guiglia, E264",
	"Emilia-Romagna, Modena, Lama Mocogno, E426",
	"Emilia-Romagna, Modena, Maranello, E904",
	"Emilia-Romagna, Modena, Marano sul Panaro, E905",
	"Emilia-Romagna, Modena, Medolla, F087",
	"Emilia-Romagna, Modena, Mirandola, F240",
	"Emilia-Romagna, Modena, Modena, F257",
	"Emilia-Romagna, Modena, Montecreto, F484",
	"Emilia-Romagna, Modena, Montefiorino, F503",
	"Emilia-Romagna, Modena, Montese, F642",
	"Emilia-Romagna, Modena, Nonantola, F930",
	"Emilia-Romagna, Modena, Novi di Modena, F966",
	"Emilia-Romagna, Modena, Palagano, G250",
	"Emilia-Romagna, Modena, Pavullo nel Frignano, G393",
	"Emilia-Romagna, Modena, Pievepelago, G649",
	"Emilia-Romagna, Modena, Polinago, G789",
	"Emilia-Romagna, Modena, Prignano sulla Secchia, H061",
	"Emilia-Romagna, Modena, Ravarino, H195",
	"Emilia-Romagna, Modena, Riolunato, H303",
	"Emilia-Romagna, Modena, San Cesario sul Panaro, H794",
	"Emilia-Romagna, Modena, San Felice sul Panaro, H835",
	"Emilia-Romagna, Modena, San Possidonio, I128",
	"Emilia-Romagna, Modena, San Prospero, I133",
	"Emilia-Romagna, Modena, Sassuolo, I462",
	"Emilia-Romagna, Modena, Savignano sul Panaro, I473",
	"Emilia-Romagna, Modena, Serramazzoni, F357",
	"Emilia-Romagna, Modena, Sestola, I689",
	"Emilia-Romagna, Modena, Soliera, I802",
	"Emilia-Romagna, Modena, Spilamberto, I903",
	"Emilia-Romagna, Modena, Vignola, L885",
	"Emilia-Romagna, Modena, Zocca, M183",
	"Emilia-Romagna, Bologna, Anzola dell'Emilia, A324",
	"Emilia-Romagna, Bologna, Argelato, A392",
	"Emilia-Romagna, Bologna, Baricella, A665",
	"Emilia-Romagna, Bologna, Bentivoglio, A785",
	"Emilia-Romagna, Bologna, Bologna, A944",
	"Emilia-Romagna, Bologna, Borgo Tossignano, B044",
	"Emilia-Romagna, Bologna, Budrio, B249",
	"Emilia-Romagna, Bologna, Calderara di Reno, B399",
	"Emilia-Romagna, Bologna, Camugnano, B572",
	"Emilia-Romagna, Bologna, Casalecchio di Reno, B880",
	"Emilia-Romagna, Bologna, Casalfiumanese, B892",
	"Emilia-Romagna, Bologna, Castel d'Aiano, C075",
	"Emilia-Romagna, Bologna, Castel del Rio, C086",
	"Emilia-Romagna, Bologna, Castel di Casio, B969",
	"Emilia-Romagna, Bologna, Castel Guelfo di Bologna, C121",
	"Emilia-Romagna, Bologna, Castello d'Argile, C185",
	"Emilia-Romagna, Bologna, Castel Maggiore, C204",
	"Emilia-Romagna, Bologna, Castel San Pietro Terme, C265",
	"Emilia-Romagna, Bologna, Castenaso, C292",
	"Emilia-Romagna, Bologna, Castiglione dei Pepoli, C296",
	"Emilia-Romagna, Bologna, Crevalcore, D166",
	"Emilia-Romagna, Bologna, Dozza, D360",
	"Emilia-Romagna, Bologna, Fontanelice, D668",
	"Emilia-Romagna, Bologna, Gaggio Montano, D847",
	"Emilia-Romagna, Bologna, Galliera, D878",
	"Emilia-Romagna, Bologna, Granarolo dell'Emilia, E136",
	"Emilia-Romagna, Bologna, Grizzana Morandi, E187",
	"Emilia-Romagna, Bologna, Imola, E289",
	"Emilia-Romagna, Bologna, Lizzano in Belvedere, A771",
	"Emilia-Romagna, Bologna, Loiano, E655",
	"Emilia-Romagna, Bologna, Malalbergo, E844",
	"Emilia-Romagna, Bologna, Marzabotto, B689",
	"Emilia-Romagna, Bologna, Medicina, F083",
	"Emilia-Romagna, Bologna, Minerbio, F219",
	"Emilia-Romagna, Bologna, Molinella, F288",
	"Emilia-Romagna, Bologna, Monghidoro, F363",
	"Emilia-Romagna, Bologna, Monterenzio, F597",
	"Emilia-Romagna, Bologna, Monte San Pietro, F627",
	"Emilia-Romagna, Bologna, Monzuno, F706",
	"Emilia-Romagna, Bologna, Mordano, F718",
	"Emilia-Romagna, Bologna, Ozzano dell'Emilia, G205",
	"Emilia-Romagna, Bologna, Pianoro, G570",
	"Emilia-Romagna, Bologna, Pieve di Cento, G643",
	"Emilia-Romagna, Bologna, Sala Bolognese, H678",
	"Emilia-Romagna, Bologna, San Benedetto Val di Sambro, G566",
	"Emilia-Romagna, Bologna, San Giorgio di Piano, H896",
	"Emilia-Romagna, Bologna, San Giovanni in Persiceto, G467",
	"Emilia-Romagna, Bologna, San Lazzaro di Savena, H945",
	"Emilia-Romagna, Bologna, San Pietro in Casale, I110",
	"Emilia-Romagna, Bologna, Sant'Agata Bolognese, I191",
	"Emilia-Romagna, Bologna, Sasso Marconi, G972",
	"Emilia-Romagna, Bologna, Vergato, L762",
	"Emilia-Romagna, Bologna, Zola Predosa, M185",
	"Emilia-Romagna, Bologna, Valsamoggia, M320",
	"Emilia-Romagna, Bologna, Alto Reno Terme, M369",
	"Emilia-Romagna, Ferrara, Argenta, A393",
	"Emilia-Romagna, Ferrara, Bondeno, A965",
	"Emilia-Romagna, Ferrara, Cento, C469",
	"Emilia-Romagna, Ferrara, Codigoro, C814",
	"Emilia-Romagna, Ferrara, Comacchio, C912",
	"Emilia-Romagna, Ferrara, Copparo, C980",
	"Emilia-Romagna, Ferrara, Ferrara, D548",
	"Emilia-Romagna, Ferrara, Jolanda di Savoia, E320",
	"Emilia-Romagna, Ferrara, Lagosanto, E410",
	"Emilia-Romagna, Ferrara, Masi Torello, F016",
	"Emilia-Romagna, Ferrara, Mesola, F156",
	"Emilia-Romagna, Ferrara, Ostellato, G184",
	"Emilia-Romagna, Ferrara, Poggio Renatico, G768",
	"Emilia-Romagna, Ferrara, Portomaggiore, G916",
	"Emilia-Romagna, Ferrara, Vigarano Mainarda, L868",
	"Emilia-Romagna, Ferrara, Voghiera, M110",
	"Emilia-Romagna, Ferrara, Goro, E107",
	"Emilia-Romagna, Ferrara, Fiscaglia, M323",
	"Emilia-Romagna, Ferrara, Terre del Reno, M381",
	"Emilia-Romagna, Ferrara, Riva del Po, M410",
	"Emilia-Romagna, Ferrara, Tresignana, M409",
	"Emilia-Romagna, Ravenna, Alfonsine, A191",
	"Emilia-Romagna, Ravenna, Bagnacavallo, A547",
	"Emilia-Romagna, Ravenna, Bagnara di Romagna, A551",
	"Emilia-Romagna, Ravenna, Brisighella, B188",
	"Emilia-Romagna, Ravenna, Casola Valsenio, B982",
	"Emilia-Romagna, Ravenna, Castel Bolognese, C065",
	"Emilia-Romagna, Ravenna, Cervia, C553",
	"Emilia-Romagna, Ravenna, Conselice, C963",
	"Emilia-Romagna, Ravenna, Cotignola, D121",
	"Emilia-Romagna, Ravenna, Faenza, D458",
	"Emilia-Romagna, Ravenna, Fusignano, D829",
	"Emilia-Romagna, Ravenna, Lugo, E730",
	"Emilia-Romagna, Ravenna, Massa Lombarda, F029",
	"Emilia-Romagna, Ravenna, Ravenna, H199",
	"Emilia-Romagna, Ravenna, Riolo Terme, H302",
	"Emilia-Romagna, Ravenna, Russi, H642",
	"Emilia-Romagna, Ravenna, Sant'Agata sul Santerno, I196",
	"Emilia-Romagna, Ravenna, Solarolo, I787",
	"Emilia-Romagna, Forlì-Cesena, Bagno di Romagna, A565",
	"Emilia-Romagna, Forlì-Cesena, Bertinoro, A809",
	"Emilia-Romagna, Forlì-Cesena, Borghi, B001",
	"Emilia-Romagna, Forlì-Cesena, Castrocaro Terme e Terra del Sole, C339",
	"Emilia-Romagna, Forlì-Cesena, Cesena, C573",
	"Emilia-Romagna, Forlì-Cesena, Cesenatico, C574",
	"Emilia-Romagna, Forlì-Cesena, Civitella di Romagna, C777",
	"Emilia-Romagna, Forlì-Cesena, Dovadola, D357",
	"Emilia-Romagna, Forlì-Cesena, Forlì, D704",
	"Emilia-Romagna, Forlì-Cesena, Forlimpopoli, D705",
	"Emilia-Romagna, Forlì-Cesena, Galeata, D867",
	"Emilia-Romagna, Forlì-Cesena, Gambettola, D899",
	"Emilia-Romagna, Forlì-Cesena, Gatteo, D935",
	"Emilia-Romagna, Forlì-Cesena, Longiano, E675",
	"Emilia-Romagna, Forlì-Cesena, Meldola, F097",
	"Emilia-Romagna, Forlì-Cesena, Mercato Saraceno, F139",
	"Emilia-Romagna, Forlì-Cesena, Modigliana, F259",
	"Emilia-Romagna, Forlì-Cesena, Montiano, F668",
	"Emilia-Romagna, Forlì-Cesena, Portico e San Benedetto, G904",
	"Emilia-Romagna, Forlì-Cesena, Predappio, H017",
	"Emilia-Romagna, Forlì-Cesena, Premilcuore, H034",
	"Emilia-Romagna, Forlì-Cesena, Rocca San Casciano, H437",
	"Emilia-Romagna, Forlì-Cesena, Roncofreddo, H542",
	"Emilia-Romagna, Forlì-Cesena, San Mauro Pascoli, I027",
	"Emilia-Romagna, Forlì-Cesena, Santa Sofia, I310",
	"Emilia-Romagna, Forlì-Cesena, Sarsina, I444",
	"Emilia-Romagna, Forlì-Cesena, Savignano sul Rubicone, I472",
	"Emilia-Romagna, Forlì-Cesena, Sogliano al Rubicone, I779",
	"Emilia-Romagna, Forlì-Cesena, Tredozio, L361",
	"Emilia-Romagna, Forlì-Cesena, Verghereto, L764",
	"Emilia-Romagna, Rimini, Bellaria-Igea Marina, A747",
	"Emilia-Romagna, Rimini, Cattolica, C357",
	"Emilia-Romagna, Rimini, Coriano, D004",
	"Emilia-Romagna, Rimini, Gemmano, D961",
	"Emilia-Romagna, Rimini, Misano Adriatico, F244",
	"Emilia-Romagna, Rimini, Mondaino, F346",
	"Emilia-Romagna, Rimini, Montefiore Conca, F502",
	"Emilia-Romagna, Rimini, Montegridolfo, F523",
	"Emilia-Romagna, Rimini, Morciano di Romagna, F715",
	"Emilia-Romagna, Rimini, Riccione, H274",
	"Emilia-Romagna, Rimini, Rimini, H294",
	"Emilia-Romagna, Rimini, Saludecio, H724",
	"Emilia-Romagna, Rimini, San Clemente, H801",
	"Emilia-Romagna, Rimini, San Giovanni in Marignano, H921",
	"Emilia-Romagna, Rimini, Santarcangelo di Romagna, I304",
	"Emilia-Romagna, Rimini, Verucchio, L797",
	"Emilia-Romagna, Rimini, Casteldelci, C080",
	"Emilia-Romagna, Rimini, Maiolo, E838",
	"Emilia-Romagna, Rimini, Novafeltria, F137",
	"Emilia-Romagna, Rimini, Pennabilli, G433",
	"Emilia-Romagna, Rimini, San Leo, H949",
	"Emilia-Romagna, Rimini, Sant'Agata Feltria, I201",
	"Emilia-Romagna, Rimini, Talamello, L034",
	"Emilia-Romagna, Rimini, Poggio Torriana, M324",
	"Emilia-Romagna, Rimini, Montescudo-Monte Colombo, M368",
	"Emilia-Romagna, Rimini, Montecopiolo, F478",
	"Emilia-Romagna, Rimini, Sassofeltrio, I460",
	"Toscana, Massa-Carrara, Aulla, A496",
	"Toscana, Massa-Carrara, Bagnone, A576",
	"Toscana, Massa-Carrara, Carrara, B832",
	"Toscana, Massa-Carrara, Casola in Lunigiana, B979",
	"Toscana, Massa-Carrara, Comano, C914",
	"Toscana, Massa-Carrara, Filattiera, D590",
	"Toscana, Massa-Carrara, Fivizzano, D629",
	"Toscana, Massa-Carrara, Fosdinovo, D735",
	"Toscana, Massa-Carrara, Licciana Nardi, E574",
	"Toscana, Massa-Carrara, Massa, F023",
	"Toscana, Massa-Carrara, Montignoso, F679",
	"Toscana, Massa-Carrara, Mulazzo, F802",
	"Toscana, Massa-Carrara, Podenzana, G746",
	"Toscana, Massa-Carrara, Pontremoli, G870",
	"Toscana, Massa-Carrara, Tresana, L386",
	"Toscana, Massa-Carrara, Villafranca in Lunigiana, L946",
	"Toscana, Massa-Carrara, Zeri, M169",
	"Toscana, Lucca, Altopascio, A241",
	"Toscana, Lucca, Bagni di Lucca, A560",
	"Toscana, Lucca, Barga, A657",
	"Toscana, Lucca, Borgo a Mozzano, B007",
	"Toscana, Lucca, Camaiore, B455",
	"Toscana, Lucca, Camporgiano, B557",
	"Toscana, Lucca, Capannori, B648",
	"Toscana, Lucca, Careggine, B760",
	"Toscana, Lucca, Castelnuovo di Garfagnana, C236",
	"Toscana, Lucca, Castiglione di Garfagnana, C303",
	"Toscana, Lucca, Coreglia Antelminelli, C996",
	"Toscana, Lucca, Forte dei Marmi, D730",
	"Toscana, Lucca, Fosciandora, D734",
	"Toscana, Lucca, Gallicano, D874",
	"Toscana, Lucca, Lucca, E715",
	"Toscana, Lucca, Massarosa, F035",
	"Toscana, Lucca, Minucciano, F225",
	"Toscana, Lucca, Molazzana, F283",
	"Toscana, Lucca, Montecarlo, F452",
	"Toscana, Lucca, Pescaglia, G480",
	"Toscana, Lucca, Piazza al Serchio, G582",
	"Toscana, Lucca, Pietrasanta, G628",
	"Toscana, Lucca, Pieve Fosciana, G648",
	"Toscana, Lucca, Porcari, G882",
	"Toscana, Lucca, San Romano in Garfagnana, I142",
	"Toscana, Lucca, Seravezza, I622",
	"Toscana, Lucca, Stazzema, I942",
	"Toscana, Lucca, Vagli Sotto, L533",
	"Toscana, Lucca, Viareggio, L833",
	"Toscana, Lucca, Villa Basilica, L913",
	"Toscana, Lucca, Villa Collemandina, L926",
	"Toscana, Lucca, Fabbriche di Vergemoli, M319",
	"Toscana, Lucca, Sillano Giuncugnano, M347",
	"Toscana, Pistoia, Agliana, A071",
	"Toscana, Pistoia, Buggiano, B251",
	"Toscana, Pistoia, Lamporecchio, E432",
	"Toscana, Pistoia, Larciano, E451",
	"Toscana, Pistoia, Marliana, E960",
	"Toscana, Pistoia, Massa e Cozzile, F025",
	"Toscana, Pistoia, Monsummano Terme, F384",
	"Toscana, Pistoia, Montale, F410",
	"Toscana, Pistoia, Montecatini-Terme, A561",
	"Toscana, Pistoia, Pescia, G491",
	"Toscana, Pistoia, Pieve a Nievole, G636",
	"Toscana, Pistoia, Pistoia, G713",
	"Toscana, Pistoia, Ponte Buggianese, G833",
	"Toscana, Pistoia, Quarrata, H109",
	"Toscana, Pistoia, Sambuca Pistoiese, H744",
	"Toscana, Pistoia, Serravalle Pistoiese, I660",
	"Toscana, Pistoia, Uzzano, L522",
	"Toscana, Pistoia, Chiesina Uzzanese, C631",
	"Toscana, Pistoia, Abetone Cutigliano, M376",
	"Toscana, Pistoia, San Marcello Piteglio, M377",
	"Toscana, Firenze, Bagno a Ripoli, A564",
	"Toscana, Firenze, Barberino di Mugello, A632",
	"Toscana, Firenze, Borgo San Lorenzo, B036",
	"Toscana, Firenze, Calenzano, B406",
	"Toscana, Firenze, Campi Bisenzio, B507",
	"Toscana, Firenze, Capraia e Limite, B684",
	"Toscana, Firenze, Castelfiorentino, C101",
	"Toscana, Firenze, Cerreto Guidi, C529",
	"Toscana, Firenze, Certaldo, C540",
	"Toscana, Firenze, Dicomano, D299",
	"Toscana, Firenze, Empoli, D403",
	"Toscana, Firenze, Fiesole, D575",
	"Toscana, Firenze, Firenze, D612",
	"Toscana, Firenze, Firenzuola, D613",
	"Toscana, Firenze, Fucecchio, D815",
	"Toscana, Firenze, Gambassi Terme, D895",
	"Toscana, Firenze, Greve in Chianti, E169",
	"Toscana, Firenze, Impruneta, E291",
	"Toscana, Firenze, Lastra a Signa, E466",
	"Toscana, Firenze, Londa, E668",
	"Toscana, Firenze, Marradi, E971",
	"Toscana, Firenze, Montaione, F398",
	"Toscana, Firenze, Montelupo Fiorentino, F551",
	"Toscana, Firenze, Montespertoli, F648",
	"Toscana, Firenze, Palazzuolo sul Senio, G270",
	"Toscana, Firenze, Pelago, G420",
	"Toscana, Firenze, Pontassieve, G825",
	"Toscana, Firenze, Reggello, H222",
	"Toscana, Firenze, Rignano sull'Arno, H286",
	"Toscana, Firenze, Rufina, H635",
	"Toscana, Firenze, San Casciano in Val di Pesa, H791",
	"Toscana, Firenze, San Godenzo, H937",
	"Toscana, Firenze, Scandicci, B962",
	"Toscana, Firenze, Sesto Fiorentino, I684",
	"Toscana, Firenze, Signa, I728",
	"Toscana, Firenze, Vaglia, L529",
	"Toscana, Firenze, Vicchio, L838",
	"Toscana, Firenze, Vinci, M059",
	"Toscana, Firenze, Figline e Incisa Valdarno, M321",
	"Toscana, Firenze, Scarperia e San Piero, M326",
	"Toscana, Firenze, Barberino Tavarnelle, M408",
	"Toscana, Livorno, Bibbona, A852",
	"Toscana, Livorno, Campiglia Marittima, B509",
	"Toscana, Livorno, Campo nell'Elba, B553",
	"Toscana, Livorno, Capoliveri, B669",
	"Toscana, Livorno, Capraia Isola, B685",
	"Toscana, Livorno, Castagneto Carducci, C044",
	"Toscana, Livorno, Cecina, C415",
	"Toscana, Livorno, Collesalvetti, C869",
	"Toscana, Livorno, Livorno, E625",
	"Toscana, Livorno, Marciana, E930",
	"Toscana, Livorno, Marciana Marina, E931",
	"Toscana, Livorno, Piombino, G687",
	"Toscana, Livorno, Porto Azzurro, E680",
	"Toscana, Livorno, Portoferraio, G912",
	"Toscana, Livorno, Rosignano Marittimo, H570",
	"Toscana, Livorno, San Vincenzo, I390",
	"Toscana, Livorno, Sassetta, I454",
	"Toscana, Livorno, Suvereto, L019",
	"Toscana, Livorno, Rio, M391",
	"Toscana, Pisa, Bientina, A864",
	"Toscana, Pisa, Buti, B303",
	"Toscana, Pisa, Calci, B390",
	"Toscana, Pisa, Calcinaia, B392",
	"Toscana, Pisa, Capannoli, B647",
	"Toscana, Pisa, Casale Marittimo, B878",
	"Toscana, Pisa, Cascina, B950",
	"Toscana, Pisa, Castelfranco di Sotto, C113",
	"Toscana, Pisa, Castellina Marittima, C174",
	"Toscana, Pisa, Castelnuovo di Val di Cecina, C244",
	"Toscana, Pisa, Chianni, C609",
	"Toscana, Pisa, Fauglia, D510",
	"Toscana, Pisa, Guardistallo, E250",
	"Toscana, Pisa, Lajatico, E413",
	"Toscana, Pisa, Montecatini Val di Cecina, F458",
	"Toscana, Pisa, Montescudaio, F640",
	"Toscana, Pisa, Monteverdi Marittimo, F661",
	"Toscana, Pisa, Montopoli in Val d'Arno, F686",
	"Toscana, Pisa, Orciano Pisano, G090",
	"Toscana, Pisa, Palaia, G254",
	"Toscana, Pisa, Peccioli, G395",
	"Toscana, Pisa, Pisa, G702",
	"Toscana, Pisa, Pomarance, G804",
	"Toscana, Pisa, Ponsacco, G822",
	"Toscana, Pisa, Pontedera, G843",
	"Toscana, Pisa, Riparbella, H319",
	"Toscana, Pisa, San Giuliano Terme, A562",
	"Toscana, Pisa, San Miniato, I046",
	"Toscana, Pisa, Santa Croce sull'Arno, I177",
	"Toscana, Pisa, Santa Luce, I217",
	"Toscana, Pisa, Santa Maria a Monte, I232",
	"Toscana, Pisa, Terricciola, L138",
	"Toscana, Pisa, Vecchiano, L702",
	"Toscana, Pisa, Vicopisano, L850",
	"Toscana, Pisa, Volterra, M126",
	"Toscana, Pisa, Casciana Terme Lari, M327",
	"Toscana, Pisa, Crespina Lorenzana, M328",
	"Toscana, Arezzo, Anghiari, A291",
	"Toscana, Arezzo, Arezzo, A390",
	"Toscana, Arezzo, Badia Tedalda, A541",
	"Toscana, Arezzo, Bibbiena, A851",
	"Toscana, Arezzo, Bucine, B243",
	"Toscana, Arezzo, Capolona, B670",
	"Toscana, Arezzo, Caprese Michelangelo, B693",
	"Toscana, Arezzo, Castel Focognano, C102",
	"Toscana, Arezzo, Castel San Niccolò, C263",
	"Toscana, Arezzo, Castiglion Fibocchi, C318",
	"Toscana, Arezzo, Castiglion Fiorentino, C319",
	"Toscana, Arezzo, Cavriglia, C407",
	"Toscana, Arezzo, Chitignano, C648",
	"Toscana, Arezzo, Chiusi della Verna, C663",
	"Toscana, Arezzo, Civitella in Val di Chiana, C774",
	"Toscana, Arezzo, Cortona, D077",
	"Toscana, Arezzo, Foiano della Chiana, D649",
	"Toscana, Arezzo, Loro Ciuffenna, E693",
	"Toscana, Arezzo, Lucignano, E718",
	"Toscana, Arezzo, Marciano della Chiana, E933",
	"Toscana, Arezzo, Montemignaio, F565",
	"Toscana, Arezzo, Monterchi, F594",
	"Toscana, Arezzo, Monte San Savino, F628",
	"Toscana, Arezzo, Montevarchi, F656",
	"Toscana, Arezzo, Ortignano Raggiolo, G139",
	"Toscana, Arezzo, Pieve Santo Stefano, G653",
	"Toscana, Arezzo, Poppi, G879",
	"Toscana, Arezzo, San Giovanni Valdarno, H901",
	"Toscana, Arezzo, Sansepolcro, I155",
	"Toscana, Arezzo, Sestino, I681",
	"Toscana, Arezzo, Subbiano, I991",
	"Toscana, Arezzo, Talla, L038",
	"Toscana, Arezzo, Terranuova Bracciolini, L123",
	"Toscana, Arezzo, Castelfranco Piandiscò, M322",
	"Toscana, Arezzo, Pratovecchio Stia, M329",
	"Toscana, Arezzo, Laterina Pergine Valdarno, M392",
	"Toscana, Siena, Abbadia San Salvatore, A006",
	"Toscana, Siena, Asciano, A461",
	"Toscana, Siena, Buonconvento, B269",
	"Toscana, Siena, Casole d'Elsa, B984",
	"Toscana, Siena, Castellina in Chianti, C172",
	"Toscana, Siena, Castelnuovo Berardenga, C227",
	"Toscana, Siena, Castiglione d'Orcia, C313",
	"Toscana, Siena, Cetona, C587",
	"Toscana, Siena, Chianciano Terme, C608",
	"Toscana, Siena, Chiusdino, C661",
	"Toscana, Siena, Chiusi, C662",
	"Toscana, Siena, Colle di Val d'Elsa, C847",
	"Toscana, Siena, Gaiole in Chianti, D858",
	"Toscana, Siena, Montepulciano, F592",
	"Toscana, Siena, Monteriggioni, F598",
	"Toscana, Siena, Monteroni d'Arbia, F605",
	"Toscana, Siena, Monticiano, F676",
	"Toscana, Siena, Murlo, F815",
	"Toscana, Siena, Piancastagnaio, G547",
	"Toscana, Siena, Pienza, G602",
	"Toscana, Siena, Poggibonsi, G752",
	"Toscana, Siena, Radda in Chianti, H153",
	"Toscana, Siena, Radicofani, H156",
	"Toscana, Siena, Radicondoli, H157",
	"Toscana, Siena, Rapolano Terme, H185",
	"Toscana, Siena, San Casciano dei Bagni, H790",
	"Toscana, Siena, San Gimignano, H875",
	"Toscana, Siena, San Quirico d'Orcia, I135",
	"Toscana, Siena, Sarteano, I445",
	"Toscana, Siena, Siena, I726",
	"Toscana, Siena, Sinalunga, A468",
	"Toscana, Siena, Sovicille, I877",
	"Toscana, Siena, Torrita di Siena, L303",
	"Toscana, Siena, Trequanda, L384",
	"Toscana, Siena, Montalcino, M378",
	"Toscana, Grosseto, Arcidosso, A369",
	"Toscana, Grosseto, Campagnatico, B497",
	"Toscana, Grosseto, Capalbio, B646",
	"Toscana, Grosseto, Castel del Piano, C085",
	"Toscana, Grosseto, Castell'Azzara, C147",
	"Toscana, Grosseto, Castiglione della Pescaia, C310",
	"Toscana, Grosseto, Cinigiano, C705",
	"Toscana, Grosseto, Civitella Paganico, C782",
	"Toscana, Grosseto, Follonica, D656",
	"Toscana, Grosseto, Gavorrano, D948",
	"Toscana, Grosseto, Grosseto, E202",
	"Toscana, Grosseto, Isola del Giglio, E348",
	"Toscana, Grosseto, Magliano in Toscana, E810",
	"Toscana, Grosseto, Manciano, E875",
	"Toscana, Grosseto, Massa Marittima, F032",
	"Toscana, Grosseto, Monte Argentario, F437",
	"Toscana, Grosseto, Montieri, F677",
	"Toscana, Grosseto, Orbetello, G088",
	"Toscana, Grosseto, Pitigliano, G716",
	"Toscana, Grosseto, Roccalbegna, H417",
	"Toscana, Grosseto, Roccastrada, H449",
	"Toscana, Grosseto, Santa Fiora, I187",
	"Toscana, Grosseto, Scansano, I504",
	"Toscana, Grosseto, Scarlino, I510",
	"Toscana, Grosseto, Seggiano, I571",
	"Toscana, Grosseto, Sorano, I841",
	"Toscana, Grosseto, Monterotondo Marittimo, F612",
	"Toscana, Grosseto, Semproniano, I601",
	"Toscana, Prato, Cantagallo, B626",
	"Toscana, Prato, Carmignano, B794",
	"Toscana, Prato, Montemurlo, F572",
	"Toscana, Prato, Poggio a Caiano, G754",
	"Toscana, Prato, Prato, G999",
	"Toscana, Prato, Vaiano, L537",
	"Toscana, Prato, Vernio, L775",
	"Umbria, Perugia, Assisi, A475",
	"Umbria, Perugia, Bastia Umbra, A710",
	"Umbria, Perugia, Bettona, A832",
	"Umbria, Perugia, Bevagna, A835",
	"Umbria, Perugia, Campello sul Clitunno, B504",
	"Umbria, Perugia, Cannara, B609",
	"Umbria, Perugia, Cascia, B948",
	"Umbria, Perugia, Castel Ritaldi, C252",
	"Umbria, Perugia, Castiglione del Lago, C309",
	"Umbria, Perugia, Cerreto di Spoleto, C527",
	"Umbria, Perugia, Citerna, C742",
	"Umbria, Perugia, Città della Pieve, C744",
	"Umbria, Perugia, Città di Castello, C745",
	"Umbria, Perugia, Collazzone, C845",
	"Umbria, Perugia, Corciano, C990",
	"Umbria, Perugia, Costacciaro, D108",
	"Umbria, Perugia, Deruta, D279",
	"Umbria, Perugia, Foligno, D653",
	"Umbria, Perugia, Fossato di Vico, D745",
	"Umbria, Perugia, Fratta Todina, D787",
	"Umbria, Perugia, Giano dell'Umbria, E012",
	"Umbria, Perugia, Gualdo Cattaneo, E229",
	"Umbria, Perugia, Gualdo Tadino, E230",
	"Umbria, Perugia, Gubbio, E256",
	"Umbria, Perugia, Lisciano Niccone, E613",
	"Umbria, Perugia, Magione, E805",
	"Umbria, Perugia, Marsciano, E975",
	"Umbria, Perugia, Massa Martana, F024",
	"Umbria, Perugia, Monte Castello di Vibio, F456",
	"Umbria, Perugia, Montefalco, F492",
	"Umbria, Perugia, Monteleone di Spoleto, F540",
	"Umbria, Perugia, Monte Santa Maria Tiberina, F629",
	"Umbria, Perugia, Montone, F685",
	"Umbria, Perugia, Nocera Umbra, F911",
	"Umbria, Perugia, Norcia, F935",
	"Umbria, Perugia, Paciano, G212",
	"Umbria, Perugia, Panicale, G308",
	"Umbria, Perugia, Passignano sul Trasimeno, G359",
	"Umbria, Perugia, Perugia, G478",
	"Umbria, Perugia, Piegaro, G601",
	"Umbria, Perugia, Pietralunga, G618",
	"Umbria, Perugia, Poggiodomo, G758",
	"Umbria, Perugia, Preci, H015",
	"Umbria, Perugia, San Giustino, H935",
	"Umbria, Perugia, Sant'Anatolia di Narco, I263",
	"Umbria, Perugia, Scheggia e Pascelupo, I522",
	"Umbria, Perugia, Scheggino, I523",
	"Umbria, Perugia, Sellano, I585",
	"Umbria, Perugia, Sigillo, I727",
	"Umbria, Perugia, Spello, I888",
	"Umbria, Perugia, Spoleto, I921",
	"Umbria, Perugia, Todi, L188",
	"Umbria, Perugia, Torgiano, L216",
	"Umbria, Perugia, Trevi, L397",
	"Umbria, Perugia, Tuoro sul Trasimeno, L466",
	"Umbria, Perugia, Umbertide, D786",
	"Umbria, Perugia, Valfabbrica, L573",
	"Umbria, Perugia, Vallo di Nera, L627",
	"Umbria, Perugia, Valtopina, L653",
	"Umbria, Terni, Acquasparta, A045",
	"Umbria, Terni, Allerona, A207",
	"Umbria, Terni, Alviano, A242",
	"Umbria, Terni, Amelia, A262",
	"Umbria, Terni, Arrone, A439",
	"Umbria, Terni, Attigliano, A490",
	"Umbria, Terni, Baschi, A691",
	"Umbria, Terni, Calvi dell'Umbria, B446",
	"Umbria, Terni, Castel Giorgio, C117",
	"Umbria, Terni, Castel Viscardo, C289",
	"Umbria, Terni, Fabro, D454",
	"Umbria, Terni, Ferentillo, D538",
	"Umbria, Terni, Ficulle, D570",
	"Umbria, Terni, Giove, E045",
	"Umbria, Terni, Guardea, E241",
	"Umbria, Terni, Lugnano in Teverina, E729",
	"Umbria, Terni, Montecastrilli, F457",
	"Umbria, Terni, Montecchio, F462",
	"Umbria, Terni, Montefranco, F510",
	"Umbria, Terni, Montegabbione, F513",
	"Umbria, Terni, Monteleone d'Orvieto, F543",
	"Umbria, Terni, Narni, F844",
	"Umbria, Terni, Orvieto, G148",
	"Umbria, Terni, Otricoli, G189",
	"Umbria, Terni, Parrano, G344",
	"Umbria, Terni, Penna in Teverina, G432",
	"Umbria, Terni, Polino, G790",
	"Umbria, Terni, Porano, G881",
	"Umbria, Terni, San Gemini, H857",
	"Umbria, Terni, San Venanzo, I381",
	"Umbria, Terni, Stroncone, I981",
	"Umbria, Terni, Terni, L117",
	"Umbria, Terni, Avigliano Umbro, M258",
	"Marche, Pesaro e Urbino, Acqualagna, A035",
	"Marche, Pesaro e Urbino, Apecchio, A327",
	"Marche, Pesaro e Urbino, Belforte all'Isauro, A740",
	"Marche, Pesaro e Urbino, Borgo Pace, B026",
	"Marche, Pesaro e Urbino, Cagli, B352",
	"Marche, Pesaro e Urbino, Cantiano, B636",
	"Marche, Pesaro e Urbino, Carpegna, B816",
	"Marche, Pesaro e Urbino, Cartoceto, B846",
	"Marche, Pesaro e Urbino, Fano, D488",
	"Marche, Pesaro e Urbino, Fermignano, D541",
	"Marche, Pesaro e Urbino, Fossombrone, D749",
	"Marche, Pesaro e Urbino, Fratte Rosa, D791",
	"Marche, Pesaro e Urbino, Frontino, D807",
	"Marche, Pesaro e Urbino, Frontone, D808",
	"Marche, Pesaro e Urbino, Gabicce Mare, D836",
	"Marche, Pesaro e Urbino, Gradara, E122",
	"Marche, Pesaro e Urbino, Isola del Piano, E351",
	"Marche, Pesaro e Urbino, Lunano, E743",
	"Marche, Pesaro e Urbino, Macerata Feltria, E785",
	"Marche, Pesaro e Urbino, Mercatello sul Metauro, F135",
	"Marche, Pesaro e Urbino, Mercatino Conca, F136",
	"Marche, Pesaro e Urbino, Mombaroccio, F310",
	"Marche, Pesaro e Urbino, Mondavio, F347",
	"Marche, Pesaro e Urbino, Mondolfo, F348",
	"Marche, Pesaro e Urbino, Montecalvo in Foglia, F450",
	"Marche, Pesaro e Urbino, Monte Cerignone, F467",
	"Marche, Pesaro e Urbino, Montefelcino, F497",
	"Marche, Pesaro e Urbino, Monte Grimano Terme, F524",
	"Marche, Pesaro e Urbino, Montelabbate, F533",
	"Marche, Pesaro e Urbino, Monte Porzio, F589",
	"Marche, Pesaro e Urbino, Peglio, G416",
	"Marche, Pesaro e Urbino, Pergola, G453",
	"Marche, Pesaro e Urbino, Pesaro, G479",
	"Marche, Pesaro e Urbino, Petriano, G514",
	"Marche, Pesaro e Urbino, Piandimeleto, G551",
	"Marche, Pesaro e Urbino, Pietrarubbia, G627",
	"Marche, Pesaro e Urbino, Piobbico, G682",
	"Marche, Pesaro e Urbino, San Costanzo, H809",
	"Marche, Pesaro e Urbino, San Lorenzo in Campo, H958",
	"Marche, Pesaro e Urbino, Sant'Angelo in Vado, I287",
	"Marche, Pesaro e Urbino, Sant'Ippolito, I344",
	"Marche, Pesaro e Urbino, Serra Sant'Abbondio, I654",
	"Marche, Pesaro e Urbino, Tavoleto, L078",
	"Marche, Pesaro e Urbino, Tavullia, L081",
	"Marche, Pesaro e Urbino, Urbania, L498",
	"Marche, Pesaro e Urbino, Urbino, L500",
	"Marche, Pesaro e Urbino, Vallefoglia, M331",
	"Marche, Pesaro e Urbino, Colli al Metauro, M380",
	"Marche, Pesaro e Urbino, Terre Roveresche, M379",
	"Marche, Pesaro e Urbino, Sassocorvaro Auditore, M413",
	"Marche, Ancona, Agugliano, A092",
	"Marche, Ancona, Ancona, A271",
	"Marche, Ancona, Arcevia, A366",
	"Marche, Ancona, Barbara, A626",
	"Marche, Ancona, Belvedere Ostrense, A769",
	"Marche, Ancona, Camerano, B468",
	"Marche, Ancona, Camerata Picena, B470",
	"Marche, Ancona, Castelbellino, C060",
	"Marche, Ancona, Castelfidardo, C100",
	"Marche, Ancona, Castelleone di Suasa, C152",
	"Marche, Ancona, Castelplanio, C248",
	"Marche, Ancona, Cerreto d'Esi, C524",
	"Marche, Ancona, Chiaravalle, C615",
	"Marche, Ancona, Corinaldo, D007",
	"Marche, Ancona, Cupramontana, D211",
	"Marche, Ancona, Fabriano, D451",
	"Marche, Ancona, Falconara Marittima, D472",
	"Marche, Ancona, Filottrano, D597",
	"Marche, Ancona, Genga, D965",
	"Marche, Ancona, Jesi, E388",
	"Marche, Ancona, Loreto, E690",
	"Marche, Ancona, Maiolati Spontini, E837",
	"Marche, Ancona, Mergo, F145",
	"Marche, Ancona, Monsano, F381",
	"Marche, Ancona, Montecarotto, F453",
	"Marche, Ancona, Montemarciano, F560",
	"Marche, Ancona, Monte Roberto, F600",
	"Marche, Ancona, Monte San Vito, F634",
	"Marche, Ancona, Morro d'Alba, F745",
	"Marche, Ancona, Numana, F978",
	"Marche, Ancona, Offagna, G003",
	"Marche, Ancona, Osimo, G157",
	"Marche, Ancona, Ostra, F401",
	"Marche, Ancona, Ostra Vetere, F581",
	"Marche, Ancona, Poggio San Marcello, G771",
	"Marche, Ancona, Polverigi, G803",
	"Marche, Ancona, Rosora, H575",
	"Marche, Ancona, San Marcello, H979",
	"Marche, Ancona, San Paolo di Jesi, I071",
	"Marche, Ancona, Santa Maria Nuova, I251",
	"Marche, Ancona, Sassoferrato, I461",
	"Marche, Ancona, Senigallia, I608",
	"Marche, Ancona, Serra de' Conti, I643",
	"Marche, Ancona, Serra San Quirico, I653",
	"Marche, Ancona, Sirolo, I758",
	"Marche, Ancona, Staffolo, I932",
	"Marche, Ancona, Trecastelli, M318",
	"Marche, Macerata, Apiro, A329",
	"Marche, Macerata, Appignano, A334",
	"Marche, Macerata, Belforte del Chienti, A739",
	"Marche, Macerata, Bolognola, A947",
	"Marche, Macerata, Caldarola, B398",
	"Marche, Macerata, Camerino, B474",
	"Marche, Macerata, Camporotondo di Fiastrone, B562",
	"Marche, Macerata, Castelraimondo, C251",
	"Marche, Macerata, Castelsantangelo sul Nera, C267",
	"Marche, Macerata, Cessapalombo, C582",
	"Marche, Macerata, Cingoli, C704",
	"Marche, Macerata, Civitanova Marche, C770",
	"Marche, Macerata, Colmurano, C886",
	"Marche, Macerata, Corridonia, D042",
	"Marche, Macerata, Esanatoglia, D429",
	"Marche, Macerata, Fiastra, D564",
	"Marche, Macerata, Fiuminata, D628",
	"Marche, Macerata, Gagliole, D853",
	"Marche, Macerata, Gualdo, E228",
	"Marche, Macerata, Loro Piceno, E694",
	"Marche, Macerata, Macerata, E783",
	"Marche, Macerata, Matelica, F051",
	"Marche, Macerata, Mogliano, F268",
	"Marche, Macerata, Montecassiano, F454",
	"Marche, Macerata, Monte Cavallo, F460",
	"Marche, Macerata, Montecosaro, F482",
	"Marche, Macerata, Montefano, F496",
	"Marche, Macerata, Montelupone, F552",
	"Marche, Macerata, Monte San Giusto, F621",
	"Marche, Macerata, Monte San Martino, F622",
	"Marche, Macerata, Morrovalle, F749",
	"Marche, Macerata, Muccia, F793",
	"Marche, Macerata, Penna San Giovanni, G436",
	"Marche, Macerata, Petriolo, G515",
	"Marche, Macerata, Pieve Torina, G657",
	"Marche, Macerata, Pioraco, G690",
	"Marche, Macerata, Poggio San Vicino, D566",
	"Marche, Macerata, Pollenza, F567",
	"Marche, Macerata, Porto Recanati, G919",
	"Marche, Macerata, Potenza Picena, F632",
	"Marche, Macerata, Recanati, H211",
	"Marche, Macerata, Ripe San Ginesio, H323",
	"Marche, Macerata, San Ginesio, H876",
	"Marche, Macerata, San Severino Marche, I156",
	"Marche, Macerata, Sant'Angelo in Pontano, I286",
	"Marche, Macerata, Sarnano, I436",
	"Marche, Macerata, Sefro, I569",
	"Marche, Macerata, Serrapetrona, I651",
	"Marche, Macerata, Serravalle di Chienti, I661",
	"Marche, Macerata, Tolentino, L191",
	"Marche, Macerata, Treia, L366",
	"Marche, Macerata, Urbisaglia, L501",
	"Marche, Macerata, Ussita, L517",
	"Marche, Macerata, Visso, M078",
	"Marche, Macerata, Valfornace, M382",
	"Marche, Ascoli Piceno, Acquasanta Terme, A044",
	"Marche, Ascoli Piceno, Acquaviva Picena, A047",
	"Marche, Ascoli Piceno, Appignano del Tronto, A335",
	"Marche, Ascoli Piceno, Arquata del Tronto, A437",
	"Marche, Ascoli Piceno, Ascoli Piceno, A462",
	"Marche, Ascoli Piceno, Carassai, B727",
	"Marche, Ascoli Piceno, Castel di Lama, C093",
	"Marche, Ascoli Piceno, Castignano, C321",
	"Marche, Ascoli Piceno, Castorano, C331",
	"Marche, Ascoli Piceno, Colli del Tronto, C877",
	"Marche, Ascoli Piceno, Comunanza, C935",
	"Marche, Ascoli Piceno, Cossignano, D096",
	"Marche, Ascoli Piceno, Cupra Marittima, D210",
	"Marche, Ascoli Piceno, Folignano, D652",
	"Marche, Ascoli Piceno, Force, D691",
	"Marche, Ascoli Piceno, Grottammare, E207",
	"Marche, Ascoli Piceno, Maltignano, E868",
	"Marche, Ascoli Piceno, Massignano, F044",
	"Marche, Ascoli Piceno, Monsampolo del Tronto, F380",
	"Marche, Ascoli Piceno, Montalto delle Marche, F415",
	"Marche, Ascoli Piceno, Montedinove, F487",
	"Marche, Ascoli Piceno, Montefiore dell'Aso, F501",
	"Marche, Ascoli Piceno, Montegallo, F516",
	"Marche, Ascoli Piceno, Montemonaco, F570",
	"Marche, Ascoli Piceno, Monteprandone, F591",
	"Marche, Ascoli Piceno, Offida, G005",
	"Marche, Ascoli Piceno, Palmiano, G289",
	"Marche, Ascoli Piceno, Ripatransone, H321",
	"Marche, Ascoli Piceno, Roccafluvione, H390",
	"Marche, Ascoli Piceno, Rotella, H588",
	"Marche, Ascoli Piceno, San Benedetto del Tronto, H769",
	"Marche, Ascoli Piceno, Spinetoli, I912",
	"Marche, Ascoli Piceno, Venarotta, L728",
	"Marche, Fermo, Altidona, A233",
	"Marche, Fermo, Amandola, A252",
	"Marche, Fermo, Belmonte Piceno, A760",
	"Marche, Fermo, Campofilone, B534",
	"Marche, Fermo, Falerone, D477",
	"Marche, Fermo, Fermo, D542",
	"Marche, Fermo, Francavilla d'Ete, D760",
	"Marche, Fermo, Grottazzolina, E208",
	"Marche, Fermo, Lapedona, E447",
	"Marche, Fermo, Magliano di Tenna, E807",
	"Marche, Fermo, Massa Fermana, F021",
	"Marche, Fermo, Monsampietro Morico, F379",
	"Marche, Fermo, Montappone, F428",
	"Marche, Fermo, Montefalcone Appennino, F493",
	"Marche, Fermo, Montefortino, F509",
	"Marche, Fermo, Monte Giberto, F517",
	"Marche, Fermo, Montegiorgio, F520",
	"Marche, Fermo, Montegranaro, F522",
	"Marche, Fermo, Monteleone di Fermo, F536",
	"Marche, Fermo, Montelparo, F549",
	"Marche, Fermo, Monte Rinaldo, F599",
	"Marche, Fermo, Monterubbiano, F614",
	"Marche, Fermo, Monte San Pietrangeli, F626",
	"Marche, Fermo, Monte Urano, F653",
	"Marche, Fermo, Monte Vidon Combatte, F664",
	"Marche, Fermo, Monte Vidon Corrado, F665",
	"Marche, Fermo, Montottone, F697",
	"Marche, Fermo, Moresco, F722",
	"Marche, Fermo, Ortezzano, G137",
	"Marche, Fermo, Pedaso, G403",
	"Marche, Fermo, Petritoli, G516",
	"Marche, Fermo, Ponzano di Fermo, G873",
	"Marche, Fermo, Porto San Giorgio, G920",
	"Marche, Fermo, Porto Sant'Elpidio, G921",
	"Marche, Fermo, Rapagnano, H182",
	"Marche, Fermo, Santa Vittoria in Matenano, I315",
	"Marche, Fermo, Sant'Elpidio a Mare, I324",
	"Marche, Fermo, Servigliano, C070",
	"Marche, Fermo, Smerillo, I774",
	"Marche, Fermo, Torre San Patrizio, L279",
	"Lazio, Viterbo, Acquapendente, A040",
	"Lazio, Viterbo, Arlena di Castro, A412",
	"Lazio, Viterbo, Bagnoregio, A577",
	"Lazio, Viterbo, Barbarano Romano, A628",
	"Lazio, Viterbo, Bassano Romano, A704",
	"Lazio, Viterbo, Bassano in Teverina, A706",
	"Lazio, Viterbo, Blera, A857",
	"Lazio, Viterbo, Bolsena, A949",
	"Lazio, Viterbo, Bomarzo, A955",
	"Lazio, Viterbo, Calcata, B388",
	"Lazio, Viterbo, Canepina, B597",
	"Lazio, Viterbo, Canino, B604",
	"Lazio, Viterbo, Capodimonte, B663",
	"Lazio, Viterbo, Capranica, B688",
	"Lazio, Viterbo, Caprarola, B691",
	"Lazio, Viterbo, Carbognano, B735",
	"Lazio, Viterbo, Castel Sant'Elia, C269",
	"Lazio, Viterbo, Castiglione in Teverina, C315",
	"Lazio, Viterbo, Celleno, C446",
	"Lazio, Viterbo, Cellere, C447",
	"Lazio, Viterbo, Civita Castellana, C765",
	"Lazio, Viterbo, Civitella d'Agliano, C780",
	"Lazio, Viterbo, Corchiano, C988",
	"Lazio, Viterbo, Fabrica di Roma, D452",
	"Lazio, Viterbo, Faleria, D475",
	"Lazio, Viterbo, Farnese, D503",
	"Lazio, Viterbo, Gallese, D870",
	"Lazio, Viterbo, Gradoli, E126",
	"Lazio, Viterbo, Graffignano, E128",
	"Lazio, Viterbo, Grotte di Castro, E210",
	"Lazio, Viterbo, Ischia di Castro, E330",
	"Lazio, Viterbo, Latera, E467",
	"Lazio, Viterbo, Lubriano, E713",
	"Lazio, Viterbo, Marta, E978",
	"Lazio, Viterbo, Montalto di Castro, F419",
	"Lazio, Viterbo, Montefiascone, F499",
	"Lazio, Viterbo, Monte Romano, F603",
	"Lazio, Viterbo, Monterosi, F606",
	"Lazio, Viterbo, Nepi, F868",
	"Lazio, Viterbo, Onano, G065",
	"Lazio, Viterbo, Oriolo Romano, G111",
	"Lazio, Viterbo, Orte, G135",
	"Lazio, Viterbo, Piansano, G571",
	"Lazio, Viterbo, Proceno, H071",
	"Lazio, Viterbo, Ronciglione, H534",
	"Lazio, Viterbo, Villa San Giovanni in Tuscia, H913",
	"Lazio, Viterbo, San Lorenzo Nuovo, H969",
	"Lazio, Viterbo, Soriano nel Cimino, I855",
	"Lazio, Viterbo, Sutri, L017",
	"Lazio, Viterbo, Tarquinia, D024",
	"Lazio, Viterbo, Tessennano, L150",
	"Lazio, Viterbo, Tuscania, L310",
	"Lazio, Viterbo, Valentano, L569",
	"Lazio, Viterbo, Vallerano, L612",
	"Lazio, Viterbo, Vasanello, A701",
	"Lazio, Viterbo, Vejano, L713",
	"Lazio, Viterbo, Vetralla, L814",
	"Lazio, Viterbo, Vignanello, L882",
	"Lazio, Viterbo, Viterbo, M082",
	"Lazio, Viterbo, Vitorchiano, M086",
	"Lazio, Rieti, Accumoli, A019",
	"Lazio, Rieti, Amatrice, A258",
	"Lazio, Rieti, Antrodoco, A315",
	"Lazio, Rieti, Ascrea, A464",
	"Lazio, Rieti, Belmonte in Sabina, A765",
	"Lazio, Rieti, Borbona, A981",
	"Lazio, Rieti, Borgorose, B008",
	"Lazio, Rieti, Borgo Velino, A996",
	"Lazio, Rieti, Cantalice, B627",
	"Lazio, Rieti, Cantalupo in Sabina, B631",
	"Lazio, Rieti, Casaprota, B934",
	"Lazio, Rieti, Casperia, A472",
	"Lazio, Rieti, Castel di Tora, C098",
	"Lazio, Rieti, Castelnuovo di Farfa, C224",
	"Lazio, Rieti, Castel Sant'Angelo, C268",
	"Lazio, Rieti, Cittaducale, C746",
	"Lazio, Rieti, Cittareale, C749",
	"Lazio, Rieti, Collalto Sabino, C841",
	"Lazio, Rieti, Colle di Tora, C857",
	"Lazio, Rieti, Collegiove, C859",
	"Lazio, Rieti, Collevecchio, C876",
	"Lazio, Rieti, Colli sul Velino, C880",
	"Lazio, Rieti, Concerviano, C946",
	"Lazio, Rieti, Configni, C959",
	"Lazio, Rieti, Contigliano, C969",
	"Lazio, Rieti, Cottanello, D124",
	"Lazio, Rieti, Fara in Sabina, D493",
	"Lazio, Rieti, Fiamignano, D560",
	"Lazio, Rieti, Forano, D689",
	"Lazio, Rieti, Frasso Sabino, D785",
	"Lazio, Rieti, Greccio, E160",
	"Lazio, Rieti, Labro, E393",
	"Lazio, Rieti, Leonessa, E535",
	"Lazio, Rieti, Longone Sabino, E681",
	"Lazio, Rieti, Magliano Sabina, E812",
	"Lazio, Rieti, Marcetelli, E927",
	"Lazio, Rieti, Micigliano, F193",
	"Lazio, Rieti, Mompeo, F319",
	"Lazio, Rieti, Montasola, F430",
	"Lazio, Rieti, Montebuono, F446",
	"Lazio, Rieti, Monteleone Sabino, F541",
	"Lazio, Rieti, Montenero Sabino, F579",
	"Lazio, Rieti, Monte San Giovanni in Sabina, F619",
	"Lazio, Rieti, Montopoli di Sabina, F687",
	"Lazio, Rieti, Morro Reatino, F746",
	"Lazio, Rieti, Nespolo, F876",
	"Lazio, Rieti, Orvinio, B595",
	"Lazio, Rieti, Paganico Sabino, G232",
	"Lazio, Rieti, Pescorocchiano, G498",
	"Lazio, Rieti, Petrella Salto, G513",
	"Lazio, Rieti, Poggio Bustone, G756",
	"Lazio, Rieti, Poggio Catino, G757",
	"Lazio, Rieti, Poggio Mirteto, G763",
	"Lazio, Rieti, Poggio Moiano, G764",
	"Lazio, Rieti, Poggio Nativo, G765",
	"Lazio, Rieti, Poggio San Lorenzo, G770",
	"Lazio, Rieti, Posta, G934",
	"Lazio, Rieti, Pozzaglia Sabina, G951",
	"Lazio, Rieti, Rieti, H282",
	"Lazio, Rieti, Rivodutri, H354",
	"Lazio, Rieti, Roccantica, H427",
	"Lazio, Rieti, Rocca Sinibalda, H446",
	"Lazio, Rieti, Salisano, H713",
	"Lazio, Rieti, Scandriglia, I499",
	"Lazio, Rieti, Selci, I581",
	"Lazio, Rieti, Stimigliano, I959",
	"Lazio, Rieti, Tarano, L046",
	"Lazio, Rieti, Toffia, L189",
	"Lazio, Rieti, Torricella in Sabina, L293",
	"Lazio, Rieti, Torri in Sabina, L286",
	"Lazio, Rieti, Turania, G507",
	"Lazio, Rieti, Vacone, L525",
	"Lazio, Rieti, Varco Sabino, L676",
	"Lazio, Roma, Affile, A062",
	"Lazio, Roma, Agosta, A084",
	"Lazio, Roma, Albano Laziale, A132",
	"Lazio, Roma, Allumiere, A210",
	"Lazio, Roma, Anguillara Sabazia, A297",
	"Lazio, Roma, Anticoli Corrado, A309",
	"Lazio, Roma, Anzio, A323",
	"Lazio, Roma, Arcinazzo Romano, A370",
	"Lazio, Roma, Ariccia, A401",
	"Lazio, Roma, Arsoli, A446",
	"Lazio, Roma, Artena, A449",
	"Lazio, Roma, Bellegra, A749",
	"Lazio, Roma, Bracciano, B114",
	"Lazio, Roma, Camerata Nuova, B472",
	"Lazio, Roma, Campagnano di Roma, B496",
	"Lazio, Roma, Canale Monterano, B576",
	"Lazio, Roma, Canterano, B635",
	"Lazio, Roma, Capena, B649",
	"Lazio, Roma, Capranica Prenestina, B687",
	"Lazio, Roma, Carpineto Romano, B828",
	"Lazio, Roma, Casape, B932",
	"Lazio, Roma, Castel Gandolfo, C116",
	"Lazio, Roma, Castel Madama, C203",
	"Lazio, Roma, Castelnuovo di Porto, C237",
	"Lazio, Roma, Castel San Pietro Romano, C266",
	"Lazio, Roma, Cave, C390",
	"Lazio, Roma, Cerreto Laziale, C518",
	"Lazio, Roma, Cervara di Roma, C543",
	"Lazio, Roma, Cerveteri, C552",
	"Lazio, Roma, Ciciliano, C677",
	"Lazio, Roma, Cineto Romano, C702",
	"Lazio, Roma, Civitavecchia, C773",
	"Lazio, Roma, Civitella San Paolo, C784",
	"Lazio, Roma, Colleferro, C858",
	"Lazio, Roma, Colonna, C900",
	"Lazio, Roma, Fiano Romano, D561",
	"Lazio, Roma, Filacciano, D586",
	"Lazio, Roma, Formello, D707",
	"Lazio, Roma, Frascati, D773",
	"Lazio, Roma, Gallicano nel Lazio, D875",
	"Lazio, Roma, Gavignano, D945",
	"Lazio, Roma, Genazzano, D964",
	"Lazio, Roma, Genzano di Roma, D972",
	"Lazio, Roma, Gerano, D978",
	"Lazio, Roma, Gorga, E091",
	"Lazio, Roma, Grottaferrata, E204",
	"Lazio, Roma, Guidonia Montecelio, E263",
	"Lazio, Roma, Jenne, E382",
	"Lazio, Roma, Labico, E392",
	"Lazio, Roma, Lanuvio, C767",
	"Lazio, Roma, Licenza, E576",
	"Lazio, Roma, Magliano Romano, E813",
	"Lazio, Roma, Mandela, B632",
	"Lazio, Roma, Manziana, E900",
	"Lazio, Roma, Marano Equo, E908",
	"Lazio, Roma, Marcellina, E924",
	"Lazio, Roma, Marino, E958",
	"Lazio, Roma, Mazzano Romano, F064",
	"Lazio, Roma, Mentana, F127",
	"Lazio, Roma, Monte Compatri, F477",
	"Lazio, Roma, Monteflavio, F504",
	"Lazio, Roma, Montelanico, F534",
	"Lazio, Roma, Montelibretti, F545",
	"Lazio, Roma, Monte Porzio Catone, F590",
	"Lazio, Roma, Monterotondo, F611",
	"Lazio, Roma, Montorio Romano, F692",
	"Lazio, Roma, Moricone, F730",
	"Lazio, Roma, Morlupo, F734",
	"Lazio, Roma, Nazzano, F857",
	"Lazio, Roma, Nemi, F865",
	"Lazio, Roma, Nerola, F871",
	"Lazio, Roma, Nettuno, F880",
	"Lazio, Roma, Olevano Romano, G022",
	"Lazio, Roma, Palestrina, G274",
	"Lazio, Roma, Palombara Sabina, G293",
	"Lazio, Roma, Percile, G444",
	"Lazio, Roma, Pisoniano, G704",
	"Lazio, Roma, Poli, G784",
	"Lazio, Roma, Pomezia, G811",
	"Lazio, Roma, Ponzano Romano, G874",
	"Lazio, Roma, Riano, H267",
	"Lazio, Roma, Rignano Flaminio, H288",
	"Lazio, Roma, Riofreddo, H300",
	"Lazio, Roma, Rocca Canterano, H387",
	"Lazio, Roma, Rocca di Cave, H401",
	"Lazio, Roma, Rocca di Papa, H404",
	"Lazio, Roma, Roccagiovine, H411",
	"Lazio, Roma, Rocca Priora, H432",
	"Lazio, Roma, Rocca Santo Stefano, H441",
	"Lazio, Roma, Roiate, H494",
	"Lazio, Roma, Roma, H501",
	"Lazio, Roma, Roviano, H618",
	"Lazio, Roma, Sacrofano, H658",
	"Lazio, Roma, Sambuci, H745",
	"Lazio, Roma, San Gregorio da Sassola, H942",
	"Lazio, Roma, San Polo dei Cavalieri, I125",
	"Lazio, Roma, Santa Marinella, I255",
	"Lazio, Roma, Sant'Angelo Romano, I284",
	"Lazio, Roma, Sant'Oreste, I352",
	"Lazio, Roma, San Vito Romano, I400",
	"Lazio, Roma, Saracinesco, I424",
	"Lazio, Roma, Segni, I573",
	"Lazio, Roma, Subiaco, I992",
	"Lazio, Roma, Tivoli, L182",
	"Lazio, Roma, Tolfa, L192",
	"Lazio, Roma, Torrita Tiberina, L302",
	"Lazio, Roma, Trevignano Romano, L401",
	"Lazio, Roma, Vallepietra, L611",
	"Lazio, Roma, Vallinfreda, L625",
	"Lazio, Roma, Valmontone, L639",
	"Lazio, Roma, Velletri, L719",
	"Lazio, Roma, Vicovaro, L851",
	"Lazio, Roma, Vivaro Romano, M095",
	"Lazio, Roma, Zagarolo, M141",
	"Lazio, Roma, Lariano, M207",
	"Lazio, Roma, Ladispoli, M212",
	"Lazio, Roma, Ardea, M213",
	"Lazio, Roma, Ciampino, M272",
	"Lazio, Roma, San Cesareo, M295",
	"Lazio, Roma, Fiumicino, M297",
	"Lazio, Roma, Fonte Nuova, M309",
	"Lazio, Latina, Aprilia, A341",
	"Lazio, Latina, Bassiano, A707",
	"Lazio, Latina, Campodimele, B527",
	"Lazio, Latina, Castelforte, C104",
	"Lazio, Latina, Cisterna di Latina, C740",
	"Lazio, Latina, Cori, D003",
	"Lazio, Latina, Fondi, D662",
	"Lazio, Latina, Formia, D708",
	"Lazio, Latina, Gaeta, D843",
	"Lazio, Latina, Itri, E375",
	"Lazio, Latina, Latina, E472",
	"Lazio, Latina, Lenola, E527",
	"Lazio, Latina, Maenza, E798",
	"Lazio, Latina, Minturno, F224",
	"Lazio, Latina, Monte San Biagio, F616",
	"Lazio, Latina, Norma, F937",
	"Lazio, Latina, Pontinia, G865",
	"Lazio, Latina, Ponza, G871",
	"Lazio, Latina, Priverno, G698",
	"Lazio, Latina, Prossedi, H076",
	"Lazio, Latina, Roccagorga, H413",
	"Lazio, Latina, Rocca Massima, H421",
	"Lazio, Latina, Roccasecca dei Volsci, H444",
	"Lazio, Latina, Sabaudia, H647",
	"Lazio, Latina, San Felice Circeo, H836",
	"Lazio, Latina, Santi Cosma e Damiano, I339",
	"Lazio, Latina, Sermoneta, I634",
	"Lazio, Latina, Sezze, I712",
	"Lazio, Latina, Sonnino, I832",
	"Lazio, Latina, Sperlonga, I892",
	"Lazio, Latina, Spigno Saturnia, I902",
	"Lazio, Latina, Terracina, L120",
	"Lazio, Latina, Ventotene, L742",
	"Lazio, Frosinone, Acquafondata, A032",
	"Lazio, Frosinone, Acuto, A054",
	"Lazio, Frosinone, Alatri, A123",
	"Lazio, Frosinone, Alvito, A244",
	"Lazio, Frosinone, Amaseno, A256",
	"Lazio, Frosinone, Anagni, A269",
	"Lazio, Frosinone, Aquino, A348",
	"Lazio, Frosinone, Arce, A363",
	"Lazio, Frosinone, Arnara, A421",
	"Lazio, Frosinone, Arpino, A433",
	"Lazio, Frosinone, Atina, A486",
	"Lazio, Frosinone, Ausonia, A502",
	"Lazio, Frosinone, Belmonte Castello, A763",
	"Lazio, Frosinone, Boville Ernica, A720",
	"Lazio, Frosinone, Broccostella, B195",
	"Lazio, Frosinone, Campoli Appennino, B543",
	"Lazio, Frosinone, Casalattico, B862",
	"Lazio, Frosinone, Casalvieri, B919",
	"Lazio, Frosinone, Cassino, C034",
	"Lazio, Frosinone, Castelliri, C177",
	"Lazio, Frosinone, Castelnuovo Parano, C223",
	"Lazio, Frosinone, Castrocielo, C340",
	"Lazio, Frosinone, Castro dei Volsci, C338",
	"Lazio, Frosinone, Ceccano, C413",
	"Lazio, Frosinone, Ceprano, C479",
	"Lazio, Frosinone, Cervaro, C545",
	"Lazio, Frosinone, Colfelice, C836",
	"Lazio, Frosinone, Collepardo, C864",
	"Lazio, Frosinone, Colle San Magno, C870",
	"Lazio, Frosinone, Coreno Ausonio, C998",
	"Lazio, Frosinone, Esperia, D440",
	"Lazio, Frosinone, Falvaterra, D483",
	"Lazio, Frosinone, Ferentino, D539",
	"Lazio, Frosinone, Filettino, D591",
	"Lazio, Frosinone, Fiuggi, A310",
	"Lazio, Frosinone, Fontana Liri, D667",
	"Lazio, Frosinone, Fontechiari, D682",
	"Lazio, Frosinone, Frosinone, D810",
	"Lazio, Frosinone, Fumone, D819",
	"Lazio, Frosinone, Gallinaro, D881",
	"Lazio, Frosinone, Giuliano di Roma, E057",
	"Lazio, Frosinone, Guarcino, E236",
	"Lazio, Frosinone, Isola del Liri, E340",
	"Lazio, Frosinone, Monte San Giovanni Campano, F620",
	"Lazio, Frosinone, Morolo, F740",
	"Lazio, Frosinone, Paliano, G276",
	"Lazio, Frosinone, Pastena, G362",
	"Lazio, Frosinone, Patrica, G374",
	"Lazio, Frosinone, Pescosolido, G500",
	"Lazio, Frosinone, Picinisco, G591",
	"Lazio, Frosinone, Pico, G592",
	"Lazio, Frosinone, Piedimonte San Germano, G598",
	"Lazio, Frosinone, Piglio, G659",
	"Lazio, Frosinone, Pignataro Interamna, G662",
	"Lazio, Frosinone, Pofi, G749",
	"Lazio, Frosinone, Pontecorvo, G838",
	"Lazio, Frosinone, Posta Fibreno, G935",
	"Lazio, Frosinone, Ripi, H324",
	"Lazio, Frosinone, Rocca d'Arce, H393",
	"Lazio, Frosinone, Roccasecca, H443",
	"Lazio, Frosinone, San Biagio Saracinisco, H779",
	"Lazio, Frosinone, San Donato Val di Comino, H824",
	"Lazio, Frosinone, San Giorgio a Liri, H880",
	"Lazio, Frosinone, San Giovanni Incarico, H917",
	"Lazio, Frosinone, Sant'Ambrogio sul Garigliano, I256",
	"Lazio, Frosinone, Sant'Andrea del Garigliano, I265",
	"Lazio, Frosinone, Sant'Apollinare, I302",
	"Lazio, Frosinone, Sant'Elia Fiumerapido, I321",
	"Lazio, Frosinone, Santopadre, I351",
	"Lazio, Frosinone, San Vittore del Lazio, I408",
	"Lazio, Frosinone, Serrone, I669",
	"Lazio, Frosinone, Settefrati, I697",
	"Lazio, Frosinone, Sgurgola, I716",
	"Lazio, Frosinone, Sora, I838",
	"Lazio, Frosinone, Strangolagalli, I973",
	"Lazio, Frosinone, Supino, L009",
	"Lazio, Frosinone, Terelle, L105",
	"Lazio, Frosinone, Torre Cajetani, L243",
	"Lazio, Frosinone, Torrice, L290",
	"Lazio, Frosinone, Trevi nel Lazio, L398",
	"Lazio, Frosinone, Trivigliano, L437",
	"Lazio, Frosinone, Vallecorsa, L598",
	"Lazio, Frosinone, Vallemaio, L605",
	"Lazio, Frosinone, Vallerotonda, L614",
	"Lazio, Frosinone, Veroli, L780",
	"Lazio, Frosinone, Vicalvi, L836",
	"Lazio, Frosinone, Vico nel Lazio, L843",
	"Lazio, Frosinone, Villa Latina, A081",
	"Lazio, Frosinone, Villa Santa Lucia, L905",
	"Lazio, Frosinone, Villa Santo Stefano, I364",
	"Lazio, Frosinone, Viticuso, M083",
	"Abruzzo, L'Aquila, Acciano, A018",
	"Abruzzo, L'Aquila, Aielli, A100",
	"Abruzzo, L'Aquila, Alfedena, A187",
	"Abruzzo, L'Aquila, Anversa degli Abruzzi, A318",
	"Abruzzo, L'Aquila, Ateleta, A481",
	"Abruzzo, L'Aquila, Avezzano, A515",
	"Abruzzo, L'Aquila, Balsorano, A603",
	"Abruzzo, L'Aquila, Barete, A656",
	"Abruzzo, L'Aquila, Barisciano, A667",
	"Abruzzo, L'Aquila, Barrea, A678",
	"Abruzzo, L'Aquila, Bisegna, A884",
	"Abruzzo, L'Aquila, Bugnara, B256",
	"Abruzzo, L'Aquila, Cagnano Amiterno, B358",
	"Abruzzo, L'Aquila, Calascio, B382",
	"Abruzzo, L'Aquila, Campo di Giove, B526",
	"Abruzzo, L'Aquila, Campotosto, B569",
	"Abruzzo, L'Aquila, Canistro, B606",
	"Abruzzo, L'Aquila, Cansano, B624",
	"Abruzzo, L'Aquila, Capestrano, B651",
	"Abruzzo, L'Aquila, Capistrello, B656",
	"Abruzzo, L'Aquila, Capitignano, B658",
	"Abruzzo, L'Aquila, Caporciano, B672",
	"Abruzzo, L'Aquila, Cappadocia, B677",
	"Abruzzo, L'Aquila, Carapelle Calvisio, B725",
	"Abruzzo, L'Aquila, Carsoli, B842",
	"Abruzzo, L'Aquila, Castel del Monte, C083",
	"Abruzzo, L'Aquila, Castel di Ieri, C090",
	"Abruzzo, L'Aquila, Castel di Sangro, C096",
	"Abruzzo, L'Aquila, Castellafiume, C126",
	"Abruzzo, L'Aquila, Castelvecchio Calvisio, C278",
	"Abruzzo, L'Aquila, Castelvecchio Subequo, C279",
	"Abruzzo, L'Aquila, Celano, C426",
	"Abruzzo, L'Aquila, Cerchio, C492",
	"Abruzzo, L'Aquila, Civita d'Antino, C766",
	"Abruzzo, L'Aquila, Civitella Alfedena, C778",
	"Abruzzo, L'Aquila, Civitella Roveto, C783",
	"Abruzzo, L'Aquila, Cocullo, C811",
	"Abruzzo, L'Aquila, Collarmele, C844",
	"Abruzzo, L'Aquila, Collelongo, C862",
	"Abruzzo, L'Aquila, Collepietro, C866",
	"Abruzzo, L'Aquila, Corfinio, C999",
	"Abruzzo, L'Aquila, Fagnano Alto, D465",
	"Abruzzo, L'Aquila, Fontecchio, D681",
	"Abruzzo, L'Aquila, Fossa, D736",
	"Abruzzo, L'Aquila, Gagliano Aterno, D850",
	"Abruzzo, L'Aquila, Gioia dei Marsi, E040",
	"Abruzzo, L'Aquila, Goriano Sicoli, E096",
	"Abruzzo, L'Aquila, Introdacqua, E307",
	"Abruzzo, L'Aquila, L'Aquila, A345",
	"Abruzzo, L'Aquila, Lecce nei Marsi, E505",
	"Abruzzo, L'Aquila, Luco dei Marsi, E723",
	"Abruzzo, L'Aquila, Lucoli, E724",
	"Abruzzo, L'Aquila, Magliano de' Marsi, E811",
	"Abruzzo, L'Aquila, Massa d'Albe, F022",
	"Abruzzo, L'Aquila, Molina Aterno, M255",
	"Abruzzo, L'Aquila, Montereale, F595",
	"Abruzzo, L'Aquila, Morino, F732",
	"Abruzzo, L'Aquila, Navelli, F852",
	"Abruzzo, L'Aquila, Ocre, F996",
	"Abruzzo, L'Aquila, Ofena, G002",
	"Abruzzo, L'Aquila, Opi, G079",
	"Abruzzo, L'Aquila, Oricola, G102",
	"Abruzzo, L'Aquila, Ortona dei Marsi, G142",
	"Abruzzo, L'Aquila, Ortucchio, G145",
	"Abruzzo, L'Aquila, Ovindoli, G200",
	"Abruzzo, L'Aquila, Pacentro, G210",
	"Abruzzo, L'Aquila, Pereto, G449",
	"Abruzzo, L'Aquila, Pescasseroli, G484",
	"Abruzzo, L'Aquila, Pescina, G492",
	"Abruzzo, L'Aquila, Pescocostanzo, G493",
	"Abruzzo, L'Aquila, Pettorano sul Gizio, G524",
	"Abruzzo, L'Aquila, Pizzoli, G726",
	"Abruzzo, L'Aquila, Poggio Picenze, G766",
	"Abruzzo, L'Aquila, Prata d'Ansidonia, G992",
	"Abruzzo, L'Aquila, Pratola Peligna, H007",
	"Abruzzo, L'Aquila, Prezza, H056",
	"Abruzzo, L'Aquila, Raiano, H166",
	"Abruzzo, L'Aquila, Rivisondoli, H353",
	"Abruzzo, L'Aquila, Roccacasale, H389",
	"Abruzzo, L'Aquila, Rocca di Botte, H399",
	"Abruzzo, L'Aquila, Rocca di Cambio, H400",
	"Abruzzo, L'Aquila, Rocca di Mezzo, H402",
	"Abruzzo, L'Aquila, Rocca Pia, H429",
	"Abruzzo, L'Aquila, Roccaraso, H434",
	"Abruzzo, L'Aquila, San Benedetto dei Marsi, H772",
	"Abruzzo, L'Aquila, San Benedetto in Perillis, H773",
	"Abruzzo, L'Aquila, San Demetrio ne' Vestini, H819",
	"Abruzzo, L'Aquila, San Pio delle Camere, I121",
	"Abruzzo, L'Aquila, Sante Marie, I326",
	"Abruzzo, L'Aquila, Sant'Eusanio Forconese, I336",
	"Abruzzo, L'Aquila, Santo Stefano di Sessanio, I360",
	"Abruzzo, L'Aquila, San Vincenzo Valle Roveto, I389",
	"Abruzzo, L'Aquila, Scanno, I501",
	"Abruzzo, L'Aquila, Scontrone, I543",
	"Abruzzo, L'Aquila, Scoppito, I546",
	"Abruzzo, L'Aquila, Scurcola Marsicana, I553",
	"Abruzzo, L'Aquila, Secinaro, I558",
	"Abruzzo, L'Aquila, Sulmona, I804",
	"Abruzzo, L'Aquila, Tagliacozzo, L025",
	"Abruzzo, L'Aquila, Tione degli Abruzzi, L173",
	"Abruzzo, L'Aquila, Tornimparte, L227",
	"Abruzzo, L'Aquila, Trasacco, L334",
	"Abruzzo, L'Aquila, Villalago, L958",
	"Abruzzo, L'Aquila, Villa Santa Lucia degli Abruzzi, M021",
	"Abruzzo, L'Aquila, Villa Sant'Angelo, M023",
	"Abruzzo, L'Aquila, Villavallelonga, M031",
	"Abruzzo, L'Aquila, Villetta Barrea, M041",
	"Abruzzo, L'Aquila, Vittorito, M090",
	"Abruzzo, Teramo, Alba Adriatica, A125",
	"Abruzzo, Teramo, Ancarano, A270",
	"Abruzzo, Teramo, Arsita, A445",
	"Abruzzo, Teramo, Atri, A488",
	"Abruzzo, Teramo, Basciano, A692",
	"Abruzzo, Teramo, Bellante, A746",
	"Abruzzo, Teramo, Bisenti, A885",
	"Abruzzo, Teramo, Campli, B515",
	"Abruzzo, Teramo, Canzano, B640",
	"Abruzzo, Teramo, Castel Castagna, C040",
	"Abruzzo, Teramo, Castellalto, C128",
	"Abruzzo, Teramo, Castelli, C169",
	"Abruzzo, Teramo, Castiglione Messer Raimondo, C316",
	"Abruzzo, Teramo, Castilenti, C322",
	"Abruzzo, Teramo, Cellino Attanasio, C449",
	"Abruzzo, Teramo, Cermignano, C517",
	"Abruzzo, Teramo, Civitella del Tronto, C781",
	"Abruzzo, Teramo, Colledara, C311",
	"Abruzzo, Teramo, Colonnella, C901",
	"Abruzzo, Teramo, Controguerra, C972",
	"Abruzzo, Teramo, Corropoli, D043",
	"Abruzzo, Teramo, Cortino, D076",
	"Abruzzo, Teramo, Crognaleto, D179",
	"Abruzzo, Teramo, Fano Adriano, D489",
	"Abruzzo, Teramo, Giulianova, E058",
	"Abruzzo, Teramo, Isola del Gran Sasso d'Italia, E343",
	"Abruzzo, Teramo, Montefino, F500",
	"Abruzzo, Teramo, Montorio al Vomano, F690",
	"Abruzzo, Teramo, Morro d'Oro, F747",
	"Abruzzo, Teramo, Mosciano Sant'Angelo, F764",
	"Abruzzo, Teramo, Nereto, F870",
	"Abruzzo, Teramo, Notaresco, F942",
	"Abruzzo, Teramo, Penna Sant'Andrea, G437",
	"Abruzzo, Teramo, Pietracamela, G608",
	"Abruzzo, Teramo, Pineto, F831",
	"Abruzzo, Teramo, Rocca Santa Maria, H440",
	"Abruzzo, Teramo, Roseto degli Abruzzi, F585",
	"Abruzzo, Teramo, Sant'Egidio alla Vibrata, I318",
	"Abruzzo, Teramo, Sant'Omero, I348",
	"Abruzzo, Teramo, Silvi, I741",
	"Abruzzo, Teramo, Teramo, L103",
	"Abruzzo, Teramo, Torano Nuovo, L207",
	"Abruzzo, Teramo, Torricella Sicura, L295",
	"Abruzzo, Teramo, Tortoreto, L307",
	"Abruzzo, Teramo, Tossicia, L314",
	"Abruzzo, Teramo, Valle Castellana, L597",
	"Abruzzo, Teramo, Martinsicuro, E989",
	"Abruzzo, Pescara, Abbateggio, A008",
	"Abruzzo, Pescara, Alanno, A120",
	"Abruzzo, Pescara, Bolognano, A945",
	"Abruzzo, Pescara, Brittoli, B193",
	"Abruzzo, Pescara, Bussi sul Tirino, B294",
	"Abruzzo, Pescara, Cappelle sul Tavo, B681",
	"Abruzzo, Pescara, Caramanico Terme, B722",
	"Abruzzo, Pescara, Carpineto della Nora, B827",
	"Abruzzo, Pescara, Castiglione a Casauria, C308",
	"Abruzzo, Pescara, Catignano, C354",
	"Abruzzo, Pescara, Cepagatti, C474",
	"Abruzzo, Pescara, Città Sant'Angelo, C750",
	"Abruzzo, Pescara, Civitaquana, C771",
	"Abruzzo, Pescara, Civitella Casanova, C779",
	"Abruzzo, Pescara, Collecorvino, C853",
	"Abruzzo, Pescara, Corvara, D078",
	"Abruzzo, Pescara, Cugnoli, D201",
	"Abruzzo, Pescara, Elice, D394",
	"Abruzzo, Pescara, Farindola, D501",
	"Abruzzo, Pescara, Lettomanoppello, E558",
	"Abruzzo, Pescara, Loreto Aprutino, E691",
	"Abruzzo, Pescara, Manoppello, E892",
	"Abruzzo, Pescara, Montebello di Bertona, F441",
	"Abruzzo, Pescara, Montesilvano, F646",
	"Abruzzo, Pescara, Moscufo, F765",
	"Abruzzo, Pescara, Nocciano, F908",
	"Abruzzo, Pescara, Penne, G438",
	"Abruzzo, Pescara, Pescara, G482",
	"Abruzzo, Pescara, Pescosansonesco, G499",
	"Abruzzo, Pescara, Pianella, G555",
	"Abruzzo, Pescara, Picciano, G589",
	"Abruzzo, Pescara, Pietranico, G621",
	"Abruzzo, Pescara, Popoli, G878",
	"Abruzzo, Pescara, Roccamorice, H425",
	"Abruzzo, Pescara, Rosciano, H562",
	"Abruzzo, Pescara, Salle, H715",
	"Abruzzo, Pescara, Sant'Eufemia a Maiella, I332",
	"Abruzzo, Pescara, San Valentino in Abruzzo Citeriore, I376",
	"Abruzzo, Pescara, Scafa, I482",
	"Abruzzo, Pescara, Serramonacesca, I649",
	"Abruzzo, Pescara, Spoltore, I922",
	"Abruzzo, Pescara, Tocco da Casauria, L186",
	"Abruzzo, Pescara, Torre de' Passeri, L263",
	"Abruzzo, Pescara, Turrivalignani, L475",
	"Abruzzo, Pescara, Vicoli, L846",
	"Abruzzo, Pescara, Villa Celiera, L922",
	"Abruzzo, Chieti, Altino, A235",
	"Abruzzo, Chieti, Archi, A367",
	"Abruzzo, Chieti, Ari, A398",
	"Abruzzo, Chieti, Arielli, A402",
	"Abruzzo, Chieti, Atessa, A485",
	"Abruzzo, Chieti, Bomba, A956",
	"Abruzzo, Chieti, Borrello, B057",
	"Abruzzo, Chieti, Bucchianico, B238",
	"Abruzzo, Chieti, Montebello sul Sangro, B268",
	"Abruzzo, Chieti, Canosa Sannita, B620",
	"Abruzzo, Chieti, Carpineto Sinello, B826",
	"Abruzzo, Chieti, Carunchio, B853",
	"Abruzzo, Chieti, Casacanditella, B859",
	"Abruzzo, Chieti, Casalanguida, B861",
	"Abruzzo, Chieti, Casalbordino, B865",
	"Abruzzo, Chieti, Casalincontrada, B896",
	"Abruzzo, Chieti, Casoli, B985",
	"Abruzzo, Chieti, Castel Frentano, C114",
	"Abruzzo, Chieti, Castelguidone, C123",
	"Abruzzo, Chieti, Castiglione Messer Marino, C298",
	"Abruzzo, Chieti, Celenza sul Trigno, C428",
	"Abruzzo, Chieti, Chieti, C632",
	"Abruzzo, Chieti, Civitaluparella, C768",
	"Abruzzo, Chieti, Civitella Messer Raimondo, C776",
	"Abruzzo, Chieti, Colledimacine, C855",
	"Abruzzo, Chieti, Colledimezzo, C856",
	"Abruzzo, Chieti, Crecchio, D137",
	"Abruzzo, Chieti, Cupello, D209",
	"Abruzzo, Chieti, Dogliola, D315",
	"Abruzzo, Chieti, Fara Filiorum Petri, D494",
	"Abruzzo, Chieti, Fara San Martino, D495",
	"Abruzzo, Chieti, Filetto, D592",
	"Abruzzo, Chieti, Fossacesia, D738",
	"Abruzzo, Chieti, Fraine, D757",
	"Abruzzo, Chieti, Francavilla al Mare, D763",
	"Abruzzo, Chieti, Fresagrandinaria, D796",
	"Abruzzo, Chieti, Frisa, D803",
	"Abruzzo, Chieti, Furci, D823",
	"Abruzzo, Chieti, Gamberale, D898",
	"Abruzzo, Chieti, Gessopalena, D996",
	"Abruzzo, Chieti, Gissi, E052",
	"Abruzzo, Chieti, Giuliano Teatino, E056",
	"Abruzzo, Chieti, Guardiagrele, E243",
	"Abruzzo, Chieti, Guilmi, E266",
	"Abruzzo, Chieti, Lama dei Peligni, E424",
	"Abruzzo, Chieti, Lanciano, E435",
	"Abruzzo, Chieti, Lentella, E531",
	"Abruzzo, Chieti, Lettopalena, E559",
	"Abruzzo, Chieti, Liscia, E611",
	"Abruzzo, Chieti, Miglianico, F196",
	"Abruzzo, Chieti, Montazzoli, F433",
	"Abruzzo, Chieti, Monteferrante, F498",
	"Abruzzo, Chieti, Montelapiano, F535",
	"Abruzzo, Chieti, Montenerodomo, F578",
	"Abruzzo, Chieti, Monteodorisio, F582",
	"Abruzzo, Chieti, Mozzagrogna, F785",
	"Abruzzo, Chieti, Orsogna, G128",
	"Abruzzo, Chieti, Ortona, G141",
	"Abruzzo, Chieti, Paglieta, G237",
	"Abruzzo, Chieti, Palena, G271",
	"Abruzzo, Chieti, Palmoli, G290",
	"Abruzzo, Chieti, Palombaro, G294",
	"Abruzzo, Chieti, Pennadomo, G434",
	"Abruzzo, Chieti, Pennapiedimonte, G435",
	"Abruzzo, Chieti, Perano, G441",
	"Abruzzo, Chieti, Pizzoferrato, G724",
	"Abruzzo, Chieti, Poggiofiorito, G760",
	"Abruzzo, Chieti, Pollutri, G799",
	"Abruzzo, Chieti, Pretoro, H052",
	"Abruzzo, Chieti, Quadri, H098",
	"Abruzzo, Chieti, Rapino, H184",
	"Abruzzo, Chieti, Ripa Teatina, H320",
	"Abruzzo, Chieti, Roccamontepiano, H424",
	"Abruzzo, Chieti, Rocca San Giovanni, H439",
	"Abruzzo, Chieti, Roccascalegna, H442",
	"Abruzzo, Chieti, Roccaspinalveti, H448",
	"Abruzzo, Chieti, Roio del Sangro, H495",
	"Abruzzo, Chieti, Rosello, H566",
	"Abruzzo, Chieti, San Buono, H784",
	"Abruzzo, Chieti, San Giovanni Lipioni, H923",
	"Abruzzo, Chieti, San Giovanni Teatino, D690",
	"Abruzzo, Chieti, San Martino sulla Marrucina, H991",
	"Abruzzo, Chieti, San Salvo, I148",
	"Abruzzo, Chieti, Santa Maria Imbaro, I244",
	"Abruzzo, Chieti, Sant'Eusanio del Sangro, I335",
	"Abruzzo, Chieti, San Vito Chietino, I394",
	"Abruzzo, Chieti, Scerni, I520",
	"Abruzzo, Chieti, Schiavi di Abruzzo, I526",
	"Abruzzo, Chieti, Taranta Peligna, L047",
	"Abruzzo, Chieti, Tollo, L194",
	"Abruzzo, Chieti, Torino di Sangro, L218",
	"Abruzzo, Chieti, Tornareccio, L224",
	"Abruzzo, Chieti, Torrebruna, L253",
	"Abruzzo, Chieti, Torrevecchia Teatina, L284",
	"Abruzzo, Chieti, Torricella Peligna, L291",
	"Abruzzo, Chieti, Treglio, L363",
	"Abruzzo, Chieti, Tufillo, L459",
	"Abruzzo, Chieti, Vacri, L526",
	"Abruzzo, Chieti, Vasto, E372",
	"Abruzzo, Chieti, Villalfonsina, L961",
	"Abruzzo, Chieti, Villamagna, L964",
	"Abruzzo, Chieti, Villa Santa Maria, M022",
	"Abruzzo, Chieti, Pietraferrazzana, G613",
	"Abruzzo, Chieti, Fallo, D480",
	"Molise, Campobasso, Acquaviva Collecroce, A050",
	"Molise, Campobasso, Baranello, A616",
	"Molise, Campobasso, Bojano, A930",
	"Molise, Campobasso, Bonefro, A971",
	"Molise, Campobasso, Busso, B295",
	"Molise, Campobasso, Campobasso, B519",
	"Molise, Campobasso, Campochiaro, B522",
	"Molise, Campobasso, Campodipietra, B528",
	"Molise, Campobasso, Campolieto, B544",
	"Molise, Campobasso, Campomarino, B550",
	"Molise, Campobasso, Casacalenda, B858",
	"Molise, Campobasso, Casalciprano, B871",
	"Molise, Campobasso, Castelbottaccio, C066",
	"Molise, Campobasso, Castellino del Biferno, C175",
	"Molise, Campobasso, Castelmauro, C197",
	"Molise, Campobasso, Castropignano, C346",
	"Molise, Campobasso, Cercemaggiore, C486",
	"Molise, Campobasso, Cercepiccola, C488",
	"Molise, Campobasso, Civitacampomarano, C764",
	"Molise, Campobasso, Colle d'Anchise, C854",
	"Molise, Campobasso, Colletorto, C875",
	"Molise, Campobasso, Duronia, C772",
	"Molise, Campobasso, Ferrazzano, D550",
	"Molise, Campobasso, Fossalto, D737",
	"Molise, Campobasso, Gambatesa, D896",
	"Molise, Campobasso, Gildone, E030",
	"Molise, Campobasso, Guardialfiera, E244",
	"Molise, Campobasso, Guardiaregia, E248",
	"Molise, Campobasso, Guglionesi, E259",
	"Molise, Campobasso, Jelsi, E381",
	"Molise, Campobasso, Larino, E456",
	"Molise, Campobasso, Limosano, E599",
	"Molise, Campobasso, Lucito, E722",
	"Molise, Campobasso, Lupara, E748",
	"Molise, Campobasso, Macchia Valfortore, E780",
	"Molise, Campobasso, Mafalda, E799",
	"Molise, Campobasso, Matrice, F055",
	"Molise, Campobasso, Mirabello Sannitico, F233",
	"Molise, Campobasso, Molise, F294",
	"Molise, Campobasso, Monacilioni, F322",
	"Molise, Campobasso, Montagano, F391",
	"Molise, Campobasso, Montecilfone, F475",
	"Molise, Campobasso, Montefalcone nel Sannio, F495",
	"Molise, Campobasso, Montelongo, F548",
	"Molise, Campobasso, Montemitro, F569",
	"Molise, Campobasso, Montenero di Bisaccia, F576",
	"Molise, Campobasso, Montorio nei Frentani, F689",
	"Molise, Campobasso, Morrone del Sannio, F748",
	"Molise, Campobasso, Oratino, G086",
	"Molise, Campobasso, Palata, G257",
	"Molise, Campobasso, Petacciato, G506",
	"Molise, Campobasso, Petrella Tifernina, G512",
	"Molise, Campobasso, Pietracatella, G609",
	"Molise, Campobasso, Pietracupa, G610",
	"Molise, Campobasso, Portocannone, G910",
	"Molise, Campobasso, Provvidenti, H083",
	"Molise, Campobasso, Riccia, H273",
	"Molise, Campobasso, Ripabottoni, H311",
	"Molise, Campobasso, Ripalimosani, H313",
	"Molise, Campobasso, Roccavivara, H454",
	"Molise, Campobasso, Rotello, H589",
	"Molise, Campobasso, Salcito, H693",
	"Molise, Campobasso, San Biase, H782",
	"Molise, Campobasso, San Felice del Molise, H833",
	"Molise, Campobasso, San Giacomo degli Schiavoni, H867",
	"Molise, Campobasso, San Giovanni in Galdo, H920",
	"Molise, Campobasso, San Giuliano del Sannio, H928",
	"Molise, Campobasso, San Giuliano di Puglia, H929",
	"Molise, Campobasso, San Martino in Pensilis, H990",
	"Molise, Campobasso, San Massimo, I023",
	"Molise, Campobasso, San Polo Matese, I122",
	"Molise, Campobasso, Santa Croce di Magliano, I181",
	"Molise, Campobasso, Sant'Angelo Limosano, I289",
	"Molise, Campobasso, Sant'Elia a Pianisi, I320",
	"Molise, Campobasso, Sepino, I618",
	"Molise, Campobasso, Spinete, I910",
	"Molise, Campobasso, Tavenna, L069",
	"Molise, Campobasso, Termoli, L113",
	"Molise, Campobasso, Torella del Sannio, L215",
	"Molise, Campobasso, Toro, L230",
	"Molise, Campobasso, Trivento, L435",
	"Molise, Campobasso, Tufara, L458",
	"Molise, Campobasso, Ururi, L505",
	"Molise, Campobasso, Vinchiaturo, M057",
	"Molise, Isernia, Acquaviva d'Isernia, A051",
	"Molise, Isernia, Agnone, A080",
	"Molise, Isernia, Bagnoli del Trigno, A567",
	"Molise, Isernia, Belmonte del Sannio, A761",
	"Molise, Isernia, Cantalupo nel Sannio, B630",
	"Molise, Isernia, Capracotta, B682",
	"Molise, Isernia, Carovilli, B810",
	"Molise, Isernia, Carpinone, B830",
	"Molise, Isernia, Castel del Giudice, C082",
	"Molise, Isernia, Castelpetroso, C246",
	"Molise, Isernia, Castelpizzuto, C247",
	"Molise, Isernia, Castel San Vincenzo, C270",
	"Molise, Isernia, Castelverrino, C200",
	"Molise, Isernia, Cerro al Volturno, C534",
	"Molise, Isernia, Chiauci, C620",
	"Molise, Isernia, Civitanova del Sannio, C769",
	"Molise, Isernia, Colli a Volturno, C878",
	"Molise, Isernia, Conca Casale, C941",
	"Molise, Isernia, Filignano, D595",
	"Molise, Isernia, Forlì del Sannio, D703",
	"Molise, Isernia, Fornelli, D715",
	"Molise, Isernia, Frosolone, D811",
	"Molise, Isernia, Isernia, E335",
	"Molise, Isernia, Longano, E669",
	"Molise, Isernia, Macchia d'Isernia, E778",
	"Molise, Isernia, Macchiagodena, E779",
	"Molise, Isernia, Miranda, F239",
	"Molise, Isernia, Montaquila, F429",
	"Molise, Isernia, Montenero Val Cocchiara, F580",
	"Molise, Isernia, Monteroduni, F601",
	"Molise, Isernia, Pesche, G486",
	"Molise, Isernia, Pescolanciano, G495",
	"Molise, Isernia, Pescopennataro, G497",
	"Molise, Isernia, Pettoranello del Molise, G523",
	"Molise, Isernia, Pietrabbondante, G606",
	"Molise, Isernia, Pizzone, G727",
	"Molise, Isernia, Poggio Sannita, B317",
	"Molise, Isernia, Pozzilli, G954",
	"Molise, Isernia, Rionero Sannitico, H308",
	"Molise, Isernia, Roccamandolfi, H420",
	"Molise, Isernia, Roccasicura, H445",
	"Molise, Isernia, Rocchetta a Volturno, H458",
	"Molise, Isernia, San Pietro Avellana, I096",
	"Molise, Isernia, Sant'Agapito, I189",
	"Molise, Isernia, Santa Maria del Molise, I238",
	"Molise, Isernia, Sant'Angelo del Pesco, I282",
	"Molise, Isernia, Sant'Elena Sannita, B466",
	"Molise, Isernia, Scapoli, I507",
	"Molise, Isernia, Sessano del Molise, I679",
	"Molise, Isernia, Sesto Campano, I682",
	"Molise, Isernia, Vastogirardi, L696",
	"Molise, Isernia, Venafro, L725",
	"Campania, Caserta, Ailano, A106",
	"Campania, Caserta, Alife, A200",
	"Campania, Caserta, Alvignano, A243",
	"Campania, Caserta, Arienzo, A403",
	"Campania, Caserta, Aversa, A512",
	"Campania, Caserta, Baia e Latina, A579",
	"Campania, Caserta, Bellona, A755",
	"Campania, Caserta, Caianello, B361",
	"Campania, Caserta, Caiazzo, B362",
	"Campania, Caserta, Calvi Risorta, B445",
	"Campania, Caserta, Camigliano, B477",
	"Campania, Caserta, Cancello ed Arnone, B581",
	"Campania, Caserta, Capodrise, B667",
	"Campania, Caserta, Capriati a Volturno, B704",
	"Campania, Caserta, Capua, B715",
	"Campania, Caserta, Carinaro, B779",
	"Campania, Caserta, Carinola, B781",
	"Campania, Caserta, Casagiove, B860",
	"Campania, Caserta, Casal di Principe, B872",
	"Campania, Caserta, Casaluce, B916",
	"Campania, Caserta, Casapulla, B935",
	"Campania, Caserta, Caserta, B963",
	"Campania, Caserta, Castel Campagnano, B494",
	"Campania, Caserta, Castel di Sasso, C097",
	"Campania, Caserta, Castello del Matese, C178",
	"Campania, Caserta, Castel Morrone, C211",
	"Campania, Caserta, Castel Volturno, C291",
	"Campania, Caserta, Cervino, C558",
	"Campania, Caserta, Cesa, C561",
	"Campania, Caserta, Ciorlano, C716",
	"Campania, Caserta, Conca della Campania, C939",
	"Campania, Caserta, Curti, D228",
	"Campania, Caserta, Dragoni, D361",
	"Campania, Caserta, Fontegreca, D683",
	"Campania, Caserta, Formicola, D709",
	"Campania, Caserta, Francolise, D769",
	"Campania, Caserta, Frignano, D799",
	"Campania, Caserta, Gallo Matese, D884",
	"Campania, Caserta, Galluccio, D886",
	"Campania, Caserta, Giano Vetusto, E011",
	"Campania, Caserta, Gioia Sannitica, E039",
	"Campania, Caserta, Grazzanise, E158",
	"Campania, Caserta, Gricignano di Aversa, E173",
	"Campania, Caserta, Letino, E554",
	"Campania, Caserta, Liberi, E570",
	"Campania, Caserta, Lusciano, E754",
	"Campania, Caserta, Macerata Campania, E784",
	"Campania, Caserta, Maddaloni, E791",
	"Campania, Caserta, Marcianise, E932",
	"Campania, Caserta, Marzano Appio, E998",
	"Campania, Caserta, Mignano Monte Lungo, F203",
	"Campania, Caserta, Mondragone, F352",
	"Campania, Caserta, Orta di Atella, G130",
	"Campania, Caserta, Parete, G333",
	"Campania, Caserta, Pastorano, G364",
	"Campania, Caserta, Piana di Monte Verna, G541",
	"Campania, Caserta, Piedimonte Matese, G596",
	"Campania, Caserta, Pietramelara, G620",
	"Campania, Caserta, Pietravairano, G630",
	"Campania, Caserta, Pignataro Maggiore, G661",
	"Campania, Caserta, Pontelatone, G849",
	"Campania, Caserta, Portico di Caserta, G903",
	"Campania, Caserta, Prata Sannita, G991",
	"Campania, Caserta, Pratella, G995",
	"Campania, Caserta, Presenzano, H045",
	"Campania, Caserta, Raviscanina, H202",
	"Campania, Caserta, Recale, H210",
	"Campania, Caserta, Riardo, H268",
	"Campania, Caserta, Rocca d'Evandro, H398",
	"Campania, Caserta, Roccamonfina, H423",
	"Campania, Caserta, Roccaromana, H436",
	"Campania, Caserta, Rocchetta e Croce, H459",
	"Campania, Caserta, Ruviano, H165",
	"Campania, Caserta, San Cipriano d'Aversa, H798",
	"Campania, Caserta, San Felice a Cancello, H834",
	"Campania, Caserta, San Gregorio Matese, H939",
	"Campania, Caserta, San Marcellino, H978",
	"Campania, Caserta, San Nicola la Strada, I056",
	"Campania, Caserta, San Pietro Infine, I113",
	"Campania, Caserta, San Potito Sannitico, I130",
	"Campania, Caserta, San Prisco, I131",
	"Campania, Caserta, Santa Maria a Vico, I233",
	"Campania, Caserta, Santa Maria Capua Vetere, I234",
	"Campania, Caserta, Santa Maria la Fossa, I247",
	"Campania, Caserta, San Tammaro, I261",
	"Campania, Caserta, Sant'Angelo d'Alife, I273",
	"Campania, Caserta, Sant'Arpino, I306",
	"Campania, Caserta, Sessa Aurunca, I676",
	"Campania, Caserta, Sparanise, I885",
	"Campania, Caserta, Succivo, I993",
	"Campania, Caserta, Teano, L083",
	"Campania, Caserta, Teverola, L155",
	"Campania, Caserta, Tora e Piccilli, L205",
	"Campania, Caserta, Trentola Ducenta, L379",
	"Campania, Caserta, Vairano Patenora, L540",
	"Campania, Caserta, Valle Agricola, L594",
	"Campania, Caserta, Valle di Maddaloni, L591",
	"Campania, Caserta, Villa di Briano, D801",
	"Campania, Caserta, Villa Literno, L844",
	"Campania, Caserta, Vitulazio, M092",
	"Campania, Caserta, Falciano del Massico, D471",
	"Campania, Caserta, Cellole, M262",
	"Campania, Caserta, Casapesenna, M260",
	"Campania, Caserta, San Marco Evangelista, F043",
	"Campania, Benevento, Airola, A110",
	"Campania, Benevento, Amorosi, A265",
	"Campania, Benevento, Apice, A328",
	"Campania, Benevento, Apollosa, A330",
	"Campania, Benevento, Arpaia, A431",
	"Campania, Benevento, Arpaise, A432",
	"Campania, Benevento, Baselice, A696",
	"Campania, Benevento, Benevento, A783",
	"Campania, Benevento, Bonea, A970",
	"Campania, Benevento, Bucciano, B239",
	"Campania, Benevento, Buonalbergo, B267",
	"Campania, Benevento, Calvi, B444",
	"Campania, Benevento, Campolattaro, B541",
	"Campania, Benevento, Campoli del Monte Taburno, B542",
	"Campania, Benevento, Casalduni, B873",
	"Campania, Benevento, Castelfranco in Miscano, C106",
	"Campania, Benevento, Castelpagano, C245",
	"Campania, Benevento, Castelpoto, C250",
	"Campania, Benevento, Castelvenere, C280",
	"Campania, Benevento, Castelvetere in Val Fortore, C284",
	"Campania, Benevento, Cautano, C359",
	"Campania, Benevento, Ceppaloni, C476",
	"Campania, Benevento, Cerreto Sannita, C525",
	"Campania, Benevento, Circello, C719",
	"Campania, Benevento, Colle Sannita, C846",
	"Campania, Benevento, Cusano Mutri, D230",
	"Campania, Benevento, Dugenta, D380",
	"Campania, Benevento, Durazzano, D386",
	"Campania, Benevento, Faicchio, D469",
	"Campania, Benevento, Foglianise, D644",
	"Campania, Benevento, Foiano di Val Fortore, D650",
	"Campania, Benevento, Forchia, D693",
	"Campania, Benevento, Fragneto l'Abate, D755",
	"Campania, Benevento, Fragneto Monforte, D756",
	"Campania, Benevento, Frasso Telesino, D784",
	"Campania, Benevento, Ginestra degli Schiavoni, E034",
	"Campania, Benevento, Guardia Sanframondi, E249",
	"Campania, Benevento, Limatola, E589",
	"Campania, Benevento, Melizzano, F113",
	"Campania, Benevento, Moiano, F274",
	"Campania, Benevento, Molinara, F287",
	"Campania, Benevento, Montefalcone di Val Fortore, F494",
	"Campania, Benevento, Montesarchio, F636",
	"Campania, Benevento, Morcone, F717",
	"Campania, Benevento, Paduli, G227",
	"Campania, Benevento, Pago Veiano, G243",
	"Campania, Benevento, Pannarano, G311",
	"Campania, Benevento, Paolisi, G318",
	"Campania, Benevento, Paupisi, G386",
	"Campania, Benevento, Pesco Sannita, G494",
	"Campania, Benevento, Pietraroja, G626",
	"Campania, Benevento, Pietrelcina, G631",
	"Campania, Benevento, Ponte, G827",
	"Campania, Benevento, Pontelandolfo, G848",
	"Campania, Benevento, Puglianello, H087",
	"Campania, Benevento, Reino, H227",
	"Campania, Benevento, San Bartolomeo in Galdo, H764",
	"Campania, Benevento, San Giorgio del Sannio, H894",
	"Campania, Benevento, San Giorgio La Molara, H898",
	"Campania, Benevento, San Leucio del Sannio, H953",
	"Campania, Benevento, San Lorenzello, H955",
	"Campania, Benevento, San Lorenzo Maggiore, H967",
	"Campania, Benevento, San Lupo, H973",
	"Campania, Benevento, San Marco dei Cavoti, H984",
	"Campania, Benevento, San Martino Sannita, I002",
	"Campania, Benevento, San Nazzaro, I049",
	"Campania, Benevento, San Nicola Manfredi, I062",
	"Campania, Benevento, San Salvatore Telesino, I145",
	"Campania, Benevento, Santa Croce del Sannio, I179",
	"Campania, Benevento, Sant'Agata de' Goti, I197",
	"Campania, Benevento, Sant'Angelo a Cupolo, I277",
	"Campania, Benevento, Sassinoro, I455",
	"Campania, Benevento, Solopaca, I809",
	"Campania, Benevento, Telese Terme, L086",
	"Campania, Benevento, Tocco Caudio, L185",
	"Campania, Benevento, Torrecuso, L254",
	"Campania, Benevento, Vitulano, M093",
	"Campania, Benevento, Sant'Arcangelo Trimonte, F557",
	"Campania, Napoli, Acerra, A024",
	"Campania, Napoli, Afragola, A064",
	"Campania, Napoli, Agerola, A068",
	"Campania, Napoli, Anacapri, A268",
	"Campania, Napoli, Arzano, A455",
	"Campania, Napoli, Bacoli, A535",
	"Campania, Napoli, Barano d'Ischia, A617",
	"Campania, Napoli, Boscoreale, B076",
	"Campania, Napoli, Boscotrecase, B077",
	"Campania, Napoli, Brusciano, B227",
	"Campania, Napoli, Caivano, B371",
	"Campania, Napoli, Calvizzano, B452",
	"Campania, Napoli, Camposano, B565",
	"Campania, Napoli, Capri, B696",
	"Campania, Napoli, Carbonara di Nola, B740",
	"Campania, Napoli, Cardito, B759",
	"Campania, Napoli, Casalnuovo di Napoli, B905",
	"Campania, Napoli, Casamarciano, B922",
	"Campania, Napoli, Casamicciola Terme, B924",
	"Campania, Napoli, Casandrino, B925",
	"Campania, Napoli, Casavatore, B946",
	"Campania, Napoli, Casola di Napoli, B980",
	"Campania, Napoli, Casoria, B990",
	"Campania, Napoli, Castellammare di Stabia, C129",
	"Campania, Napoli, Castello di Cisterna, C188",
	"Campania, Napoli, Cercola, C495",
	"Campania, Napoli, Cicciano, C675",
	"Campania, Napoli, Cimitile, C697",
	"Campania, Napoli, Comiziano, C929",
	"Campania, Napoli, Crispano, D170",
	"Campania, Napoli, Forio, D702",
	"Campania, Napoli, Frattamaggiore, D789",
	"Campania, Napoli, Frattaminore, D790",
	"Campania, Napoli, Giugliano in Campania, E054",
	"Campania, Napoli, Gragnano, E131",
	"Campania, Napoli, Grumo Nevano, E224",
	"Campania, Napoli, Ischia, E329",
	"Campania, Napoli, Lacco Ameno, E396",
	"Campania, Napoli, Lettere, E557",
	"Campania, Napoli, Liveri, E620",
	"Campania, Napoli, Marano di Napoli, E906",
	"Campania, Napoli, Mariglianella, E954",
	"Campania, Napoli, Marigliano, E955",
	"Campania, Napoli, Massa Lubrense, F030",
	"Campania, Napoli, Melito di Napoli, F111",
	"Campania, Napoli, Meta, F162",
	"Campania, Napoli, Monte di Procida, F488",
	"Campania, Napoli, Mugnano di Napoli, F799",
	"Campania, Napoli, Napoli, F839",
	"Campania, Napoli, Nola, F924",
	"Campania, Napoli, Ottaviano, G190",
	"Campania, Napoli, Palma Campania, G283",
	"Campania, Napoli, Piano di Sorrento, G568",
	"Campania, Napoli, Pimonte, G670",
	"Campania, Napoli, Poggiomarino, G762",
	"Campania, Napoli, Pollena Trocchia, G795",
	"Campania, Napoli, Pomigliano d'Arco, G812",
	"Campania, Napoli, Pompei, G813",
	"Campania, Napoli, Portici, G902",
	"Campania, Napoli, Pozzuoli, G964",
	"Campania, Napoli, Procida, H072",
	"Campania, Napoli, Qualiano, H101",
	"Campania, Napoli, Quarto, H114",
	"Campania, Napoli, Ercolano, H243",
	"Campania, Napoli, Roccarainola, H433",
	"Campania, Napoli, San Gennaro Vesuviano, H860",
	"Campania, Napoli, San Giorgio a Cremano, H892",
	"Campania, Napoli, San Giuseppe Vesuviano, H931",
	"Campania, Napoli, San Paolo Bel Sito, I073",
	"Campania, Napoli, San Sebastiano al Vesuvio, I151",
	"Campania, Napoli, Sant'Agnello, I208",
	"Campania, Napoli, Sant'Anastasia, I262",
	"Campania, Napoli, Sant'Antimo, I293",
	"Campania, Napoli, Sant'Antonio Abate, I300",
	"Campania, Napoli, San Vitaliano, I391",
	"Campania, Napoli, Saviano, I469",
	"Campania, Napoli, Scisciano, I540",
	"Campania, Napoli, Serrara Fontana, I652",
	"Campania, Napoli, Somma Vesuviana, I820",
	"Campania, Napoli, Sorrento, I862",
	"Campania, Napoli, Striano, I978",
	"Campania, Napoli, Terzigno, L142",
	"Campania, Napoli, Torre Annunziata, L245",
	"Campania, Napoli, Torre del Greco, L259",
	"Campania, Napoli, Tufino, L460",
	"Campania, Napoli, Vico Equense, L845",
	"Campania, Napoli, Villaricca, G309",
	"Campania, Napoli, Visciano, M072",
	"Campania, Napoli, Volla, M115",
	"Campania, Napoli, Santa Maria la Carità, M273",
	"Campania, Napoli, Trecase, M280",
	"Campania, Napoli, Massa di Somma, M289",
	"Campania, Avellino, Aiello del Sabato, A101",
	"Campania, Avellino, Altavilla Irpina, A228",
	"Campania, Avellino, Andretta, A284",
	"Campania, Avellino, Aquilonia, A347",
	"Campania, Avellino, Ariano Irpino, A399",
	"Campania, Avellino, Atripalda, A489",
	"Campania, Avellino, Avella, A508",
	"Campania, Avellino, Avellino, A509",
	"Campania, Avellino, Bagnoli Irpino, A566",
	"Campania, Avellino, Baiano, A580",
	"Campania, Avellino, Bisaccia, A881",
	"Campania, Avellino, Bonito, A975",
	"Campania, Avellino, Cairano, B367",
	"Campania, Avellino, Calabritto, B374",
	"Campania, Avellino, Calitri, B415",
	"Campania, Avellino, Candida, B590",
	"Campania, Avellino, Caposele, B674",
	"Campania, Avellino, Capriglia Irpina, B706",
	"Campania, Avellino, Carife, B776",
	"Campania, Avellino, Casalbore, B866",
	"Campania, Avellino, Cassano Irpino, B997",
	"Campania, Avellino, Castel Baronia, C058",
	"Campania, Avellino, Castelfranci, C105",
	"Campania, Avellino, Castelvetere sul Calore, C283",
	"Campania, Avellino, Cervinara, C557",
	"Campania, Avellino, Cesinali, C576",
	"Campania, Avellino, Chianche, C606",
	"Campania, Avellino, Chiusano di San Domenico, C659",
	"Campania, Avellino, Contrada, C971",
	"Campania, Avellino, Conza della Campania, C976",
	"Campania, Avellino, Domicella, D331",
	"Campania, Avellino, Flumeri, D638",
	"Campania, Avellino, Fontanarosa, D671",
	"Campania, Avellino, Forino, D701",
	"Campania, Avellino, Frigento, D798",
	"Campania, Avellino, Gesualdo, D998",
	"Campania, Avellino, Greci, E161",
	"Campania, Avellino, Grottaminarda, E206",
	"Campania, Avellino, Grottolella, E214",
	"Campania, Avellino, Guardia Lombardi, E245",
	"Campania, Avellino, Lacedonia, E397",
	"Campania, Avellino, Lapio, E448",
	"Campania, Avellino, Lauro, E487",
	"Campania, Avellino, Lioni, E605",
	"Campania, Avellino, Luogosano, E746",
	"Campania, Avellino, Manocalzati, E891",
	"Campania, Avellino, Marzano di Nola, E997",
	"Campania, Avellino, Melito Irpino, F110",
	"Campania, Avellino, Mercogliano, F141",
	"Campania, Avellino, Mirabella Eclano, F230",
	"Campania, Avellino, Montaguto, F397",
	"Campania, Avellino, Montecalvo Irpino, F448",
	"Campania, Avellino, Montefalcione, F491",
	"Campania, Avellino, Monteforte Irpino, F506",
	"Campania, Avellino, Montefredane, F511",
	"Campania, Avellino, Montefusco, F512",
	"Campania, Avellino, Montella, F546",
	"Campania, Avellino, Montemarano, F559",
	"Campania, Avellino, Montemiletto, F566",
	"Campania, Avellino, Monteverde, F660",
	"Campania, Avellino, Morra De Sanctis, F744",
	"Campania, Avellino, Moschiano, F762",
	"Campania, Avellino, Mugnano del Cardinale, F798",
	"Campania, Avellino, Nusco, F988",
	"Campania, Avellino, Ospedaletto d'Alpinolo, G165",
	"Campania, Avellino, Pago del Vallo di Lauro, G242",
	"Campania, Avellino, Parolise, G340",
	"Campania, Avellino, Paternopoli, G370",
	"Campania, Avellino, Petruro Irpino, G519",
	"Campania, Avellino, Pietradefusi, G611",
	"Campania, Avellino, Pietrastornina, G629",
	"Campania, Avellino, Prata di Principato Ultra, G990",
	"Campania, Avellino, Pratola Serra, H006",
	"Campania, Avellino, Quadrelle, H097",
	"Campania, Avellino, Quindici, H128",
	"Campania, Avellino, Roccabascerana, H382",
	"Campania, Avellino, Rocca San Felice, H438",
	"Campania, Avellino, Rotondi, H592",
	"Campania, Avellino, Salza Irpina, H733",
	"Campania, Avellino, San Mango sul Calore, H975",
	"Campania, Avellino, San Martino Valle Caudina, I016",
	"Campania, Avellino, San Michele di Serino, I034",
	"Campania, Avellino, San Nicola Baronia, I061",
	"Campania, Avellino, San Potito Ultra, I129",
	"Campania, Avellino, San Sossio Baronia, I163",
	"Campania, Avellino, Santa Lucia di Serino, I219",
	"Campania, Avellino, Sant'Andrea di Conza, I264",
	"Campania, Avellino, Sant'Angelo all'Esca, I279",
	"Campania, Avellino, Sant'Angelo a Scala, I280",
	"Campania, Avellino, Sant'Angelo dei Lombardi, I281",
	"Campania, Avellino, Santa Paolina, I301",
	"Campania, Avellino, Santo Stefano del Sole, I357",
	"Campania, Avellino, Savignano Irpino, I471",
	"Campania, Avellino, Scampitella, I493",
	"Campania, Avellino, Senerchia, I606",
	"Campania, Avellino, Serino, I630",
	"Campania, Avellino, Sirignano, I756",
	"Campania, Avellino, Solofra, I805",
	"Campania, Avellino, Sorbo Serpico, I843",
	"Campania, Avellino, Sperone, I893",
	"Campania, Avellino, Sturno, I990",
	"Campania, Avellino, Summonte, L004",
	"Campania, Avellino, Taurano, L061",
	"Campania, Avellino, Taurasi, L062",
	"Campania, Avellino, Teora, L102",
	"Campania, Avellino, Torella dei Lombardi, L214",
	"Campania, Avellino, Torre Le Nocelle, L272",
	"Campania, Avellino, Torrioni, L301",
	"Campania, Avellino, Trevico, L399",
	"Campania, Avellino, Tufo, L461",
	"Campania, Avellino, Vallata, L589",
	"Campania, Avellino, Vallesaccarda, L616",
	"Campania, Avellino, Venticano, L739",
	"Campania, Avellino, Villamaina, L965",
	"Campania, Avellino, Villanova del Battista, L973",
	"Campania, Avellino, Volturara Irpina, M130",
	"Campania, Avellino, Zungoli, M203",
	"Campania, Avellino, Montoro, M330",
	"Campania, Salerno, Acerno, A023",
	"Campania, Salerno, Agropoli, A091",
	"Campania, Salerno, Albanella, A128",
	"Campania, Salerno, Alfano, A186",
	"Campania, Salerno, Altavilla Silentina, A230",
	"Campania, Salerno, Amalfi, A251",
	"Campania, Salerno, Angri, A294",
	"Campania, Salerno, Aquara, A343",
	"Campania, Salerno, Ascea, A460",
	"Campania, Salerno, Atena Lucana, A484",
	"Campania, Salerno, Atrani, A487",
	"Campania, Salerno, Auletta, A495",
	"Campania, Salerno, Baronissi, A674",
	"Campania, Salerno, Battipaglia, A717",
	"Campania, Salerno, Bellosguardo, A756",
	"Campania, Salerno, Bracigliano, B115",
	"Campania, Salerno, Buccino, B242",
	"Campania, Salerno, Buonabitacolo, B266",
	"Campania, Salerno, Caggiano, B351",
	"Campania, Salerno, Calvanico, B437",
	"Campania, Salerno, Camerota, B476",
	"Campania, Salerno, Campagna, B492",
	"Campania, Salerno, Campora, B555",
	"Campania, Salerno, Cannalonga, B608",
	"Campania, Salerno, Capaccio Paestum, B644",
	"Campania, Salerno, Casalbuono, B868",
	"Campania, Salerno, Casaletto Spartano, B888",
	"Campania, Salerno, Casal Velino, B895",
	"Campania, Salerno, Caselle in Pittari, B959",
	"Campania, Salerno, Castelcivita, C069",
	"Campania, Salerno, Castellabate, C125",
	"Campania, Salerno, Castelnuovo Cilento, C231",
	"Campania, Salerno, Castelnuovo di Conza, C235",
	"Campania, Salerno, Castel San Giorgio, C259",
	"Campania, Salerno, Castel San Lorenzo, C262",
	"Campania, Salerno, Castiglione del Genovesi, C306",
	"Campania, Salerno, Cava de' Tirreni, C361",
	"Campania, Salerno, Celle di Bulgheria, C444",
	"Campania, Salerno, Centola, C470",
	"Campania, Salerno, Ceraso, C485",
	"Campania, Salerno, Cetara, C584",
	"Campania, Salerno, Cicerale, C676",
	"Campania, Salerno, Colliano, C879",
	"Campania, Salerno, Conca dei Marini, C940",
	"Campania, Salerno, Controne, C973",
	"Campania, Salerno, Contursi Terme, C974",
	"Campania, Salerno, Corbara, C984",
	"Campania, Salerno, Corleto Monforte, D011",
	"Campania, Salerno, Cuccaro Vetere, D195",
	"Campania, Salerno, Eboli, D390",
	"Campania, Salerno, Felitto, D527",
	"Campania, Salerno, Fisciano, D615",
	"Campania, Salerno, Furore, D826",
	"Campania, Salerno, Futani, D832",
	"Campania, Salerno, Giffoni Sei Casali, E026",
	"Campania, Salerno, Giffoni Valle Piana, E027",
	"Campania, Salerno, Gioi, E037",
	"Campania, Salerno, Giungano, E060",
	"Campania, Salerno, Ispani, E365",
	"Campania, Salerno, Laureana Cilento, E480",
	"Campania, Salerno, Laurino, E485",
	"Campania, Salerno, Laurito, E486",
	"Campania, Salerno, Laviano, E498",
	"Campania, Salerno, Lustra, E767",
	"Campania, Salerno, Magliano Vetere, E814",
	"Campania, Salerno, Maiori, E839",
	"Campania, Salerno, Mercato San Severino, F138",
	"Campania, Salerno, Minori, F223",
	"Campania, Salerno, Moio della Civitella, F278",
	"Campania, Salerno, Montano Antilia, F426",
	"Campania, Salerno, Montecorice, F479",
	"Campania, Salerno, Montecorvino Pugliano, F480",
	"Campania, Salerno, Montecorvino Rovella, F481",
	"Campania, Salerno, Monteforte Cilento, F507",
	"Campania, Salerno, Monte San Giacomo, F618",
	"Campania, Salerno, Montesano sulla Marcellana, F625",
	"Campania, Salerno, Morigerati, F731",
	"Campania, Salerno, Nocera Inferiore, F912",
	"Campania, Salerno, Nocera Superiore, F913",
	"Campania, Salerno, Novi Velia, F967",
	"Campania, Salerno, Ogliastro Cilento, G011",
	"Campania, Salerno, Olevano sul Tusciano, G023",
	"Campania, Salerno, Oliveto Citra, G039",
	"Campania, Salerno, Omignano, G063",
	"Campania, Salerno, Orria, G121",
	"Campania, Salerno, Ottati, G192",
	"Campania, Salerno, Padula, G226",
	"Campania, Salerno, Pagani, G230",
	"Campania, Salerno, Palomonte, G292",
	"Campania, Salerno, Pellezzano, G426",
	"Campania, Salerno, Perdifumo, G447",
	"Campania, Salerno, Perito, G455",
	"Campania, Salerno, Pertosa, G476",
	"Campania, Salerno, Petina, G509",
	"Campania, Salerno, Piaggine, G538",
	"Campania, Salerno, Pisciotta, G707",
	"Campania, Salerno, Polla, G793",
	"Campania, Salerno, Pollica, G796",
	"Campania, Salerno, Pontecagnano Faiano, G834",
	"Campania, Salerno, Positano, G932",
	"Campania, Salerno, Postiglione, G939",
	"Campania, Salerno, Praiano, G976",
	"Campania, Salerno, Prignano Cilento, H062",
	"Campania, Salerno, Ravello, H198",
	"Campania, Salerno, Ricigliano, H277",
	"Campania, Salerno, Roccadaspide, H394",
	"Campania, Salerno, Roccagloriosa, H412",
	"Campania, Salerno, Roccapiemonte, H431",
	"Campania, Salerno, Rofrano, H485",
	"Campania, Salerno, Romagnano al Monte, H503",
	"Campania, Salerno, Roscigno, H564",
	"Campania, Salerno, Rutino, H644",
	"Campania, Salerno, Sacco, H654",
	"Campania, Salerno, Sala Consilina, H683",
	"Campania, Salerno, Salento, H686",
	"Campania, Salerno, Salerno, H703",
	"Campania, Salerno, Salvitelle, H732",
	"Campania, Salerno, San Cipriano Picentino, H800",
	"Campania, Salerno, San Giovanni a Piro, H907",
	"Campania, Salerno, San Gregorio Magno, H943",
	"Campania, Salerno, San Mango Piemonte, H977",
	"Campania, Salerno, San Marzano sul Sarno, I019",
	"Campania, Salerno, San Mauro Cilento, I031",
	"Campania, Salerno, San Mauro la Bruca, I032",
	"Campania, Salerno, San Pietro al Tanagro, I089",
	"Campania, Salerno, San Rufo, I143",
	"Campania, Salerno, Santa Marina, I253",
	"Campania, Salerno, Sant'Angelo a Fasanella, I278",
	"Campania, Salerno, Sant'Arsenio, I307",
	"Campania, Salerno, Sant'Egidio del Monte Albino, I317",
	"Campania, Salerno, Santomenna, I260",
	"Campania, Salerno, San Valentino Torio, I377",
	"Campania, Salerno, Sanza, I410",
	"Campania, Salerno, Sapri, I422",
	"Campania, Salerno, Sarno, I438",
	"Campania, Salerno, Sassano, I451",
	"Campania, Salerno, Scafati, I483",
	"Campania, Salerno, Scala, I486",
	"Campania, Salerno, Serramezzana, I648",
	"Campania, Salerno, Serre, I666",
	"Campania, Salerno, Sessa Cilento, I677",
	"Campania, Salerno, Siano, I720",
	"Campania, Salerno, Sicignano degli Alburni, M253",
	"Campania, Salerno, Stella Cilento, G887",
	"Campania, Salerno, Stio, I960",
	"Campania, Salerno, Teggiano, D292",
	"Campania, Salerno, Torchiara, L212",
	"Campania, Salerno, Torraca, L233",
	"Campania, Salerno, Torre Orsaia, L274",
	"Campania, Salerno, Tortorella, L306",
	"Campania, Salerno, Tramonti, L323",
	"Campania, Salerno, Trentinara, L377",
	"Campania, Salerno, Valle dell'Angelo, G540",
	"Campania, Salerno, Vallo della Lucania, L628",
	"Campania, Salerno, Valva, L656",
	"Campania, Salerno, Vibonati, L835",
	"Campania, Salerno, Vietri sul Mare, L860",
	"Campania, Salerno, Bellizzi, M294",
	"Puglia, Foggia, Accadia, A015",
	"Puglia, Foggia, Alberona, A150",
	"Puglia, Foggia, Anzano di Puglia, A320",
	"Puglia, Foggia, Apricena, A339",
	"Puglia, Foggia, Ascoli Satriano, A463",
	"Puglia, Foggia, Biccari, A854",
	"Puglia, Foggia, Bovino, B104",
	"Puglia, Foggia, Cagnano Varano, B357",
	"Puglia, Foggia, Candela, B584",
	"Puglia, Foggia, Carapelle, B724",
	"Puglia, Foggia, Carlantino, B784",
	"Puglia, Foggia, Carpino, B829",
	"Puglia, Foggia, Casalnuovo Monterotaro, B904",
	"Puglia, Foggia, Casalvecchio di Puglia, B917",
	"Puglia, Foggia, Castelluccio dei Sauri, C198",
	"Puglia, Foggia, Castelluccio Valmaggiore, C202",
	"Puglia, Foggia, Castelnuovo della Daunia, C222",
	"Puglia, Foggia, Celenza Valfortore, C429",
	"Puglia, Foggia, Celle di San Vito, C442",
	"Puglia, Foggia, Cerignola, C514",
	"Puglia, Foggia, Chieuti, C633",
	"Puglia, Foggia, Deliceto, D269",
	"Puglia, Foggia, Faeto, D459",
	"Puglia, Foggia, Foggia, D643",
	"Puglia, Foggia, Ischitella, E332",
	"Puglia, Foggia, Isole Tremiti, E363",
	"Puglia, Foggia, Lesina, E549",
	"Puglia, Foggia, Lucera, E716",
	"Puglia, Foggia, Manfredonia, E885",
	"Puglia, Foggia, Mattinata, F059",
	"Puglia, Foggia, Monteleone di Puglia, F538",
	"Puglia, Foggia, Monte Sant'Angelo, F631",
	"Puglia, Foggia, Motta Montecorvino, F777",
	"Puglia, Foggia, Orsara di Puglia, G125",
	"Puglia, Foggia, Orta Nova, G131",
	"Puglia, Foggia, Panni, G312",
	"Puglia, Foggia, Peschici, G487",
	"Puglia, Foggia, Pietramontecorvino, G604",
	"Puglia, Foggia, Poggio Imperiale, G761",
	"Puglia, Foggia, Rignano Garganico, H287",
	"Puglia, Foggia, Rocchetta Sant'Antonio, H467",
	"Puglia, Foggia, Rodi Garganico, H480",
	"Puglia, Foggia, Roseto Valfortore, H568",
	"Puglia, Foggia, San Giovanni Rotondo, H926",
	"Puglia, Foggia, San Marco in Lamis, H985",
	"Puglia, Foggia, San Marco la Catola, H986",
	"Puglia, Foggia, San Nicandro Garganico, I054",
	"Puglia, Foggia, San Paolo di Civitate, I072",
	"Puglia, Foggia, San Severo, I158",
	"Puglia, Foggia, Sant'Agata di Puglia, I193",
	"Puglia, Foggia, Serracapriola, I641",
	"Puglia, Foggia, Stornara, I962",
	"Puglia, Foggia, Stornarella, I963",
	"Puglia, Foggia, Torremaggiore, L273",
	"Puglia, Foggia, Troia, L447",
	"Puglia, Foggia, Vico del Gargano, L842",
	"Puglia, Foggia, Vieste, L858",
	"Puglia, Foggia, Volturara Appula, M131",
	"Puglia, Foggia, Volturino, M132",
	"Puglia, Foggia, Ordona, M266",
	"Puglia, Foggia, Zapponeta, M267",
	"Puglia, Bari, Acquaviva delle Fonti, A048",
	"Puglia, Bari, Adelfia, A055",
	"Puglia, Bari, Alberobello, A149",
	"Puglia, Bari, Altamura, A225",
	"Puglia, Bari, Bari, A662",
	"Puglia, Bari, Binetto, A874",
	"Puglia, Bari, Bitetto, A892",
	"Puglia, Bari, Bitonto, A893",
	"Puglia, Bari, Bitritto, A894",
	"Puglia, Bari, Capurso, B716",
	"Puglia, Bari, Casamassima, B923",
	"Puglia, Bari, Cassano delle Murge, B998",
	"Puglia, Bari, Castellana Grotte, C134",
	"Puglia, Bari, Cellamare, C436",
	"Puglia, Bari, Conversano, C975",
	"Puglia, Bari, Corato, C983",
	"Puglia, Bari, Gioia del Colle, E038",
	"Puglia, Bari, Giovinazzo, E047",
	"Puglia, Bari, Gravina in Puglia, E155",
	"Puglia, Bari, Grumo Appula, E223",
	"Puglia, Bari, Locorotondo, E645",
	"Puglia, Bari, Modugno, F262",
	"Puglia, Bari, Mola di Bari, F280",
	"Puglia, Bari, Molfetta, F284",
	"Puglia, Bari, Monopoli, F376",
	"Puglia, Bari, Noci, F915",
	"Puglia, Bari, Noicattaro, F923",
	"Puglia, Bari, Palo del Colle, G291",
	"Puglia, Bari, Poggiorsini, G769",
	"Puglia, Bari, Polignano a Mare, G787",
	"Puglia, Bari, Putignano, H096",
	"Puglia, Bari, Rutigliano, H643",
	"Puglia, Bari, Ruvo di Puglia, H645",
	"Puglia, Bari, Sammichele di Bari, H749",
	"Puglia, Bari, Sannicandro di Bari, I053",
	"Puglia, Bari, Santeramo in Colle, I330",
	"Puglia, Bari, Terlizzi, L109",
	"Puglia, Bari, Toritto, L220",
	"Puglia, Bari, Triggiano, L425",
	"Puglia, Bari, Turi, L472",
	"Puglia, Bari, Valenzano, L571",
	"Puglia, Taranto, Avetrana, A514",
	"Puglia, Taranto, Carosino, B808",
	"Puglia, Taranto, Castellaneta, C136",
	"Puglia, Taranto, Crispiano, D171",
	"Puglia, Taranto, Faggiano, D463",
	"Puglia, Taranto, Fragagnano, D754",
	"Puglia, Taranto, Ginosa, E036",
	"Puglia, Taranto, Grottaglie, E205",
	"Puglia, Taranto, Laterza, E469",
	"Puglia, Taranto, Leporano, E537",
	"Puglia, Taranto, Lizzano, E630",
	"Puglia, Taranto, Manduria, E882",
	"Puglia, Taranto, Martina Franca, E986",
	"Puglia, Taranto, Maruggio, E995",
	"Puglia, Taranto, Massafra, F027",
	"Puglia, Taranto, Monteiasi, F531",
	"Puglia, Taranto, Montemesola, F563",
	"Puglia, Taranto, Monteparano, F587",
	"Puglia, Taranto, Mottola, F784",
	"Puglia, Taranto, Palagianello, G251",
	"Puglia, Taranto, Palagiano, G252",
	"Puglia, Taranto, Pulsano, H090",
	"Puglia, Taranto, Roccaforzata, H409",
	"Puglia, Taranto, San Giorgio Ionico, H882",
	"Puglia, Taranto, San Marzano di San Giuseppe, I018",
	"Puglia, Taranto, Sava, I467",
	"Puglia, Taranto, Taranto, L049",
	"Puglia, Taranto, Torricella, L294",
	"Puglia, Taranto, Statte, M298",
	"Puglia, Brindisi, Brindisi, B180",
	"Puglia, Brindisi, Carovigno, B809",
	"Puglia, Brindisi, Ceglie Messapica, C424",
	"Puglia, Brindisi, Cellino San Marco, C448",
	"Puglia, Brindisi, Cisternino, C741",
	"Puglia, Brindisi, Erchie, D422",
	"Puglia, Brindisi, Fasano, D508",
	"Puglia, Brindisi, Francavilla Fontana, D761",
	"Puglia, Brindisi, Latiano, E471",
	"Puglia, Brindisi, Mesagne, F152",
	"Puglia, Brindisi, Oria, G098",
	"Puglia, Brindisi, Ostuni, G187",
	"Puglia, Brindisi, San Donaci, H822",
	"Puglia, Brindisi, San Michele Salentino, I045",
	"Puglia, Brindisi, San Pancrazio Salentino, I066",
	"Puglia, Brindisi, San Pietro Vernotico, I119",
	"Puglia, Brindisi, San Vito dei Normanni, I396",
	"Puglia, Brindisi, Torchiarolo, L213",
	"Puglia, Brindisi, Torre Santa Susanna, L280",
	"Puglia, Brindisi, Villa Castelli, L920",
	"Puglia, Lecce, Alessano, A184",
	"Puglia, Lecce, Alezio, A185",
	"Puglia, Lecce, Alliste, A208",
	"Puglia, Lecce, Andrano, A281",
	"Puglia, Lecce, Aradeo, A350",
	"Puglia, Lecce, Arnesano, A425",
	"Puglia, Lecce, Bagnolo del Salento, A572",
	"Puglia, Lecce, Botrugno, B086",
	"Puglia, Lecce, Calimera, B413",
	"Puglia, Lecce, Campi Salentina, B506",
	"Puglia, Lecce, Cannole, B616",
	"Puglia, Lecce, Caprarica di Lecce, B690",
	"Puglia, Lecce, Carmiano, B792",
	"Puglia, Lecce, Carpignano Salentino, B822",
	"Puglia, Lecce, Casarano, B936",
	"Puglia, Lecce, Castri di Lecce, C334",
	"Puglia, Lecce, Castrignano de' Greci, C335",
	"Puglia, Lecce, Castrignano del Capo, C336",
	"Puglia, Lecce, Cavallino, C377",
	"Puglia, Lecce, Collepasso, C865",
	"Puglia, Lecce, Copertino, C978",
	"Puglia, Lecce, Corigliano d'Otranto, D006",
	"Puglia, Lecce, Corsano, D044",
	"Puglia, Lecce, Cursi, D223",
	"Puglia, Lecce, Cutrofiano, D237",
	"Puglia, Lecce, Diso, D305",
	"Puglia, Lecce, Gagliano del Capo, D851",
	"Puglia, Lecce, Galatina, D862",
	"Puglia, Lecce, Galatone, D863",
	"Puglia, Lecce, Gallipoli, D883",
	"Puglia, Lecce, Giuggianello, E053",
	"Puglia, Lecce, Giurdignano, E061",
	"Puglia, Lecce, Guagnano, E227",
	"Puglia, Lecce, Lecce, E506",
	"Puglia, Lecce, Lequile, E538",
	"Puglia, Lecce, Leverano, E563",
	"Puglia, Lecce, Lizzanello, E629",
	"Puglia, Lecce, Maglie, E815",
	"Puglia, Lecce, Martano, E979",
	"Puglia, Lecce, Martignano, E984",
	"Puglia, Lecce, Matino, F054",
	"Puglia, Lecce, Melendugno, F101",
	"Puglia, Lecce, Melissano, F109",
	"Puglia, Lecce, Melpignano, F117",
	"Puglia, Lecce, Miggiano, F194",
	"Puglia, Lecce, Minervino di Lecce, F221",
	"Puglia, Lecce, Monteroni di Lecce, F604",
	"Puglia, Lecce, Montesano Salentino, F623",
	"Puglia, Lecce, Morciano di Leuca, F716",
	"Puglia, Lecce, Muro Leccese, F816",
	"Puglia, Lecce, Nardò, F842",
	"Puglia, Lecce, Neviano, F881",
	"Puglia, Lecce, Nociglia, F916",
	"Puglia, Lecce, Novoli, F970",
	"Puglia, Lecce, Ortelle, G136",
	"Puglia, Lecce, Otranto, G188",
	"Puglia, Lecce, Palmariggi, G285",
	"Puglia, Lecce, Parabita, G325",
	"Puglia, Lecce, Patù, G378",
	"Puglia, Lecce, Poggiardo, G751",
	"Puglia, Lecce, Racale, H147",
	"Puglia, Lecce, Ruffano, H632",
	"Puglia, Lecce, Salice Salentino, H708",
	"Puglia, Lecce, Salve, H729",
	"Puglia, Lecce, Sanarica, H757",
	"Puglia, Lecce, San Cesario di Lecce, H793",
	"Puglia, Lecce, San Donato di Lecce, H826",
	"Puglia, Lecce, Sannicola, I059",
	"Puglia, Lecce, San Pietro in Lama, I115",
	"Puglia, Lecce, Santa Cesarea Terme, I172",
	"Puglia, Lecce, Scorrano, I549",
	"Puglia, Lecce, Seclì, I559",
	"Puglia, Lecce, Sogliano Cavour, I780",
	"Puglia, Lecce, Soleto, I800",
	"Puglia, Lecce, Specchia, I887",
	"Puglia, Lecce, Spongano, I923",
	"Puglia, Lecce, Squinzano, I930",
	"Puglia, Lecce, Sternatia, I950",
	"Puglia, Lecce, Supersano, L008",
	"Puglia, Lecce, Surano, L010",
	"Puglia, Lecce, Surbo, L011",
	"Puglia, Lecce, Taurisano, L064",
	"Puglia, Lecce, Taviano, L074",
	"Puglia, Lecce, Tiggiano, L166",
	"Puglia, Lecce, Trepuzzi, L383",
	"Puglia, Lecce, Tricase, L419",
	"Puglia, Lecce, Tuglie, L462",
	"Puglia, Lecce, Ugento, L484",
	"Puglia, Lecce, Uggiano la Chiesa, L485",
	"Puglia, Lecce, Veglie, L711",
	"Puglia, Lecce, Vernole, L776",
	"Puglia, Lecce, Zollino, M187",
	"Puglia, Lecce, San Cassiano, M264",
	"Puglia, Lecce, Castro, M261",
	"Puglia, Lecce, Porto Cesareo, M263",
	"Puglia, Lecce, Presicce-Acquarica, M428",
	"Puglia, Barletta-Andria-Trani, Andria, A285",
	"Puglia, Barletta-Andria-Trani, Barletta, A669",
	"Puglia, Barletta-Andria-Trani, Bisceglie, A883",
	"Puglia, Barletta-Andria-Trani, Canosa di Puglia, B619",
	"Puglia, Barletta-Andria-Trani, Margherita di Savoia, E946",
	"Puglia, Barletta-Andria-Trani, Minervino Murge, F220",
	"Puglia, Barletta-Andria-Trani, San Ferdinando di Puglia, H839",
	"Puglia, Barletta-Andria-Trani, Spinazzola, I907",
	"Puglia, Barletta-Andria-Trani, Trani, L328",
	"Puglia, Barletta-Andria-Trani, Trinitapoli, B915",
	"Basilicata, Potenza, Abriola, A013",
	"Basilicata, Potenza, Acerenza, A020",
	"Basilicata, Potenza, Albano di Lucania, A131",
	"Basilicata, Potenza, Anzi, A321",
	"Basilicata, Potenza, Armento, A415",
	"Basilicata, Potenza, Atella, A482",
	"Basilicata, Potenza, Avigliano, A519",
	"Basilicata, Potenza, Balvano, A604",
	"Basilicata, Potenza, Banzi, A612",
	"Basilicata, Potenza, Baragiano, A615",
	"Basilicata, Potenza, Barile, A666",
	"Basilicata, Potenza, Bella, A743",
	"Basilicata, Potenza, Brienza, B173",
	"Basilicata, Potenza, Brindisi Montagna, B181",
	"Basilicata, Potenza, Calvello, B440",
	"Basilicata, Potenza, Calvera, B443",
	"Basilicata, Potenza, Campomaggiore, B549",
	"Basilicata, Potenza, Cancellara, B580",
	"Basilicata, Potenza, Carbone, B743",
	"Basilicata, Potenza, San Paolo Albanese, B906",
	"Basilicata, Potenza, Castelgrande, C120",
	"Basilicata, Potenza, Castelluccio Inferiore, C199",
	"Basilicata, Potenza, Castelluccio Superiore, C201",
	"Basilicata, Potenza, Castelmezzano, C209",
	"Basilicata, Potenza, Castelsaraceno, C271",
	"Basilicata, Potenza, Castronuovo di Sant'Andrea, C345",
	"Basilicata, Potenza, Cersosimo, C539",
	"Basilicata, Potenza, Chiaromonte, C619",
	"Basilicata, Potenza, Corleto Perticara, D010",
	"Basilicata, Potenza, Episcopia, D414",
	"Basilicata, Potenza, Fardella, D497",
	"Basilicata, Potenza, Filiano, D593",
	"Basilicata, Potenza, Forenza, D696",
	"Basilicata, Potenza, Francavilla in Sinni, D766",
	"Basilicata, Potenza, Gallicchio, D876",
	"Basilicata, Potenza, Genzano di Lucania, D971",
	"Basilicata, Potenza, Grumento Nova, E221",
	"Basilicata, Potenza, Guardia Perticara, E246",
	"Basilicata, Potenza, Lagonegro, E409",
	"Basilicata, Potenza, Latronico, E474",
	"Basilicata, Potenza, Laurenzana, E482",
	"Basilicata, Potenza, Lauria, E483",
	"Basilicata, Potenza, Lavello, E493",
	"Basilicata, Potenza, Maratea, E919",
	"Basilicata, Potenza, Marsico Nuovo, E976",
	"Basilicata, Potenza, Marsicovetere, E977",
	"Basilicata, Potenza, Maschito, F006",
	"Basilicata, Potenza, Melfi, F104",
	"Basilicata, Potenza, Missanello, F249",
	"Basilicata, Potenza, Moliterno, F295",
	"Basilicata, Potenza, Montemilone, F568",
	"Basilicata, Potenza, Montemurro, F573",
	"Basilicata, Potenza, Muro Lucano, F817",
	"Basilicata, Potenza, Nemoli, F866",
	"Basilicata, Potenza, Noepoli, F917",
	"Basilicata, Potenza, Oppido Lucano, G081",
	"Basilicata, Potenza, Palazzo San Gervasio, G261",
	"Basilicata, Potenza, Pescopagano, G496",
	"Basilicata, Potenza, Picerno, G590",
	"Basilicata, Potenza, Pietragalla, G616",
	"Basilicata, Potenza, Pietrapertosa, G623",
	"Basilicata, Potenza, Pignola, G663",
	"Basilicata, Potenza, Potenza, G942",
	"Basilicata, Potenza, Rapolla, H186",
	"Basilicata, Potenza, Rapone, H187",
	"Basilicata, Potenza, Rionero in Vulture, H307",
	"Basilicata, Potenza, Ripacandida, H312",
	"Basilicata, Potenza, Rivello, H348",
	"Basilicata, Potenza, Roccanova, H426",
	"Basilicata, Potenza, Rotonda, H590",
	"Basilicata, Potenza, Ruoti, H641",
	"Basilicata, Potenza, Ruvo del Monte, H646",
	"Basilicata, Potenza, San Chirico Nuovo, H795",
	"Basilicata, Potenza, San Chirico Raparo, H796",
	"Basilicata, Potenza, San Costantino Albanese, H808",
	"Basilicata, Potenza, San Fele, H831",
	"Basilicata, Potenza, San Martino d'Agri, H994",
	"Basilicata, Potenza, San Severino Lucano, I157",
	"Basilicata, Potenza, Sant'Angelo Le Fratte, I288",
	"Basilicata, Potenza, Sant'Arcangelo, I305",
	"Basilicata, Potenza, Sarconi, I426",
	"Basilicata, Potenza, Sasso di Castalda, I457",
	"Basilicata, Potenza, Satriano di Lucania, G614",
	"Basilicata, Potenza, Savoia di Lucania, H730",
	"Basilicata, Potenza, Senise, I610",
	"Basilicata, Potenza, Spinoso, I917",
	"Basilicata, Potenza, Teana, L082",
	"Basilicata, Potenza, Terranova di Pollino, L126",
	"Basilicata, Potenza, Tito, L181",
	"Basilicata, Potenza, Tolve, L197",
	"Basilicata, Potenza, Tramutola, L326",
	"Basilicata, Potenza, Trecchina, L357",
	"Basilicata, Potenza, Trivigno, L439",
	"Basilicata, Potenza, Vaglio Basilicata, L532",
	"Basilicata, Potenza, Venosa, L738",
	"Basilicata, Potenza, Vietri di Potenza, L859",
	"Basilicata, Potenza, Viggianello, L873",
	"Basilicata, Potenza, Viggiano, L874",
	"Basilicata, Potenza, Ginestra, E033",
	"Basilicata, Potenza, Paterno, M269",
	"Basilicata, Matera, Accettura, A017",
	"Basilicata, Matera, Aliano, A196",
	"Basilicata, Matera, Bernalda, A801",
	"Basilicata, Matera, Calciano, B391",
	"Basilicata, Matera, Cirigliano, C723",
	"Basilicata, Matera, Colobraro, C888",
	"Basilicata, Matera, Craco, D128",
	"Basilicata, Matera, Ferrandina, D547",
	"Basilicata, Matera, Garaguso, D909",
	"Basilicata, Matera, Gorgoglione, E093",
	"Basilicata, Matera, Grassano, E147",
	"Basilicata, Matera, Grottole, E213",
	"Basilicata, Matera, Irsina, E326",
	"Basilicata, Matera, Matera, F052",
	"Basilicata, Matera, Miglionico, F201",
	"Basilicata, Matera, Montalbano Jonico, F399",
	"Basilicata, Matera, Montescaglioso, F637",
	"Basilicata, Matera, Nova Siri, A942",
	"Basilicata, Matera, Oliveto Lucano, G037",
	"Basilicata, Matera, Pisticci, G712",
	"Basilicata, Matera, Policoro, G786",
	"Basilicata, Matera, Pomarico, G806",
	"Basilicata, Matera, Rotondella, H591",
	"Basilicata, Matera, Salandra, H687",
	"Basilicata, Matera, San Giorgio Lucano, H888",
	"Basilicata, Matera, San Mauro Forte, I029",
	"Basilicata, Matera, Stigliano, I954",
	"Basilicata, Matera, Tricarico, L418",
	"Basilicata, Matera, Tursi, L477",
	"Basilicata, Matera, Valsinni, D513",
	"Basilicata, Matera, Scanzano Jonico, M256",
	"Calabria, Cosenza, Acquaformosa, A033",
	"Calabria, Cosenza, Acquappesa, A041",
	"Calabria, Cosenza, Acri, A053",
	"Calabria, Cosenza, Aiello Calabro, A102",
	"Calabria, Cosenza, Aieta, A105",
	"Calabria, Cosenza, Albidona, A160",
	"Calabria, Cosenza, Alessandria del Carretto, A183",
	"Calabria, Cosenza, Altilia, A234",
	"Calabria, Cosenza, Altomonte, A240",
	"Calabria, Cosenza, Amantea, A253",
	"Calabria, Cosenza, Amendolara, A263",
	"Calabria, Cosenza, Aprigliano, A340",
	"Calabria, Cosenza, Belmonte Calabro, A762",
	"Calabria, Cosenza, Belsito, A768",
	"Calabria, Cosenza, Belvedere Marittimo, A773",
	"Calabria, Cosenza, Bianchi, A842",
	"Calabria, Cosenza, Bisignano, A887",
	"Calabria, Cosenza, Bocchigliero, A912",
	"Calabria, Cosenza, Bonifati, A973",
	"Calabria, Cosenza, Buonvicino, B270",
	"Calabria, Cosenza, Calopezzati, B424",
	"Calabria, Cosenza, Caloveto, B426",
	"Calabria, Cosenza, Campana, B500",
	"Calabria, Cosenza, Canna, B607",
	"Calabria, Cosenza, Cariati, B774",
	"Calabria, Cosenza, Carolei, B802",
	"Calabria, Cosenza, Carpanzano, B813",
	"Calabria, Cosenza, Cassano all'Ionio, C002",
	"Calabria, Cosenza, Castiglione Cosentino, C301",
	"Calabria, Cosenza, Castrolibero, C108",
	"Calabria, Cosenza, Castroregio, C348",
	"Calabria, Cosenza, Castrovillari, C349",
	"Calabria, Cosenza, Celico, C430",
	"Calabria, Cosenza, Cellara, C437",
	"Calabria, Cosenza, Cerchiara di Calabria, C489",
	"Calabria, Cosenza, Cerisano, C515",
	"Calabria, Cosenza, Cervicati, C554",
	"Calabria, Cosenza, Cerzeto, C560",
	"Calabria, Cosenza, Cetraro, C588",
	"Calabria, Cosenza, Civita, C763",
	"Calabria, Cosenza, Cleto, C795",
	"Calabria, Cosenza, Colosimi, C905",
	"Calabria, Cosenza, Cosenza, D086",
	"Calabria, Cosenza, Cropalati, D180",
	"Calabria, Cosenza, Crosia, D184",
	"Calabria, Cosenza, Diamante, D289",
	"Calabria, Cosenza, Dipignano, D304",
	"Calabria, Cosenza, Domanico, D328",
	"Calabria, Cosenza, Fagnano Castello, D464",
	"Calabria, Cosenza, Falconara Albanese, D473",
	"Calabria, Cosenza, Figline Vegliaturo, D582",
	"Calabria, Cosenza, Firmo, D614",
	"Calabria, Cosenza, Fiumefreddo Bruzio, D624",
	"Calabria, Cosenza, Francavilla Marittima, D764",
	"Calabria, Cosenza, Frascineto, D774",
	"Calabria, Cosenza, Fuscaldo, D828",
	"Calabria, Cosenza, Grimaldi, E180",
	"Calabria, Cosenza, Grisolia, E185",
	"Calabria, Cosenza, Guardia Piemontese, E242",
	"Calabria, Cosenza, Lago, E407",
	"Calabria, Cosenza, Laino Borgo, E417",
	"Calabria, Cosenza, Laino Castello, E419",
	"Calabria, Cosenza, Lappano, E450",
	"Calabria, Cosenza, Lattarico, E475",
	"Calabria, Cosenza, Longobardi, E677",
	"Calabria, Cosenza, Longobucco, E678",
	"Calabria, Cosenza, Lungro, E745",
	"Calabria, Cosenza, Luzzi, E773",
	"Calabria, Cosenza, Maierà, E835",
	"Calabria, Cosenza, Malito, E859",
	"Calabria, Cosenza, Malvito, E872",
	"Calabria, Cosenza, Mandatoriccio, E878",
	"Calabria, Cosenza, Mangone, E888",
	"Calabria, Cosenza, Marano Marchesato, E914",
	"Calabria, Cosenza, Marano Principato, E915",
	"Calabria, Cosenza, Marzi, F001",
	"Calabria, Cosenza, Mendicino, F125",
	"Calabria, Cosenza, Mongrassano, F370",
	"Calabria, Cosenza, Montalto Uffugo, F416",
	"Calabria, Cosenza, Montegiordano, F519",
	"Calabria, Cosenza, Morano Calabro, F708",
	"Calabria, Cosenza, Mormanno, F735",
	"Calabria, Cosenza, Mottafollone, F775",
	"Calabria, Cosenza, Nocara, F907",
	"Calabria, Cosenza, Oriolo, G110",
	"Calabria, Cosenza, Orsomarso, G129",
	"Calabria, Cosenza, Paludi, G298",
	"Calabria, Cosenza, Panettieri, G307",
	"Calabria, Cosenza, Paola, G317",
	"Calabria, Cosenza, Papasidero, G320",
	"Calabria, Cosenza, Parenti, G331",
	"Calabria, Cosenza, Paterno Calabro, G372",
	"Calabria, Cosenza, Pedivigliano, G411",
	"Calabria, Cosenza, Piane Crati, G553",
	"Calabria, Cosenza, Pietrafitta, G615",
	"Calabria, Cosenza, Pietrapaola, G622",
	"Calabria, Cosenza, Plataci, G733",
	"Calabria, Cosenza, Praia a Mare, G975",
	"Calabria, Cosenza, Rende, H235",
	"Calabria, Cosenza, Rocca Imperiale, H416",
	"Calabria, Cosenza, Roggiano Gravina, H488",
	"Calabria, Cosenza, Rogliano, H490",
	"Calabria, Cosenza, Rose, H565",
	"Calabria, Cosenza, Roseto Capo Spulico, H572",
	"Calabria, Cosenza, Rota Greca, H585",
	"Calabria, Cosenza, Rovito, H621",
	"Calabria, Cosenza, San Basile, H765",
	"Calabria, Cosenza, San Benedetto Ullano, H774",
	"Calabria, Cosenza, San Cosmo Albanese, H806",
	"Calabria, Cosenza, San Demetrio Corone, H818",
	"Calabria, Cosenza, San Donato di Ninea, H825",
	"Calabria, Cosenza, San Fili, H841",
	"Calabria, Cosenza, Sangineto, H877",
	"Calabria, Cosenza, San Giorgio Albanese, H881",
	"Calabria, Cosenza, San Giovanni in Fiore, H919",
	"Calabria, Cosenza, San Lorenzo Bellizzi, H961",
	"Calabria, Cosenza, San Lorenzo del Vallo, H962",
	"Calabria, Cosenza, San Lucido, H971",
	"Calabria, Cosenza, San Marco Argentano, H981",
	"Calabria, Cosenza, San Martino di Finita, H992",
	"Calabria, Cosenza, San Nicola Arcella, I060",
	"Calabria, Cosenza, San Pietro in Amantea, I108",
	"Calabria, Cosenza, San Pietro in Guarano, I114",
	"Calabria, Cosenza, San Sosti, I165",
	"Calabria, Cosenza, Santa Caterina Albanese, I171",
	"Calabria, Cosenza, Santa Domenica Talao, I183",
	"Calabria, Cosenza, Sant'Agata di Esaro, I192",
	"Calabria, Cosenza, Santa Maria del Cedro, C717",
	"Calabria, Cosenza, Santa Sofia d'Epiro, I309",
	"Calabria, Cosenza, Santo Stefano di Rogliano, I359",
	"Calabria, Cosenza, San Vincenzo La Costa, I388",
	"Calabria, Cosenza, Saracena, I423",
	"Calabria, Cosenza, Scala Coeli, I485",
	"Calabria, Cosenza, Scalea, I489",
	"Calabria, Cosenza, Scigliano, D290",
	"Calabria, Cosenza, Serra d'Aiello, I642",
	"Calabria, Cosenza, Spezzano Albanese, I895",
	"Calabria, Cosenza, Spezzano della Sila, I896",
	"Calabria, Cosenza, Tarsia, L055",
	"Calabria, Cosenza, Terranova da Sibari, L124",
	"Calabria, Cosenza, Terravecchia, L134",
	"Calabria, Cosenza, Torano Castello, L206",
	"Calabria, Cosenza, Tortora, L305",
	"Calabria, Cosenza, Trebisacce, L353",
	"Calabria, Cosenza, Vaccarizzo Albanese, L524",
	"Calabria, Cosenza, Verbicaro, L747",
	"Calabria, Cosenza, Villapiana, B903",
	"Calabria, Cosenza, Zumpano, M202",
	"Calabria, Cosenza, Casali del Manco, M385",
	"Calabria, Cosenza, Corigliano-Rossano, M403",
	"Calabria, Catanzaro, Albi, A155",
	"Calabria, Catanzaro, Amaroni, A255",
	"Calabria, Catanzaro, Amato, A257",
	"Calabria, Catanzaro, Andali, A272",
	"Calabria, Catanzaro, Argusto, A397",
	"Calabria, Catanzaro, Badolato, A542",
	"Calabria, Catanzaro, Belcastro, A736",
	"Calabria, Catanzaro, Borgia, B002",
	"Calabria, Catanzaro, Botricello, B085",
	"Calabria, Catanzaro, Caraffa di Catanzaro, B717",
	"Calabria, Catanzaro, Cardinale, B758",
	"Calabria, Catanzaro, Carlopoli, B790",
	"Calabria, Catanzaro, Catanzaro, C352",
	"Calabria, Catanzaro, Cenadi, C453",
	"Calabria, Catanzaro, Centrache, C472",
	"Calabria, Catanzaro, Cerva, C542",
	"Calabria, Catanzaro, Chiaravalle Centrale, C616",
	"Calabria, Catanzaro, Cicala, C674",
	"Calabria, Catanzaro, Conflenti, C960",
	"Calabria, Catanzaro, Cortale, D049",
	"Calabria, Catanzaro, Cropani, D181",
	"Calabria, Catanzaro, Curinga, D218",
	"Calabria, Catanzaro, Davoli, D257",
	"Calabria, Catanzaro, Decollatura, D261",
	"Calabria, Catanzaro, Falerna, D476",
	"Calabria, Catanzaro, Feroleto Antico, D544",
	"Calabria, Catanzaro, Fossato Serralta, D744",
	"Calabria, Catanzaro, Gagliato, D852",
	"Calabria, Catanzaro, Gasperina, D932",
	"Calabria, Catanzaro, Gimigliano, E031",
	"Calabria, Catanzaro, Girifalco, E050",
	"Calabria, Catanzaro, Gizzeria, E068",
	"Calabria, Catanzaro, Guardavalle, E239",
	"Calabria, Catanzaro, Isca sullo Ionio, E328",
	"Calabria, Catanzaro, Jacurso, E274",
	"Calabria, Catanzaro, Magisano, E806",
	"Calabria, Catanzaro, Maida, E834",
	"Calabria, Catanzaro, Marcedusa, E923",
	"Calabria, Catanzaro, Marcellinara, E925",
	"Calabria, Catanzaro, Martirano, E990",
	"Calabria, Catanzaro, Martirano Lombardo, E991",
	"Calabria, Catanzaro, Miglierina, F200",
	"Calabria, Catanzaro, Montauro, F432",
	"Calabria, Catanzaro, Montepaone, F586",
	"Calabria, Catanzaro, Motta Santa Lucia, F780",
	"Calabria, Catanzaro, Nocera Terinese, F910",
	"Calabria, Catanzaro, Olivadi, G034",
	"Calabria, Catanzaro, Palermiti, G272",
	"Calabria, Catanzaro, Pentone, G439",
	"Calabria, Catanzaro, Petrizzi, G517",
	"Calabria, Catanzaro, Petronà, G518",
	"Calabria, Catanzaro, Pianopoli, D546",
	"Calabria, Catanzaro, Platania, G734",
	"Calabria, Catanzaro, San Floro, H846",
	"Calabria, Catanzaro, San Mango d'Aquino, H976",
	"Calabria, Catanzaro, San Pietro a Maida, I093",
	"Calabria, Catanzaro, San Pietro Apostolo, I095",
	"Calabria, Catanzaro, San Sostene, I164",
	"Calabria, Catanzaro, Santa Caterina dello Ionio, I170",
	"Calabria, Catanzaro, Sant'Andrea Apostolo dello Ionio, I266",
	"Calabria, Catanzaro, San Vito sullo Ionio, I393",
	"Calabria, Catanzaro, Satriano, I463",
	"Calabria, Catanzaro, Sellia, I589",
	"Calabria, Catanzaro, Sellia Marina, I590",
	"Calabria, Catanzaro, Serrastretta, I655",
	"Calabria, Catanzaro, Sersale, I671",
	"Calabria, Catanzaro, Settingiano, I704",
	"Calabria, Catanzaro, Simeri Crichi, I745",
	"Calabria, Catanzaro, Sorbo San Basile, I844",
	"Calabria, Catanzaro, Soverato, I872",
	"Calabria, Catanzaro, Soveria Mannelli, I874",
	"Calabria, Catanzaro, Soveria Simeri, I875",
	"Calabria, Catanzaro, Squillace, I929",
	"Calabria, Catanzaro, Stalettì, I937",
	"Calabria, Catanzaro, Taverna, L070",
	"Calabria, Catanzaro, Tiriolo, L177",
	"Calabria, Catanzaro, Torre di Ruggiero, L240",
	"Calabria, Catanzaro, Vallefiorita, I322",
	"Calabria, Catanzaro, Zagarise, M140",
	"Calabria, Catanzaro, Lamezia Terme, M208",
	"Calabria, Reggio Calabria, Africo, A065",
	"Calabria, Reggio Calabria, Agnana Calabra, A077",
	"Calabria, Reggio Calabria, Anoia, A303",
	"Calabria, Reggio Calabria, Antonimina, A314",
	"Calabria, Reggio Calabria, Ardore, A385",
	"Calabria, Reggio Calabria, Bagaladi, A544",
	"Calabria, Reggio Calabria, Bagnara Calabra, A552",
	"Calabria, Reggio Calabria, Benestare, A780",
	"Calabria, Reggio Calabria, Bianco, A843",
	"Calabria, Reggio Calabria, Bivongi, A897",
	"Calabria, Reggio Calabria, Bova, B097",
	"Calabria, Reggio Calabria, Bovalino, B098",
	"Calabria, Reggio Calabria, Bova Marina, B099",
	"Calabria, Reggio Calabria, Brancaleone, B118",
	"Calabria, Reggio Calabria, Bruzzano Zeffirio, B234",
	"Calabria, Reggio Calabria, Calanna, B379",
	"Calabria, Reggio Calabria, Camini, B481",
	"Calabria, Reggio Calabria, Campo Calabro, B516",
	"Calabria, Reggio Calabria, Candidoni, B591",
	"Calabria, Reggio Calabria, Canolo, B617",
	"Calabria, Reggio Calabria, Caraffa del Bianco, B718",
	"Calabria, Reggio Calabria, Cardeto, B756",
	"Calabria, Reggio Calabria, Careri, B766",
	"Calabria, Reggio Calabria, Casignana, B966",
	"Calabria, Reggio Calabria, Caulonia, C285",
	"Calabria, Reggio Calabria, Ciminà, C695",
	"Calabria, Reggio Calabria, Cinquefrondi, C710",
	"Calabria, Reggio Calabria, Cittanova, C747",
	"Calabria, Reggio Calabria, Condofuri, C954",
	"Calabria, Reggio Calabria, Cosoleto, D089",
	"Calabria, Reggio Calabria, Delianuova, D268",
	"Calabria, Reggio Calabria, Feroleto della Chiesa, D545",
	"Calabria, Reggio Calabria, Ferruzzano, D557",
	"Calabria, Reggio Calabria, Fiumara, D619",
	"Calabria, Reggio Calabria, Galatro, D864",
	"Calabria, Reggio Calabria, Gerace, D975",
	"Calabria, Reggio Calabria, Giffone, E025",
	"Calabria, Reggio Calabria, Gioia Tauro, E041",
	"Calabria, Reggio Calabria, Gioiosa Ionica, E044",
	"Calabria, Reggio Calabria, Grotteria, E212",
	"Calabria, Reggio Calabria, Laganadi, E402",
	"Calabria, Reggio Calabria, Laureana di Borrello, E479",
	"Calabria, Reggio Calabria, Locri, D976",
	"Calabria, Reggio Calabria, Mammola, E873",
	"Calabria, Reggio Calabria, Marina di Gioiosa Ionica, E956",
	"Calabria, Reggio Calabria, Maropati, E968",
	"Calabria, Reggio Calabria, Martone, E993",
	"Calabria, Reggio Calabria, Melicuccà, F105",
	"Calabria, Reggio Calabria, Melicucco, F106",
	"Calabria, Reggio Calabria, Melito di Porto Salvo, F112",
	"Calabria, Reggio Calabria, Molochio, F301",
	"Calabria, Reggio Calabria, Monasterace, F324",
	"Calabria, Reggio Calabria, Montebello Jonico, D746",
	"Calabria, Reggio Calabria, Motta San Giovanni, F779",
	"Calabria, Reggio Calabria, Oppido Mamertina, G082",
	"Calabria, Reggio Calabria, Palizzi, G277",
	"Calabria, Reggio Calabria, Palmi, G288",
	"Calabria, Reggio Calabria, Pazzano, G394",
	"Calabria, Reggio Calabria, Placanica, G729",
	"Calabria, Reggio Calabria, Platì, G735",
	"Calabria, Reggio Calabria, Polistena, G791",
	"Calabria, Reggio Calabria, Portigliola, G905",
	"Calabria, Reggio Calabria, Reggio di Calabria, H224",
	"Calabria, Reggio Calabria, Riace, H265",
	"Calabria, Reggio Calabria, Rizziconi, H359",
	"Calabria, Reggio Calabria, Roccaforte del Greco, H408",
	"Calabria, Reggio Calabria, Roccella Ionica, H456",
	"Calabria, Reggio Calabria, Roghudi, H489",
	"Calabria, Reggio Calabria, Rosarno, H558",
	"Calabria, Reggio Calabria, Samo, H013",
	"Calabria, Reggio Calabria, San Giorgio Morgeto, H889",
	"Calabria, Reggio Calabria, San Giovanni di Gerace, H903",
	"Calabria, Reggio Calabria, San Lorenzo, H959",
	"Calabria, Reggio Calabria, San Luca, H970",
	"Calabria, Reggio Calabria, San Pietro di Caridà, I102",
	"Calabria, Reggio Calabria, San Procopio, I132",
	"Calabria, Reggio Calabria, San Roberto, I139",
	"Calabria, Reggio Calabria, Santa Cristina d'Aspromonte, I176",
	"Calabria, Reggio Calabria, Sant'Agata del Bianco, I198",
	"Calabria, Reggio Calabria, Sant'Alessio in Aspromonte, I214",
	"Calabria, Reggio Calabria, Sant'Eufemia d'Aspromonte, I333",
	"Calabria, Reggio Calabria, Sant'Ilario dello Ionio, I341",
	"Calabria, Reggio Calabria, Santo Stefano in Aspromonte, I371",
	"Calabria, Reggio Calabria, Scido, I536",
	"Calabria, Reggio Calabria, Scilla, I537",
	"Calabria, Reggio Calabria, Seminara, I600",
	"Calabria, Reggio Calabria, Serrata, I656",
	"Calabria, Reggio Calabria, Siderno, I725",
	"Calabria, Reggio Calabria, Sinopoli, I753",
	"Calabria, Reggio Calabria, Staiti, I936",
	"Calabria, Reggio Calabria, Stignano, I955",
	"Calabria, Reggio Calabria, Stilo, I956",
	"Calabria, Reggio Calabria, Taurianova, L063",
	"Calabria, Reggio Calabria, Terranova Sappo Minulio, L127",
	"Calabria, Reggio Calabria, Varapodio, L673",
	"Calabria, Reggio Calabria, Villa San Giovanni, M018",
	"Calabria, Reggio Calabria, San Ferdinando, M277",
	"Calabria, Crotone, Belvedere di Spinello, A772",
	"Calabria, Crotone, Caccuri, B319",
	"Calabria, Crotone, Carfizzi, B771",
	"Calabria, Crotone, Casabona, B857",
	"Calabria, Crotone, Castelsilano, B968",
	"Calabria, Crotone, Cerenzia, C501",
	"Calabria, Crotone, Cirò, C725",
	"Calabria, Crotone, Cirò Marina, C726",
	"Calabria, Crotone, Cotronei, D123",
	"Calabria, Crotone, Crotone, D122",
	"Calabria, Crotone, Crucoli, D189",
	"Calabria, Crotone, Cutro, D236",
	"Calabria, Crotone, Isola di Capo Rizzuto, E339",
	"Calabria, Crotone, Melissa, F108",
	"Calabria, Crotone, Mesoraca, F157",
	"Calabria, Crotone, Pallagorio, G278",
	"Calabria, Crotone, Petilia Policastro, G508",
	"Calabria, Crotone, Roccabernarda, H383",
	"Calabria, Crotone, Rocca di Neto, H403",
	"Calabria, Crotone, San Mauro Marchesato, I026",
	"Calabria, Crotone, San Nicola dell'Alto, I057",
	"Calabria, Crotone, Santa Severina, I308",
	"Calabria, Crotone, Savelli, I468",
	"Calabria, Crotone, Scandale, I494",
	"Calabria, Crotone, Strongoli, I982",
	"Calabria, Crotone, Umbriatico, L492",
	"Calabria, Crotone, Verzino, L802",
	"Calabria, Vibo Valentia, Acquaro, A043",
	"Calabria, Vibo Valentia, Arena, A386",
	"Calabria, Vibo Valentia, Briatico, B169",
	"Calabria, Vibo Valentia, Brognaturo, B197",
	"Calabria, Vibo Valentia, Capistrano, B655",
	"Calabria, Vibo Valentia, Cessaniti, C581",
	"Calabria, Vibo Valentia, Dasà, D253",
	"Calabria, Vibo Valentia, Dinami, D303",
	"Calabria, Vibo Valentia, Drapia, D364",
	"Calabria, Vibo Valentia, Fabrizia, D453",
	"Calabria, Vibo Valentia, Filadelfia, D587",
	"Calabria, Vibo Valentia, Filandari, D589",
	"Calabria, Vibo Valentia, Filogaso, D596",
	"Calabria, Vibo Valentia, Francavilla Angitola, D762",
	"Calabria, Vibo Valentia, Francica, D767",
	"Calabria, Vibo Valentia, Gerocarne, D988",
	"Calabria, Vibo Valentia, Ionadi, E321",
	"Calabria, Vibo Valentia, Joppolo, E389",
	"Calabria, Vibo Valentia, Limbadi, E590",
	"Calabria, Vibo Valentia, Maierato, E836",
	"Calabria, Vibo Valentia, Mileto, F207",
	"Calabria, Vibo Valentia, Mongiana, F364",
	"Calabria, Vibo Valentia, Monterosso Calabro, F607",
	"Calabria, Vibo Valentia, Nardodipace, F843",
	"Calabria, Vibo Valentia, Nicotera, F893",
	"Calabria, Vibo Valentia, Parghelia, G335",
	"Calabria, Vibo Valentia, Pizzo, G722",
	"Calabria, Vibo Valentia, Pizzoni, G728",
	"Calabria, Vibo Valentia, Polia, G785",
	"Calabria, Vibo Valentia, Ricadi, H271",
	"Calabria, Vibo Valentia, Rombiolo, H516",
	"Calabria, Vibo Valentia, San Calogero, H785",
	"Calabria, Vibo Valentia, San Costantino Calabro, H807",
	"Calabria, Vibo Valentia, San Gregorio d'Ippona, H941",
	"Calabria, Vibo Valentia, San Nicola da Crissa, I058",
	"Calabria, Vibo Valentia, Sant'Onofrio, I350",
	"Calabria, Vibo Valentia, Serra San Bruno, I639",
	"Calabria, Vibo Valentia, Simbario, I744",
	"Calabria, Vibo Valentia, Sorianello, I853",
	"Calabria, Vibo Valentia, Soriano Calabro, I854",
	"Calabria, Vibo Valentia, Spadola, I884",
	"Calabria, Vibo Valentia, Spilinga, I905",
	"Calabria, Vibo Valentia, Stefanaconi, I945",
	"Calabria, Vibo Valentia, Tropea, L452",
	"Calabria, Vibo Valentia, Vallelonga, L607",
	"Calabria, Vibo Valentia, Vazzano, L699",
	"Calabria, Vibo Valentia, Vibo Valentia, F537",
	"Calabria, Vibo Valentia, Zaccanopoli, M138",
	"Calabria, Vibo Valentia, Zambrone, M143",
	"Calabria, Vibo Valentia, Zungri, M204",
	"Sicilia, Trapani, Alcamo, A176",
	"Sicilia, Trapani, Buseto Palizzolo, B288",
	"Sicilia, Trapani, Calatafimi-Segesta, B385",
	"Sicilia, Trapani, Campobello di Mazara, B521",
	"Sicilia, Trapani, Castellammare del Golfo, C130",
	"Sicilia, Trapani, Castelvetrano, C286",
	"Sicilia, Trapani, Custonaci, D234",
	"Sicilia, Trapani, Erice, D423",
	"Sicilia, Trapani, Favignana, D518",
	"Sicilia, Trapani, Gibellina, E023",
	"Sicilia, Trapani, Marsala, E974",
	"Sicilia, Trapani, Mazara del Vallo, F061",
	"Sicilia, Trapani, Paceco, G208",
	"Sicilia, Trapani, Pantelleria, G315",
	"Sicilia, Trapani, Partanna, G347",
	"Sicilia, Trapani, Poggioreale, G767",
	"Sicilia, Trapani, Salaparuta, H688",
	"Sicilia, Trapani, Salemi, H700",
	"Sicilia, Trapani, Santa Ninfa, I291",
	"Sicilia, Trapani, San Vito Lo Capo, I407",
	"Sicilia, Trapani, Trapani, L331",
	"Sicilia, Trapani, Valderice, G319",
	"Sicilia, Trapani, Vita, M081",
	"Sicilia, Trapani, Petrosino, M281",
	"Sicilia, Trapani, Misiliscemi, M432",
	"Sicilia, Palermo, Alia, A195",
	"Sicilia, Palermo, Alimena, A202",
	"Sicilia, Palermo, Aliminusa, A203",
	"Sicilia, Palermo, Altavilla Milicia, A229",
	"Sicilia, Palermo, Altofonte, A239",
	"Sicilia, Palermo, Bagheria, A546",
	"Sicilia, Palermo, Balestrate, A592",
	"Sicilia, Palermo, Baucina, A719",
	"Sicilia, Palermo, Belmonte Mezzagno, A764",
	"Sicilia, Palermo, Bisacquino, A882",
	"Sicilia, Palermo, Bolognetta, A946",
	"Sicilia, Palermo, Bompietro, A958",
	"Sicilia, Palermo, Borgetto, A991",
	"Sicilia, Palermo, Caccamo, B315",
	"Sicilia, Palermo, Caltavuturo, B430",
	"Sicilia, Palermo, Campofelice di Fitalia, B533",
	"Sicilia, Palermo, Campofelice di Roccella, B532",
	"Sicilia, Palermo, Campofiorito, B535",
	"Sicilia, Palermo, Camporeale, B556",
	"Sicilia, Palermo, Capaci, B645",
	"Sicilia, Palermo, Carini, B780",
	"Sicilia, Palermo, Castelbuono, C067",
	"Sicilia, Palermo, Casteldaccia, C074",
	"Sicilia, Palermo, Castellana Sicula, C135",
	"Sicilia, Palermo, Castronovo di Sicilia, C344",
	"Sicilia, Palermo, Cefalà Diana, C420",
	"Sicilia, Palermo, Cefalù, C421",
	"Sicilia, Palermo, Cerda, C496",
	"Sicilia, Palermo, Chiusa Sclafani, C654",
	"Sicilia, Palermo, Ciminna, C696",
	"Sicilia, Palermo, Cinisi, C708",
	"Sicilia, Palermo, Collesano, C871",
	"Sicilia, Palermo, Contessa Entellina, C968",
	"Sicilia, Palermo, Corleone, D009",
	"Sicilia, Palermo, Ficarazzi, D567",
	"Sicilia, Palermo, Gangi, D907",
	"Sicilia, Palermo, Geraci Siculo, D977",
	"Sicilia, Palermo, Giardinello, E013",
	"Sicilia, Palermo, Giuliana, E055",
	"Sicilia, Palermo, Godrano, E074",
	"Sicilia, Palermo, Gratteri, E149",
	"Sicilia, Palermo, Isnello, E337",
	"Sicilia, Palermo, Isola delle Femmine, E350",
	"Sicilia, Palermo, Lascari, E459",
	"Sicilia, Palermo, Lercara Friddi, E541",
	"Sicilia, Palermo, Marineo, E957",
	"Sicilia, Palermo, Mezzojuso, F184",
	"Sicilia, Palermo, Misilmeri, F246",
	"Sicilia, Palermo, Monreale, F377",
	"Sicilia, Palermo, Montelepre, F544",
	"Sicilia, Palermo, Montemaggiore Belsito, F553",
	"Sicilia, Palermo, Palazzo Adriano, G263",
	"Sicilia, Palermo, Palermo, G273",
	"Sicilia, Palermo, Partinico, G348",
	"Sicilia, Palermo, Petralia Soprana, G510",
	"Sicilia, Palermo, Petralia Sottana, G511",
	"Sicilia, Palermo, Piana degli Albanesi, G543",
	"Sicilia, Palermo, Polizzi Generosa, G792",
	"Sicilia, Palermo, Pollina, G797",
	"Sicilia, Palermo, Prizzi, H070",
	"Sicilia, Palermo, Roccamena, H422",
	"Sicilia, Palermo, Roccapalumba, H428",
	"Sicilia, Palermo, San Cipirello, H797",
	"Sicilia, Palermo, San Giuseppe Jato, H933",
	"Sicilia, Palermo, San Mauro Castelverde, I028",
	"Sicilia, Palermo, Santa Cristina Gela, I174",
	"Sicilia, Palermo, Santa Flavia, I188",
	"Sicilia, Palermo, Sciara, I534",
	"Sicilia, Palermo, Sclafani Bagni, I541",
	"Sicilia, Palermo, Termini Imerese, L112",
	"Sicilia, Palermo, Terrasini, L131",
	"Sicilia, Palermo, Torretta, L282",
	"Sicilia, Palermo, Trabia, L317",
	"Sicilia, Palermo, Trappeto, L332",
	"Sicilia, Palermo, Ustica, L519",
	"Sicilia, Palermo, Valledolmo, L603",
	"Sicilia, Palermo, Ventimiglia di Sicilia, L740",
	"Sicilia, Palermo, Vicari, L837",
	"Sicilia, Palermo, Villabate, L916",
	"Sicilia, Palermo, Villafrati, L951",
	"Sicilia, Palermo, Scillato, I538",
	"Sicilia, Palermo, Blufi, M268",
	"Sicilia, Messina, Alcara li Fusi, A177",
	"Sicilia, Messina, Alì, A194",
	"Sicilia, Messina, Alì Terme, A201",
	"Sicilia, Messina, Antillo, A313",
	"Sicilia, Messina, Barcellona Pozzo di Gotto, A638",
	"Sicilia, Messina, Basicò, A698",
	"Sicilia, Messina, Brolo, B198",
	"Sicilia, Messina, Capizzi, B660",
	"Sicilia, Messina, Capo d'Orlando, B666",
	"Sicilia, Messina, Capri Leone, B695",
	"Sicilia, Messina, Caronia, B804",
	"Sicilia, Messina, Casalvecchio Siculo, B918",
	"Sicilia, Messina, Castel di Lucio, C094",
	"Sicilia, Messina, Castell'Umberto, C051",
	"Sicilia, Messina, Castelmola, C210",
	"Sicilia, Messina, Castroreale, C347",
	"Sicilia, Messina, Cesarò, C568",
	"Sicilia, Messina, Condrò, C956",
	"Sicilia, Messina, Falcone, D474",
	"Sicilia, Messina, Ficarra, D569",
	"Sicilia, Messina, Fiumedinisi, D622",
	"Sicilia, Messina, Floresta, D635",
	"Sicilia, Messina, Fondachelli-Fantina, D661",
	"Sicilia, Messina, Forza d'Agrò, D733",
	"Sicilia, Messina, Francavilla di Sicilia, D765",
	"Sicilia, Messina, Frazzanò, D793",
	"Sicilia, Messina, Furci Siculo, D824",
	"Sicilia, Messina, Furnari, D825",
	"Sicilia, Messina, Gaggi, D844",
	"Sicilia, Messina, Galati Mamertino, D861",
	"Sicilia, Messina, Gallodoro, D885",
	"Sicilia, Messina, Giardini-Naxos, E014",
	"Sicilia, Messina, Gioiosa Marea, E043",
	"Sicilia, Messina, Graniti, E142",
	"Sicilia, Messina, Gualtieri Sicaminò, E233",
	"Sicilia, Messina, Itala, E374",
	"Sicilia, Messina, Leni, E523",
	"Sicilia, Messina, Letojanni, E555",
	"Sicilia, Messina, Librizzi, E571",
	"Sicilia, Messina, Limina, E594",
	"Sicilia, Messina, Lipari, E606",
	"Sicilia, Messina, Longi, E674",
	"Sicilia, Messina, Malfa, E855",
	"Sicilia, Messina, Malvagna, E869",
	"Sicilia, Messina, Mandanici, E876",
	"Sicilia, Messina, Mazzarrà Sant'Andrea, F066",
	"Sicilia, Messina, Merì, F147",
	"Sicilia, Messina, Messina, F158",
	"Sicilia, Messina, Milazzo, F206",
	"Sicilia, Messina, Militello Rosmarino, F210",
	"Sicilia, Messina, Mirto, F242",
	"Sicilia, Messina, Mistretta, F251",
	"Sicilia, Messina, Moio Alcantara, F277",
	"Sicilia, Messina, Monforte San Giorgio, F359",
	"Sicilia, Messina, Mongiuffi Melia, F368",
	"Sicilia, Messina, Montagnareale, F395",
	"Sicilia, Messina, Montalbano Elicona, F400",
	"Sicilia, Messina, Motta Camastra, F772",
	"Sicilia, Messina, Motta d'Affermo, F773",
	"Sicilia, Messina, Naso, F848",
	"Sicilia, Messina, Nizza di Sicilia, F901",
	"Sicilia, Messina, Novara di Sicilia, F951",
	"Sicilia, Messina, Oliveri, G036",
	"Sicilia, Messina, Pace del Mela, G209",
	"Sicilia, Messina, Pagliara, G234",
	"Sicilia, Messina, Patti, G377",
	"Sicilia, Messina, Pettineo, G522",
	"Sicilia, Messina, Piraino, G699",
	"Sicilia, Messina, Raccuja, H151",
	"Sicilia, Messina, Reitano, H228",
	"Sicilia, Messina, Roccafiorita, H405",
	"Sicilia, Messina, Roccalumera, H418",
	"Sicilia, Messina, Roccavaldina, H380",
	"Sicilia, Messina, Roccella Valdemone, H455",
	"Sicilia, Messina, Rodì Milici, H479",
	"Sicilia, Messina, Rometta, H519",
	"Sicilia, Messina, San Filippo del Mela, H842",
	"Sicilia, Messina, San Fratello, H850",
	"Sicilia, Messina, San Marco d'Alunzio, H982",
	"Sicilia, Messina, San Pier Niceto, I084",
	"Sicilia, Messina, San Piero Patti, I086",
	"Sicilia, Messina, San Salvatore di Fitalia, I147",
	"Sicilia, Messina, Santa Domenica Vittoria, I184",
	"Sicilia, Messina, Sant'Agata di Militello, I199",
	"Sicilia, Messina, Sant'Alessio Siculo, I215",
	"Sicilia, Messina, Santa Lucia del Mela, I220",
	"Sicilia, Messina, Santa Marina Salina, I254",
	"Sicilia, Messina, Sant'Angelo di Brolo, I283",
	"Sicilia, Messina, Santa Teresa di Riva, I311",
	"Sicilia, Messina, San Teodoro, I328",
	"Sicilia, Messina, Santo Stefano di Camastra, I370",
	"Sicilia, Messina, Saponara, I420",
	"Sicilia, Messina, Savoca, I477",
	"Sicilia, Messina, Scaletta Zanclea, I492",
	"Sicilia, Messina, Sinagra, I747",
	"Sicilia, Messina, Spadafora, I881",
	"Sicilia, Messina, Taormina, L042",
	"Sicilia, Messina, Torregrotta, L271",
	"Sicilia, Messina, Tortorici, L308",
	"Sicilia, Messina, Tripi, L431",
	"Sicilia, Messina, Tusa, L478",
	"Sicilia, Messina, Ucria, L482",
	"Sicilia, Messina, Valdina, L561",
	"Sicilia, Messina, Venetico, L735",
	"Sicilia, Messina, Villafranca Tirrena, L950",
	"Sicilia, Messina, Terme Vigliatore, M210",
	"Sicilia, Messina, Acquedolci, M211",
	"Sicilia, Messina, Torrenova, M286",
	"Sicilia, Agrigento, Agrigento, A089",
	"Sicilia, Agrigento, Alessandria della Rocca, A181",
	"Sicilia, Agrigento, Aragona, A351",
	"Sicilia, Agrigento, Bivona, A896",
	"Sicilia, Agrigento, Burgio, B275",
	"Sicilia, Agrigento, Calamonaci, B377",
	"Sicilia, Agrigento, Caltabellotta, B427",
	"Sicilia, Agrigento, Camastra, B460",
	"Sicilia, Agrigento, Cammarata, B486",
	"Sicilia, Agrigento, Campobello di Licata, B520",
	"Sicilia, Agrigento, Canicattì, B602",
	"Sicilia, Agrigento, Casteltermini, C275",
	"Sicilia, Agrigento, Castrofilippo, C341",
	"Sicilia, Agrigento, Cattolica Eraclea, C356",
	"Sicilia, Agrigento, Cianciana, C668",
	"Sicilia, Agrigento, Comitini, C928",
	"Sicilia, Agrigento, Favara, D514",
	"Sicilia, Agrigento, Grotte, E209",
	"Sicilia, Agrigento, Joppolo Giancaxio, E390",
	"Sicilia, Agrigento, Lampedusa e Linosa, E431",
	"Sicilia, Agrigento, Licata, E573",
	"Sicilia, Agrigento, Lucca Sicula, E714",
	"Sicilia, Agrigento, Menfi, F126",
	"Sicilia, Agrigento, Montallegro, F414",
	"Sicilia, Agrigento, Montevago, F655",
	"Sicilia, Agrigento, Naro, F845",
	"Sicilia, Agrigento, Palma di Montechiaro, G282",
	"Sicilia, Agrigento, Porto Empedocle, F299",
	"Sicilia, Agrigento, Racalmuto, H148",
	"Sicilia, Agrigento, Raffadali, H159",
	"Sicilia, Agrigento, Ravanusa, H194",
	"Sicilia, Agrigento, Realmonte, H205",
	"Sicilia, Agrigento, Ribera, H269",
	"Sicilia, Agrigento, Sambuca di Sicilia, H743",
	"Sicilia, Agrigento, San Biagio Platani, H778",
	"Sicilia, Agrigento, San Giovanni Gemini, H914",
	"Sicilia, Agrigento, Santa Elisabetta, I185",
	"Sicilia, Agrigento, Santa Margherita di Belice, I224",
	"Sicilia, Agrigento, Sant'Angelo Muxaro, I290",
	"Sicilia, Agrigento, Santo Stefano Quisquina, I356",
	"Sicilia, Agrigento, Sciacca, I533",
	"Sicilia, Agrigento, Siculiana, I723",
	"Sicilia, Agrigento, Villafranca Sicula, L944",
	"Sicilia, Caltanissetta, Acquaviva Platani, A049",
	"Sicilia, Caltanissetta, Bompensiere, A957",
	"Sicilia, Caltanissetta, Butera, B302",
	"Sicilia, Caltanissetta, Caltanissetta, B429",
	"Sicilia, Caltanissetta, Campofranco, B537",
	"Sicilia, Caltanissetta, Delia, D267",
	"Sicilia, Caltanissetta, Gela, D960",
	"Sicilia, Caltanissetta, Marianopoli, E953",
	"Sicilia, Caltanissetta, Mazzarino, F065",
	"Sicilia, Caltanissetta, Milena, E618",
	"Sicilia, Caltanissetta, Montedoro, F489",
	"Sicilia, Caltanissetta, Mussomeli, F830",
	"Sicilia, Caltanissetta, Niscemi, F899",
	"Sicilia, Caltanissetta, Resuttano, H245",
	"Sicilia, Caltanissetta, Riesi, H281",
	"Sicilia, Caltanissetta, San Cataldo, H792",
	"Sicilia, Caltanissetta, Santa Caterina Villarmosa, I169",
	"Sicilia, Caltanissetta, Serradifalco, I644",
	"Sicilia, Caltanissetta, Sommatino, I824",
	"Sicilia, Caltanissetta, Sutera, L016",
	"Sicilia, Caltanissetta, Vallelunga Pratameno, L609",
	"Sicilia, Caltanissetta, Villalba, L959",
	"Sicilia, Enna, Agira, A070",
	"Sicilia, Enna, Aidone, A098",
	"Sicilia, Enna, Assoro, A478",
	"Sicilia, Enna, Barrafranca, A676",
	"Sicilia, Enna, Calascibetta, B381",
	"Sicilia, Enna, Catenanuova, C353",
	"Sicilia, Enna, Centuripe, C471",
	"Sicilia, Enna, Cerami, C480",
	"Sicilia, Enna, Enna, C342",
	"Sicilia, Enna, Gagliano Castelferrato, D849",
	"Sicilia, Enna, Leonforte, E536",
	"Sicilia, Enna, Nicosia, F892",
	"Sicilia, Enna, Nissoria, F900",
	"Sicilia, Enna, Piazza Armerina, G580",
	"Sicilia, Enna, Pietraperzia, G624",
	"Sicilia, Enna, Regalbuto, H221",
	"Sicilia, Enna, Sperlinga, I891",
	"Sicilia, Enna, Troina, L448",
	"Sicilia, Enna, Valguarnera Caropepe, L583",
	"Sicilia, Enna, Villarosa, M011",
	"Sicilia, Catania, Aci Bonaccorsi, A025",
	"Sicilia, Catania, Aci Castello, A026",
	"Sicilia, Catania, Aci Catena, A027",
	"Sicilia, Catania, Acireale, A028",
	"Sicilia, Catania, Aci Sant'Antonio, A029",
	"Sicilia, Catania, Adrano, A056",
	"Sicilia, Catania, Belpasso, A766",
	"Sicilia, Catania, Biancavilla, A841",
	"Sicilia, Catania, Bronte, B202",
	"Sicilia, Catania, Calatabiano, B384",
	"Sicilia, Catania, Caltagirone, B428",
	"Sicilia, Catania, Camporotondo Etneo, B561",
	"Sicilia, Catania, Castel di Iudica, C091",
	"Sicilia, Catania, Castiglione di Sicilia, C297",
	"Sicilia, Catania, Catania, C351",
	"Sicilia, Catania, Fiumefreddo di Sicilia, D623",
	"Sicilia, Catania, Giarre, E017",
	"Sicilia, Catania, Grammichele, E133",
	"Sicilia, Catania, Gravina di Catania, E156",
	"Sicilia, Catania, Licodia Eubea, E578",
	"Sicilia, Catania, Linguaglossa, E602",
	"Sicilia, Catania, Maletto, E854",
	"Sicilia, Catania, Mascali, F004",
	"Sicilia, Catania, Mascalucia, F005",
	"Sicilia, Catania, Militello in Val di Catania, F209",
	"Sicilia, Catania, Milo, F214",
	"Sicilia, Catania, Mineo, F217",
	"Sicilia, Catania, Mirabella Imbaccari, F231",
	"Sicilia, Catania, Misterbianco, F250",
	"Sicilia, Catania, Motta Sant'Anastasia, F781",
	"Sicilia, Catania, Nicolosi, F890",
	"Sicilia, Catania, Palagonia, G253",
	"Sicilia, Catania, Paternò, G371",
	"Sicilia, Catania, Pedara, G402",
	"Sicilia, Catania, Piedimonte Etneo, G597",
	"Sicilia, Catania, Raddusa, H154",
	"Sicilia, Catania, Ramacca, H168",
	"Sicilia, Catania, Randazzo, H175",
	"Sicilia, Catania, Riposto, H325",
	"Sicilia, Catania, San Cono, H805",
	"Sicilia, Catania, San Giovanni la Punta, H922",
	"Sicilia, Catania, San Gregorio di Catania, H940",
	"Sicilia, Catania, San Michele di Ganzaria, I035",
	"Sicilia, Catania, San Pietro Clarenza, I098",
	"Sicilia, Catania, Sant'Agata li Battiati, I202",
	"Sicilia, Catania, Sant'Alfio, I216",
	"Sicilia, Catania, Santa Maria di Licodia, I240",
	"Sicilia, Catania, Santa Venerina, I314",
	"Sicilia, Catania, Scordia, I548",
	"Sicilia, Catania, Trecastagni, L355",
	"Sicilia, Catania, Tremestieri Etneo, L369",
	"Sicilia, Catania, Valverde, L658",
	"Sicilia, Catania, Viagrande, L828",
	"Sicilia, Catania, Vizzini, M100",
	"Sicilia, Catania, Zafferana Etnea, M139",
	"Sicilia, Catania, Mazzarrone, M271",
	"Sicilia, Catania, Maniace, M283",
	"Sicilia, Catania, Ragalna, M287",
	"Sicilia, Ragusa, Acate, A014",
	"Sicilia, Ragusa, Chiaramonte Gulfi, C612",
	"Sicilia, Ragusa, Comiso, C927",
	"Sicilia, Ragusa, Giarratana, E016",
	"Sicilia, Ragusa, Ispica, E366",
	"Sicilia, Ragusa, Modica, F258",
	"Sicilia, Ragusa, Monterosso Almo, F610",
	"Sicilia, Ragusa, Pozzallo, G953",
	"Sicilia, Ragusa, Ragusa, H163",
	"Sicilia, Ragusa, Santa Croce Camerina, I178",
	"Sicilia, Ragusa, Scicli, I535",
	"Sicilia, Ragusa, Vittoria, M088",
	"Sicilia, Siracusa, Augusta, A494",
	"Sicilia, Siracusa, Avola, A522",
	"Sicilia, Siracusa, Buccheri, B237",
	"Sicilia, Siracusa, Buscemi, B287",
	"Sicilia, Siracusa, Canicattini Bagni, B603",
	"Sicilia, Siracusa, Carlentini, B787",
	"Sicilia, Siracusa, Cassaro, C006",
	"Sicilia, Siracusa, Ferla, D540",
	"Sicilia, Siracusa, Floridia, D636",
	"Sicilia, Siracusa, Francofonte, D768",
	"Sicilia, Siracusa, Lentini, E532",
	"Sicilia, Siracusa, Melilli, F107",
	"Sicilia, Siracusa, Noto, F943",
	"Sicilia, Siracusa, Pachino, G211",
	"Sicilia, Siracusa, Palazzolo Acreide, G267",
	"Sicilia, Siracusa, Rosolini, H574",
	"Sicilia, Siracusa, Siracusa, I754",
	"Sicilia, Siracusa, Solarino, I785",
	"Sicilia, Siracusa, Sortino, I864",
	"Sicilia, Siracusa, Portopalo di Capo Passero, M257",
	"Sicilia, Siracusa, Priolo Gargallo, M279",
	"Sardegna, Sassari, Aggius, A069",
	"Sardegna, Sassari, Alà dei Sardi, A115",
	"Sardegna, Sassari, Alghero, A192",
	"Sardegna, Sassari, Anela, A287",
	"Sardegna, Sassari, Ardara, A379",
	"Sardegna, Sassari, Arzachena, A453",
	"Sardegna, Sassari, Banari, A606",
	"Sardegna, Sassari, Benetutti, A781",
	"Sardegna, Sassari, Berchidda, A789",
	"Sardegna, Sassari, Bessude, A827",
	"Sardegna, Sassari, Bonnanaro, A976",
	"Sardegna, Sassari, Bono, A977",
	"Sardegna, Sassari, Bonorva, A978",
	"Sardegna, Sassari, Bortigiadas, B063",
	"Sardegna, Sassari, Borutta, B064",
	"Sardegna, Sassari, Bottidda, B094",
	"Sardegna, Sassari, Buddusò, B246",
	"Sardegna, Sassari, Bultei, B264",
	"Sardegna, Sassari, Bulzi, B265",
	"Sardegna, Sassari, Burgos, B276",
	"Sardegna, Sassari, Calangianus, B378",
	"Sardegna, Sassari, Cargeghe, B772",
	"Sardegna, Sassari, Castelsardo, C272",
	"Sardegna, Sassari, Cheremule, C600",
	"Sardegna, Sassari, Chiaramonti, C613",
	"Sardegna, Sassari, Codrongianos, C818",
	"Sardegna, Sassari, Cossoine, D100",
	"Sardegna, Sassari, Esporlatu, D441",
	"Sardegna, Sassari, Florinas, D637",
	"Sardegna, Sassari, Giave, E019",
	"Sardegna, Sassari, Illorai, E285",
	"Sardegna, Sassari, Ittireddu, E376",
	"Sardegna, Sassari, Ittiri, E377",
	"Sardegna, Sassari, Laerru, E401",
	"Sardegna, Sassari, La Maddalena, E425",
	"Sardegna, Sassari, Luogosanto, E747",
	"Sardegna, Sassari, Luras, E752",
	"Sardegna, Sassari, Mara, E902",
	"Sardegna, Sassari, Martis, E992",
	"Sardegna, Sassari, Monteleone Rocca Doria, F542",
	"Sardegna, Sassari, Monti, F667",
	"Sardegna, Sassari, Mores, F721",
	"Sardegna, Sassari, Muros, F818",
	"Sardegna, Sassari, Nughedu San Nicolò, F975",
	"Sardegna, Sassari, Nule, F976",
	"Sardegna, Sassari, Nulvi, F977",
	"Sardegna, Sassari, Olbia, G015",
	"Sardegna, Sassari, Olmedo, G046",
	"Sardegna, Sassari, Oschiri, G153",
	"Sardegna, Sassari, Osilo, G156",
	"Sardegna, Sassari, Ossi, G178",
	"Sardegna, Sassari, Ozieri, G203",
	"Sardegna, Sassari, Padria, G225",
	"Sardegna, Sassari, Palau, G258",
	"Sardegna, Sassari, Pattada, G376",
	"Sardegna, Sassari, Perfugas, G450",
	"Sardegna, Sassari, Ploaghe, G740",
	"Sardegna, Sassari, Porto Torres, G924",
	"Sardegna, Sassari, Pozzomaggiore, G962",
	"Sardegna, Sassari, Putifigari, H095",
	"Sardegna, Sassari, Romana, H507",
	"Sardegna, Sassari, Aglientu, H848",
	"Sardegna, Sassari, Santa Teresa Gallura, I312",
	"Sardegna, Sassari, Sassari, I452",
	"Sardegna, Sassari, Sedini, I565",
	"Sardegna, Sassari, Semestene, I598",
	"Sardegna, Sassari, Sennori, I614",
	"Sardegna, Sassari, Siligo, I732",
	"Sardegna, Sassari, Sorso, I863",
	"Sardegna, Sassari, Tempio Pausania, L093",
	"Sardegna, Sassari, Thiesi, L158",
	"Sardegna, Sassari, Tissi, L180",
	"Sardegna, Sassari, Torralba, L235",
	"Sardegna, Sassari, Trinità d'Agultu e Vignola, L428",
	"Sardegna, Sassari, Tula, L464",
	"Sardegna, Sassari, Uri, L503",
	"Sardegna, Sassari, Usini, L509",
	"Sardegna, Sassari, Villanova Monteleone, L989",
	"Sardegna, Sassari, Valledoria, L604",
	"Sardegna, Sassari, Telti, L088",
	"Sardegna, Sassari, Badesi, M214",
	"Sardegna, Sassari, Viddalba, M259",
	"Sardegna, Sassari, Golfo Aranci, M274",
	"Sardegna, Sassari, Loiri Porto San Paolo, M275",
	"Sardegna, Sassari, Sant'Antonio di Gallura, M276",
	"Sardegna, Sassari, Tergu, M282",
	"Sardegna, Sassari, Santa Maria Coghinas, M284",
	"Sardegna, Sassari, Erula, M292",
	"Sardegna, Sassari, Stintino, M290",
	"Sardegna, Sassari, Padru, M301",
	"Sardegna, Sassari, Budoni, B248",
	"Sardegna, Sassari, San Teodoro, I329",
	"Sardegna, Nuoro, Aritzo, A407",
	"Sardegna, Nuoro, Arzana, A454",
	"Sardegna, Nuoro, Atzara, A492",
	"Sardegna, Nuoro, Austis, A503",
	"Sardegna, Nuoro, Bari Sardo, A663",
	"Sardegna, Nuoro, Baunei, A722",
	"Sardegna, Nuoro, Belvì, A776",
	"Sardegna, Nuoro, Birori, A880",
	"Sardegna, Nuoro, Bitti, A895",
	"Sardegna, Nuoro, Bolotana, A948",
	"Sardegna, Nuoro, Borore, B056",
	"Sardegna, Nuoro, Bortigali, B062",
	"Sardegna, Nuoro, Desulo, D287",
	"Sardegna, Nuoro, Dorgali, D345",
	"Sardegna, Nuoro, Dualchi, D376",
	"Sardegna, Nuoro, Elini, D395",
	"Sardegna, Nuoro, Fonni, D665",
	"Sardegna, Nuoro, Gadoni, D842",
	"Sardegna, Nuoro, Gairo, D859",
	"Sardegna, Nuoro, Galtellì, D888",
	"Sardegna, Nuoro, Gavoi, D947",
	"Sardegna, Nuoro, Girasole, E049",
	"Sardegna, Nuoro, Ilbono, E283",
	"Sardegna, Nuoro, Irgoli, E323",
	"Sardegna, Nuoro, Jerzu, E387",
	"Sardegna, Nuoro, Lanusei, E441",
	"Sardegna, Nuoro, Lei, E517",
	"Sardegna, Nuoro, Loceri, E644",
	"Sardegna, Nuoro, Loculi, E646",
	"Sardegna, Nuoro, Lodè, E647",
	"Sardegna, Nuoro, Lotzorai, E700",
	"Sardegna, Nuoro, Lula, E736",
	"Sardegna, Nuoro, Macomer, E788",
	"Sardegna, Nuoro, Mamoiada, E874",
	"Sardegna, Nuoro, Meana Sardo, F073",
	"Sardegna, Nuoro, Noragugume, F933",
	"Sardegna, Nuoro, Nuoro, F979",
	"Sardegna, Nuoro, Oliena, G031",
	"Sardegna, Nuoro, Ollolai, G044",
	"Sardegna, Nuoro, Olzai, G058",
	"Sardegna, Nuoro, Onanì, G064",
	"Sardegna, Nuoro, Onifai, G070",
	"Sardegna, Nuoro, Oniferi, G071",
	"Sardegna, Nuoro, Orani, G084",
	"Sardegna, Nuoro, Orgosolo, G097",
	"Sardegna, Nuoro, Orosei, G119",
	"Sardegna, Nuoro, Orotelli, G120",
	"Sardegna, Nuoro, Ortueri, G146",
	"Sardegna, Nuoro, Orune, G147",
	"Sardegna, Nuoro, Osidda, G154",
	"Sardegna, Nuoro, Osini, G158",
	"Sardegna, Nuoro, Ottana, G191",
	"Sardegna, Nuoro, Ovodda, G201",
	"Sardegna, Nuoro, Perdasdefogu, G445",
	"Sardegna, Nuoro, Posada, G929",
	"Sardegna, Nuoro, Sarule, I448",
	"Sardegna, Nuoro, Silanus, I730",
	"Sardegna, Nuoro, Sindia, I748",
	"Sardegna, Nuoro, Siniscola, I751",
	"Sardegna, Nuoro, Sorgono, I851",
	"Sardegna, Nuoro, Talana, L036",
	"Sardegna, Nuoro, Tertenia, L140",
	"Sardegna, Nuoro, Teti, L153",
	"Sardegna, Nuoro, Tiana, L160",
	"Sardegna, Nuoro, Tonara, L202",
	"Sardegna, Nuoro, Torpè, L231",
	"Sardegna, Nuoro, Tortolì, A355",
	"Sardegna, Nuoro, Triei, L423",
	"Sardegna, Nuoro, Ulassai, L489",
	"Sardegna, Nuoro, Urzulei, L506",
	"Sardegna, Nuoro, Ussassai, L514",
	"Sardegna, Nuoro, Villagrande Strisaili, L953",
	"Sardegna, Nuoro, Cardedu, M285",
	"Sardegna, Nuoro, Lodine, E649",
	"Sardegna, Cagliari, Assemini, A474",
	"Sardegna, Cagliari, Cagliari, B354",
	"Sardegna, Cagliari, Capoterra, B675",
	"Sardegna, Cagliari, Decimomannu, D259",
	"Sardegna, Cagliari, Maracalagonis, E903",
	"Sardegna, Cagliari, Pula, H088",
	"Sardegna, Cagliari, Quartu Sant'Elena, H118",
	"Sardegna, Cagliari, Sarroch, I443",
	"Sardegna, Cagliari, Selargius, I580",
	"Sardegna, Cagliari, Sestu, I695",
	"Sardegna, Cagliari, Settimo San Pietro, I699",
	"Sardegna, Cagliari, Sinnai, I752",
	"Sardegna, Cagliari, Uta, L521",
	"Sardegna, Cagliari, Villa San Pietro, I118",
	"Sardegna, Cagliari, Quartucciu, H119",
	"Sardegna, Cagliari, Elmas, D399",
	"Sardegna, Cagliari, Monserrato, F383",
	"Sardegna, Oristano, Abbasanta, A007",
	"Sardegna, Oristano, Aidomaggiore, A097",
	"Sardegna, Oristano, Albagiara, A126",
	"Sardegna, Oristano, Ales, A180",
	"Sardegna, Oristano, Allai, A204",
	"Sardegna, Oristano, Arborea, A357",
	"Sardegna, Oristano, Ardauli, A380",
	"Sardegna, Oristano, Assolo, A477",
	"Sardegna, Oristano, Asuni, A480",
	"Sardegna, Oristano, Baradili, A614",
	"Sardegna, Oristano, Baratili San Pietro, A621",
	"Sardegna, Oristano, Baressa, A655",
	"Sardegna, Oristano, Bauladu, A721",
	"Sardegna, Oristano, Bidonì, A856",
	"Sardegna, Oristano, Bonarcado, A960",
	"Sardegna, Oristano, Boroneddu, B055",
	"Sardegna, Oristano, Busachi, B281",
	"Sardegna, Oristano, Cabras, B314",
	"Sardegna, Oristano, Cuglieri, D200",
	"Sardegna, Oristano, Fordongianus, D695",
	"Sardegna, Oristano, Ghilarza, E004",
	"Sardegna, Oristano, Gonnoscodina, E087",
	"Sardegna, Oristano, Gonnosnò, D585",
	"Sardegna, Oristano, Gonnostramatza, E088",
	"Sardegna, Oristano, Marrubiu, E972",
	"Sardegna, Oristano, Masullas, F050",
	"Sardegna, Oristano, Milis, F208",
	"Sardegna, Oristano, Mogorella, F270",
	"Sardegna, Oristano, Mogoro, F272",
	"Sardegna, Oristano, Morgongiori, F727",
	"Sardegna, Oristano, Narbolia, F840",
	"Sardegna, Oristano, Neoneli, F867",
	"Sardegna, Oristano, Norbello, F934",
	"Sardegna, Oristano, Nughedu Santa Vittoria, F974",
	"Sardegna, Oristano, Nurachi, F980",
	"Sardegna, Oristano, Nureci, F985",
	"Sardegna, Oristano, Ollastra, G043",
	"Sardegna, Oristano, Oristano, G113",
	"Sardegna, Oristano, Palmas Arborea, G286",
	"Sardegna, Oristano, Pau, G379",
	"Sardegna, Oristano, Paulilatino, G384",
	"Sardegna, Oristano, Pompu, G817",
	"Sardegna, Oristano, Riola Sardo, H301",
	"Sardegna, Oristano, Ruinas, F271",
	"Sardegna, Oristano, Samugheo, H756",
	"Sardegna, Oristano, San Nicolò d'Arcidano, A368",
	"Sardegna, Oristano, Santa Giusta, I205",
	"Sardegna, Oristano, Villa Sant'Antonio, I298",
	"Sardegna, Oristano, Santu Lussurgiu, I374",
	"Sardegna, Oristano, San Vero Milis, I384",
	"Sardegna, Oristano, Scano di Montiferro, I503",
	"Sardegna, Oristano, Sedilo, I564",
	"Sardegna, Oristano, Seneghe, I605",
	"Sardegna, Oristano, Senis, I609",
	"Sardegna, Oristano, Sennariolo, I613",
	"Sardegna, Oristano, Siamaggiore, I717",
	"Sardegna, Oristano, Siamanna, I718",
	"Sardegna, Oristano, Simala, I742",
	"Sardegna, Oristano, Simaxis, I743",
	"Sardegna, Oristano, Sini, I749",
	"Sardegna, Oristano, Siris, I757",
	"Sardegna, Oristano, Solarussa, I791",
	"Sardegna, Oristano, Sorradile, I861",
	"Sardegna, Oristano, Tadasuni, L023",
	"Sardegna, Oristano, Terralba, L122",
	"Sardegna, Oristano, Tramatza, L321",
	"Sardegna, Oristano, Tresnuraghes, L393",
	"Sardegna, Oristano, Ulà Tirso, L488",
	"Sardegna, Oristano, Uras, L496",
	"Sardegna, Oristano, Usellus, L508",
	"Sardegna, Oristano, Villanova Truschedu, L991",
	"Sardegna, Oristano, Villaurbana, M030",
	"Sardegna, Oristano, Villa Verde, A609",
	"Sardegna, Oristano, Zeddiani, M153",
	"Sardegna, Oristano, Zerfaliu, M168",
	"Sardegna, Oristano, Siapiccia, I721",
	"Sardegna, Oristano, Curcuris, D214",
	"Sardegna, Oristano, Soddì, I778",
	"Sardegna, Oristano, Bosa, B068",
	"Sardegna, Oristano, Flussio, D640",
	"Sardegna, Oristano, Laconi, E400",
	"Sardegna, Oristano, Magomadas, E825",
	"Sardegna, Oristano, Modolo, F261",
	"Sardegna, Oristano, Montresta, F698",
	"Sardegna, Oristano, Sagama, H661",
	"Sardegna, Oristano, Suni, L006",
	"Sardegna, Oristano, Tinnura, L172",
	"Sardegna, Sud Sardegna, Arbus, A359",
	"Sardegna, Sud Sardegna, Armungia, A419",
	"Sardegna, Sud Sardegna, Ballao, A597",
	"Sardegna, Sud Sardegna, Barrali, A677",
	"Sardegna, Sud Sardegna, Barumini, A681",
	"Sardegna, Sud Sardegna, Buggerru, B250",
	"Sardegna, Sud Sardegna, Burcei, B274",
	"Sardegna, Sud Sardegna, Calasetta, B383",
	"Sardegna, Sud Sardegna, Carbonia, B745",
	"Sardegna, Sud Sardegna, Carloforte, B789",
	"Sardegna, Sud Sardegna, Castiadas, M288",
	"Sardegna, Sud Sardegna, Collinas, C882",
	"Sardegna, Sud Sardegna, Decimoputzu, D260",
	"Sardegna, Sud Sardegna, Dolianova, D323",
	"Sardegna, Sud Sardegna, Domus de Maria, D333",
	"Sardegna, Sud Sardegna, Domusnovas, D334",
	"Sardegna, Sud Sardegna, Donori, D344",
	"Sardegna, Sud Sardegna, Escalaplano, D430",
	"Sardegna, Sud Sardegna, Escolca, D431",
	"Sardegna, Sud Sardegna, Esterzili, D443",
	"Sardegna, Sud Sardegna, Fluminimaggiore, D639",
	"Sardegna, Sud Sardegna, Furtei, D827",
	"Sardegna, Sud Sardegna, Genoni, D968",
	"Sardegna, Sud Sardegna, Genuri, D970",
	"Sardegna, Sud Sardegna, Gergei, D982",
	"Sardegna, Sud Sardegna, Gesico, D994",
	"Sardegna, Sud Sardegna, Gesturi, D997",
	"Sardegna, Sud Sardegna, Giba, E022",
	"Sardegna, Sud Sardegna, Goni, E084",
	"Sardegna, Sud Sardegna, Gonnesa, E086",
	"Sardegna, Sud Sardegna, Gonnosfanadiga, E085",
	"Sardegna, Sud Sardegna, Guamaggiore, E234",
	"Sardegna, Sud Sardegna, Guasila, E252",
	"Sardegna, Sud Sardegna, Guspini, E270",
	"Sardegna, Sud Sardegna, Iglesias, E281",
	"Sardegna, Sud Sardegna, Isili, E336",
	"Sardegna, Sud Sardegna, Las Plassas, E464",
	"Sardegna, Sud Sardegna, Lunamatrona, E742",
	"Sardegna, Sud Sardegna, Mandas, E877",
	"Sardegna, Sud Sardegna, Masainas, M270",
	"Sardegna, Sud Sardegna, Monastir, F333",
	"Sardegna, Sud Sardegna, Muravera, F808",
	"Sardegna, Sud Sardegna, Musei, F822",
	"Sardegna, Sud Sardegna, Narcao, F841",
	"Sardegna, Sud Sardegna, Nuragus, F981",
	"Sardegna, Sud Sardegna, Nurallao, F982",
	"Sardegna, Sud Sardegna, Nuraminis, F983",
	"Sardegna, Sud Sardegna, Nurri, F986",
	"Sardegna, Sud Sardegna, Nuxis, F991",
	"Sardegna, Sud Sardegna, Orroli, G122",
	"Sardegna, Sud Sardegna, Ortacesus, G133",
	"Sardegna, Sud Sardegna, Pabillonis, G207",
	"Sardegna, Sud Sardegna, Pauli Arbarei, G382",
	"Sardegna, Sud Sardegna, Perdaxius, G446",
	"Sardegna, Sud Sardegna, Pimentel, G669",
	"Sardegna, Sud Sardegna, Piscinas, M291",
	"Sardegna, Sud Sardegna, Portoscuso, G922",
	"Sardegna, Sud Sardegna, Sadali, H659",
	"Sardegna, Sud Sardegna, Samassi, H738",
	"Sardegna, Sud Sardegna, Samatzai, H739",
	"Sardegna, Sud Sardegna, San Basilio, H766",
	"Sardegna, Sud Sardegna, San Gavino Monreale, H856",
	"Sardegna, Sud Sardegna, San Giovanni Suergiu, G287",
	"Sardegna, Sud Sardegna, San Nicolò Gerrei, G383",
	"Sardegna, Sud Sardegna, San Sperate, I166",
	"Sardegna, Sud Sardegna, San Vito, I402",
	"Sardegna, Sud Sardegna, Sanluri, H974",
	"Sardegna, Sud Sardegna, Santadi, I182",
	"Sardegna, Sud Sardegna, Sant'Andrea Frius, I271",
	"Sardegna, Sud Sardegna, Sant'Anna Arresi, M209",
	"Sardegna, Sud Sardegna, Sant'Antioco, I294",
	"Sardegna, Sud Sardegna, Sardara, I428",
	"Sardegna, Sud Sardegna, Segariu, I570",
	"Sardegna, Sud Sardegna, Selegas, I582",
	"Sardegna, Sud Sardegna, Senorbì, I615",
	"Sardegna, Sud Sardegna, Serdiana, I624",
	"Sardegna, Sud Sardegna, Serramanna, I647",
	"Sardegna, Sud Sardegna, Serrenti, I667",
	"Sardegna, Sud Sardegna, Serri, I668",
	"Sardegna, Sud Sardegna, Setzu, I705",
	"Sardegna, Sud Sardegna, Seui, I706",
	"Sardegna, Sud Sardegna, Seulo, I707",
	"Sardegna, Sud Sardegna, Siddi, I724",
	"Sardegna, Sud Sardegna, Siliqua, I734",
	"Sardegna, Sud Sardegna, Silius, I735",
	"Sardegna, Sud Sardegna, Siurgus Donigala, I765",
	"Sardegna, Sud Sardegna, Soleminis, I797",
	"Sardegna, Sud Sardegna, Suelli, I995",
	"Sardegna, Sud Sardegna, Teulada, L154",
	"Sardegna, Sud Sardegna, Tratalias, L337",
	"Sardegna, Sud Sardegna, Tuili, L463",
	"Sardegna, Sud Sardegna, Turri, L473",
	"Sardegna, Sud Sardegna, Ussana, L512",
	"Sardegna, Sud Sardegna, Ussaramanna, L513",
	"Sardegna, Sud Sardegna, Vallermosa, L613",
	"Sardegna, Sud Sardegna, Villacidro, L924",
	"Sardegna, Sud Sardegna, Villamar, L966",
	"Sardegna, Sud Sardegna, Villamassargia, L968",
	"Sardegna, Sud Sardegna, Villanova Tulo, L992",
	"Sardegna, Sud Sardegna, Villanovaforru, L986",
	"Sardegna, Sud Sardegna, Villanovafranca, L987",
	"Sardegna, Sud Sardegna, Villaperuccio, M278",
	"Sardegna, Sud Sardegna, Villaputzu, L998",
	"Sardegna, Sud Sardegna, Villasalto, M016",
	"Sardegna, Sud Sardegna, Villasimius, B738",
	"Sardegna, Sud Sardegna, Villasor, M025",
	"Sardegna, Sud Sardegna, Villaspeciosa, M026",
	
	"STRANIERO, Asia, AFGHANISTAN, Z200",
	"STRANIERO, Africa, AFRICA DEL SUD-OVEST, Z300",
	"STRANIERO, Europa, ALBANIA, Z100",
	"STRANIERO, Africa, ALGERIA, Z301",
	"STRANIERO, Europa, ANDORRA, Z101",
	"STRANIERO, Africa, ANGOLA, Z302",
	"STRANIERO, Africa, ANGOLA, Z302",
	"STRANIERO, America del Centro, ANGUILLA (ISOLA), Z529",
	"STRANIERO, America del Centro, ANTIGUA E BARBUDA, Z532",
	"STRANIERO, America del Centro, ANTILLE BRITANNICHE, Z500",
	"STRANIERO, America del Centro, ANTILLE BRITANNICHE, Z521",
	"STRANIERO, America del Centro, ANTILLE BRITANNICHE, Z523",
	"STRANIERO, America del Centro, ANTILLE BRITANNICHE, Z523",
	"STRANIERO, America del Centro, ANTILLE BRITANNICHE, Z523",
	"STRANIERO, America del Centro, ANTILLE BRITANNICHE, Z521",
	"STRANIERO, America del Centro, ANTILLE BRITANNICHE, Z500",
	"STRANIERO, America del Centro, ANTILLE OLANDESI, Z501",
	"STRANIERO, Asia, ARABIA MERIDIONALE FEDERAZIONE, Z201",
	"STRANIERO, Asia, ARABIA MERIDIONALE PROTETTORATO, Z202",
	"STRANIERO, Asia, ARABIA SAUDITA, Z203",
	"STRANIERO, America del Sud, ARGENTINA, Z600",
	"STRANIERO, Asia, ARMENIA, Z252",
	"STRANIERO, Europa, ARMENIA, Z137",
	"STRANIERO, Australia, AUSTRALIA, Z700",
	"STRANIERO, Europa, AUSTRIA, Z102",
	"STRANIERO, Asia, AZERBAIGIAN, Z253",
	"STRANIERO, Europa, AZERBAIGIAN, Z141",
	"STRANIERO, America del Centro, BAHAMA, Z502",
	"STRANIERO, America del Centro, BAHAMA (ISOLE), Z502",
	"STRANIERO, Asia, BAHREIN, Z204",
	"STRANIERO, Asia, BAHREIN, Z204",
	"STRANIERO, Asia, BANGLADESH, Z249",
	"STRANIERO, America del Centro, BARBADOS, Z522",
	"STRANIERO, Africa, BASUTOLAND-SUD AFRICA BRITANNICO, Z303",
	"STRANIERO, Africa, BECIUANIA-SUD AFRICA BRITANNICO, Z304",
	"STRANIERO, Europa, BELGIO, Z103",
	"STRANIERO, America del Centro, BELIZE, Z512",
	"STRANIERO, America del Centro, BELIZE, Z512",
	"STRANIERO, Africa, BENIN, Z314",
	"STRANIERO, America del Nord, BERMUDA (ISOLE), Z400",
	"STRANIERO, Asia, BHUTAN, Z205",
	"STRANIERO, Europa, BIELORUSSIA=RUSSIA BIANCA, Z139",
	"STRANIERO, Asia, BIRMANIA, Z206",
	"STRANIERO, America del Sud, BOLIVIA, Z601",
	"STRANIERO, Africa, BOPHUTHATSWANA, Z364",
	"STRANIERO, Europa, BOSNIA ED ERZEGOVINA, Z153",
	"STRANIERO, Africa, BOTSWANA, Z358",
	"STRANIERO, America del Sud, BRASILE, Z602",
	"STRANIERO, Asia, BRUNEI, Z207",
	"STRANIERO, Asia, BRUNEI, Z207",
	"STRANIERO, Europa, BULGARIA, Z104",
	"STRANIERO, Africa, BURKINA, Z354",
	"STRANIERO, Africa, BURUNDI, Z305",
	"STRANIERO, Asia, CAMBOGIA, Z208",
	"STRANIERO, Africa, CAMERUN, Z306",
	"STRANIERO, America del Nord, CANADA, Z401",
	"STRANIERO, Africa, CAPO VERDE, Z307",
	"STRANIERO, Africa, CAPO VERDE (ISOLE), Z307",
	"STRANIERO, Australia, CAROLINE (ISOLE), Z701",
	"STRANIERO, Australia, CAROLINE (ISOLE), Z701",
	"STRANIERO, Australia, CAROLINE (ISOLE)=STATI FEDERATI DI MICRONESIA, Z701",
	"STRANIERO, America del Centro, CAYMAN (ISOLE), Z530",
	"STRANIERO, Europa, CECA REPUBBLICA, Z156",
	"STRANIERO, Europa, CECOSLOVACCHIA, Z105",
	"STRANIERO, Europa, CECOSLOVACCHIA, Z105",
	"STRANIERO, Africa, CENTRAFRICANA REPUBBLICA, Z308",
	"STRANIERO, Africa, CENTROAFRICANA REPUBBLICA, Z308",
	"STRANIERO, Africa, CENTROAFRICANO IMPERO, Z308",
	"STRANIERO, Asia, CEYLON, Z209",
	"STRANIERO, Australia, CHRISTMAS (ISOLA), Z702",
	"STRANIERO, Africa, CIAD, Z309",
	"STRANIERO, America del Sud, CILE, Z603",
	"STRANIERO, Asia, CINA REPUBBLICA POPOLARE, Z210",
	"STRANIERO, Asia, CIPRO, Z211",
	"STRANIERO, Africa, CISKEI, Z367",
	"STRANIERO, Europa, CITTA' DEL VATICANO, Z106",
	"STRANIERO, Asia, COCOS (ISOLE), Z212",
	"STRANIERO, America del Sud, COLOMBIA, Z604",
	"STRANIERO, Africa, COMORE, Z310",
	"STRANIERO, Africa, COMORE (ISOLE), Z310",
	"STRANIERO, Africa, COMORE (ISOLE), Z310",
	"STRANIERO, Africa, COMORE (ISOLE), Z310",
	"STRANIERO, Africa, CONGO BRAZZAVILLE, Z311",
	"STRANIERO, Africa, CONGO LEOPOLDVILLE, Z312",
	"STRANIERO, Africa, CONGO REPUBBLICA DEMOCRATICA, Z312",
	"STRANIERO, Africa, CONGO REPUBBLICA POPOLARE, Z311",
	"STRANIERO, Australia, COOK (ISOLE), Z703",
	"STRANIERO, Asia, COREA DEL NORD, Z214",
	"STRANIERO, Asia, COREA DEL SUD, Z213",
	"STRANIERO, Africa, COSTA D'AVORIO, Z313",
	"STRANIERO, Asia, COSTA DEI PIRATI=TRUCIAL STATES, Z215",
	"STRANIERO, America del Centro, COSTA RICA, Z503",
	"STRANIERO, Europa, CROAZIA, Z149",
	"STRANIERO, America del Centro, CUBA, Z504",
	"STRANIERO, Africa, DAHOMEY=BENIN, Z314",
	"STRANIERO, Europa, DANIMARCA, Z107",
	"STRANIERO, Polo Nord, DIPENDENZE AUSTRALIANE, Z900",
	"STRANIERO, Polo Nord, DIPENDENZE BRITANNICHE, Z901",
	"STRANIERO, Polo Sud, DIPENDENZE CANADESI, Z800",
	"STRANIERO, Polo Nord, DIPENDENZE FRANCESI, Z902",
	"STRANIERO, Polo Nord, DIPENDENZE NEOZELANDESI, Z903",
	"STRANIERO, Polo Nord, DIPENDENZE NORVEGESI ANTARTICHE, Z904",
	"STRANIERO, Polo Sud, DIPENDENZE NORVEGESI ARTICHE, Z801",
	"STRANIERO, Polo Sud, DIPENDENZE RUSSE, Z802",
	"STRANIERO, Polo Sud, DIPENDENZE SOVIETICHE, Z802",
	"STRANIERO, Polo Nord, DIPENDENZE STATUNITENSI, Z905",
	"STRANIERO, Polo Nord, DIPENDENZE SUDAFRICANE, Z906",
	"STRANIERO, America del Centro, DOMINICA, Z526",
	"STRANIERO, America del Centro, DOMINICANA REPUBBLICA, Z505",
	"STRANIERO, America del Sud, ECUADOR, Z605",
	"STRANIERO, Africa, EGITTO, Z336",
	"STRANIERO, America del Centro, EL SALVADOR, Z506",
	"STRANIERO, Asia, EMIRATI ARABI UNITI, Z215",
	"STRANIERO, Africa, ERITREA, Z368",
	"STRANIERO, Europa, ESTONIA, Z144",
	"STRANIERO, Africa, ETIOPIA, Z315",
	"STRANIERO, Africa, ETIOPIA, Z315",
	"STRANIERO, Africa, ETIOPIA, Z315",
	"STRANIERO, Europa, FAER OER (ISOLE), Z108",
	"STRANIERO, Australia, FIGI=VITI, Z704",
	"STRANIERO, Australia, FIGI=VITI (ISOLE), Z704",
	"STRANIERO, Asia, FILIPPINE, Z216",
	"STRANIERO, Europa, FINLANDIA, Z109",
	"STRANIERO, Asia, FORMOSA=TAIWAN, Z217",
	"STRANIERO, Europa, FRANCIA, Z110",
	"STRANIERO, Africa, GABON, Z316",
	"STRANIERO, Africa, GAMBIA, Z317",
	"STRANIERO, Asia, GAZA (TERRITORIO DI), Z218",
	"STRANIERO, Asia, GEORGIA, Z254",
	"STRANIERO, Europa, GEORGIA, Z136",
	"STRANIERO, Europa, GERMANIA, Z112",
	"STRANIERO, Europa, GERMANIA REPUBBLICA DEMOCRATICA, Z111",
	"STRANIERO, Europa, GERMANIA REPUBBLICA FEDERALE, Z112",
	"STRANIERO, Africa, GHANA, Z318",
	"STRANIERO, America del Centro, GIAMAICA, Z507",
	"STRANIERO, Asia, GIAPPONE, Z219",
	"STRANIERO, Europa, GIBILTERRA, Z113",
	"STRANIERO, Africa, GIBUTI, Z361",
	"STRANIERO, Australia, GILBERT E ELLICE (ISOLE), Z705",
	"STRANIERO, Australia, GILBERT E ELLICE (ISOLE), Z705",
	"STRANIERO, Asia, GIORDANIA, Z220",
	"STRANIERO, Europa, GRAN BRETAGNA E IRLANDA DEL NORD, Z114",
	"STRANIERO, Europa, GRECIA, Z115",
	"STRANIERO, America del Centro, GRENADA, Z524",
	"STRANIERO, America del Nord, GROENLANDIA, Z402",
	"STRANIERO, America del Centro, GUADALUPA, Z508",
	"STRANIERO, Australia, GUAM (ISOLA), Z706",
	"STRANIERO, America del Centro, GUATEMALA, Z509",
	"STRANIERO, America del Sud, GUAYANA OLANDESE, Z608",
	"STRANIERO, America del Sud, GUAYANA=GUIANA FRANCESE, Z607",
	"STRANIERO, Africa, GUINEA, Z319",
	"STRANIERO, Africa, GUINEA BISSAU, Z320",
	"STRANIERO, Africa, GUINEA EQUATORIALE, Z321",
	"STRANIERO, Africa, GUINEA PORTOGHESE, Z320",
	"STRANIERO, Africa, GUINEA SPAGNOLA, Z321",
	"STRANIERO, America del Sud, GUYANA, Z606",
	"STRANIERO, America del Sud, GUYANA BRITANNICA, Z606",
	"STRANIERO, America del Centro, HAITI, Z510",
	"STRANIERO, America del Centro, HONDURAS, Z511",
	"STRANIERO, America del Centro, HONDURAS BRITANNICO, Z512",
	"STRANIERO, Asia, HONG KONG, Z221",
	"STRANIERO, Africa, IFNI, Z323",
	"STRANIERO, Africa, IFNI, Z323",
	"STRANIERO, Asia, INDIA, Z222",
	"STRANIERO, Asia, INDONESIA, Z223",
	"STRANIERO, Asia, IRAN, Z224",
	"STRANIERO, Asia, IRAQ, Z225",
	"STRANIERO, Australia, IRIAN OCCIDENTALE, Z707",
	"STRANIERO, Europa, IRLANDA=EIRE, Z116",
	"STRANIERO, Europa, ISLANDA, Z117",
	"STRANIERO, Australia, ISOLE CILENE (PASQUA E SALA Y GOMEZ), Z721",
	"STRANIERO, Asia, ISRAELE, Z226",
	"STRANIERO, Europa, IUGOSLAVIA, Z118",
	"STRANIERO, Europa, IUGOSLAVIA, Z118",
	"STRANIERO, Europa, IUGOSLAVIA, Z118",
	"STRANIERO, Europa, IUGOSLAVIA, Z118",
	"STRANIERO, Europa, IUGOSLAVIA, Z118",
	"STRANIERO, Asia, KAZAKISTAN, Z255",
	"STRANIERO, Europa, KAZAKISTAN, Z152",
	"STRANIERO, Africa, KENYA, Z322",
	"STRANIERO, Asia, KIRGHIZISTAN, Z256",
	"STRANIERO, Europa, KIRGHIZISTAN, Z142",
	"STRANIERO, Australia, KIRIBATI, Z731",
	"STRANIERO, Europa, KOSOVO, Z160",
	"STRANIERO, Asia, KUWAIT, Z227",
	"STRANIERO, Africa, LA REUNION (ISOLA), Z324",
	"STRANIERO, Asia, LAOS, Z228",
	"STRANIERO, Africa, LESOTHO, Z359",
	"STRANIERO, Europa, LETTONIA, Z145",
	"STRANIERO, Asia, LIBANO, Z229",
	"STRANIERO, Africa, LIBERIA, Z325",
	"STRANIERO, Africa, LIBIA, Z326",
	"STRANIERO, Europa, LIECHTENSTEIN, Z119",
	"STRANIERO, Europa, LITUANIA, Z146",
	"STRANIERO, Europa, LUSSEMBURGO, Z120",
	"STRANIERO, Asia, MACAO, Z231",
	"STRANIERO, Europa, MACEDONIA, Z148",
	"STRANIERO, Australia, MACQUARIE (ISOLE), Z708",
	"STRANIERO, Africa, MADAGASCAR, Z327",
	"STRANIERO, Africa, MALAWI, Z328",
	"STRANIERO, Asia, MALAYSIA, Z230",
	"STRANIERO, Asia, MALAYSIA, Z230",
	"STRANIERO, Asia, MALAYSIA, Z247",
	"STRANIERO, Asia, MALDIVE, Z232",
	"STRANIERO, Africa, MALI, Z329",
	"STRANIERO, Europa, MALTA, Z121",
	"STRANIERO, America del Sud, MALVINE=FALKLAND (ISOLE), Z609",
	"STRANIERO, Europa, MAN (ISOLA), Z122",
	"STRANIERO, Australia, MARCUS (ISOLE), Z709",
	"STRANIERO, Australia, MARIANNE (ISOLE), Z710",
	"STRANIERO, Africa, MAROCCO, Z330",
	"STRANIERO, Australia, MARSHALL, Z711",
	"STRANIERO, Australia, MARSHALL (ISOLE), Z711",
	"STRANIERO, America del Centro, MARTINICA, Z513",
	"STRANIERO, Africa, MAURITANIA, Z331",
	"STRANIERO, Africa, MAURIZIO, Z332",
	"STRANIERO, Africa, MAURIZIO (ISOLE), Z332",
	"STRANIERO, Africa, MAYOTTE (ISOLA), Z360",
	"STRANIERO, America del Centro, MESSICO, Z514",
	"STRANIERO, Australia, MICRONESIA STATI FEDERATI, Z735",
	"STRANIERO, Australia, MIDWAY (ISOLE), Z712",
	"STRANIERO, Europa, MOLDAVIA, Z140",
	"STRANIERO, Europa, MONACO, Z123",
	"STRANIERO, Asia, MONGOLIA, Z233",
	"STRANIERO, Europa, MONTENEGRO, Z157",
	"STRANIERO, America del Centro, MONTSERRAT, Z531",
	"STRANIERO, Africa, MOZAMBICO, Z333",
	"STRANIERO, Africa, MOZAMBICO, Z333",
	"STRANIERO, Africa, NAMIBIA, Z300",
	"STRANIERO, Africa, NAMIBIA=AFRICA DEL SUD OVEST, Z300",
	"STRANIERO, Australia, NAURU, Z713",
	"STRANIERO, Australia, NAURU (ISOLE), Z713",
	"STRANIERO, Asia, NEPAL, Z234",
	"STRANIERO, America del Centro, NICARAGUA, Z515",
	"STRANIERO, Africa, NIGER, Z334",
	"STRANIERO, Africa, NIGERIA, Z335",
	"STRANIERO, Australia, NIUE=SAVAGE (ISOLE), Z714",
	"STRANIERO, Australia, NORFOLK (ISOLE E ISOLE DEL MAR DEI CORALLI), Z715",
	"STRANIERO, Europa, NORMANNE (ISOLE)=ISOLE DEL CANALE, Z124",
	"STRANIERO, Europa, NORVEGIA, Z125",
	"STRANIERO, Australia, NUOVA CALEDONIA (ISOLE E DIPENDENZE), Z716",
	"STRANIERO, Australia, NUOVA GUINEA, Z718",
	"STRANIERO, Australia, NUOVA ZELANDA, Z719",
	"STRANIERO, Australia, NUOVE EBRIDI (ISOLE CONDOMINIO FRANCO-INGLESE), Z717",
	"STRANIERO, Asia, OMAN, Z235",
	"STRANIERO, Europa, PAESI BASSI, Z126",
	"STRANIERO, Asia, PAKISTAN, Z236",
	"STRANIERO, Australia, PALAU, Z734",
	"STRANIERO, Australia, PALAU REPUBBLICA, Z734",
	"STRANIERO, America del Centro, PANAMA', Z516",
	"STRANIERO, America del Centro, PANAMA ZONA DEL CANALE, Z517",
	"STRANIERO, America del Centro, PANAMA ZONA DEL CANALE, Z517",
	"STRANIERO, Australia, PAPUA NUOVA GUINEA, Z730",
	"STRANIERO, Australia, PAPUASIA, Z720",
	"STRANIERO, America del Sud, PARAGUAY, Z610",
	"STRANIERO, Australia, PASQUA (ISOLA), Z721",
	"STRANIERO, America del Sud, PERU', Z611",
	"STRANIERO, Australia, PITCAIRN (E DIPENDENZE), Z722",
	"STRANIERO, Australia, POLINESIA FRANCESE (ISOLE), Z723",
	"STRANIERO, Europa, POLONIA, Z127",
	"STRANIERO, Europa, PORTOGALLO, Z128",
	"STRANIERO, America del Centro, PUERTO RICO, Z518",
	"STRANIERO, Asia, QATAR, Z237",
	"STRANIERO, Asia, QATAR, Z237",
	"STRANIERO, Asia, REPUBBLICA DELLA CINA NAZIONALE=TAIWAN, Z217",
	"STRANIERO, Europa, REPUBBLICA DI POLONIA, Z127",
	"STRANIERO, Africa, RHODESIA, Z337",
	"STRANIERO, Europa, ROMANIA, Z129",
	"STRANIERO, Africa, RUANDA, Z338",
	"STRANIERO, Europa, RUSSIA=FEDERAZIONE RUSSA, Z154",
	"STRANIERO, Asia, RYUKYU (ISOLE), Z238",
	"STRANIERO, Africa, SAHARA MERIDIONALE, Z362",
	"STRANIERO, Africa, SAHARA SETTENTRIONALE, Z363",
	"STRANIERO, Africa, SAHARA SPAGNOLO, Z339",
	"STRANIERO, Africa, SAHARA SPAGNOLO, Z339",
	"STRANIERO, America del Centro, SAINT KITTS E NEVIS=SAINT CHRISTOPHER E NEVIS, Z533",
	"STRANIERO, America del Centro, SAINT LUCIA, Z527",
	"STRANIERO, America del Nord, SAINT PIERRE ET MIQUELON (ISOLE), Z403",
	"STRANIERO, America del Centro, SAINT VINCENT E GRENADINE, Z528",
	"STRANIERO, Australia, SALOMONE, Z724",
	"STRANIERO, Australia, SALOMONE (ISOLE), Z724",
	"STRANIERO, Australia, SAMOA, Z726",
	"STRANIERO, Australia, SAMOA AMERICANE (ISOLE), Z725",
	"STRANIERO, Europa, SAN MARINO, Z130",
	"STRANIERO, Africa, SANT'ELENA (ISOLA), Z340",
	"STRANIERO, Africa, SAO TOME' E PRINCIPE, Z341",
	"STRANIERO, Africa, SAO TOME' E PRINCIPE (ISOLE), Z341",
	"STRANIERO, Africa, SEICELLE, Z342",
	"STRANIERO, Africa, SEICELLE (ISOLE), Z342",
	"STRANIERO, Africa, SEICELLE (ISOLE), Z342",
	"STRANIERO, Africa, SENEGAL, Z343",
	"STRANIERO, Europa, SERBIA, Z158",
	"STRANIERO, Europa, SERBIA E MONTENEGRO, Z118",
	"STRANIERO, Africa, SIERRA LEONE, Z344",
	"STRANIERO, Asia, SIKKIM, Z239",
	"STRANIERO, Asia, SINGAPORE, Z248",
	"STRANIERO, Asia, SIRIA, Z240",
	"STRANIERO, Europa, SLOVACCHIA, Z155",
	"STRANIERO, Europa, SLOVENIA, Z150",
	"STRANIERO, Africa, SOMALIA, Z345",
	"STRANIERO, Africa, SOMALIA FRANCESE, Z346",
	"STRANIERO, Europa, SPAGNA, Z131",
	"STRANIERO, Asia, SRI LANKA, Z209",
	"STRANIERO, America del Nord, STATI UNITI D'AMERICA, Z404",
	"STRANIERO, Africa, SUDAFRICANA REPUBBLICA, Z347",
	"STRANIERO, Africa, SUDAFRICANA REPUBBLICA, Z347",
	"STRANIERO, Africa, SUDAFRICANA REPUBBLICA, Z347",
	"STRANIERO, Africa, SUDAFRICANA REPUBBLICA, Z347",
	"STRANIERO, Africa, SUDAFRICANA REPUBBLICA, Z347",
	"STRANIERO, Africa, SUDAN, Z348",
	"STRANIERO, America del Sud, SURINAME, Z608",
	"STRANIERO, Europa, SVEZIA, Z132",
	"STRANIERO, Europa, SVIZZERA, Z133",
	"STRANIERO, Africa, SWAZILAND, Z349",
	"STRANIERO, Africa, SWAZILAND-SUDAFRICA BRITANNICO, Z349",
	"STRANIERO, Asia, TAGIKISTAN, Z257",
	"STRANIERO, Europa, TAGIKISTAN, Z147",
	"STRANIERO, Africa, TANGANICA, Z350",
	"STRANIERO, Africa, TANZANIA, Z357",
	"STRANIERO, Africa, TERRITORIO FRANCESE DEGLI AFAR E DEGLI ISSA, Z346",
	"STRANIERO, Asia, THAILANDIA, Z241",
	"STRANIERO, Asia, TIMOR (ISOLA), Z242",
	"STRANIERO, Africa, TOGO, Z351",
	"STRANIERO, Australia, TOKELAU=ISOLE DELL'UNIONE, Z727",
	"STRANIERO, Australia, TONGA=DEGLI AMICI (ISOLE), Z728",
	"STRANIERO, Australia, TONGA=ISOLE DEGLI AMICI, Z728",
	"STRANIERO, Africa, TRANSKEI, Z365",
	"STRANIERO, America del Sud, TRINIDAD E TOBAGO, Z612",
	"STRANIERO, Africa, TUNISIA, Z352",
	"STRANIERO, Asia, TURCHIA, Z243",
	"STRANIERO, Asia, TURKEMENISTAN, Z258",
	"STRANIERO, Europa, TURKEMENISTAN, Z151",
	"STRANIERO, America del Centro, TURKS E CAICOS (ISOLE), Z519",
	"STRANIERO, Australia, TUVALU, Z732",
	"STRANIERO, Europa, UCRAINA, Z138",
	"STRANIERO, Africa, UGANDA, Z353",
	"STRANIERO, Europa, UNGHERIA, Z134",
	"STRANIERO, Europa, UNIONE REPUBBLICHE SOCIALISTE SOVIETICHE, Z135",
	"STRANIERO, Europa, UNIONE REPUBBLICHE SOCIALISTE SOVIETICHE, Z135",
	"STRANIERO, Europa, UNIONE REPUBBLICHE SOCIALISTE SOVIETICHE, Z135",
	"STRANIERO, Europa, UNIONE REPUBBLICHE SOCIALISTE SOVIETICHE, Z135",
	"STRANIERO, Europa, UNIONE REPUBBLICHE SOCIALISTE SOVIETICHE, Z135",
	"STRANIERO, Europa, UNIONE REPUBBLICHE SOCIALISTE SOVIETICHE, Z135",
	"STRANIERO, Europa, UNIONE REPUBBLICHE SOCIALISTE SOVIETICHE, Z135",
	"STRANIERO, Europa, UNIONE REPUBBLICHE SOCIALISTE SOVIETICHE, Z135",
	"STRANIERO, Europa, UNIONE REPUBBLICHE SOCIALISTE SOVIETICHE, Z135",
	"STRANIERO, Europa, UNIONE REPUBBLICHE SOCIALISTE SOVIETICHE, Z135",
	"STRANIERO, Europa, UNIONE REPUBBLICHE SOCIALISTE SOVIETICHE, Z135",
	"STRANIERO, Europa, UNIONE REPUBBLICHE SOCIALISTE SOVIETICHE, Z135",
	"STRANIERO, America del Sud, URUGUAY, Z613",
	"STRANIERO, Asia, UZBEKISTAN, Z259",
	"STRANIERO, Europa, UZBEKISTAN, Z143",
	"STRANIERO, Australia, VANUATU, Z733",
	"STRANIERO, Africa, VENDA, Z366",
	"STRANIERO, America del Sud, VENEZUELA, Z614",
	"STRANIERO, America del Centro, VERGINI AMERICANE (ISOLE), Z520",
	"STRANIERO, America del Centro, VERGINI BRITANNICHE (ISOLE), Z525",
	"STRANIERO, Asia, VIETNAM, Z251",
	"STRANIERO, Asia, VIETNAM DEL NORD, Z245",
	"STRANIERO, Asia, VIETNAM DEL SUD, Z244",
	"STRANIERO, Africa, VOLTA=ALTOVOLTA, Z354",
	"STRANIERO, Australia, WALLIS E FUTUNA (ISOLE), Z729",
	"STRANIERO, Asia, YEMEN, Z246",
	"STRANIERO, Asia, YEMEN REPUBBLICA DEMOCRATICA POPOLARE, Z250",
	"STRANIERO, Africa, ZAIRE, Z312",
	"STRANIERO, Africa, ZAMBIA, Z355",
	"STRANIERO, Africa, ZANZIBAR, Z356",
	"STRANIERO, Africa, ZIMBABWE, Z337",
]
